/* eslint-disable */
export const datatZr = [
  {
    "pk": 14,
    "fields": {
      "postcode": 1014,
      "wilaya": 1,
      "name": "Tamentit"
    },
    "id": 22,
    "commune_name_ascii": "Timekten",
    "commune_name": "تيمقتن",
    "daira_name_ascii": "Aoulef",
    "daira_name": "أولف",
    "wilaya_code": "1",
    "wilaya_name_ascii": "Adrar",
    "wilaya_name": "أدرار"
  },
  {
    "model": "base.commune",
    "pk": 22,
    "fields": {
      "postcode": 1022,
      "wilaya": 1,
      "name": "Bouda"
    },
    "id": 6,
    "commune_name_ascii": "Bouda",
    "commune_name": "بودة",
    "daira_name_ascii": "Adrar",
    "daira_name": "أدرار",
    "wilaya_code": "1",
    "wilaya_name_ascii": "Adrar",
    "wilaya_name": "أدرار"
  },
  {
    "model": "base.commune",
    "pk": 21,
    "fields": {
      "postcode": 1021,
      "wilaya": 1,
      "name": "Ouled Ahmed Timmi"
    },
    "id": 13,
    "commune_name_ascii": "Ouled Ahmed Timmi",
    "commune_name": "أولاد أحمد تيمي",
    "daira_name_ascii": "Adrar",
    "daira_name": "أدرار",
    "wilaya_code": "1",
    "wilaya_name_ascii": "Adrar",
    "wilaya_name": "أدرار"
  },
  {
    "model": "base.commune",
    "pk": 1,
    "fields": {
      "postcode": 1001,
      "wilaya": 1,
      "name": "Adrar"
    },
    "id": 1,
    "commune_name_ascii": "Adrar",
    "commune_name": "أدرار",
    "daira_name_ascii": "Adrar",
    "daira_name": "أدرار",
    "wilaya_code": "1",
    "wilaya_name_ascii": "Adrar",
    "wilaya_name": "أدرار"
  },
  {
    "model": "base.commune",
    "pk": 15,
    "fields": {
      "postcode": 1015,
      "wilaya": 1,
      "name": "Fenoughil"
    },
    "id": 9,
    "commune_name_ascii": "Fenoughil",
    "commune_name": "فنوغيل",
    "daira_name_ascii": "Fenoughil",
    "daira_name": "فنوغيل",
    "wilaya_code": "1",
    "wilaya_name_ascii": "Adrar",
    "wilaya_name": "أدرار"
  },
  {
    "pk": 5, "fields": { "postcode": 1005, "wilaya": 1, "name": "Inozghmir" },
    "id": 10,
    "commune_name_ascii": "In Zghmir",
    "commune_name": "إن زغمير",
    "daira_name_ascii": "Zaouiat Kounta",
    "daira_name": "زاوية كنتة",
    "wilaya_code": "1",
    "wilaya_name_ascii": "Adrar",
    "wilaya_name": "أدرار"
  },
  {
    "model": "base.commune",
    "pk": 4,
    "fields": {
      "postcode": 1004,
      "wilaya": 1,
      "name": "Reggane"
    },
    "id": 16,
    "commune_name_ascii": "Reggane",
    "commune_name": "رقان",
    "daira_name_ascii": "Reggane",
    "daira_name": "رقان",
    "wilaya_code": "1",
    "wilaya_name_ascii": "Adrar",
    "wilaya_name": "أدرار"
  },
  {
    "model": "base.commune",
    "pk": 18,
    "fields": {
      "postcode": 1018,
      "wilaya": 1,
      "name": "Sali"
    },
    "id": 17,
    "commune_name_ascii": "Sali",
    "commune_name": "سالي",
    "daira_name_ascii": "Reggane",
    "daira_name": "رقان",
    "wilaya_code": "1",
    "wilaya_name_ascii": "Adrar",
    "wilaya_name": "أدرار"
  },
  {
    "pk": 26, "fields": { "postcode": 1026, "wilaya": 1, "name": "Sbaa" },
    "id": 18,
    "commune_name_ascii": "Sebaa",
    "commune_name": "السبع",
    "daira_name_ascii": "Tsabit",
    "daira_name": "تسابيت",
    "wilaya_code": "1",
    "wilaya_name_ascii": "Adrar",
    "wilaya_name": "أدرار"
  },
  {
    "model": "base.commune",
    "pk": 8,
    "fields": {
      "postcode": 1008,
      "wilaya": 1,
      "name": "Tsabit"
    },
    "id": 27,
    "commune_name_ascii": "Tsabit",
    "commune_name": "تسابيت",
    "daira_name_ascii": "Tsabit",
    "daira_name": "تسابيت",
    "wilaya_code": "1",
    "wilaya_name_ascii": "Adrar",
    "wilaya_name": "أدرار"
  },
  {
    "model": "base.commune",
    "pk": 2,
    "fields": {
      "postcode": 1002,
      "wilaya": 1,
      "name": "Tamest"
    },
    "id": 21,
    "commune_name_ascii": "Tamest",
    "commune_name": "تامست",
    "daira_name_ascii": "Fenoughil",
    "daira_name": "فنوغيل",
    "wilaya_code": "1",
    "wilaya_name_ascii": "Adrar",
    "wilaya_name": "أدرار"
  },
  {
    "pk": 14, "fields": { "postcode": 1014, "wilaya": 1, "name": "Tamentit" },
    "id": 20,
    "commune_name_ascii": "Tamantit",
    "commune_name": "تامنطيط",
    "daira_name_ascii": "Fenoughil",
    "daira_name": "فنوغيل",
    "wilaya_code": "1",
    "wilaya_name_ascii": "Adrar",
    "wilaya_name": "أدرار"
  },
  {
    "model": "base.commune",
    "pk": 6,
    "fields": {
      "postcode": 1006,
      "wilaya": 1,
      "name": "Tit"
    },
    "id": 26,
    "commune_name_ascii": "Tit",
    "commune_name": "تيت",
    "daira_name_ascii": "Aoulef",
    "daira_name": "أولف",
    "wilaya_code": "1",
    "wilaya_name_ascii": "Adrar",
    "wilaya_name": "أدرار"
  },
  {
    "model": "base.commune",
    "pk": 11,
    "fields": {
      "postcode": 1011,
      "wilaya": 1,
      "name": "Zaouiet Kounta"
    },
    "id": 28,
    "commune_name_ascii": "Zaouiet Kounta",
    "commune_name": "زاوية كنتة",
    "daira_name_ascii": "Zaouiat Kounta",
    "daira_name": "زاوية كنتة",
    "wilaya_code": "1",
    "wilaya_name_ascii": "Adrar",
    "wilaya_name": "أدرار"
  },
  {
    "model": "base.commune",
    "pk": 19,
    "fields": {
      "postcode": 1019,
      "wilaya": 1,
      "name": "Akabli"
    },
    "id": 2,
    "commune_name_ascii": "Akabli",
    "commune_name": "اقبلي",
    "daira_name_ascii": "Aoulef",
    "daira_name": "أولف",
    "wilaya_code": "1",
    "wilaya_name_ascii": "Adrar",
    "wilaya_name": "أدرار"
  },
  {
    "model": "base.commune",
    "pk": 12,
    "fields": {
      "postcode": 1012,
      "wilaya": 1,
      "name": "Aoulef"
    },
    "id": 4,
    "commune_name_ascii": "Aoulef",
    "commune_name": "أولف",
    "daira_name_ascii": "Aoulef",
    "daira_name": "أولف",
    "wilaya_code": "1",
    "wilaya_name_ascii": "Adrar",
    "wilaya_name": "أدرار"
  },
  {
    "model": "base.commune",
    "pk": 42,
    "fields": {
      "postcode": 2014,
      "wilaya": 2,
      "name": "Talassa"
    },
    "id": 60,
    "commune_name_ascii": "Talassa",
    "commune_name": "تلعصة",
    "daira_name_ascii": "Abou El Hassane",
    "daira_name": "أبو الحسن",
    "wilaya_code": "2",
    "wilaya_name_ascii": "Chlef",
    "wilaya_name": "الشلف"
  },
  {
    "model": "base.commune",
    "pk": 48,
    "fields": {
      "postcode": 2020,
      "wilaya": 2,
      "name": "Zeboudja"
    },
    "id": 63,
    "commune_name_ascii": "Zeboudja",
    "commune_name": "الزبوجة",
    "daira_name_ascii": "Zeboudja",
    "daira_name": "الزبوجة",
    "wilaya_code": "2",
    "wilaya_name_ascii": "Chlef",
    "wilaya_name": "الشلف"
  },
  {
    "model": "base.commune",
    "pk": 55,
    "fields": {
      "postcode": 2027,
      "wilaya": 2,
      "name": "El Hadjadj"
    },
    "id": 41,
    "commune_name_ascii": "El Hadjadj",
    "commune_name": "الحجاج",
    "daira_name_ascii": "Ouled Ben Abdelkader",
    "daira_name": "أولاد بن عبد القادر",
    "wilaya_code": "2",
    "wilaya_name_ascii": "Chlef",
    "wilaya_name": "الشلف"
  },
  {
    "model": "base.commune",
    "pk": 58,
    "fields": {
      "postcode": 2030,
      "wilaya": 2,
      "name": "Ouled Ben Abdelkader"
    },
    "id": 52,
    "commune_name_ascii": "Ouled Ben Abdelkader",
    "commune_name": "أولاد بن عبد القادر",
    "daira_name_ascii": "Ouled Ben Abdelkader",
    "daira_name": "أولاد بن عبد القادر",
    "wilaya_code": "2",
    "wilaya_name_ascii": "Chlef",
    "wilaya_name": "الشلف"
  },
  {
    "model": "base.commune",
    "pk": 60,
    "fields": {
      "postcode": 2032,
      "wilaya": 2,
      "name": "Ain Merane"
    },
    "id": 30,
    "commune_name_ascii": "Ain Merane",
    "commune_name": "عين مران",
    "daira_name_ascii": "Ain Merane",
    "daira_name": "عين مران",
    "wilaya_code": "2",
    "wilaya_name_ascii": "Chlef",
    "wilaya_name": "الشلف"
  },
  {
    "model": "base.commune",
    "pk": 62,
    "fields": {
      "postcode": 2034,
      "wilaya": 2,
      "name": "Breira"
    },
    "id": 37,
    "commune_name_ascii": "Breira",
    "commune_name": "بريرة",
    "daira_name_ascii": "Beni Haoua",
    "daira_name": "بني حواء",
    "wilaya_code": "2",
    "wilaya_name_ascii": "Chlef",
    "wilaya_name": "الشلف"
  },
  {
    "model": "base.commune",
    "pk": 46,
    "fields": {
      "postcode": 2018,
      "wilaya": 2,
      "name": "Ouled Abbes"
    },
    "id": 51,
    "commune_name_ascii": "Ouled Abbes",
    "commune_name": "أولاد عباس",
    "daira_name_ascii": "Oued Fodda",
    "daira_name": "وادي الفضة",
    "wilaya_code": "2",
    "wilaya_name_ascii": "Chlef",
    "wilaya_name": "الشلف"
  },
  {
    "model": "base.commune",
    "pk": 57,
    "fields": {
      "postcode": 2029,
      "wilaya": 2,
      "name": "Oued Fodda"
    },
    "id": 48,
    "commune_name_ascii": "Oued Fodda",
    "commune_name": "وادي الفضة",
    "daira_name_ascii": "Oued Fodda",
    "daira_name": "وادي الفضة",
    "wilaya_code": "2",
    "wilaya_name_ascii": "Chlef",
    "wilaya_name": "الشلف"
  },
  {
    "model": "base.commune",
    "pk": 41,
    "fields": {
      "postcode": 2013,
      "wilaya": 2,
      "name": "Beni Rached"
    },
    "id": 34,
    "commune_name_ascii": "Beni Rached",
    "commune_name": "بني راشد",
    "daira_name_ascii": "Oued Fodda",
    "daira_name": "وادي الفضة",
    "wilaya_code": "2",
    "wilaya_name_ascii": "Chlef",
    "wilaya_name": "الشلف"
  },
  {
    "model": "base.commune",
    "pk": 43,
    "fields": {
      "postcode": 2015,
      "wilaya": 2,
      "name": "Herenfa"
    },
    "id": 45,
    "commune_name_ascii": "Herenfa",
    "commune_name": "الهرانفة",
    "daira_name_ascii": "Ain Merane",
    "daira_name": "عين مران",
    "wilaya_code": "2",
    "wilaya_name_ascii": "Chlef",
    "wilaya_name": "الشلف"
  },
  {
    "pk": 33, "fields": { "postcode": 2005, "wilaya": 2, "name": "Tadjna" },
    "id": 59,
    "commune_name_ascii": "Tadjena",
    "commune_name": "تاجنة",
    "daira_name_ascii": "Abou El Hassane",
    "daira_name": "أبو الحسن",
    "wilaya_code": "2",
    "wilaya_name_ascii": "Chlef",
    "wilaya_name": "الشلف"
  },
  {
    "model": "base.commune",
    "pk": 51,
    "fields": {
      "postcode": 2023,
      "wilaya": 2,
      "name": "El Marsa"
    },
    "id": 43,
    "commune_name_ascii": "El Marsa",
    "commune_name": "المرسى",
    "daira_name_ascii": "El Marsa",
    "daira_name": "المرسى",
    "wilaya_code": "2",
    "wilaya_name_ascii": "Chlef",
    "wilaya_name": "الشلف"
  },
  {
    "model": "base.commune",
    "pk": 29,
    "fields": {
      "postcode": 2001,
      "wilaya": 2,
      "name": "Chlef"
    },
    "id": 39,
    "commune_name_ascii": "Chlef",
    "commune_name": "الشلف",
    "daira_name_ascii": "Chlef",
    "daira_name": "الشلف",
    "wilaya_code": "2",
    "wilaya_name_ascii": "Chlef",
    "wilaya_name": "الشلف"
  },
  {
    "model": "base.commune",
    "pk": 61,
    "fields": {
      "postcode": 2033,
      "wilaya": 2,
      "name": "Oum Drou"
    },
    "id": 54,
    "commune_name_ascii": "Oum Drou",
    "commune_name": "أم الدروع",
    "daira_name_ascii": "Chlef",
    "daira_name": "الشلف",
    "wilaya_code": "2",
    "wilaya_name_ascii": "Chlef",
    "wilaya_name": "الشلف"
  },
  {
    "model": "base.commune",
    "pk": 47,
    "fields": {
      "postcode": 2019,
      "wilaya": 2,
      "name": "Sendjas"
    },
    "id": 55,
    "commune_name_ascii": "Sendjas",
    "commune_name": "سنجاس",
    "daira_name_ascii": "Chlef",
    "daira_name": "الشلف",
    "wilaya_code": "2",
    "wilaya_name_ascii": "Chlef",
    "wilaya_name": "الشلف"
  },
  {
    "model": "base.commune",
    "pk": 53,
    "fields": {
      "postcode": 2025,
      "wilaya": 2,
      "name": "Sidi Abderrahmane"
    },
    "id": 56,
    "commune_name_ascii": "Sidi Abderrahmane",
    "commune_name": "سيدي عبد الرحمن",
    "daira_name_ascii": "Tenes",
    "daira_name": "تنس",
    "wilaya_code": "2",
    "wilaya_name_ascii": "Chlef",
    "wilaya_name": "الشلف"
  },
  {
    "id": 57,
    "commune_name_ascii": "Sidi Akkacha",
    "commune_name": "سيدي عكاشة",
    "daira_name_ascii": "Tenes",
    "daira_name": "تنس",
    "wilaya_code": "2",
    "wilaya_name_ascii": "Chlef",
    "wilaya_name": "الشلف"
  },
  {
    "model": "base.commune",
    "pk": 30,
    "fields": {
      "postcode": 2002,
      "wilaya": 2,
      "name": "Tenes"
    },
    "id": 62,
    "commune_name_ascii": "Tenes",
    "commune_name": "تنس",
    "daira_name_ascii": "Tenes",
    "daira_name": "تنس",
    "wilaya_code": "2",
    "wilaya_name_ascii": "Chlef",
    "wilaya_name": "الشلف"
  },
  {
    /**هادي مكانش في مايسترو */
    "id": 32,
    "commune_name_ascii": "Beni  Bouattab",
    "commune_name": "بني بوعتاب",
    "daira_name_ascii": "El Karimia",
    "daira_name": "الكريمية",
    "wilaya_code": "2",
    "wilaya_name_ascii": "Chlef",
    "wilaya_name": "الشلف"
  },
  {
    "model": "base.commune",
    "pk": 32,
    "fields": {
      "postcode": 2004,
      "wilaya": 2,
      "name": "El Karimia"
    },
    "id": 42,
    "commune_name_ascii": "El Karimia",
    "commune_name": "الكريمية",
    "daira_name_ascii": "El Karimia",
    "daira_name": "الكريمية",
    "wilaya_code": "2",
    "wilaya_name_ascii": "Chlef",
    "wilaya_name": "الشلف"
  },
  {
    "model": "base.commune",
    "pk": 37,
    "fields": {
      "postcode": 2009,
      "wilaya": 2,
      "name": "Harchoun"
    },
    "id": 44,
    "commune_name_ascii": "Harchoun",
    "commune_name": "حرشون",
    "daira_name_ascii": "El Karimia",
    "daira_name": "الكريمية",
    "wilaya_code": "2",
    "wilaya_name_ascii": "Chlef",
    "wilaya_name": "الشلف"
  },
  {
    "pk": 59, "fields": { "postcode": 2031, "wilaya": 2, "name": "Bouzghaia" },
    "id": 36,
    "commune_name_ascii": "Bouzeghaia",
    "commune_name": "بوزغاية",
    "daira_name_ascii": "Zeboudja",
    "daira_name": "الزبوجة",
    "wilaya_code": "2",
    "wilaya_name_ascii": "Chlef",
    "wilaya_name": "الشلف"
  },
  {
    "pk": 34, "fields": { "postcode": 2006, "wilaya": 2, "name": "Taougrite" },
    "id": 61,
    "commune_name_ascii": "Taougrit",
    "commune_name": "تاوقريت",
    "daira_name_ascii": "Taougrit",
    "daira_name": "تاوقريت",
    "wilaya_code": "2",
    "wilaya_name_ascii": "Chlef",
    "wilaya_name": "الشلف"
  },
  {
    "model": "base.commune",
    "pk": 35,
    "fields": {
      "postcode": 2007,
      "wilaya": 2,
      "name": "Beni Haoua"
    },
    "id": 33,
    "commune_name_ascii": "Beni Haoua",
    "commune_name": "بني حواء",
    "daira_name_ascii": "Beni Haoua",
    "daira_name": "بني حواء",
    "wilaya_code": "2",
    "wilaya_name_ascii": "Chlef",
    "wilaya_name": "الشلف"
  },
  {
    "pk": 50, "fields": { "postcode": 2022, "wilaya": 2, "name": "Abou El Hassen" },
    "id": 29,
    "commune_name_ascii": "Abou El Hassane",
    "commune_name": "أبو الحسن",
    "daira_name_ascii": "Abou El Hassane",
    "daira_name": "أبو الحسن",
    "wilaya_code": "2",
    "wilaya_name_ascii": "Chlef",
    "wilaya_name": "الشلف"
  },
  {
    "model": "base.commune",
    "pk": 44,
    "fields": {
      "postcode": 2016,
      "wilaya": 2,
      "name": "Oued Goussine"
    },
    "id": 49,
    "commune_name_ascii": "Oued Goussine",
    "commune_name": "وادي قوسين",
    "daira_name_ascii": "Beni Haoua",
    "daira_name": "بني حواء",
    "wilaya_code": "2",
    "wilaya_name_ascii": "Chlef",
    "wilaya_name": "الشلف"
  },
  {
    "model": "base.commune",
    "pk": 52,
    "fields": {
      "postcode": 2024,
      "wilaya": 2,
      "name": "Chettia"
    },
    "id": 38,
    "commune_name_ascii": "Chettia",
    "commune_name": "الشطية",
    "daira_name_ascii": "Ouled Fares",
    "daira_name": "أولاد فارس",
    "wilaya_code": "2",
    "wilaya_name_ascii": "Chlef",
    "wilaya_name": "الشلف"
  },
  {
    "model": "base.commune",
    "pk": 54,
    "fields": {
      "postcode": 2026,
      "wilaya": 2,
      "name": "Moussadek"
    },
    "id": 47,
    "commune_name_ascii": "Moussadek",
    "commune_name": "مصدق",
    "daira_name_ascii": "El Marsa",
    "daira_name": "المرسى",
    "wilaya_code": "2",
    "wilaya_name_ascii": "Chlef",
    "wilaya_name": "الشلف"
  },
  {
    "model": "base.commune",
    "pk": 38,
    "fields": {
      "postcode": 2010,
      "wilaya": 2,
      "name": "Ouled Fares"
    },
    "id": 53,
    "commune_name_ascii": "Ouled Fares",
    "commune_name": "أولاد فارس",
    "daira_name_ascii": "Ouled Fares",
    "daira_name": "أولاد فارس",
    "wilaya_code": "2",
    "wilaya_name_ascii": "Chlef",
    "wilaya_name": "الشلف"
  },
  {
    "model": "base.commune",
    "pk": 40,
    "fields": {
      "postcode": 2012,
      "wilaya": 2,
      "name": "Boukadir"
    },
    "id": 35,
    "commune_name_ascii": "Boukadir",
    "commune_name": "بوقادير",
    "daira_name_ascii": "Boukadir",
    "daira_name": "بوقادير",
    "wilaya_code": "2",
    "wilaya_name_ascii": "Chlef",
    "wilaya_name": "الشلف"
  },
  {
    "model": "base.commune",
    "pk": 49,
    "fields": {
      "postcode": 2021,
      "wilaya": 2,
      "name": "Oued Sly"
    },
    "id": 50,
    "commune_name_ascii": "Oued Sly",
    "commune_name": "وادي سلي",
    "daira_name_ascii": "Boukadir",
    "daira_name": "بوقادير",
    "wilaya_code": "2",
    "wilaya_name_ascii": "Chlef",
    "wilaya_name": "الشلف"
  },
  {
    "model": "base.commune",
    "pk": 36,
    "fields": {
      "postcode": 2008,
      "wilaya": 2,
      "name": "Sobha"
    },
    "id": 58,
    "commune_name_ascii": "Sobha",
    "commune_name": "الصبحة",
    "daira_name_ascii": "Boukadir",
    "daira_name": "بوقادير",
    "wilaya_code": "2",
    "wilaya_name_ascii": "Chlef",
    "wilaya_name": "الشلف"
  },
  {
    "model": "base.commune",
    "pk": 31,
    "fields": {
      "postcode": 2003,
      "wilaya": 2,
      "name": "Benairia"
    },
    "id": 31,
    "commune_name_ascii": "Benairia",
    "commune_name": "بنايرية",
    "daira_name_ascii": "Zeboudja",
    "daira_name": "الزبوجة",
    "wilaya_code": "2",
    "wilaya_name_ascii": "Chlef",
    "wilaya_name": "الشلف"
  },
  {
    "model": "base.commune",
    "pk": 56,
    "fields": {
      "postcode": 2028,
      "wilaya": 2,
      "name": "Labiod Medjadja"
    },
    "id": 46,
    "commune_name_ascii": "Labiod Medjadja",
    "commune_name": "الأبيض مجاجة",
    "daira_name_ascii": "Ouled Fares",
    "daira_name": "أولاد فارس",
    "wilaya_code": "2",
    "wilaya_name_ascii": "Chlef",
    "wilaya_name": "الشلف"
  },
  {
    "model": "base.commune",
    "pk": 45,
    "fields": {
      "postcode": 2017,
      "wilaya": 2,
      "name": "Dahra"
    },
    "id": 40,
    "commune_name_ascii": "Dahra",
    "commune_name": "الظهرة",
    "daira_name_ascii": "Taougrit",
    "daira_name": "تاوقريت",
    "wilaya_code": "2",
    "wilaya_name_ascii": "Chlef",
    "wilaya_name": "الشلف"
  },
  {
    "pk": 75, "fields": { "postcode": 3012, "wilaya": 3, "name": "Beidha" },
    "id": 67,
    "commune_name_ascii": "El Beidha",
    "commune_name": "البيضاء",
    "daira_name_ascii": "Gueltat Sidi Saad",
    "daira_name": "قتلة سيدي سعيد",
    "wilaya_code": "3",
    "wilaya_name_ascii": "Laghouat",
    "wilaya_name": "الأغواط"
  },
  {
    "model": "base.commune",
    "pk": 73,
    "fields": {
      "postcode": 3010,
      "wilaya": 3,
      "name": "Gueltat Sidi Saad"
    },
    "id": 73,
    "commune_name_ascii": "Gueltat Sidi Saad",
    "commune_name": "قلتة سيدي سعد",
    "daira_name_ascii": "Gueltat Sidi Saad",
    "daira_name": "قتلة سيدي سعيد",
    "wilaya_code": "3",
    "wilaya_name_ascii": "Laghouat",
    "wilaya_name": "الأغواط"
  },
  {
    "model": "base.commune",
    "pk": 76,
    "fields": {
      "postcode": 3013,
      "wilaya": 3,
      "name": "Brida"
    },
    "id": 69,
    "commune_name_ascii": "Brida",
    "commune_name": "بريدة",
    "daira_name_ascii": "Brida",
    "daira_name": "بريدة",
    "wilaya_code": "3",
    "wilaya_name_ascii": "Laghouat",
    "wilaya_name": "الأغواط"
  },
  {
    "model": "base.commune",
    "pk": 74,
    "fields": {
      "postcode": 3011,
      "wilaya": 3,
      "name": "Ain Sidi Ali"
    },
    "id": 66,
    "commune_name_ascii": "Ain Sidi Ali",
    "commune_name": "عين سيدي علي",
    "daira_name_ascii": "Gueltat Sidi Saad",
    "daira_name": "قتلة سيدي سعيد",
    "wilaya_code": "3",
    "wilaya_name_ascii": "Laghouat",
    "wilaya_name": "الأغواط"
  },
  {
    "pk": 71, "fields": { "postcode": 3008, "wilaya": 3, "name": "Tadjmout" },
    "id": 85,
    "commune_name_ascii": "Tadjemout",
    "commune_name": "تاجموت",
    "daira_name_ascii": "Ain Madhi",
    "daira_name": "عين ماضي",
    "wilaya_code": "3",
    "wilaya_name_ascii": "Laghouat",
    "wilaya_name": "الأغواط"
  },
  {
    "model": "base.commune",
    "pk": 78,
    "fields": {
      "postcode": 3015,
      "wilaya": 3,
      "name": "Hadj Mechri"
    },
    "id": 74,
    "commune_name_ascii": "Hadj Mechri",
    "commune_name": "الحاج مشري",
    "daira_name_ascii": "Brida",
    "daira_name": "بريدة",
    "wilaya_code": "3",
    "wilaya_name_ascii": "Laghouat",
    "wilaya_name": "الأغواط"
  },
  {
    "model": "base.commune",
    "pk": 80,
    "fields": {
      "postcode": 3017,
      "wilaya": 3,
      "name": "Taouiala"
    },
    "id": 87,
    "commune_name_ascii": "Taouiala",
    "commune_name": "تاويالة",
    "daira_name_ascii": "Brida",
    "daira_name": "بريدة",
    "wilaya_code": "3",
    "wilaya_name_ascii": "Laghouat",
    "wilaya_name": "الأغواط"
  },
  {
    "model": "base.commune",
    "pk": 77,
    "fields": {
      "postcode": 3014,
      "wilaya": 3,
      "name": "El Ghicha"
    },
    "id": 71,
    "commune_name_ascii": "El Ghicha",
    "commune_name": "الغيشة",
    "daira_name_ascii": "El Ghicha",
    "daira_name": "الغيشة",
    "wilaya_code": "3",
    "wilaya_name_ascii": "Laghouat",
    "wilaya_name": "الأغواط"
  },
  {
    "model": "base.commune",
    "pk": 81,
    "fields": {
      "postcode": 3018,
      "wilaya": 3,
      "name": "Tadjrouna"
    },
    "id": 86,
    "commune_name_ascii": "Tadjrouna",
    "commune_name": "تاجرونة",
    "daira_name_ascii": "Ain Madhi",
    "daira_name": "عين ماضي",
    "wilaya_code": "3",
    "wilaya_name_ascii": "Laghouat",
    "wilaya_name": "الأغواط"
  },
  {
    "model": "base.commune",
    "pk": 79,
    "fields": {
      "postcode": 3016,
      "wilaya": 3,
      "name": "Sebgag"
    },
    "id": 82,
    "commune_name_ascii": "Sebgag",
    "commune_name": "سبقاق",
    "daira_name_ascii": "Aflou",
    "daira_name": "أفلو",
    "wilaya_code": "3",
    "wilaya_name_ascii": "Laghouat",
    "wilaya_name": "الأغواط"
  },
  {
    "model": "base.commune",
    "pk": 87,
    "fields": {
      "postcode": 3024,
      "wilaya": 3,
      "name": "Sidi Bouzid"
    },
    "id": 83,
    "commune_name_ascii": "Sidi Bouzid",
    "commune_name": "سيدي بوزيد",
    "daira_name_ascii": "Aflou",
    "daira_name": "أفلو",
    "wilaya_code": "3",
    "wilaya_name_ascii": "Laghouat",
    "wilaya_name": "الأغواط"
  },
  {
    "model": "base.commune",
    "pk": 84,
    "fields": {
      "postcode": 3021,
      "wilaya": 3,
      "name": "Oued Morra"
    },
    "id": 80,
    "commune_name_ascii": "Oued Morra",
    "commune_name": "وادي مرة",
    "daira_name_ascii": "Oued Morra",
    "daira_name": "وادي مرة",
    "wilaya_code": "3",
    "wilaya_name_ascii": "Laghouat",
    "wilaya_name": "الأغواط"
  },
  {
    "model": "base.commune",
    "pk": 64,
    "fields": {
      "postcode": 3001,
      "wilaya": 3,
      "name": "Laghouat"
    },
    "id": 79,
    "commune_name_ascii": "Laghouat",
    "commune_name": "الأغواط",
    "daira_name_ascii": "Laghouat",
    "daira_name": "الأغواط",
    "wilaya_code": "3",
    "wilaya_name_ascii": "Laghouat",
    "wilaya_name": "الأغواط"
  },
  {
    "pk": 85, "fields": { "postcode": 3022, "wilaya": 3, "name": "Oued M Zi" },
    "id": 81,
    "commune_name_ascii": "Oued M'zi",
    "commune_name": "وادي مزي",
    "daira_name_ascii": "Oued Morra",
    "daira_name": "وادي مرة",
    "wilaya_code": "3",
    "wilaya_name_ascii": "Laghouat",
    "wilaya_name": "الأغواط"
  },
  {
    "model": "base.commune",
    "pk": 65,
    "fields": {
      "postcode": 3002,
      "wilaya": 3,
      "name": "Ksar El Hirane"
    },
    "id": 78,
    "commune_name_ascii": "Ksar El Hirane",
    "commune_name": "قصر الحيران",
    "daira_name_ascii": "Ksar El Hirane",
    "daira_name": "قصر الحيران",
    "wilaya_code": "3",
    "wilaya_name_ascii": "Laghouat",
    "wilaya_name": "الأغواط"
  },
  {
    "model": "base.commune",
    "pk": 83,
    "fields": {
      "postcode": 3020,
      "wilaya": 3,
      "name": "El Assafia"
    },
    "id": 70,
    "commune_name_ascii": "El Assafia",
    "commune_name": "العسافية",
    "daira_name_ascii": "Sidi Makhlouf",
    "daira_name": "سيدي مخلوف",
    "wilaya_code": "3",
    "wilaya_name_ascii": "Laghouat",
    "wilaya_name": "الأغواط"
  },
  {
    "model": "base.commune",
    "pk": 67,
    "fields": {
      "postcode": 3004,
      "wilaya": 3,
      "name": "Sidi Makhlouf"
    },
    "id": 84,
    "commune_name_ascii": "Sidi Makhlouf",
    "commune_name": "سيدي مخلوف",
    "daira_name_ascii": "Sidi Makhlouf",
    "daira_name": "سيدي مخلوف",
    "wilaya_code": "3",
    "wilaya_name_ascii": "Laghouat",
    "wilaya_name": "الأغواط"
  },
  {
    "model": "base.commune",
    "pk": 68,
    "fields": {
      "postcode": 3005,
      "wilaya": 3,
      "name": "Hassi Delaa"
    },
    "id": 75,
    "commune_name_ascii": "Hassi Delaa",
    "commune_name": "حاسي الدلاعة",
    "daira_name_ascii": "Hassi R'mel",
    "daira_name": "حاسي الرمل",
    "wilaya_code": "3",
    "wilaya_name_ascii": "Laghouat",
    "wilaya_name": "الأغواط"
  },
  {
    "pk": 69, "fields": { "postcode": 3006, "wilaya": 3, "name": "Hassi R Mel" },
    "id": 76,
    "commune_name_ascii": "Hassi R'mel",
    "commune_name": "حاسي الرمل",
    "daira_name_ascii": "Hassi R'mel",
    "daira_name": "حاسي الرمل",
    "wilaya_code": "3",
    "wilaya_name_ascii": "Laghouat",
    "wilaya_name": "الأغواط"
  },
  {
    "pk": 70 ,"fields": {  "postcode": 3007 , "wilaya":   3, "name": "Ain Mahdi" },
    "id": 65,
    "commune_name_ascii": "Ain Madhi",
    "commune_name": "عين ماضي",
    "daira_name_ascii": "Ain Madhi",
    "daira_name": "عين ماضي",
    "wilaya_code": "3",
    "wilaya_name_ascii": "Laghouat",
    "wilaya_name": "الأغواط"
  },
  {
    "model": "base.commune",
    "pk": 86,
    "fields": {
      "postcode": 3023,
      "wilaya": 3,
      "name": "El Haouaita"
    },
    "id": 72,
    "commune_name_ascii": "El Haouaita",
    "commune_name": "الحويطة",
    "daira_name_ascii": "Ain Madhi",
    "daira_name": "عين ماضي",
    "wilaya_code": "3",
    "wilaya_name_ascii": "Laghouat",
    "wilaya_name": "الأغواط"
  },
  {
    "model": "base.commune",
    "pk": 72,
    "fields": {
      "postcode": 3009,
      "wilaya": 3,
      "name": "Kheneg"
    },
    "id": 77,
    "commune_name_ascii": "Kheneg",
    "commune_name": "الخنق",
    "daira_name_ascii": "Ain Madhi",
    "daira_name": "عين ماضي",
    "wilaya_code": "3",
    "wilaya_name_ascii": "Laghouat",
    "wilaya_name": "الأغواط"
  },
  {
    "pk": 66 ,"fields": {  "postcode": 3003 , "wilaya":   3, "name": "Benacer Ben Chohra" },
    "id": 68,
    "commune_name_ascii": "Benacer Benchohra",
    "commune_name": "بن ناصر بن شهرة",
    "daira_name_ascii": "Ksar El Hirane",
    "daira_name": "قصر الحيران",
    "wilaya_code": "3",
    "wilaya_name_ascii": "Laghouat",
    "wilaya_name": "الأغواط"
  },
  {
    "model": "base.commune",
    "pk": 82,
    "fields": {
      "postcode": 3019,
      "wilaya": 3,
      "name": "Aflou"
    },
    "id": 64,
    "commune_name_ascii": "Aflou",
    "commune_name": "أفلو",
    "daira_name_ascii": "Aflou",
    "daira_name": "أفلو",
    "wilaya_code": "3",
    "wilaya_name_ascii": "Laghouat",
    "wilaya_name": "الأغواط"
  },
  {
    "model": "base.commune",
    "pk": 103,
    "fields": {
      "postcode": 4016,
      "wilaya": 4,
      "name": "Fkirina"
    },
    "id": 104,
    "commune_name_ascii": "Fkirina",
    "commune_name": "فكيرينة",
    "daira_name_ascii": "F'kirina",
    "daira_name": "فكيرينة",
    "wilaya_code": "4",
    "wilaya_name_ascii": "Oum El Bouaghi",
    "wilaya_name": "أم البواقي"
  },
  {
    "pk": 106 ,"fields": {  "postcode": 4019 , "wilaya":   4, "name": "El Fedjoudj Boughrar" },
    "id": 102,
    "commune_name_ascii": "El Fedjoudj Boughrara Sa",
    "commune_name": "الفجوج بوغرارة سعودي",
    "daira_name_ascii": "Ain Fekroun",
    "daira_name": "عين فكرون",
    "wilaya_code": "4",
    "wilaya_name_ascii": "Oum El Bouaghi",
    "wilaya_name": "أم البواقي"
  },
  {
    "pk": 112 ,"fields": {  "postcode": 4025 , "wilaya":   4, "name": "Ain Fekroune" },
    "id": 91,
    "commune_name_ascii": "Ain Fekroun",
    "commune_name": "عين فكرون",
    "daira_name_ascii": "Ain Fekroun",
    "daira_name": "عين فكرون",
    "wilaya_code": "4",
    "wilaya_name_ascii": "Oum El Bouaghi",
    "wilaya_name": "أم البواقي"
  },
  {
    "model": "base.commune",
    "pk": 113,
    "fields": {
      "postcode": 4026,
      "wilaya": 4,
      "name": "Rahia"
    },
    "id": 113,
    "commune_name_ascii": "Rahia",
    "commune_name": "الرحية",
    "daira_name_ascii": "Meskiana",
    "daira_name": "مسكيانة",
    "wilaya_code": "4",
    "wilaya_name_ascii": "Oum El Bouaghi",
    "wilaya_name": "أم البواقي"
  },
  {
    "model": "base.commune",
    "pk": 111,
    "fields": {
      "postcode": 4024,
      "wilaya": 4,
      "name": "Meskiana"
    },
    "id": 107,
    "commune_name_ascii": "Meskiana",
    "commune_name": "مسكيانة",
    "daira_name_ascii": "Meskiana",
    "daira_name": "مسكيانة",
    "wilaya_code": "4",
    "wilaya_name_ascii": "Oum El Bouaghi",
    "wilaya_name": "أم البواقي"
  },
  {
    "model": "base.commune",
    "pk": 94,
    "fields": {
      "postcode": 4007,
      "wilaya": 4,
      "name": "El Belala"
    },
    "id": 100,
    "commune_name_ascii": "El Belala",
    "commune_name": "البلالة",
    "daira_name_ascii": "Meskiana",
    "daira_name": "مسكيانة",
    "wilaya_code": "4",
    "wilaya_name_ascii": "Oum El Bouaghi",
    "wilaya_name": "أم البواقي"
  },
  {
    "model": "base.commune",
    "pk": 91,
    "fields": {
      "postcode": 4004,
      "wilaya": 4,
      "name": "Behir Chergui"
    },
    "id": 95,
    "commune_name_ascii": "Behir Chergui",
    "commune_name": "بحير الشرقي",
    "daira_name_ascii": "Meskiana",
    "daira_name": "مسكيانة",
    "wilaya_code": "4",
    "wilaya_name_ascii": "Oum El Bouaghi",
    "wilaya_name": "أم البواقي"
  },
  {
    "model": "base.commune",
    "pk": 109,
    "fields": {
      "postcode": 4022,
      "wilaya": 4,
      "name": "Ksar Sbahi"
    },
    "id": 106,
    "commune_name_ascii": "Ksar Sbahi",
    "commune_name": "قصر الصباحي",
    "daira_name_ascii": "Ksar Sbahi",
    "daira_name": "قصر الصباحي",
    "wilaya_code": "4",
    "wilaya_name_ascii": "Oum El Bouaghi",
    "wilaya_name": "أم البواقي"
  },
  {
    "model": "base.commune",
    "pk": 104,
    "fields": {
      "postcode": 4017,
      "wilaya": 4,
      "name": "Souk Naamane"
    },
    "id": 115,
    "commune_name_ascii": "Souk Naamane",
    "commune_name": "سوق نعمان",
    "daira_name_ascii": "Souk Naamane",
    "daira_name": "سوق نعمان",
    "wilaya_code": "4",
    "wilaya_name_ascii": "Oum El Bouaghi",
    "wilaya_name": "أم البواقي"
  },
  {
    "model": "base.commune",
    "pk": 107,
    "fields": {
      "postcode": 4020,
      "wilaya": 4,
      "name": "Ouled Zouai"
    },
    "id": 111,
    "commune_name_ascii": "Ouled Zouai",
    "commune_name": "أولاد زواي",
    "daira_name_ascii": "Souk Naamane",
    "daira_name": "سوق نعمان",
    "wilaya_code": "4",
    "wilaya_name_ascii": "Oum El Bouaghi",
    "wilaya_name": "أم البواقي"
  },
  {
    "model": "base.commune",
    "pk": 88,
    "fields": {
      "postcode": 4001,
      "wilaya": 4,
      "name": "Oum El Bouaghi"
    },
    "id": 112,
    "commune_name_ascii": "Oum El Bouaghi",
    "commune_name": "أم البواقي",
    "daira_name_ascii": "Oum El Bouaghi",
    "daira_name": "أم البواقي",
    "wilaya_code": "4",
    "wilaya_name_ascii": "Oum El Bouaghi",
    "wilaya_name": "أم البواقي"
  },
  {
    "model": "base.commune",
    "pk": 95,
    "fields": {
      "postcode": 4008,
      "wilaya": 4,
      "name": "Ain Babouche"
    },
    "id": 88,
    "commune_name_ascii": "Ain Babouche",
    "commune_name": "عين ببوش",
    "daira_name_ascii": "Ain Babouche",
    "daira_name": "عين ببوش",
    "wilaya_code": "4",
    "wilaya_name_ascii": "Oum El Bouaghi",
    "wilaya_name": "أم البواقي"
  },
  {
    "model": "base.commune",
    "pk": 114,
    "fields": {
      "postcode": 4027,
      "wilaya": 4,
      "name": "Ain Zitoun"
    },
    "id": 94,
    "commune_name_ascii": "Ain Zitoun",
    "commune_name": "عين الزيتون",
    "daira_name_ascii": "Oum El Bouaghi",
    "daira_name": "أم البواقي",
    "wilaya_code": "4",
    "wilaya_name_ascii": "Oum El Bouaghi",
    "wilaya_name": "أم البواقي"
  },
  {
    "model": "base.commune",
    "pk": 108,
    "fields": {
      "postcode": 4021,
      "wilaya": 4,
      "name": "Bir Chouhada"
    },
    "id": 97,
    "commune_name_ascii": "Bir Chouhada",
    "commune_name": "بئر الشهداء",
    "daira_name_ascii": "Souk Naamane",
    "daira_name": "سوق نعمان",
    "wilaya_code": "4",
    "wilaya_name_ascii": "Oum El Bouaghi",
    "wilaya_name": "أم البواقي"
  },
  {
    "model": "base.commune",
    "pk": 89,
    "fields": {
      "postcode": 4002,
      "wilaya": 4,
      "name": "Ain Beida"
    },
    "id": 89,
    "commune_name_ascii": "Ain Beida",
    "commune_name": "عين البيضاء",
    "daira_name_ascii": "Ain Beida",
    "daira_name": "عين البيضاء",
    "wilaya_code": "4",
    "wilaya_name_ascii": "Oum El Bouaghi",
    "wilaya_name": "أم البواقي"
  },
  {
    "model": "base.commune",
    "pk": 96,
    "fields": {
      "postcode": 4009,
      "wilaya": 4,
      "name": "Berriche"
    },
    "id": 96,
    "commune_name_ascii": "Berriche",
    "commune_name": "بريش",
    "daira_name_ascii": "Ain Beida",
    "daira_name": "عين البيضاء",
    "wilaya_code": "4",
    "wilaya_name_ascii": "Oum El Bouaghi",
    "wilaya_name": "أم البواقي"
  },
  {
    "model": "base.commune",
    "pk": 105,
    "fields": {
      "postcode": 4018,
      "wilaya": 4,
      "name": "Zorg"
    },
    "id": 116,
    "commune_name_ascii": "Zorg",
    "commune_name": "الزرق",
    "daira_name_ascii": "Ain Beida",
    "daira_name": "عين البيضاء",
    "wilaya_code": "4",
    "wilaya_name_ascii": "Oum El Bouaghi",
    "wilaya_name": "أم البواقي"
  },
  {
    "pk": 90 ,"fields": {  "postcode": 4003 , "wilaya":   4, "name": "Ainmlila" },
    "id": 93,
    "commune_name_ascii": "Ain M'lila",
    "commune_name": "عين مليلة",
    "daira_name_ascii": "Ain M'lila",
    "daira_name": "عين مليلة",
    "wilaya_code": "4",
    "wilaya_name_ascii": "Oum El Bouaghi",
    "wilaya_name": "أم البواقي"
  },
  {
    "model": "base.commune",
    "pk": 115,
    "fields": {
      "postcode": 4028,
      "wilaya": 4,
      "name": "Ouled Gacem"
    },
    "id": 109,
    "commune_name_ascii": "Ouled Gacem",
    "commune_name": "أولاد قاسم",
    "daira_name_ascii": "Ain M'lila",
    "daira_name": "عين مليلة",
    "wilaya_code": "4",
    "wilaya_name_ascii": "Oum El Bouaghi",
    "wilaya_name": "أم البواقي"
  },
  {
    "model": "base.commune",
    "pk": 97,
    "fields": {
      "postcode": 4010,
      "wilaya": 4,
      "name": "Ouled Hamla"
    },
    "id": 110,
    "commune_name_ascii": "Ouled Hamla",
    "commune_name": "أولاد حملة",
    "daira_name_ascii": "Ain M'lila",
    "daira_name": "عين مليلة",
    "wilaya_code": "4",
    "wilaya_name_ascii": "Oum El Bouaghi",
    "wilaya_name": "أم البواقي"
  },
  {
    "model": "base.commune",
    "pk": 92,
    "fields": {
      "postcode": 4005,
      "wilaya": 4,
      "name": "El Amiria"
    },
    "id": 99,
    "commune_name_ascii": "El Amiria",
    "commune_name": "العامرية",
    "daira_name_ascii": "Sigus",
    "daira_name": "سيقوس",
    "wilaya_code": "4",
    "wilaya_name_ascii": "Oum El Bouaghi",
    "wilaya_name": "أم البواقي"
  },
  {
    "model": "base.commune",
    "pk": 93,
    "fields": {
      "postcode": 4006,
      "wilaya": 4,
      "name": "Sigus"
    },
    "id": 114,
    "commune_name_ascii": "Sigus",
    "commune_name": "سيقوس",
    "daira_name_ascii": "Sigus",
    "daira_name": "سيقوس",
    "wilaya_code": "4",
    "wilaya_name_ascii": "Oum El Bouaghi",
    "wilaya_name": "أم البواقي"
  },
  {
    "model": "base.commune",
    "pk": 110,
    "fields": {
      "postcode": 4023,
      "wilaya": 4,
      "name": "Oued Nini"
    },
    "id": 108,
    "commune_name_ascii": "Oued Nini",
    "commune_name": "وادي نيني",
    "daira_name_ascii": "F'kirina",
    "daira_name": "فكيرينة",
    "wilaya_code": "4",
    "wilaya_name_ascii": "Oum El Bouaghi",
    "wilaya_name": "أم البواقي"
  },
  {
    "model": "base.commune",
    "pk": 102,
    "fields": {
      "postcode": 4015,
      "wilaya": 4,
      "name": "Ain Diss"
    },
    "id": 90,
    "commune_name_ascii": "Ain Diss",
    "commune_name": "عين الديس",
    "daira_name_ascii": "Ain Babouche",
    "daira_name": "عين ببوش",
    "wilaya_code": "4",
    "wilaya_name_ascii": "Oum El Bouaghi",
    "wilaya_name": "أم البواقي"
  },
  {
    "pk": 98 ,"fields": {  "postcode": 4011 , "wilaya":   4, "name": "Dhala" },
    "id": 98,
    "commune_name_ascii": "Dhalaa",
    "commune_name": "الضلعة",
    "daira_name_ascii": "Dhalaa",
    "daira_name": "الضلعة",
    "wilaya_code": "4",
    "wilaya_name_ascii": "Oum El Bouaghi",
    "wilaya_name": "أم البواقي"
  },
  {
    "model": "base.commune",
    "pk": 101,
    "fields": {
      "postcode": 4014,
      "wilaya": 4,
      "name": "El Djazia"
    },
    "id": 101,
    "commune_name_ascii": "El Djazia",
    "commune_name": "الجازية",
    "daira_name_ascii": "Dhalaa",
    "daira_name": "الضلعة",
    "wilaya_code": "4",
    "wilaya_name_ascii": "Oum El Bouaghi",
    "wilaya_name": "أم البواقي"
  },
  {
    "model": "base.commune",
    "pk": 99,
    "fields": {
      "postcode": 4012,
      "wilaya": 4,
      "name": "Ain Kercha"
    },
    "id": 92,
    "commune_name_ascii": "Ain Kercha",
    "commune_name": "عين كرشة",
    "daira_name_ascii": "Ain Kercha",
    "daira_name": "عين كرشة",
    "wilaya_code": "4",
    "wilaya_name_ascii": "Oum El Bouaghi",
    "wilaya_name": "أم البواقي"
  },
  {
    "model": "base.commune",
    "pk": 116,
    "fields": {
      "postcode": 4029,
      "wilaya": 4,
      "name": "El Harmilia"
    },
    "id": 103,
    "commune_name_ascii": "El Harmilia",
    "commune_name": "الحرملية",
    "daira_name_ascii": "Ain Kercha",
    "daira_name": "عين كرشة",
    "wilaya_code": "4",
    "wilaya_name_ascii": "Oum El Bouaghi",
    "wilaya_name": "أم البواقي"
  },
  {
    "model": "base.commune",
    "pk": 100,
    "fields": {
      "postcode": 4013,
      "wilaya": 4,
      "name": "Hanchir Toumghani"
    },
    "id": 105,
    "commune_name_ascii": "Hanchir Toumghani",
    "commune_name": "هنشير تومغني",
    "daira_name_ascii": "Ain Kercha",
    "daira_name": "عين كرشة",
    "wilaya_code": "4",
    "wilaya_name_ascii": "Oum El Bouaghi",
    "wilaya_name": "أم البواقي"
  },
  {
    "model": "base.commune",
    "pk": 119,
    "fields": {
      "postcode": 5003,
      "wilaya": 5,
      "name": "Maafa"
    },
    "id": 150,
    "commune_name_ascii": "Maafa",
    "commune_name": "معافة",
    "daira_name_ascii": "Ain Touta",
    "daira_name": "عين التوتة",
    "wilaya_code": "5",
    "wilaya_name_ascii": "Batna",
    "wilaya_name": "باتنة"
  },
  {
    "model": "base.commune",
    "pk": 155,
    "fields": {
      "postcode": 5039,
      "wilaya": 5,
      "name": "Gosbat"
    },
    "id": 139,
    "commune_name_ascii": "Gosbat",
    "commune_name": "القصبات",
    "daira_name_ascii": "Ras El Aioun",
    "daira_name": "رأس العيون",
    "wilaya_code": "5",
    "wilaya_name_ascii": "Batna",
    "wilaya_name": "باتنة"
  },
  {
    "model": "base.commune",
    "pk": 166,
    "fields": {
      "postcode": 5050,
      "wilaya": 5,
      "name": "Timgad"
    },
    "id": 176,
    "commune_name_ascii": "Timgad",
    "commune_name": "تيمقاد",
    "daira_name_ascii": "Timgad",
    "daira_name": "تيمقاد",
    "wilaya_code": "5",
    "wilaya_name_ascii": "Batna",
    "wilaya_name": "باتنة"
  },
  {
    "model": "base.commune",
    "pk": 154,
    "fields": {
      "postcode": 5038,
      "wilaya": 5,
      "name": "Taxlent"
    },
    "id": 170,
    "commune_name_ascii": "Taxlent",
    "commune_name": "تاكسلانت",
    "daira_name_ascii": "Ouled Si Slimane",
    "daira_name": "أولاد سي سليمان",
    "wilaya_code": "5",
    "wilaya_name_ascii": "Batna",
    "wilaya_name": "باتنة"
  },
  {
    "model": "base.commune",
    "pk": 169,
    "fields": {
      "postcode": 5053,
      "wilaya": 5,
      "name": "Ouled Si Slimane"
    },
    "id": 161,
    "commune_name_ascii": "Ouled Si Slimane",
    "commune_name": "أولاد سي سليمان",
    "daira_name_ascii": "Ouled Si Slimane",
    "daira_name": "أولاد سي سليمان",
    "wilaya_code": "5",
    "wilaya_name_ascii": "Batna",
    "wilaya_name": "باتنة"
  },
  {
    "pk": 143 ,"fields": {  "postcode": 5027 , "wilaya":   5, "name": "Lemsane" },
    "id": 148,
    "commune_name_ascii": "Lemcene",
    "commune_name": "لمسان",
    "daira_name_ascii": "Ouled Si Slimane",
    "daira_name": "أولاد سي سليمان",
    "wilaya_code": "5",
    "wilaya_name_ascii": "Batna",
    "wilaya_name": "باتنة"
  },
  {
    "model": "base.commune",
    "pk": 150,
    "fields": {
      "postcode": 5034,
      "wilaya": 5,
      "name": "Talkhamt"
    },
    "id": 169,
    "commune_name_ascii": "Talkhamt",
    "commune_name": "تالخمت",
    "daira_name_ascii": "Ras El Aioun",
    "daira_name": "رأس العيون",
    "wilaya_code": "5",
    "wilaya_name_ascii": "Batna",
    "wilaya_name": "باتنة"
  },
  {
    "model": "base.commune",
    "pk": 167,
    "fields": {
      "postcode": 5051,
      "wilaya": 5,
      "name": "Ras El Aioun"
    },
    "id": 164,
    "commune_name_ascii": "Ras El Aioun",
    "commune_name": "رأس العيون",
    "daira_name_ascii": "Ras El Aioun",
    "daira_name": "رأس العيون",
    "wilaya_code": "5",
    "wilaya_name_ascii": "Batna",
    "wilaya_name": "باتنة"
  },
  {
    "model": "base.commune",
    "pk": 141,
    "fields": {
      "postcode": 5025,
      "wilaya": 5,
      "name": "Rahbat"
    },
    "id": 163,
    "commune_name_ascii": "Rahbat",
    "commune_name": "الرحبات",
    "daira_name_ascii": "Ras El Aioun",
    "daira_name": "رأس العيون",
    "wilaya_code": "5",
    "wilaya_name_ascii": "Batna",
    "wilaya_name": "باتنة"
  },
  {
    "pk": 136 ,"fields": {  "postcode": 5020 , "wilaya":   5, "name": "Ouled Selam" },
    "id": 160,
    "commune_name_ascii": "Ouled Sellem",
    "commune_name": "أولاد سلام",
    "daira_name_ascii": "Ras El Aioun",
    "daira_name": "رأس العيون",
    "wilaya_code": "5",
    "wilaya_name_ascii": "Batna",
    "wilaya_name": "باتنة"
  },
  {
    "model": "base.commune",
    "pk": 126,
    "fields": {
      "postcode": 5010,
      "wilaya": 5,
      "name": "Guigba"
    },
    "id": 140,
    "commune_name_ascii": "Guigba",
    "commune_name": "القيقبة",
    "daira_name_ascii": "Ras El Aioun",
    "daira_name": "رأس العيون",
    "wilaya_code": "5",
    "wilaya_name_ascii": "Batna",
    "wilaya_name": "باتنة"
  },
  {
    "model": "base.commune",
    "pk": 163,
    "fields": {
      "postcode": 5047,
      "wilaya": 5,
      "name": "Teniet El Abed"
    },
    "id": 172,
    "commune_name_ascii": "Teniet El Abed",
    "commune_name": "ثنية العابد",
    "daira_name_ascii": "Theniet El Abed",
    "daira_name": "ثنية العابد",
    "wilaya_code": "5",
    "wilaya_name_ascii": "Batna",
    "wilaya_name": "باتنة"
  },
  {
    "model": "base.commune",
    "pk": 117,
    "fields": {
      "postcode": 5001,
      "wilaya": 5,
      "name": "Batna"
    },
    "id": 123,
    "commune_name_ascii": "Batna",
    "commune_name": "باتنة",
    "daira_name_ascii": "Batna",
    "daira_name": "باتنة",
    "wilaya_code": "5",
    "wilaya_name_ascii": "Batna",
    "wilaya_name": "باتنة"
  },
  {
    "model": "base.commune",
    "pk": 139,
    "fields": {
      "postcode": 5023,
      "wilaya": 5,
      "name": "Fesdis"
    },
    "id": 136,
    "commune_name_ascii": "Fesdis",
    "commune_name": "فسديس",
    "daira_name_ascii": "Batna",
    "daira_name": "باتنة",
    "wilaya_code": "5",
    "wilaya_name_ascii": "Batna",
    "wilaya_name": "باتنة"
  },
  {
    "model": "base.commune",
    "pk": 153,
    "fields": {
      "postcode": 5037,
      "wilaya": 5,
      "name": "Oued Chaaba"
    },
    "id": 154,
    "commune_name_ascii": "Oued Chaaba",
    "commune_name": "وادي الشعبة",
    "daira_name_ascii": "Batna",
    "daira_name": "باتنة",
    "wilaya_code": "5",
    "wilaya_name_ascii": "Batna",
    "wilaya_name": "باتنة"
  },
  {
    "model": "base.commune",
    "pk": 162,
    "fields": {
      "postcode": 5046,
      "wilaya": 5,
      "name": "Hidoussa"
    },
    "id": 141,
    "commune_name_ascii": "Hidoussa",
    "commune_name": "حيدوسة",
    "daira_name_ascii": "Merouana",
    "daira_name": "مروانة",
    "wilaya_code": "5",
    "wilaya_name_ascii": "Batna",
    "wilaya_name": "باتنة"
  },
  {
    "pk": 144 ,"fields": {  "postcode": 5028 , "wilaya":   5, "name": "Ksar Belezma" },
    "id": 145,
    "commune_name_ascii": "Ksar Bellezma",
    "commune_name": "قصر بلزمة",
    "daira_name_ascii": "Merouana",
    "daira_name": "مروانة",
    "wilaya_code": "5",
    "wilaya_name_ascii": "Batna",
    "wilaya_name": "باتنة"
  },
  {
    "model": "base.commune",
    "pk": 120,
    "fields": {
      "postcode": 5004,
      "wilaya": 5,
      "name": "Merouana"
    },
    "id": 152,
    "commune_name_ascii": "Merouana",
    "commune_name": "مروانة",
    "daira_name_ascii": "Merouana",
    "daira_name": "مروانة",
    "wilaya_code": "5",
    "wilaya_name_ascii": "Batna",
    "wilaya_name": "باتنة"
  },
  {
    "model": "base.commune",
    "pk": 149,
    "fields": {
      "postcode": 5033,
      "wilaya": 5,
      "name": "Oued El Ma"
    },
    "id": 155,
    "commune_name_ascii": "Oued El Ma",
    "commune_name": "وادي الماء",
    "daira_name_ascii": "Merouana",
    "daira_name": "مروانة",
    "wilaya_code": "5",
    "wilaya_name_ascii": "Batna",
    "wilaya_name": "باتنة"
  },
  {
    "model": "base.commune",
    "pk": 174,
    "fields": {
      "postcode": 5058,
      "wilaya": 5,
      "name": "Lazrou"
    },
    "id": 147,
    "commune_name_ascii": "Lazrou",
    "commune_name": "لازرو",
    "daira_name_ascii": "Seriana",
    "daira_name": "سريانة",
    "wilaya_code": "5",
    "wilaya_name_ascii": "Batna",
    "wilaya_name": "باتنة"
  },
  {
    "model": "base.commune",
    "pk": 121,
    "fields": {
      "postcode": 5005,
      "wilaya": 5,
      "name": "Seriana"
    },
    "id": 167,
    "commune_name_ascii": "Seriana",
    "commune_name": "سريانة",
    "daira_name_ascii": "Seriana",
    "daira_name": "سريانة",
    "wilaya_code": "5",
    "wilaya_name_ascii": "Batna",
    "wilaya_name": "باتنة"
  },
  {
    "pk": 170 ,"fields": {  "postcode": 5054 , "wilaya":   5, "name": "Zanat El Beida" },
    "id": 177,
    "commune_name_ascii": "Zanet El Beida",
    "commune_name": "زانة البيضاء",
    "daira_name_ascii": "Seriana",
    "daira_name": "سريانة",
    "wilaya_code": "5",
    "wilaya_name_ascii": "Batna",
    "wilaya_name": "باتنة"
  },
  {
    "model": "base.commune",
    "pk": 122,
    "fields": {
      "postcode": 5006,
      "wilaya": 5,
      "name": "Menaa"
    },
    "id": 151,
    "commune_name_ascii": "Menaa",
    "commune_name": "منعة",
    "daira_name_ascii": "Menaa",
    "daira_name": "منعة",
    "wilaya_code": "5",
    "wilaya_name_ascii": "Batna",
    "wilaya_name": "باتنة"
  },
  {
    "pk": 137 ,"fields": {  "postcode": 5021 , "wilaya":   5, "name": "Tigherghar" },
    "id": 174,
    "commune_name_ascii": "Tigharghar",
    "commune_name": "تغرغار",
    "daira_name_ascii": "Menaa",
    "daira_name": "منعة",
    "wilaya_code": "5",
    "wilaya_name_ascii": "Batna",
    "wilaya_name": "باتنة"
  },
  {
    "model": "base.commune",
    "pk": 138,
    "fields": {
      "postcode": 5022,
      "wilaya": 5,
      "name": "Ain Yagout"
    },
    "id": 119,
    "commune_name_ascii": "Ain Yagout",
    "commune_name": "عين ياقوت",
    "daira_name_ascii": "El Madher",
    "daira_name": "المعذر",
    "wilaya_code": "5",
    "wilaya_name_ascii": "Batna",
    "wilaya_name": "باتنة"
  },
  {
    "model": "base.commune",
    "pk": 175,
    "fields": {
      "postcode": 5059,
      "wilaya": 5,
      "name": "Boumia"
    },
    "id": 128,
    "commune_name_ascii": "Boumia",
    "commune_name": "بومية",
    "daira_name_ascii": "El Madher",
    "daira_name": "المعذر",
    "wilaya_code": "5",
    "wilaya_name_ascii": "Batna",
    "wilaya_name": "باتنة"
  },
  {
    "model": "base.commune",
    "pk": 129,
    "fields": {
      "postcode": 5013,
      "wilaya": 5,
      "name": "Djerma"
    },
    "id": 132,
    "commune_name_ascii": "Djerma",
    "commune_name": "جرمة",
    "daira_name_ascii": "El Madher",
    "daira_name": "المعذر",
    "wilaya_code": "5",
    "wilaya_name_ascii": "Batna",
    "wilaya_name": "باتنة"
  },
  {
    "model": "base.commune",
    "pk": 123,
    "fields": {
      "postcode": 5007,
      "wilaya": 5,
      "name": "El Madher"
    },
    "id": 135,
    "commune_name_ascii": "El Madher",
    "commune_name": "المعذر",
    "daira_name_ascii": "El Madher",
    "daira_name": "المعذر",
    "wilaya_code": "5",
    "wilaya_name_ascii": "Batna",
    "wilaya_name": "باتنة"
  },
  {
    "model": "base.commune",
    "pk": 128,
    "fields": {
      "postcode": 5012,
      "wilaya": 5,
      "name": "Ouyoun El Assafir"
    },
    "id": 162,
    "commune_name_ascii": "Ouyoun El Assafir",
    "commune_name": "عيون العصافير",
    "daira_name_ascii": "Tazoult",
    "daira_name": "تازولت",
    "wilaya_code": "5",
    "wilaya_name_ascii": "Batna",
    "wilaya_name": "باتنة"
  },
  {
    "model": "base.commune",
    "pk": 124,
    "fields": {
      "postcode": 5008,
      "wilaya": 5,
      "name": "Tazoult"
    },
    "id": 171,
    "commune_name_ascii": "Tazoult",
    "commune_name": "تازولت",
    "daira_name_ascii": "Tazoult",
    "daira_name": "تازولت",
    "wilaya_code": "5",
    "wilaya_name_ascii": "Batna",
    "wilaya_name": "باتنة"
  },
  {
    "model": "base.commune",
    "pk": 157,
    "fields": {
      "postcode": 5041,
      "wilaya": 5,
      "name": "Boumagueur"
    },
    "id": 127,
    "commune_name_ascii": "Boumagueur",
    "commune_name": "بومقر",
    "daira_name_ascii": "N'gaous",
    "daira_name": "نقاوس",
    "wilaya_code": "5",
    "wilaya_name_ascii": "Batna",
    "wilaya_name": "باتنة"
  },
  {
    "pk": 125 ,"fields": {  "postcode": 5009 , "wilaya":   5, "name": "Ngaous" },
    "id": 153,
    "commune_name_ascii": "N Gaous",
    "commune_name": "نقاوس",
    "daira_name_ascii": "N'gaous",
    "daira_name": "نقاوس",
    "wilaya_code": "5",
    "wilaya_name_ascii": "Batna",
    "wilaya_name": "باتنة"
  },
  {
    "model": "base.commune",
    "pk": 140,
    "fields": {
      "postcode": 5024,
      "wilaya": 5,
      "name": "Sefiane"
    },
    "id": 165,
    "commune_name_ascii": "Sefiane",
    "commune_name": "سفيان",
    "daira_name_ascii": "N'gaous",
    "daira_name": "نقاوس",
    "wilaya_code": "5",
    "wilaya_name_ascii": "Batna",
    "wilaya_name": "باتنة"
  },
  {
    "model": "base.commune",
    "pk": 132,
    "fields": {
      "postcode": 5016,
      "wilaya": 5,
      "name": "Arris"
    },
    "id": 120,
    "commune_name_ascii": "Arris",
    "commune_name": "أريس",
    "daira_name_ascii": "Arris",
    "daira_name": "أريس",
    "wilaya_code": "5",
    "wilaya_name_ascii": "Batna",
    "wilaya_name": "باتنة"
  },
  {
    "model": "base.commune",
    "pk": 142,
    "fields": {
      "postcode": 5026,
      "wilaya": 5,
      "name": "Tighanimine"
    },
    "id": 173,
    "commune_name_ascii": "Tighanimine",
    "commune_name": "تيغانمين",
    "daira_name_ascii": "Arris",
    "daira_name": "أريس",
    "wilaya_code": "5",
    "wilaya_name_ascii": "Batna",
    "wilaya_name": "باتنة"
  },
  {
    "model": "base.commune",
    "pk": 135,
    "fields": {
      "postcode": 5019,
      "wilaya": 5,
      "name": "Ain Djasser"
    },
    "id": 117,
    "commune_name_ascii": "Ain Djasser",
    "commune_name": "عين جاسر",
    "daira_name_ascii": "Ain Djasser",
    "daira_name": "عين جاسر",
    "wilaya_code": "5",
    "wilaya_name_ascii": "Batna",
    "wilaya_name": "باتنة"
  },
  {
    "model": "base.commune",
    "pk": 173,
    "fields": {
      "postcode": 5057,
      "wilaya": 5,
      "name": "El Hassi"
    },
    "id": 134,
    "commune_name_ascii": "El Hassi",
    "commune_name": "الحاسي",
    "daira_name_ascii": "Ain Djasser",
    "daira_name": "عين جاسر",
    "wilaya_code": "5",
    "wilaya_name_ascii": "Batna",
    "wilaya_name": "باتنة"
  },
  {
    "model": "base.commune",
    "pk": 145,
    "fields": {
      "postcode": 5029,
      "wilaya": 5,
      "name": "Seggana"
    },
    "id": 166,
    "commune_name_ascii": "Seggana",
    "commune_name": "سقانة",
    "daira_name_ascii": "Seggana",
    "daira_name": "سقانة",
    "wilaya_code": "5",
    "wilaya_name_ascii": "Batna",
    "wilaya_name": "باتنة"
  },
  {
    "model": "base.commune",
    "pk": 134,
    "fields": {
      "postcode": 5018,
      "wilaya": 5,
      "name": "Tilatou"
    },
    "id": 175,
    "commune_name_ascii": "Tilatou",
    "commune_name": "تيلاطو",
    "daira_name_ascii": "Seggana",
    "daira_name": "سقانة",
    "wilaya_code": "5",
    "wilaya_name_ascii": "Batna",
    "wilaya_name": "باتنة"
  },
  {
    "model": "base.commune",
    "pk": 147,
    "fields": {
      "postcode": 5031,
      "wilaya": 5,
      "name": "Foum Toub"
    },
    "id": 137,
    "commune_name_ascii": "Foum Toub",
    "commune_name": "فم الطوب",
    "daira_name_ascii": "Ichemoul",
    "daira_name": "إشمول",
    "wilaya_code": "5",
    "wilaya_name_ascii": "Batna",
    "wilaya_name": "باتنة"
  },
  {
    "pk": 146 ,"fields": {  "postcode": 5030 , "wilaya":   5, "name": "Ichmoul" },
    "id": 142,
    "commune_name_ascii": "Ichemoul",
    "commune_name": "إشمول",
    "daira_name_ascii": "Ichemoul",
    "daira_name": "إشمول",
    "wilaya_code": "5",
    "wilaya_name_ascii": "Batna",
    "wilaya_name": "باتنة"
  },
  {
    "model": "base.commune",
    "pk": 127,
    "fields": {
      "postcode": 5011,
      "wilaya": 5,
      "name": "Inoughissen"
    },
    "id": 143,
    "commune_name_ascii": "Inoughissen",
    "commune_name": "إينوغيسن",
    "daira_name_ascii": "Ichemoul",
    "daira_name": "إشمول",
    "wilaya_code": "5",
    "wilaya_name_ascii": "Batna",
    "wilaya_name": "باتنة"
  },
  {
    "model": "base.commune",
    "pk": 151,
    "fields": {
      "postcode": 5035,
      "wilaya": 5,
      "name": "Bouzina"
    },
    "id": 129,
    "commune_name_ascii": "Bouzina",
    "commune_name": "بوزينة",
    "daira_name_ascii": "Bouzina",
    "daira_name": "بوزينة",
    "wilaya_code": "5",
    "wilaya_name_ascii": "Batna",
    "wilaya_name": "باتنة"
  },
  {
    "model": "base.commune",
    "pk": 177,
    "fields": {
      "postcode": 5061,
      "wilaya": 5,
      "name": "Larbaa"
    },
    "id": 146,
    "commune_name_ascii": "Larbaa",
    "commune_name": "لارباع",
    "daira_name_ascii": "Bouzina",
    "daira_name": "بوزينة",
    "wilaya_code": "5",
    "wilaya_name_ascii": "Batna",
    "wilaya_name": "باتنة"
  },
  {
    "model": "base.commune",
    "pk": 176,
    "fields": {
      "postcode": 5060,
      "wilaya": 5,
      "name": "Boulhilat"
    },
    "id": 126,
    "commune_name_ascii": "Boulhilat",
    "commune_name": "بولهيلات",
    "daira_name_ascii": "Chemora",
    "daira_name": "الشمرة",
    "wilaya_code": "5",
    "wilaya_name_ascii": "Batna",
    "wilaya_name": "باتنة"
  },
  {
    "model": "base.commune",
    "pk": 152,
    "fields": {
      "postcode": 5036,
      "wilaya": 5,
      "name": "Chemora"
    },
    "id": 130,
    "commune_name_ascii": "Chemora",
    "commune_name": "الشمرة",
    "daira_name_ascii": "Chemora",
    "daira_name": "الشمرة",
    "wilaya_code": "5",
    "wilaya_name_ascii": "Batna",
    "wilaya_name": "باتنة"
  },
  {
    "model": "base.commune",
    "pk": 158,
    "fields": {
      "postcode": 5042,
      "wilaya": 5,
      "name": "Barika"
    },
    "id": 122,
    "commune_name_ascii": "Barika",
    "commune_name": "بريكة",
    "daira_name_ascii": "Barika",
    "daira_name": "بريكة",
    "wilaya_code": "5",
    "wilaya_name_ascii": "Batna",
    "wilaya_name": "باتنة"
  },
  {
    "model": "base.commune",
    "pk": 130,
    "fields": {
      "postcode": 5014,
      "wilaya": 5,
      "name": "Bitam"
    },
    "id": 125,
    "commune_name_ascii": "Bitam",
    "commune_name": "بيطام",
    "daira_name_ascii": "Barika",
    "daira_name": "بريكة",
    "wilaya_code": "5",
    "wilaya_name_ascii": "Batna",
    "wilaya_name": "باتنة"
  },
  {
    "pk": 171 ,"fields": {  "postcode": 5055 , "wilaya":   5, "name": "Amdoukal" },
    "id": 149,
    "commune_name_ascii": "M Doukal",
    "commune_name": "إمدوكل",
    "daira_name_ascii": "Barika",
    "daira_name": "بريكة",
    "wilaya_code": "5",
    "wilaya_name_ascii": "Batna",
    "wilaya_name": "باتنة"
  },
  {
    /**مكانش في مايسترو */
    "id": 121,
    "commune_name_ascii": "Azil Abedelkader",
    "commune_name": "عزيل عبد القادر",
    "daira_name_ascii": "Djezzar",
    "daira_name": "الجزار",
    "wilaya_code": "5",
    "wilaya_name_ascii": "Batna",
    "wilaya_name": "باتنة"
  },
  {
    "model": "base.commune",
    "pk": 159,
    "fields": {
      "postcode": 5043,
      "wilaya": 5,
      "name": "Djezzar"
    },
    "id": 133,
    "commune_name_ascii": "Djezzar",
    "commune_name": "الجزار",
    "daira_name_ascii": "Djezzar",
    "daira_name": "الجزار",
    "wilaya_code": "5",
    "wilaya_name_ascii": "Batna",
    "wilaya_name": "باتنة"
  },
  {
    "model": "base.commune",
    "pk": 172,
    "fields": {
      "postcode": 5056,
      "wilaya": 5,
      "name": "Ouled Ammar"
    },
    "id": 157,
    "commune_name_ascii": "Ouled Ammar",
    "commune_name": "أولاد عمار",
    "daira_name_ascii": "Djezzar",
    "daira_name": "الجزار",
    "wilaya_code": "5",
    "wilaya_name_ascii": "Batna",
    "wilaya_name": "باتنة"
  },
  {
    "model": "base.commune",
    "pk": 118,
    "fields": {
      "postcode": 5002,
      "wilaya": 5,
      "name": "Ghassira"
    },
    "id": 138,
    "commune_name_ascii": "Ghassira",
    "commune_name": "غسيرة",
    "daira_name_ascii": "Tkout",
    "daira_name": "تكوت",
    "wilaya_code": "5",
    "wilaya_name_ascii": "Batna",
    "wilaya_name": "باتنة"
  },
  {
    "model": "base.commune",
    "pk": 133,
    "fields": {
      "postcode": 5017,
      "wilaya": 5,
      "name": "Kimmel"
    },
    "id": 144,
    "commune_name_ascii": "Kimmel",
    "commune_name": "كيمل",
    "daira_name_ascii": "Tkout",
    "daira_name": "تكوت",
    "wilaya_code": "5",
    "wilaya_name_ascii": "Batna",
    "wilaya_name": "باتنة"
  },
  {
    "pk": 160 ,"fields": {  "postcode": 5044 , "wilaya":   5, "name": "Tkout" },
    "id": 168,
    "commune_name_ascii": "T Kout",
    "commune_name": "تكوت",
    "daira_name_ascii": "Tkout",
    "daira_name": "تكوت",
    "wilaya_code": "5",
    "wilaya_name_ascii": "Batna",
    "wilaya_name": "باتنة"
  },
  {
    "model": "base.commune",
    "pk": 161,
    "fields": {
      "postcode": 5045,
      "wilaya": 5,
      "name": "Ain Touta"
    },
    "id": 118,
    "commune_name_ascii": "Ain Touta",
    "commune_name": "عين التوتة",
    "daira_name_ascii": "Ain Touta",
    "daira_name": "عين التوتة",
    "wilaya_code": "5",
    "wilaya_name_ascii": "Batna",
    "wilaya_name": "باتنة"
  },
  {
    "model": "base.commune",
    "pk": 148,
    "fields": {
      "postcode": 5032,
      "wilaya": 5,
      "name": "Beni Foudhala El Hakania"
    },
    "id": 124,
    "commune_name_ascii": "Beni Foudhala El Hakania",
    "commune_name": "بني فضالة الحقانية",
    "daira_name_ascii": "Ain Touta",
    "daira_name": "عين التوتة",
    "wilaya_code": "5",
    "wilaya_name_ascii": "Batna",
    "wilaya_name": "باتنة"
  },
  {
    "model": "base.commune",
    "pk": 165,
    "fields": {
      "postcode": 5049,
      "wilaya": 5,
      "name": "Ouled Fadel"
    },
    "id": 159,
    "commune_name_ascii": "Ouled Fadel",
    "commune_name": "أولاد فاضل",
    "daira_name_ascii": "Timgad",
    "daira_name": "تيمقاد",
    "wilaya_code": "5",
    "wilaya_name_ascii": "Batna",
    "wilaya_name": "باتنة"
  },
  {
    "model": "base.commune",
    "pk": 156,
    "fields": {
      "postcode": 5040,
      "wilaya": 5,
      "name": "Ouled Aouf"
    },
    "id": 158,
    "commune_name_ascii": "Ouled Aouf",
    "commune_name": "أولاد عوف",
    "daira_name_ascii": "Ain Touta",
    "daira_name": "عين التوتة",
    "wilaya_code": "5",
    "wilaya_name_ascii": "Batna",
    "wilaya_name": "باتنة"
  },
  {
    "model": "base.commune",
    "pk": 168,
    "fields": {
      "postcode": 5052,
      "wilaya": 5,
      "name": "Chir"
    },
    "id": 131,
    "commune_name_ascii": "Chir",
    "commune_name": "شير",
    "daira_name_ascii": "Theniet El Abed",
    "daira_name": "ثنية العابد",
    "wilaya_code": "5",
    "wilaya_name_ascii": "Batna",
    "wilaya_name": "باتنة"
  },
  {
    "model": "base.commune",
    "pk": 164,
    "fields": {
      "postcode": 5048,
      "wilaya": 5,
      "name": "Oued Taga"
    },
    "id": 156,
    "commune_name_ascii": "Oued Taga",
    "commune_name": "وادي الطاقة",
    "daira_name_ascii": "Theniet El Abed",
    "daira_name": "ثنية العابد",
    "wilaya_code": "5",
    "wilaya_name_ascii": "Batna",
    "wilaya_name": "باتنة"
  },
  {
    "model": "base.commune",
    "pk": 198,
    "fields": {
      "postcode": 6021,
      "wilaya": 6,
      "name": "Sidi Ayad"
    },
    "id": 212,
    "commune_name_ascii": "Sidi Ayad",
    "commune_name": "سيدي عياد",
    "daira_name_ascii": "Sidi Aich",
    "daira_name": "سيدي عيش",
    "wilaya_code": "6",
    "wilaya_name_ascii": "Bejaia",
    "wilaya_name": "بجاية"
  },
  {
    "model": "base.commune",
    "pk": 211,
    "fields": {
      "postcode": 6034,
      "wilaya": 6,
      "name": "Barbacha"
    },
    "id": 186,
    "commune_name_ascii": "Barbacha",
    "commune_name": "برباشة",
    "daira_name_ascii": "Barbacha",
    "daira_name": "برباشة",
    "wilaya_code": "6",
    "wilaya_name_ascii": "Bejaia",
    "wilaya_name": "بجاية"
  },
  {
    "model": "base.commune",
    "pk": 220,
    "fields": {
      "postcode": 6043,
      "wilaya": 6,
      "name": "Leflaye"
    },
    "id": 199,
    "commune_name_ascii": "Leflaye",
    "commune_name": "الفلاي",
    "daira_name_ascii": "Sidi Aich",
    "daira_name": "سيدي عيش",
    "wilaya_code": "6",
    "wilaya_name_ascii": "Bejaia",
    "wilaya_name": "بجاية"
  },
  {
    "model": "base.commune",
    "pk": 190,
    "fields": {
      "postcode": 6013,
      "wilaya": 6,
      "name": "Kendira"
    },
    "id": 206,
    "commune_name_ascii": "Kendira",
    "commune_name": "كنديرة",
    "daira_name_ascii": "Barbacha",
    "daira_name": "برباشة",
    "wilaya_code": "6",
    "wilaya_name_ascii": "Bejaia",
    "wilaya_name": "بجاية"
  },
  {
    "pk": 216 ,"fields": {  "postcode": 6039 , "wilaya":   6, "name": "Sidi Aich" },
    "id": 213,
    "commune_name_ascii": "Sidi Aich",
    "commune_name": "سيدي عيش",
    "daira_name_ascii": "Sidi Aich",
    "daira_name": "سيدي عيش",
    "wilaya_code": "6",
    "wilaya_name_ascii": "Bejaia",
    "wilaya_name": "بجاية"
  },
  {
    "model": "base.commune",
    "pk": 191,
    "fields": {
      "postcode": 6014,
      "wilaya": 6,
      "name": "Tifra"
    },
    "id": 225,
    "commune_name_ascii": "Tifra",
    "commune_name": "تيفرة",
    "daira_name_ascii": "Sidi Aich",
    "daira_name": "سيدي عيش",
    "wilaya_code": "6",
    "wilaya_name_ascii": "Bejaia",
    "wilaya_name": "بجاية"
  },
  {
    "pk": 187 ,"fields": {  "postcode": 6010 , "wilaya":   6, "name": "Thinabdher" },
    "id": 227,
    "commune_name_ascii": "Tinebdar",
    "commune_name": "تينبدار",
    "daira_name_ascii": "Sidi Aich",
    "daira_name": "سيدي عيش",
    "wilaya_code": "6",
    "wilaya_name_ascii": "Bejaia",
    "wilaya_name": "بجاية"
  },
  {
    "model": "base.commune",
    "pk": 217,
    "fields": {
      "postcode": 6040,
      "wilaya": 6,
      "name": "El Kseur"
    },
    "id": 200,
    "commune_name_ascii": "El Kseur",
    "commune_name": "القصر",
    "daira_name_ascii": "El Kseur",
    "daira_name": "القصر",
    "wilaya_code": "6",
    "wilaya_name_ascii": "Bejaia",
    "wilaya_name": "بجاية"
  },
  {
    "pk": 195 ,"fields": {  "postcode": 6018 , "wilaya":   6, "name": "Ifelain Ilmathen" },
    "id": 201,
    "commune_name_ascii": "Fenaia Il Maten",
    "commune_name": "فناية الماثن",
    "daira_name_ascii": "El Kseur",
    "daira_name": "القصر",
    "wilaya_code": "6",
    "wilaya_name_ascii": "Bejaia",
    "wilaya_name": "بجاية"
  },
  {
    "model": "base.commune",
    "pk": 196,
    "fields": {
      "postcode": 6019,
      "wilaya": 6,
      "name": "Toudja"
    },
    "id": 229,
    "commune_name_ascii": "Toudja",
    "commune_name": "توجة",
    "daira_name_ascii": "El Kseur",
    "daira_name": "القصر",
    "wilaya_code": "6",
    "wilaya_name_ascii": "Bejaia",
    "wilaya_name": "بجاية"
  },
  {
    "pk": 222 ,"fields": {  "postcode": 6045 , "wilaya":   6, "name": "Draa Kaid" },
    "id": 198,
    "commune_name_ascii": "Dra El Caid",
    "commune_name": "ذراع القايد",
    "daira_name_ascii": "Kherrata",
    "daira_name": "خراطة",
    "wilaya_code": "6",
    "wilaya_name_ascii": "Bejaia",
    "wilaya_name": "بجاية"
  },
  {
    "model": "base.commune",
    "pk": 221,
    "fields": {
      "postcode": 6044,
      "wilaya": 6,
      "name": "Kherrata"
    },
    "id": 207,
    "commune_name_ascii": "Kherrata",
    "commune_name": "خراطة",
    "daira_name_ascii": "Kherrata",
    "daira_name": "خراطة",
    "wilaya_code": "6",
    "wilaya_name_ascii": "Bejaia",
    "wilaya_name": "بجاية"
  },
  {
    "model": "base.commune",
    "pk": 178,
    "fields": {
      "postcode": 6001,
      "wilaya": 6,
      "name": "Bejaia"
    },
    "id": 187,
    "commune_name_ascii": "Bejaia",
    "commune_name": "بجاية",
    "daira_name_ascii": "Bejaia",
    "daira_name": "بجاية",
    "wilaya_code": "6",
    "wilaya_name_ascii": "Bejaia",
    "wilaya_name": "بجاية"
  },
  {
    "model": "base.commune",
    "pk": 228,
    "fields": {
      "postcode": 6051,
      "wilaya": 6,
      "name": "Oued Ghir"
    },
    "id": 210,
    "commune_name_ascii": "Oued Ghir",
    "commune_name": "وادي غير",
    "daira_name_ascii": "Bejaia",
    "daira_name": "بجاية",
    "wilaya_code": "6",
    "wilaya_name_ascii": "Bejaia",
    "wilaya_name": "بجاية"
  },
  {
    "pk": 227 ,"fields": {  "postcode": 6050 , "wilaya":   6, "name": "Beni Maouch" },
    "id": 191,
    "commune_name_ascii": "Benimaouche",
    "commune_name": "بني معوش",
    "daira_name_ascii": "Beni Maouche",
    "daira_name": "بني معوش",
    "wilaya_code": "6",
    "wilaya_name_ascii": "Bejaia",
    "wilaya_name": "بجاية"
  },
  {
    "model": "base.commune",
    "pk": 200,
    "fields": {
      "postcode": 6023,
      "wilaya": 6,
      "name": "Beni Djellil"
    },
    "id": 188,
    "commune_name_ascii": "Beni Djellil",
    "commune_name": "بني جليل",
    "daira_name_ascii": "Amizour",
    "daira_name": "أميزور",
    "wilaya_code": "6",
    "wilaya_name_ascii": "Bejaia",
    "wilaya_name": "بجاية"
  },
  {
    "id": 202,
    "commune_name_ascii": "Feraoun",
    "commune_name": "فرعون",
    "daira_name_ascii": "Amizour",
    "daira_name": "أميزور",
    "wilaya_code": "6",
    "wilaya_name_ascii": "Bejaia",
    "wilaya_name": "بجاية"
  },
  {
    "id": 214,
    "commune_name_ascii": "Smaoun",
    "commune_name": "سمعون",
    "daira_name_ascii": "Amizour",
    "daira_name": "أميزور",
    "wilaya_code": "6",
    "wilaya_name_ascii": "Bejaia",
    "wilaya_name": "بجاية"
  },
  {
    "model": "base.commune",
    "pk": 1212,
    "fields": {
      "postcode": 35018,
      "wilaya": 35,
      "name": "Timezrit"
    },
    "id": 226,
    "commune_name_ascii": "Timezrit",
    "commune_name": "تيمزريت",
    "daira_name_ascii": "Timezrit",
    "daira_name": "تيمزريت",
    "wilaya_code": "6",
    "wilaya_name_ascii": "Bejaia",
    "wilaya_name": "بجاية"
  },
  {
    "model": "base.commune",
    "pk": 218,
    "fields": {
      "postcode": 6041,
      "wilaya": 6,
      "name": "Melbou"
    },
    "id": 209,
    "commune_name_ascii": "Melbou",
    "commune_name": "مالبو",
    "daira_name_ascii": "Souk El Tenine",
    "daira_name": "سوق الإثنين",
    "wilaya_code": "6",
    "wilaya_name_ascii": "Bejaia",
    "wilaya_name": "بجاية"
  },
  {
    "id": 215,
    "commune_name_ascii": "Souk El Tenine",
    "commune_name": "سوق لإثنين",
    "daira_name_ascii": "Souk El Tenine",
    "daira_name": "سوق الإثنين",
    "wilaya_code": "6",
    "wilaya_name_ascii": "Bejaia",
    "wilaya_name": "بجاية"
  },
  {
    "model": "base.commune",
    "pk": 223,
    "fields": {
      "postcode": 6046,
      "wilaya": 6,
      "name": "Tamridjet"
    },
    "id": 219,
    "commune_name_ascii": "Tamridjet",
    "commune_name": "تامريجت",
    "daira_name_ascii": "Souk El Tenine",
    "daira_name": "سوق الإثنين",
    "wilaya_code": "6",
    "wilaya_name_ascii": "Bejaia",
    "wilaya_name": "بجاية"
  },
  {
    "model": "base.commune",
    "pk": 225,
    "fields": {
      "postcode": 6048,
      "wilaya": 6,
      "name": "Boukhelifa"
    },
    "id": 194,
    "commune_name_ascii": "Boukhelifa",
    "commune_name": "بوخليفة",
    "daira_name_ascii": "Tichy",
    "daira_name": "تيشي",
    "wilaya_code": "6",
    "wilaya_name_ascii": "Bejaia",
    "wilaya_name": "بجاية"
  },
  {
    "model": "base.commune",
    "pk": 210,
    "fields": {
      "postcode": 6033,
      "wilaya": 6,
      "name": "Tala Hamza"
    },
    "id": 217,
    "commune_name_ascii": "Tala Hamza",
    "commune_name": "تالة حمزة",
    "daira_name_ascii": "Tichy",
    "daira_name": "تيشي",
    "wilaya_code": "6",
    "wilaya_name_ascii": "Bejaia",
    "wilaya_name": "بجاية"
  },
  {
    "id": 224,
    "commune_name_ascii": "Tichy",
    "commune_name": "تيشي",
    "daira_name_ascii": "Tichy",
    "daira_name": "تيشي",
    "wilaya_code": "6",
    "wilaya_name_ascii": "Bejaia",
    "wilaya_name": "بجاية"
  },
  {
    "id": 179,
    "commune_name_ascii": "Ait R'zine",
    "commune_name": "أيت رزين",
    "daira_name_ascii": "Ighil Ali",
    "daira_name": "إغيل علي",
    "wilaya_code": "6",
    "wilaya_name_ascii": "Bejaia",
    "wilaya_name": "بجاية"
  },
  {
    "id": 204,
    "commune_name_ascii": "Ighil Ali",
    "commune_name": "إغيل علي",
    "daira_name_ascii": "Ighil Ali",
    "daira_name": "إغيل علي",
    "wilaya_code": "6",
    "wilaya_name_ascii": "Bejaia",
    "wilaya_name": "بجاية"
  },
  {
    "id": 180,
    "commune_name_ascii": "Ait Smail",
    "commune_name": "أيت إسماعيل",
    "daira_name_ascii": "Darguina",
    "daira_name": "درقينة",
    "wilaya_code": "6",
    "wilaya_name_ascii": "Bejaia",
    "wilaya_name": "بجاية"
  },
  {
    "model": "base.commune",
    "pk": 197,
    "fields": {
      "postcode": 6020,
      "wilaya": 6,
      "name": "Darguina"
    },
    "id": 197,
    "commune_name_ascii": "Darguina",
    "commune_name": "درقينة",
    "daira_name_ascii": "Darguina",
    "daira_name": "درقينة",
    "wilaya_code": "6",
    "wilaya_name_ascii": "Bejaia",
    "wilaya_name": "بجاية"
  },
  {
    "model": "base.commune",
    "pk": 208,
    "fields": {
      "postcode": 6031,
      "wilaya": 6,
      "name": "Taskriout"
    },
    "id": 221,
    "commune_name_ascii": "Taskriout",
    "commune_name": "تاسكريوت",
    "daira_name_ascii": "Darguina",
    "daira_name": "درقينة",
    "wilaya_code": "6",
    "wilaya_name_ascii": "Bejaia",
    "wilaya_name": "بجاية"
  },
  {
    "model": "base.commune",
    "pk": 199,
    "fields": {
      "postcode": 6022,
      "wilaya": 6,
      "name": "Aokas"
    },
    "id": 185,
    "commune_name_ascii": "Aokas",
    "commune_name": "أوقاس",
    "daira_name_ascii": "Aokas",
    "daira_name": "أوقاس",
    "wilaya_code": "6",
    "wilaya_name_ascii": "Bejaia",
    "wilaya_name": "بجاية"
  },
  {
    "id": 228,
    "commune_name_ascii": "Tizi N'berber",
    "commune_name": "تيزي نبربر",
    "daira_name_ascii": "Aokas",
    "daira_name": "أوقاس",
    "wilaya_code": "6",
    "wilaya_name_ascii": "Bejaia",
    "wilaya_name": "بجاية"
  },
  {
    "model": "base.commune",
    "pk": 201,
    "fields": {
      "postcode": 6024,
      "wilaya": 6,
      "name": "Adekar"
    },
    "id": 178,
    "commune_name_ascii": "Adekar",
    "commune_name": "أدكار",
    "daira_name_ascii": "Adekar",
    "daira_name": "أدكار",
    "wilaya_code": "6",
    "wilaya_name_ascii": "Bejaia",
    "wilaya_name": "بجاية"
  },
  {
    "id": 189,
    "commune_name_ascii": "Beni K'sila",
    "commune_name": "بني كسيلة",
    "daira_name_ascii": "Adekar",
    "daira_name": "أدكار",
    "wilaya_code": "6",
    "wilaya_name_ascii": "Bejaia",
    "wilaya_name": "بجاية"
  },
  {
    "id": 220,
    "commune_name_ascii": "Taourit Ighil",
    "commune_name": "تاوريرت إغيل",
    "daira_name_ascii": "Adekar",
    "daira_name": "أدكار",
    "wilaya_code": "6",
    "wilaya_name_ascii": "Bejaia",
    "wilaya_name": "بجاية"
  },
  {
    "model": "base.commune",
    "pk": 202,
    "fields": {
      "postcode": 6025,
      "wilaya": 6,
      "name": "Akbou"
    },
    "id": 181,
    "commune_name_ascii": "Akbou",
    "commune_name": "أقبو",
    "daira_name_ascii": "Akbou",
    "daira_name": "أقبو",
    "wilaya_code": "6",
    "wilaya_name_ascii": "Bejaia",
    "wilaya_name": "بجاية"
  },
  {
    "id": 195,
    "commune_name_ascii": "Chellata",
    "commune_name": "شلاطة",
    "daira_name_ascii": "Akbou",
    "daira_name": "أقبو",
    "wilaya_code": "6",
    "wilaya_name_ascii": "Bejaia",
    "wilaya_name": "بجاية"
  },
  {
    "model": "base.commune",
    "pk": 192,
    "fields": {
      "postcode": 6015,
      "wilaya": 6,
      "name": "Ighram"
    },
    "id": 205,
    "commune_name_ascii": "Ighram",
    "commune_name": "اغرم",
    "daira_name_ascii": "Akbou",
    "daira_name": "أقبو",
    "wilaya_code": "6",
    "wilaya_name_ascii": "Bejaia",
    "wilaya_name": "بجاية"
  },
  {
    "model": "base.commune",
    "pk": 183,
    "fields": {
      "postcode": 6006,
      "wilaya": 6,
      "name": "Tamokra"
    },
    "id": 218,
    "commune_name_ascii": "Tamokra",
    "commune_name": "تامقرة",
    "daira_name_ascii": "Akbou",
    "daira_name": "أقبو",
    "wilaya_code": "6",
    "wilaya_name_ascii": "Bejaia",
    "wilaya_name": "بجاية"
  },
  {
    "model": "base.commune",
    "pk": 193,
    "fields": {
      "postcode": 6016,
      "wilaya": 6,
      "name": "Amalou"
    },
    "id": 183,
    "commune_name_ascii": "Amalou",
    "commune_name": "أمالو",
    "daira_name_ascii": "Seddouk",
    "daira_name": "صدوق",
    "wilaya_code": "6",
    "wilaya_name_ascii": "Bejaia",
    "wilaya_name": "بجاية"
  },
  {
    "model": "base.commune",
    "pk": 214,
    "fields": {
      "postcode": 6037,
      "wilaya": 6,
      "name": "Bouhamza"
    },
    "id": 193,
    "commune_name_ascii": "Bouhamza",
    "commune_name": "بوحمزة",
    "daira_name_ascii": "Seddouk",
    "daira_name": "صدوق",
    "wilaya_code": "6",
    "wilaya_name_ascii": "Bejaia",
    "wilaya_name": "بجاية"
  },
  {
    "id": 208,
    "commune_name_ascii": "M'cisna",
    "commune_name": "مسيسنة",
    "daira_name_ascii": "Seddouk",
    "daira_name": "صدوق",
    "wilaya_code": "6",
    "wilaya_name_ascii": "Bejaia",
    "wilaya_name": "بجاية"
  },
  {
    "model": "base.commune",
    "pk": 203,
    "fields": {
      "postcode": 6026,
      "wilaya": 6,
      "name": "Seddouk"
    },
    "id": 211,
    "commune_name_ascii": "Seddouk",
    "commune_name": "صدوق",
    "daira_name_ascii": "Seddouk",
    "daira_name": "صدوق",
    "wilaya_code": "6",
    "wilaya_name_ascii": "Bejaia",
    "wilaya_name": "بجاية"
  },
  {
    "id": 190,
    "commune_name_ascii": "Beni Mallikeche",
    "commune_name": "بني مليكش",
    "daira_name_ascii": "Tazmalt",
    "daira_name": "تازملت",
    "wilaya_code": "6",
    "wilaya_name_ascii": "Bejaia",
    "wilaya_name": "بجاية"
  },
  {
    "model": "base.commune",
    "pk": 229,
    "fields": {
      "postcode": 6052,
      "wilaya": 6,
      "name": "Boudjellil"
    },
    "id": 192,
    "commune_name_ascii": "Boudjellil",
    "commune_name": "بو جليل",
    "daira_name_ascii": "Tazmalt",
    "daira_name": "تازملت",
    "wilaya_code": "6",
    "wilaya_name_ascii": "Bejaia",
    "wilaya_name": "بجاية"
  },
  {
    "model": "base.commune",
    "pk": 204,
    "fields": {
      "postcode": 6027,
      "wilaya": 6,
      "name": "Tazmalt"
    },
    "id": 222,
    "commune_name_ascii": "Tazmalt",
    "commune_name": "تازمالت",
    "daira_name_ascii": "Tazmalt",
    "daira_name": "تازملت",
    "wilaya_code": "6",
    "wilaya_name_ascii": "Bejaia",
    "wilaya_name": "بجاية"
  },
  {
    "model": "base.commune",
    "pk": 219,
    "fields": {
      "postcode": 6042,
      "wilaya": 6,
      "name": "Akfadou"
    },
    "id": 182,
    "commune_name_ascii": "Akfadou",
    "commune_name": "أكفادو",
    "daira_name_ascii": "Chemini",
    "daira_name": "شميني",
    "wilaya_code": "6",
    "wilaya_name_ascii": "Bejaia",
    "wilaya_name": "بجاية"
  },
  {
    "model": "base.commune",
    "pk": 206,
    "fields": {
      "postcode": 6029,
      "wilaya": 6,
      "name": "Chemini"
    },
    "id": 196,
    "commune_name_ascii": "Chemini",
    "commune_name": "شميني",
    "daira_name_ascii": "Chemini",
    "daira_name": "شميني",
    "wilaya_code": "6",
    "wilaya_name_ascii": "Bejaia",
    "wilaya_name": "بجاية"
  },
  {
    "model": "base.commune",
    "pk": 207,
    "fields": {
      "postcode": 6030,
      "wilaya": 6,
      "name": "Souk Oufella"
    },
    "id": 216,
    "commune_name_ascii": "Souk Oufella",
    "commune_name": "سوق اوفلا",
    "daira_name_ascii": "Chemini",
    "daira_name": "شميني",
    "wilaya_code": "6",
    "wilaya_name_ascii": "Bejaia",
    "wilaya_name": "بجاية"
  },
  {
    "model": "base.commune",
    "pk": 209,
    "fields": {
      "postcode": 6032,
      "wilaya": 6,
      "name": "Tibane"
    },
    "id": 223,
    "commune_name_ascii": "Tibane",
    "commune_name": "طيبان",
    "daira_name_ascii": "Chemini",
    "daira_name": "شميني",
    "wilaya_code": "6",
    "wilaya_name_ascii": "Bejaia",
    "wilaya_name": "بجاية"
  },
  {
    "id": 203,
    "commune_name_ascii": "Ouzellaguen",
    "commune_name": "أوزلاقن",
    "daira_name_ascii": "Ifri Ouzellaguene",
    "daira_name": "إفري أوزلاقن",
    "wilaya_code": "6",
    "wilaya_name_ascii": "Bejaia",
    "wilaya_name": "بجاية"
  },
  {
    "model": "base.commune",
    "pk": 179,
    "fields": {
      "postcode": 6002,
      "wilaya": 6,
      "name": "Amizour"
    },
    "id": 184,
    "commune_name_ascii": "Amizour",
    "commune_name": "أميزور",
    "daira_name_ascii": "Amizour",
    "daira_name": "أميزور",
    "wilaya_code": "6",
    "wilaya_name_ascii": "Bejaia",
    "wilaya_name": "بجاية"
  },
  {
    "model": "base.commune",
    "pk": 245,
    "fields": {
      "postcode": 7016,
      "wilaya": 7,
      "name": "El Feidh"
    },
    "id": 241,
    "commune_name_ascii": "El Feidh",
    "commune_name": "الفيض",
    "daira_name_ascii": "Zeribet El Oued",
    "daira_name": "زريبة الوادي",
    "wilaya_code": "7",
    "wilaya_name_ascii": "Biskra",
    "wilaya_name": "بسكرة"
  },
  {
    "model": "base.commune",
    "pk": 252,
    "fields": {
      "postcode": 7023,
      "wilaya": 7,
      "name": "Lichana"
    },
    "id": 249,
    "commune_name_ascii": "Lichana",
    "commune_name": "ليشانة",
    "daira_name_ascii": "Tolga",
    "daira_name": "طولقة",
    "wilaya_code": "7",
    "wilaya_name_ascii": "Biskra",
    "wilaya_name": "بسكرة"
  },
  {
    "id": 235,
    "commune_name_ascii": "Bouchakroun",
    "commune_name": "بوشقرون",
    "daira_name_ascii": "Tolga",
    "daira_name": "طولقة",
    "wilaya_code": "7",
    "wilaya_name_ascii": "Biskra",
    "wilaya_name": "بسكرة"
  },
  {
    "model": "base.commune",
    "pk": 259,
    "fields": {
      "postcode": 7030,
      "wilaya": 7,
      "name": "Mekhadma"
    },
    "id": 252,
    "commune_name_ascii": "Mekhadma",
    "commune_name": "مخادمة",
    "daira_name_ascii": "Ourlal",
    "daira_name": "أورلال",
    "wilaya_code": "7",
    "wilaya_name_ascii": "Biskra",
    "wilaya_name": "بسكرة"
  },
  {
    "model": "base.commune",
    "pk": 249,
    "fields": {
      "postcode": 7020,
      "wilaya": 7,
      "name": "Djemorah"
    },
    "id": 239,
    "commune_name_ascii": "Djemorah",
    "commune_name": "جمورة",
    "daira_name_ascii": "Djemorah",
    "daira_name": "جمورة",
    "wilaya_code": "7",
    "wilaya_name_ascii": "Biskra",
    "wilaya_name": "بسكرة"
  },
  {
    "model": "base.commune",
    "pk": 232,
    "fields": {
      "postcode": 7003,
      "wilaya": 7,
      "name": "Branis"
    },
    "id": 236,
    "commune_name_ascii": "Branis",
    "commune_name": "برانيس",
    "daira_name_ascii": "Djemorah",
    "daira_name": "جمورة",
    "wilaya_code": "7",
    "wilaya_name_ascii": "Biskra",
    "wilaya_name": "بسكرة"
  },
  {
    "model": "base.commune",
    "pk": 248,
    "fields": {
      "postcode": 7019,
      "wilaya": 7,
      "name": "El Outaya"
    },
    "id": 246,
    "commune_name_ascii": "El Outaya",
    "commune_name": "الوطاية",
    "daira_name_ascii": "El Outaya",
    "daira_name": "الوطاية",
    "wilaya_code": "7",
    "wilaya_name_ascii": "Biskra",
    "wilaya_name": "بسكرة"
  },
  {
    "model": "base.commune",
    "pk": 246,
    "fields": {
      "postcode": 7017,
      "wilaya": 7,
      "name": "El Kantara"
    },
    "id": 245,
    "commune_name_ascii": "El Kantara",
    "commune_name": "القنطرة",
    "daira_name_ascii": "El Kantara",
    "daira_name": "القنطرة",
    "wilaya_code": "7",
    "wilaya_name_ascii": "Biskra",
    "wilaya_name": "بسكرة"
  },
  {
    "id": 248,
    "commune_name_ascii": "Khenguet Sidi Nadji",
    "commune_name": "خنقة سيدي ناجي",
    "daira_name_ascii": "Zeribet El Oued",
    "daira_name": "زريبة الوادي",
    "wilaya_code": "7",
    "wilaya_name_ascii": "Biskra",
    "wilaya_name": "بسكرة"
  },
  {
    "model": "base.commune",
    "pk": 247,
    "fields": {
      "postcode": 7018,
      "wilaya": 7,
      "name": "Ain Zaatout"
    },
    "id": 231,
    "commune_name_ascii": "Ain Zaatout",
    "commune_name": "عين زعطوط",
    "daira_name_ascii": "El Kantara",
    "daira_name": "القنطرة",
    "wilaya_code": "7",
    "wilaya_name_ascii": "Biskra",
    "wilaya_name": "بسكرة"
  },
  {
    "model": "base.commune",
    "pk": 244,
    "fields": {
      "postcode": 7015,
      "wilaya": 7,
      "name": "Zeribet El Oued"
    },
    "id": 262,
    "commune_name_ascii": "Zeribet El Oued",
    "commune_name": "زريبة الوادي",
    "daira_name_ascii": "Zeribet El Oued",
    "daira_name": "زريبة الوادي",
    "wilaya_code": "7",
    "wilaya_name_ascii": "Biskra",
    "wilaya_name": "بسكرة"
  },
  {
    "model": "base.commune",
    "pk": 257,
    "fields": {
      "postcode": 7028,
      "wilaya": 7,
      "name": "Meziraa"
    },
    "id": 253,
    "commune_name_ascii": "Meziraa",
    "commune_name": "المزيرعة",
    "daira_name_ascii": "Zeribet El Oued",
    "daira_name": "زريبة الوادي",
    "wilaya_code": "7",
    "wilaya_name_ascii": "Biskra",
    "wilaya_name": "بسكرة"
  },
  {
    "model": "base.commune",
    "pk": 230,
    "fields": {
      "postcode": 7001,
      "wilaya": 7,
      "name": "Biskra"
    },
    "id": 233,
    "commune_name_ascii": "Biskra",
    "commune_name": "بسكرة",
    "daira_name_ascii": "Biskra",
    "daira_name": "بسكرة",
    "wilaya_code": "7",
    "wilaya_name_ascii": "Biskra",
    "wilaya_name": "بسكرة"
  },
  {
    "model": "base.commune",
    "pk": 261,
    "fields": {
      "postcode": 7032,
      "wilaya": 7,
      "name": "El Hadjab"
    },
    "id": 243,
    "commune_name_ascii": "El Hadjab",
    "commune_name": "الحاجب",
    "daira_name_ascii": "Biskra",
    "daira_name": "بسكرة",
    "wilaya_code": "7",
    "wilaya_name_ascii": "Biskra",
    "wilaya_name": "بسكرة"
  },
  {
    "id": 254,
    "commune_name_ascii": "M'lili",
    "commune_name": "مليلي",
    "daira_name_ascii": "Ourlal",
    "daira_name": "أورلال",
    "wilaya_code": "7",
    "wilaya_name_ascii": "Biskra",
    "wilaya_name": "بسكرة"
  },
  {
    "model": "base.commune",
    "pk": 255,
    "fields": {
      "postcode": 7026,
      "wilaya": 7,
      "name": "Foughala"
    },
    "id": 247,
    "commune_name_ascii": "Foughala",
    "commune_name": "فوغالة",
    "daira_name_ascii": "Foughala",
    "daira_name": "فوغالة",
    "wilaya_code": "7",
    "wilaya_name_ascii": "Biskra",
    "wilaya_name": "بسكرة"
  },
  {
    "model": "base.commune",
    "pk": 260,
    "fields": {
      "postcode": 7031,
      "wilaya": 7,
      "name": "El Ghrous"
    },
    "id": 242,
    "commune_name_ascii": "El Ghrous",
    "commune_name": "الغروس",
    "daira_name_ascii": "Foughala",
    "daira_name": "فوغالة",
    "wilaya_code": "7",
    "wilaya_name_ascii": "Biskra",
    "wilaya_name": "بسكرة"
  },
  {
    "model": "base.commune",
    "pk": 256,
    "fields": {
      "postcode": 7027,
      "wilaya": 7,
      "name": "Bordj Ben Azzouz"
    },
    "id": 234,
    "commune_name_ascii": "Bordj Ben Azzouz",
    "commune_name": "برج بن عزوز",
    "daira_name_ascii": "Tolga",
    "daira_name": "طولقة",
    "wilaya_code": "7",
    "wilaya_name_ascii": "Biskra",
    "wilaya_name": "بسكرة"
  },
  {
    "model": "base.commune",
    "pk": 253,
    "fields": {
      "postcode": 7024,
      "wilaya": 7,
      "name": "Ourlal"
    },
    "id": 257,
    "commune_name_ascii": "Ourlal",
    "commune_name": "أورلال",
    "daira_name_ascii": "Ourlal",
    "daira_name": "أورلال",
    "wilaya_code": "7",
    "wilaya_name_ascii": "Biskra",
    "wilaya_name": "بسكرة"
  },
  {
    "model": "base.commune",
    "pk": 231,
    "fields": {
      "postcode": 7002,
      "wilaya": 7,
      "name": "Oumache"
    },
    "id": 256,
    "commune_name_ascii": "Oumache",
    "commune_name": "أوماش",
    "daira_name_ascii": "Ourlal",
    "daira_name": "أورلال",
    "wilaya_code": "7",
    "wilaya_name_ascii": "Biskra",
    "wilaya_name": "بسكرة"
  },
  {
    "model": "base.commune",
    "pk": 243,
    "fields": {
      "postcode": 7014,
      "wilaya": 7,
      "name": "Ain Naga"
    },
    "id": 230,
    "commune_name_ascii": "Ain Naga",
    "commune_name": "عين الناقة",
    "daira_name_ascii": "Sidi Okba",
    "daira_name": "سيدي عقبة",
    "wilaya_code": "7",
    "wilaya_name_ascii": "Biskra",
    "wilaya_name": "بسكرة"
  },
  {
    "model": "base.commune",
    "pk": 233,
    "fields": {
      "postcode": 7004,
      "wilaya": 7,
      "name": "Chetma"
    },
    "id": 238,
    "commune_name_ascii": "Chetma",
    "commune_name": "شتمة",
    "daira_name_ascii": "Sidi Okba",
    "daira_name": "سيدي عقبة",
    "wilaya_code": "7",
    "wilaya_name_ascii": "Biskra",
    "wilaya_name": "بسكرة"
  },
  {
    "model": "base.commune",
    "pk": 242,
    "fields": {
      "postcode": 7013,
      "wilaya": 7,
      "name": "El Haouch"
    },
    "id": 244,
    "commune_name_ascii": "El Haouch",
    "commune_name": "الحوش",
    "daira_name_ascii": "Sidi Okba",
    "daira_name": "سيدي عقبة",
    "wilaya_code": "7",
    "wilaya_name_ascii": "Biskra",
    "wilaya_name": "بسكرة"
  },
  {
    "model": "base.commune",
    "pk": 240,
    "fields": {
      "postcode": 7011,
      "wilaya": 7,
      "name": "Sidi Okba"
    },
    "id": 260,
    "commune_name_ascii": "Sidi Okba",
    "commune_name": "سيدي عقبة",
    "daira_name_ascii": "Sidi Okba",
    "daira_name": "سيدي عقبة",
    "wilaya_code": "7",
    "wilaya_name_ascii": "Biskra",
    "wilaya_name": "بسكرة"
  },
  {
    "id": 251,
    "commune_name_ascii": "M'chouneche",
    "commune_name": "مشونش",
    "daira_name_ascii": "Mechouneche",
    "daira_name": "مشونش",
    "wilaya_code": "7",
    "wilaya_name_ascii": "Biskra",
    "wilaya_name": "بسكرة"
  },
  {
    "model": "base.commune",
    "pk": 251,
    "fields": {
      "postcode": 7022,
      "wilaya": 7,
      "name": "Lioua"
    },
    "id": 250,
    "commune_name_ascii": "Lioua",
    "commune_name": "ليوة",
    "daira_name_ascii": "Ourlal",
    "daira_name": "أورلال",
    "wilaya_code": "7",
    "wilaya_name_ascii": "Biskra",
    "wilaya_name": "بسكرة"
  },
  {
    "model": "base.commune",
    "pk": 250,
    "fields": {
      "postcode": 7021,
      "wilaya": 7,
      "name": "Tolga"
    },
    "id": 261,
    "commune_name_ascii": "Tolga",
    "commune_name": "طولقة",
    "daira_name_ascii": "Tolga",
    "daira_name": "طولقة",
    "wilaya_code": "7",
    "wilaya_name_ascii": "Biskra",
    "wilaya_name": "بسكرة"
  },
  {
    "model": "base.commune",
    "pk": 263,
    "fields": {
      "postcode": 8001,
      "wilaya": 8,
      "name": "Bechar"
    },
    "id": 264,
    "commune_name_ascii": "Bechar",
    "commune_name": "بشار",
    "daira_name_ascii": "Bechar",
    "daira_name": "بشار",
    "wilaya_code": "8",
    "wilaya_name_ascii": "Bechar",
    "wilaya_name": "بشار"
  },
  {
    "model": "base.commune",
    "pk": 277,
    "fields": {
      "postcode": 8015,
      "wilaya": 8,
      "name": "Boukais"
    },
    "id": 268,
    "commune_name_ascii": "Boukais",
    "commune_name": "بوكايس",
    "daira_name_ascii": "Lahmar",
    "daira_name": "لحمر",
    "wilaya_code": "8",
    "wilaya_name_ascii": "Bechar",
    "wilaya_name": "بشار"
  },
  {
    "model": "base.commune",
    "pk": 268,
    "fields": {
      "postcode": 8006,
      "wilaya": 8,
      "name": "Lahmar"
    },
    "id": 275,
    "commune_name_ascii": "Lahmar",
    "commune_name": "لحمر",
    "daira_name_ascii": "Lahmar",
    "daira_name": "لحمر",
    "wilaya_code": "8",
    "wilaya_name_ascii": "Bechar",
    "wilaya_name": "بشار"
  },
  {
    "model": "base.commune",
    "pk": 278,
    "fields": {
      "postcode": 8016,
      "wilaya": 8,
      "name": "Mogheul"
    },
    "id": 278,
    "commune_name_ascii": "Mogheul",
    "commune_name": "موغل",
    "daira_name_ascii": "Lahmar",
    "daira_name": "لحمر",
    "wilaya_code": "8",
    "wilaya_name_ascii": "Bechar",
    "wilaya_name": "بشار"
  },
  {
    "model": "base.commune",
    "pk": 266,
    "fields": {
      "postcode": 8004,
      "wilaya": 8,
      "name": "Meridja"
    },
    "id": 277,
    "commune_name_ascii": "Meridja",
    "commune_name": "المريجة",
    "daira_name_ascii": "Kenadsa",
    "daira_name": "القنادسة",
    "wilaya_code": "8",
    "wilaya_name_ascii": "Bechar",
    "wilaya_name": "بشار"
  },
  {
    "model": "base.commune",
    "pk": 275,
    "fields": {
      "postcode": 8013,
      "wilaya": 8,
      "name": "Taghit"
    },
    "id": 281,
    "commune_name_ascii": "Taghit",
    "commune_name": "تاغيت",
    "daira_name_ascii": "Taghit",
    "daira_name": "تاغيت",
    "wilaya_code": "8",
    "wilaya_name_ascii": "Bechar",
    "wilaya_name": "بشار"
  },
  {
    "model": "base.commune",
    "pk": 279,
    "fields": {
      "postcode": 8017,
      "wilaya": 8,
      "name": "Abadla"
    },
    "id": 263,
    "commune_name_ascii": "Abadla",
    "commune_name": "العبادلة",
    "daira_name_ascii": "Abadla",
    "daira_name": "العبادلة",
    "wilaya_code": "8",
    "wilaya_name_ascii": "Bechar",
    "wilaya_name": "بشار"
  },
  {
    "id": 270,
    "commune_name_ascii": "Erg Ferradj",
    "commune_name": "عرق فراج",
    "daira_name_ascii": "Abadla",
    "daira_name": "العبادلة",
    "wilaya_code": "8",
    "wilaya_name_ascii": "Bechar",
    "wilaya_name": "بشار"
  },
  {
    "id": 276,
    "commune_name_ascii": "Machraa Houari Boumediene",
    "commune_name": "مشرع هواري بومدين",
    "daira_name_ascii": "Abadla",
    "daira_name": "العبادلة",
    "wilaya_code": "8",
    "wilaya_name_ascii": "Bechar",
    "wilaya_name": "بشار"
  },
  {
    "id": 267,
    "commune_name_ascii": "Beni Ounif",
    "commune_name": "بني ونيف",
    "daira_name_ascii": "Beni Ounif",
    "daira_name": "بني ونيف",
    "wilaya_code": "8",
    "wilaya_name_ascii": "Bechar",
    "wilaya_name": "بشار"
  },
  {
    "id": 280,
    "commune_name_ascii": "Tabelbala",
    "commune_name": "تبلبالة",
    "daira_name_ascii": "Tabelbala",
    "daira_name": "تبلبالة",
    "wilaya_code": "8",
    "wilaya_name_ascii": "Bechar",
    "wilaya_name": "بشار"
  },
  {
    "id": 272,
    "commune_name_ascii": "Kenadsa",
    "commune_name": "القنادسة",
    "daira_name_ascii": "Kenadsa",
    "daira_name": "القنادسة",
    "wilaya_code": "8",
    "wilaya_name_ascii": "Bechar",
    "wilaya_name": "بشار"
  },
  {
    "model": "base.commune",
    "pk": 304,
    "fields": {
      "postcode": 9025,
      "wilaya": 9,
      "name": "Beni Mered"
    },
    "id": 285,
    "commune_name_ascii": "Beni Mered",
    "commune_name": "بني مراد",
    "daira_name_ascii": "Ouled Yaich",
    "daira_name": "أولاد يعيش",
    "wilaya_code": "9",
    "wilaya_name_ascii": "Blida",
    "wilaya_name": "البليدة"
  },
  {
    "id": 305,
    "commune_name_ascii": "Ouled Slama",
    "commune_name": "اولاد سلامة",
    "daira_name_ascii": "Bougara",
    "daira_name": "بوقرة",
    "wilaya_code": "9",
    "wilaya_name_ascii": "Blida",
    "wilaya_name": "البليدة"
  },
  {
    "model": "base.commune",
    "pk": 295,
    "fields": {
      "postcode": 9016,
      "wilaya": 9,
      "name": "Mouzaia"
    },
    "id": 302,
    "commune_name_ascii": "Mouzaia",
    "commune_name": "موزاية",
    "daira_name_ascii": "Mouzaia",
    "daira_name": "موزاية",
    "wilaya_code": "9",
    "wilaya_name_ascii": "Blida",
    "wilaya_name": "البليدة"
  },
  {
    "id": 299,
    "commune_name_ascii": "Hammam Elouane",
    "commune_name": "حمام ملوان",
    "daira_name_ascii": "Bougara",
    "daira_name": "بوقرة",
    "wilaya_code": "9",
    "wilaya_name_ascii": "Blida",
    "wilaya_name": "البليدة"
  },
  {
    "model": "base.commune",
    "pk": 305,
    "fields": {
      "postcode": 9026,
      "wilaya": 9,
      "name": "Bougara"
    },
    "id": 291,
    "commune_name_ascii": "Bougara",
    "commune_name": "بوقرة",
    "daira_name_ascii": "Bougara",
    "daira_name": "بوقرة",
    "wilaya_code": "9",
    "wilaya_name_ascii": "Blida",
    "wilaya_name": "البليدة"
  },
  {
    "model": "base.commune",
    "pk": 296,
    "fields": {
      "postcode": 9017,
      "wilaya": 9,
      "name": "Souhane"
    },
    "id": 307,
    "commune_name_ascii": "Souhane",
    "commune_name": "صوحان",
    "daira_name_ascii": "Larbaa",
    "daira_name": "الأربعاء",
    "wilaya_code": "9",
    "wilaya_name_ascii": "Blida",
    "wilaya_name": "البليدة"
  },
  {
    "model": "base.commune",
    "pk": 177,
    "fields": {
      "postcode": 5061,
      "wilaya": 5,
      "name": "Larbaa"
    },
    "id": 300,
    "commune_name_ascii": "Larbaa",
    "commune_name": "الأربعاء",
    "daira_name_ascii": "Larbaa",
    "daira_name": "الأربعاء",
    "wilaya_code": "9",
    "wilaya_name_ascii": "Blida",
    "wilaya_name": "البليدة"
  },
  {
    "model": "base.commune",
    "pk": 294,
    "fields": {
      "postcode": 9014,
      "wilaya": 9,
      "name": "Soumaa"
    },
    "id": 308,
    "commune_name_ascii": "Soumaa",
    "commune_name": "الصومعة",
    "daira_name_ascii": "Boufarik",
    "daira_name": "بوفاريك",
    "wilaya_code": "9",
    "wilaya_name_ascii": "Blida",
    "wilaya_name": "البليدة"
  },
  {
    "model": "base.commune",
    "pk": 306,
    "fields": {
      "postcode": 9027,
      "wilaya": 9,
      "name": "Guerrouaou"
    },
    "id": 298,
    "commune_name_ascii": "Guerrouaou",
    "commune_name": "قرواو",
    "daira_name_ascii": "Boufarik",
    "daira_name": "بوفاريك",
    "wilaya_code": "9",
    "wilaya_name_ascii": "Blida",
    "wilaya_name": "البليدة"
  },
  {
    "model": "base.commune",
    "pk": 299,
    "fields": {
      "postcode": 9020,
      "wilaya": 9,
      "name": "Boufarik"
    },
    "id": 290,
    "commune_name_ascii": "Boufarik",
    "commune_name": "بوفاريك",
    "daira_name_ascii": "Boufarik",
    "daira_name": "بوفاريك",
    "wilaya_code": "9",
    "wilaya_name_ascii": "Blida",
    "wilaya_name": "البليدة"
  },
  {
    "model": "base.commune",
    "pk": 297,
    "fields": {
      "postcode": 9018,
      "wilaya": 9,
      "name": "Meftah"
    },
    "id": 301,
    "commune_name_ascii": "Meftah",
    "commune_name": "مفتاح",
    "daira_name_ascii": "Meftah",
    "daira_name": "مفتاح",
    "wilaya_code": "9",
    "wilaya_name_ascii": "Blida",
    "wilaya_name": "البليدة"
  },
  {
    "model": "base.commune",
    "pk": 291,
    "fields": {
      "postcode": 9011,
      "wilaya": 9,
      "name": "Chiffa"
    },
    "id": 294,
    "commune_name_ascii": "Chiffa",
    "commune_name": "الشفة",
    "daira_name_ascii": "Mouzaia",
    "daira_name": "موزاية",
    "wilaya_code": "9",
    "wilaya_name_ascii": "Blida",
    "wilaya_name": "البليدة"
  },
  {
    "model": "base.commune",
    "pk": 307,
    "fields": {
      "postcode": 9028,
      "wilaya": 9,
      "name": "Ain Romana"
    },
    "id": 284,
    "commune_name_ascii": "Ain Romana",
    "commune_name": "عين الرمانة",
    "daira_name_ascii": "Mouzaia",
    "daira_name": "موزاية",
    "wilaya_code": "9",
    "wilaya_name_ascii": "Blida",
    "wilaya_name": "البليدة"
  },
  {
    "id": 303,
    "commune_name_ascii": "Oued  Djer",
    "commune_name": "وادي جر",
    "daira_name_ascii": "El Affroun",
    "daira_name": "العفرون",
    "wilaya_code": "9",
    "wilaya_name_ascii": "Blida",
    "wilaya_name": "البليدة"
  },
  {
    "id": 297,
    "commune_name_ascii": "El Affroun",
    "commune_name": "العفرون",
    "daira_name_ascii": "El Affroun",
    "daira_name": "العفرون",
    "wilaya_code": "9",
    "wilaya_name_ascii": "Blida",
    "wilaya_name": "البليدة"
  },
  {
    "model": "base.commune",
    "pk": 288,
    "fields": {
      "postcode": 9007,
      "wilaya": 9,
      "name": "Ouled Yaich"
    },
    "id": 306,
    "commune_name_ascii": "Ouled Yaich",
    "commune_name": "أولاد يعيش",
    "daira_name_ascii": "Ouled Yaich",
    "daira_name": "أولاد يعيش",
    "wilaya_code": "9",
    "wilaya_name_ascii": "Blida",
    "wilaya_name": "البليدة"
  },
  {
    "model": "base.commune",
    "pk": 289,
    "fields": {
      "postcode": 9008,
      "wilaya": 9,
      "name": "Chrea"
    },
    "id": 295,
    "commune_name_ascii": "Chrea",
    "commune_name": "الشريعة",
    "daira_name_ascii": "Ouled Yaich",
    "daira_name": "أولاد يعيش",
    "wilaya_code": "9",
    "wilaya_name_ascii": "Blida",
    "wilaya_name": "البليدة"
  },
  {
    "model": "base.commune",
    "pk": 308,
    "fields": {
      "postcode": 9029,
      "wilaya": 9,
      "name": "Djebabra"
    },
    "id": 296,
    "commune_name_ascii": "Djebabra",
    "commune_name": "جبابرة",
    "daira_name_ascii": "Meftah",
    "daira_name": "مفتاح",
    "wilaya_code": "9",
    "wilaya_name_ascii": "Blida",
    "wilaya_name": "البليدة"
  },
  {
    "model": "base.commune",
    "pk": 287,
    "fields": {
      "postcode": 9004,
      "wilaya": 9,
      "name": "Oued El Alleug"
    },
    "id": 304,
    "commune_name_ascii": "Oued El Alleug",
    "commune_name": "وادي العلايق",
    "daira_name_ascii": "Oued El Alleug",
    "daira_name": "وادي العلايق",
    "wilaya_code": "9",
    "wilaya_name_ascii": "Blida",
    "wilaya_name": "البليدة"
  },
  {
    "id": 287,
    "commune_name_ascii": "Benkhelil",
    "commune_name": "بن خليل",
    "daira_name_ascii": "Oued El Alleug",
    "daira_name": "وادي العلايق",
    "wilaya_code": "9",
    "wilaya_name_ascii": "Blida",
    "wilaya_name": "البليدة"
  },
  {
    "id": 286,
    "commune_name_ascii": "Beni Tamou",
    "commune_name": "بني تامو",
    "daira_name_ascii": "Oued El Alleug",
    "daira_name": "وادي العلايق",
    "wilaya_code": "9",
    "wilaya_name_ascii": "Blida",
    "wilaya_name": "البليدة"
  },
  {
    "model": "base.commune",
    "pk": 285,
    "fields": {
      "postcode": 9002,
      "wilaya": 9,
      "name": "Chebli"
    },
    "id": 293,
    "commune_name_ascii": "Chebli",
    "commune_name": "الشبلي",
    "daira_name_ascii": "Bouinan",
    "daira_name": "بوعينان",
    "wilaya_code": "9",
    "wilaya_name_ascii": "Blida",
    "wilaya_name": "البليدة"
  },
  {
    "model": "base.commune",
    "pk": 286,
    "fields": {
      "postcode": 9003,
      "wilaya": 9,
      "name": "Bouinan"
    },
    "id": 292,
    "commune_name_ascii": "Bouinan",
    "commune_name": "بوعينان",
    "daira_name_ascii": "Bouinan",
    "daira_name": "بوعينان",
    "wilaya_code": "9",
    "wilaya_name_ascii": "Blida",
    "wilaya_name": "البليدة"
  },
  {
    "model": "base.commune",
    "pk": 303,
    "fields": {
      "postcode": 9024,
      "wilaya": 9,
      "name": "Bouarfa"
    },
    "id": 289,
    "commune_name_ascii": "Bouarfa",
    "commune_name": "بوعرفة",
    "daira_name_ascii": "Blida",
    "daira_name": "البليدة",
    "wilaya_code": "9",
    "wilaya_name_ascii": "Blida",
    "wilaya_name": "البليدة"
  },
  {
    "model": "base.commune",
    "pk": 284,
    "fields": {
      "postcode": 9001,
      "wilaya": 9,
      "name": "Blida"
    },
    "id": 288,
    "commune_name_ascii": "Blida",
    "commune_name": "البليدة",
    "daira_name_ascii": "Blida",
    "daira_name": "البليدة",
    "wilaya_code": "9",
    "wilaya_name_ascii": "Blida",
    "wilaya_name": "البليدة"
  },
  {
    "model": "base.commune",
    "pk": 349,
    "fields": {
      "postcode": 10041,
      "wilaya": 10,
      "name": "Ain Laloui"
    },
    "id": 312,
    "commune_name_ascii": "Ain Laloui",
    "commune_name": "عين العلوي",
    "daira_name_ascii": "Ain Bessem",
    "daira_name": "عين بسام",
    "wilaya_code": "10",
    "wilaya_name_ascii": "Bouira",
    "wilaya_name": "البويرة"
  },
  {
    "model": "base.commune",
    "pk": 350,
    "fields": {
      "postcode": 10042,
      "wilaya": 10,
      "name": "Hadjera Zerga"
    },
    "id": 334,
    "commune_name_ascii": "Hadjera Zerga",
    "commune_name": "الحجرة الزرقاء",
    "daira_name_ascii": "Bordj Okhriss",
    "daira_name": "برج أوخريص",
    "wilaya_code": "10",
    "wilaya_name_ascii": "Bouira",
    "wilaya_name": "البويرة"
  },
  {
    "model": "base.commune",
    "pk": 319,
    "fields": {
      "postcode": 10011,
      "wilaya": 10,
      "name": "Mezdour"
    },
    "id": 342,
    "commune_name_ascii": "Mezdour",
    "commune_name": "مزدور",
    "daira_name_ascii": "Bordj Okhriss",
    "daira_name": "برج أوخريص",
    "wilaya_code": "10",
    "wilaya_name_ascii": "Bouira",
    "wilaya_name": "البويرة"
  },
  {
    "id": 351,
    "commune_name_ascii": "Taguedite",
    "commune_name": "تاقديت",
    "daira_name_ascii": "Bordj Okhriss",
    "daira_name": "برج أوخريص",
    "wilaya_code": "10",
    "wilaya_name_ascii": "Bouira",
    "wilaya_name": "البويرة"
  },
  {
    "model": "base.commune",
    "pk": 340,
    "fields": {
      "postcode": 10032,
      "wilaya": 10,
      "name": "Ridane"
    },
    "id": 346,
    "commune_name_ascii": "Ridane",
    "commune_name": "ريدان",
    "daira_name_ascii": "Sour El Ghozlane",
    "daira_name": "سور الغزلان",
    "wilaya_code": "10",
    "wilaya_name_ascii": "Bouira",
    "wilaya_name": "البويرة"
  },
  {
    "model": "base.commune",
    "pk": 347,
    "fields": {
      "postcode": 10039,
      "wilaya": 10,
      "name": "Maamora"
    },
    "id": 341,
    "commune_name_ascii": "Maamora",
    "commune_name": "المعمورة",
    "daira_name_ascii": "Sour El Ghozlane",
    "daira_name": "سور الغزلان",
    "wilaya_code": "10",
    "wilaya_name_ascii": "Bouira",
    "wilaya_name": "البويرة"
  },
  {
    "id": 331,
    "commune_name_ascii": "El Hakimia",
    "commune_name": "الحاكمية",
    "daira_name_ascii": "Sour El Ghozlane",
    "daira_name": "سور الغزلان",
    "wilaya_code": "10",
    "wilaya_name_ascii": "Bouira",
    "wilaya_name": "البويرة"
  },
  {
    "model": "base.commune",
    "pk": 330,
    "fields": {
      "postcode": 10022,
      "wilaya": 10,
      "name": "Ahl El Ksar"
    },
    "id": 310,
    "commune_name_ascii": "Ahl El Ksar",
    "commune_name": "أهل القصر",
    "daira_name_ascii": "Bechloul",
    "daira_name": "بشلول",
    "wilaya_code": "10",
    "wilaya_name_ascii": "Bouira",
    "wilaya_name": "البويرة"
  },
  {
    "model": "base.commune",
    "pk": 315,
    "fields": {
      "postcode": 10007,
      "wilaya": 10,
      "name": "Dirah"
    },
    "id": 325,
    "commune_name_ascii": "Dirah",
    "commune_name": "ديرة",
    "daira_name_ascii": "Sour El Ghozlane",
    "daira_name": "سور الغزلان",
    "wilaya_code": "10",
    "wilaya_name_ascii": "Bouira",
    "wilaya_name": "البويرة"
  },
  {
    "model": "base.commune",
    "pk": 339,
    "fields": {
      "postcode": 10031,
      "wilaya": 10,
      "name": "Dechmia"
    },
    "id": 324,
    "commune_name_ascii": "Dechmia",
    "commune_name": "الدشمية",
    "daira_name_ascii": "Sour El Ghozlane",
    "daira_name": "سور الغزلان",
    "wilaya_code": "10",
    "wilaya_name_ascii": "Bouira",
    "wilaya_name": "البويرة"
  },
  {
    "model": "base.commune",
    "pk": 341,
    "fields": {
      "postcode": 10033,
      "wilaya": 10,
      "name": "Bechloul"
    },
    "id": 317,
    "commune_name_ascii": "Bechloul",
    "commune_name": "بشلول",
    "daira_name_ascii": "Bechloul",
    "daira_name": "بشلول",
    "wilaya_code": "10",
    "wilaya_name_ascii": "Bouira",
    "wilaya_name": "البويرة"
  },
  {
    "model": "base.commune",
    "pk": 351,
    "fields": {
      "postcode": 10043,
      "wilaya": 10,
      "name": "Ath Mansour"
    },
    "id": 352,
    "commune_name_ascii": "Ath Mansour",
    "commune_name": "آث  منصور",
    "daira_name_ascii": "M'chedallah",
    "daira_name": "مشد الله",
    "wilaya_code": "10",
    "wilaya_name_ascii": "Bouira",
    "wilaya_name": "البويرة"
  },
  {
    "model": "base.commune",
    "pk": 338,
    "fields": {
      "postcode": 10030,
      "wilaya": 10,
      "name": "Saharidj"
    },
    "id": 347,
    "commune_name_ascii": "Saharidj",
    "commune_name": "سحاريج",
    "daira_name_ascii": "M'chedallah",
    "daira_name": "مشد الله",
    "wilaya_code": "10",
    "wilaya_name_ascii": "Bouira",
    "wilaya_name": "البويرة"
  },
  {
    "model": "base.commune",
    "pk": 327,
    "fields": {
      "postcode": 10019,
      "wilaya": 10,
      "name": "El Adjiba"
    },
    "id": 327,
    "commune_name_ascii": "El Adjiba",
    "commune_name": "العجيبة",
    "daira_name_ascii": "Bechloul",
    "daira_name": "بشلول",
    "wilaya_code": "10",
    "wilaya_name_ascii": "Bouira",
    "wilaya_name": "البويرة"
  },
  {
    "model": "base.commune",
    "pk": 310,
    "fields": {
      "postcode": 10002,
      "wilaya": 10,
      "name": "El Asnam"
    },
    "id": 328,
    "commune_name_ascii": "El Asnam",
    "commune_name": "الأسنام",
    "daira_name_ascii": "Bechloul",
    "daira_name": "بشلول",
    "wilaya_code": "10",
    "wilaya_name_ascii": "Bouira",
    "wilaya_name": "البويرة"
  },
  {
    "id": 339,
    "commune_name_ascii": "M Chedallah",
    "commune_name": "أمشدالة",
    "daira_name_ascii": "M'chedallah",
    "daira_name": "مشد الله",
    "wilaya_code": "10",
    "wilaya_name_ascii": "Bouira",
    "wilaya_name": "البويرة"
  },
  {
    "id": 319,
    "commune_name_ascii": "Bordj Okhriss",
    "commune_name": "برج أوخريص",
    "daira_name_ascii": "Bordj Okhriss",
    "daira_name": "برج أوخريص",
    "wilaya_code": "10",
    "wilaya_name_ascii": "Bouira",
    "wilaya_name": "البويرة"
  },
  {
    "model": "base.commune",
    "pk": 346,
    "fields": {
      "postcode": 10038,
      "wilaya": 10,
      "name": "Sour El Ghozlane"
    },
    "id": 349,
    "commune_name_ascii": "Sour El Ghozlane",
    "commune_name": "سور الغزلان",
    "daira_name_ascii": "Sour El Ghozlane",
    "daira_name": "سور الغزلان",
    "wilaya_code": "10",
    "wilaya_name_ascii": "Bouira",
    "wilaya_name": "البويرة"
  },
  {
    "model": "base.commune",
    "pk": 314,
    "fields": {
      "postcode": 10006,
      "wilaya": 10,
      "name": "Hanif"
    },
    "id": 336,
    "commune_name_ascii": "Hanif",
    "commune_name": "حنيف",
    "daira_name_ascii": "M'chedallah",
    "daira_name": "مشد الله",
    "wilaya_code": "10",
    "wilaya_name_ascii": "Bouira",
    "wilaya_name": "البويرة"
  },
  {
    "model": "base.commune",
    "pk": 325,
    "fields": {
      "postcode": 10017,
      "wilaya": 10,
      "name": "Chorfa"
    },
    "id": 323,
    "commune_name_ascii": "Chorfa",
    "commune_name": "شرفة",
    "daira_name_ascii": "M'chedallah",
    "daira_name": "مشد الله",
    "wilaya_code": "10",
    "wilaya_name_ascii": "Bouira",
    "wilaya_name": "البويرة"
  },
  {
    "model": "base.commune",
    "pk": 348,
    "fields": {
      "postcode": 10040,
      "wilaya": 10,
      "name": "Ouled Rached"
    },
    "id": 344,
    "commune_name_ascii": "Ouled Rached",
    "commune_name": "أولاد راشد",
    "daira_name_ascii": "Bechloul",
    "daira_name": "بشلول",
    "wilaya_code": "10",
    "wilaya_name_ascii": "Bouira",
    "wilaya_name": "البويرة"
  },
  {
    "model": "base.commune",
    "pk": 333,
    "fields": {
      "postcode": 10025,
      "wilaya": 10,
      "name": "Ain El Hadjar"
    },
    "id": 311,
    "commune_name_ascii": "Ain El Hadjar",
    "commune_name": "عين الحجر",
    "daira_name_ascii": "Ain Bessem",
    "daira_name": "عين بسام",
    "wilaya_code": "10",
    "wilaya_name_ascii": "Bouira",
    "wilaya_name": "البويرة"
  },
  {
    "model": "base.commune",
    "pk": 335,
    "fields": {
      "postcode": 10027,
      "wilaya": 10,
      "name": "Aghbalou"
    },
    "id": 309,
    "commune_name_ascii": "Aghbalou",
    "commune_name": "أغبالو",
    "daira_name_ascii": "M'chedallah",
    "daira_name": "مشد الله",
    "wilaya_code": "10",
    "wilaya_name_ascii": "Bouira",
    "wilaya_name": "البويرة"
  },
  {
    "model": "base.commune",
    "pk": 318,
    "fields": {
      "postcode": 10010,
      "wilaya": 10,
      "name": "Raouraoua"
    },
    "id": 345,
    "commune_name_ascii": "Raouraoua",
    "commune_name": "روراوة",
    "daira_name_ascii": "Bir Ghbalou",
    "daira_name": "بئر غبالو",
    "wilaya_code": "10",
    "wilaya_name_ascii": "Bouira",
    "wilaya_name": "البويرة"
  },
  {
    "id": 330,
    "commune_name_ascii": "El Khabouzia",
    "commune_name": "الخبوزية",
    "daira_name_ascii": "Bir Ghbalou",
    "daira_name": "بئر غبالو",
    "wilaya_code": "10",
    "wilaya_name_ascii": "Bouira",
    "wilaya_name": "البويرة"
  },
  {
    "model": "base.commune",
    "pk": 344,
    "fields": {
      "postcode": 10036,
      "wilaya": 10,
      "name": "Bir Ghbalou"
    },
    "id": 318,
    "commune_name_ascii": "Bir Ghbalou",
    "commune_name": "بئر غبالو",
    "daira_name_ascii": "Bir Ghbalou",
    "daira_name": "بئر غبالو",
    "wilaya_code": "10",
    "wilaya_name_ascii": "Bouira",
    "wilaya_name": "البويرة"
  },
  {
    "model": "base.commune",
    "pk": 309,
    "fields": {
      "postcode": 10001,
      "wilaya": 10,
      "name": "Bouira"
    },
    "id": 321,
    "commune_name_ascii": "Bouira",
    "commune_name": "البويرة",
    "daira_name_ascii": "Bouira",
    "daira_name": "البويرة",
    "wilaya_code": "10",
    "wilaya_name_ascii": "Bouira",
    "wilaya_name": "البويرة"
  },
  {
    "model": "base.commune",
    "pk": 337,
    "fields": {
      "postcode": 10029,
      "wilaya": 10,
      "name": "Ain Turk"
    },
    "id": 313,
    "commune_name_ascii": "Ain Turk",
    "commune_name": "عين الترك",
    "daira_name_ascii": "Bouira",
    "daira_name": "البويرة",
    "wilaya_code": "10",
    "wilaya_name_ascii": "Bouira",
    "wilaya_name": "البويرة"
  },
  {
    "model": "base.commune",
    "pk": 316,
    "fields": {
      "postcode": 10008,
      "wilaya": 10,
      "name": "Ait Laaziz"
    },
    "id": 315,
    "commune_name_ascii": "Ait Laaziz",
    "commune_name": "أيت لعزيز",
    "daira_name_ascii": "Bouira",
    "daira_name": "البويرة",
    "wilaya_code": "10",
    "wilaya_name_ascii": "Bouira",
    "wilaya_name": "البويرة"
  },
  {
    "id": 314,
    "commune_name_ascii": "Ain Bessem",
    "commune_name": "عين بسام",
    "daira_name_ascii": "Ain Bessem",
    "daira_name": "عين بسام",
    "wilaya_code": "10",
    "wilaya_name_ascii": "Bouira",
    "wilaya_name": "البويرة"
  },
  {
    "id": 332,
    "commune_name_ascii": "El Mokrani",
    "commune_name": "المقراني",
    "daira_name_ascii": "Souk El Khemis",
    "daira_name": "سوق الخميس",
    "wilaya_code": "10",
    "wilaya_name_ascii": "Bouira",
    "wilaya_name": "البويرة"
  },
  {
    "model": "base.commune",
    "pk": 312,
    "fields": {
      "postcode": 10004,
      "wilaya": 10,
      "name": "Souk El Khemis"
    },
    "id": 348,
    "commune_name_ascii": "Souk El Khemis",
    "commune_name": "سوق الخميس",
    "daira_name_ascii": "Souk El Khemis",
    "daira_name": "سوق الخميس",
    "wilaya_code": "10",
    "wilaya_name_ascii": "Bouira",
    "wilaya_name": "البويرة"
  },
  {
    "model": "base.commune",
    "pk": 324,
    "fields": {
      "postcode": 10016,
      "wilaya": 10,
      "name": "Aomar"
    },
    "id": 316,
    "commune_name_ascii": "Aomar",
    "commune_name": "أعمر",
    "daira_name_ascii": "Kadiria",
    "daira_name": "القادرية",
    "wilaya_code": "10",
    "wilaya_name_ascii": "Bouira",
    "wilaya_name": "البويرة"
  },
  {
    "model": "base.commune",
    "pk": 334,
    "fields": {
      "postcode": 10026,
      "wilaya": 10,
      "name": "Djebahia"
    },
    "id": 326,
    "commune_name_ascii": "Djebahia",
    "commune_name": "جباحية",
    "daira_name_ascii": "Kadiria",
    "daira_name": "القادرية",
    "wilaya_code": "10",
    "wilaya_name_ascii": "Bouira",
    "wilaya_name": "البويرة"
  },
  {
    "model": "base.commune",
    "pk": 323,
    "fields": {
      "postcode": 10015,
      "wilaya": 10,
      "name": "El Hachimia"
    },
    "id": 329,
    "commune_name_ascii": "El Hachimia",
    "commune_name": "الهاشمية",
    "daira_name_ascii": "El Hachimia",
    "daira_name": "الهاشمية",
    "wilaya_code": "10",
    "wilaya_name_ascii": "Bouira",
    "wilaya_name": "البويرة"
  },
  {
    "model": "base.commune",
    "pk": 320,
    "fields": {
      "postcode": 10012,
      "wilaya": 10,
      "name": "Haizer"
    },
    "id": 335,
    "commune_name_ascii": "Haizer",
    "commune_name": "حيزر",
    "daira_name_ascii": "Haizer",
    "daira_name": "الحيزر",
    "wilaya_code": "10",
    "wilaya_name_ascii": "Bouira",
    "wilaya_name": "البويرة"
  },
  {
    "model": "base.commune",
    "pk": 317,
    "fields": {
      "postcode": 10009,
      "wilaya": 10,
      "name": "Taghzout"
    },
    "id": 350,
    "commune_name_ascii": "Taghzout",
    "commune_name": "تاغزوت",
    "daira_name_ascii": "Haizer",
    "daira_name": "الحيزر",
    "wilaya_code": "10",
    "wilaya_name_ascii": "Bouira",
    "wilaya_name": "البويرة"
  },
  {
    "model": "base.commune",
    "pk": 331,
    "fields": {
      "postcode": 10023,
      "wilaya": 10,
      "name": "Bouderbala"
    },
    "id": 320,
    "commune_name_ascii": "Bouderbala",
    "commune_name": "بودربالة",
    "daira_name_ascii": "Lakhdaria",
    "daira_name": "الأخضرية",
    "wilaya_code": "10",
    "wilaya_name_ascii": "Bouira",
    "wilaya_name": "البويرة"
  },
  {
    "model": "base.commune",
    "pk": 342,
    "fields": {
      "postcode": 10034,
      "wilaya": 10,
      "name": "Boukram"
    },
    "id": 322,
    "commune_name_ascii": "Boukram",
    "commune_name": "بوكرم",
    "daira_name_ascii": "Lakhdaria",
    "daira_name": "الأخضرية",
    "wilaya_code": "10",
    "wilaya_name_ascii": "Bouira",
    "wilaya_name": "البويرة"
  },
  {
    "model": "base.commune",
    "pk": 311,
    "fields": {
      "postcode": 10003,
      "wilaya": 10,
      "name": "Guerrouma"
    },
    "id": 333,
    "commune_name_ascii": "Guerrouma",
    "commune_name": "قرومة",
    "daira_name_ascii": "Lakhdaria",
    "daira_name": "الأخضرية",
    "wilaya_code": "10",
    "wilaya_name_ascii": "Bouira",
    "wilaya_name": "البويرة"
  },
  {
    "model": "base.commune",
    "pk": 321,
    "fields": {
      "postcode": 10013,
      "wilaya": 10,
      "name": "Lakhdaria"
    },
    "id": 338,
    "commune_name_ascii": "Lakhdaria",
    "commune_name": "الأخضرية",
    "daira_name_ascii": "Lakhdaria",
    "daira_name": "الأخضرية",
    "wilaya_code": "10",
    "wilaya_name_ascii": "Bouira",
    "wilaya_name": "البويرة"
  },
  {
    "model": "base.commune",
    "pk": 322,
    "fields": {
      "postcode": 10014,
      "wilaya": 10,
      "name": "Maala"
    },
    "id": 340,
    "commune_name_ascii": "Maala",
    "commune_name": "معلة",
    "daira_name_ascii": "Lakhdaria",
    "daira_name": "الأخضرية",
    "wilaya_code": "10",
    "wilaya_name_ascii": "Bouira",
    "wilaya_name": "البويرة"
  },
  {
    "model": "base.commune",
    "pk": 313,
    "fields": {
      "postcode": 10005,
      "wilaya": 10,
      "name": "Kadiria"
    },
    "id": 337,
    "commune_name_ascii": "Kadiria",
    "commune_name": "قادرية",
    "daira_name_ascii": "Kadiria",
    "daira_name": "القادرية",
    "wilaya_code": "10",
    "wilaya_name_ascii": "Bouira",
    "wilaya_name": "البويرة"
  },
  {
    "id": 353,
    "commune_name_ascii": "Z'barbar (El Isseri )",
    "commune_name": "زبربر",
    "daira_name_ascii": "Lakhdaria",
    "daira_name": "الأخضرية",
    "wilaya_code": "10",
    "wilaya_name_ascii": "Bouira",
    "wilaya_name": "البويرة"
  },
  {
    "model": "base.commune",
    "pk": 353,
    "fields": {
      "postcode": 10045,
      "wilaya": 10,
      "name": "Oued El Berdi"
    },
    "id": 343,
    "commune_name_ascii": "Oued El Berdi",
    "commune_name": "وادي البردي",
    "daira_name_ascii": "El Hachimia",
    "daira_name": "الهاشمية",
    "wilaya_code": "10",
    "wilaya_name_ascii": "Bouira",
    "wilaya_name": "البويرة"
  },
  {
    "id": 362,
    "commune_name_ascii": "Tazrouk",
    "commune_name": "تاظروك",
    "daira_name_ascii": "Tazrouk",
    "daira_name": "تاظروك",
    "wilaya_code": "11",
    "wilaya_name_ascii": "Tamanrasset",
    "wilaya_name": "تمنراست"
  },
  {
    "id": 354,
    "commune_name_ascii": "Abelsa",
    "commune_name": "ابلسة",
    "daira_name_ascii": "Silet",
    "daira_name": "سيلت",
    "wilaya_code": "11",
    "wilaya_name_ascii": "Tamanrasset",
    "wilaya_name": "تمنراست"
  },
  {
    "id": 361,
    "commune_name_ascii": "Tamanrasset",
    "commune_name": "تمنراست",
    "daira_name_ascii": "Tamanrasset",
    "daira_name": "تمنراست",
    "wilaya_code": "11",
    "wilaya_name_ascii": "Tamanrasset",
    "wilaya_name": "تمنراست"
  },
  {
    "id": 355,
    "commune_name_ascii": "Ain Amguel",
    "commune_name": "عين امقل",
    "daira_name_ascii": "Tamanrasset",
    "daira_name": "تمنراست",
    "wilaya_code": "11",
    "wilaya_name_ascii": "Tamanrasset",
    "wilaya_name": "تمنراست"
  },
  {
    "model": "base.commune",
    "pk": 358,
    "fields": {
      "postcode": 11005,
      "wilaya": 11,
      "name": "Idles"
    },
    "id": 359,
    "commune_name_ascii": "Idles",
    "commune_name": "أدلس",
    "daira_name_ascii": "Tazrouk",
    "daira_name": "تاظروك",
    "wilaya_code": "11",
    "wilaya_name_ascii": "Tamanrasset",
    "wilaya_name": "تمنراست"
  },
  {
    "id": 380,
    "commune_name_ascii": "El Houidjbet",
    "commune_name": "الحويجبات",
    "daira_name_ascii": "El Malabiod",
    "daira_name": "الماء الابيض",
    "wilaya_code": "12",
    "wilaya_name_ascii": "Tebessa",
    "wilaya_name": "تبسة"
  },
  {
    "id": 379,
    "commune_name_ascii": "El Aouinet",
    "commune_name": "العوينات",
    "daira_name_ascii": "El Aouinet",
    "daira_name": "العوينات",
    "wilaya_code": "12",
    "wilaya_name_ascii": "Tebessa",
    "wilaya_name": "تبسة"
  },
  {
    "model": "base.commune",
    "pk": 391,
    "fields": {
      "postcode": 12028,
      "wilaya": 12,
      "name": "Ferkane"
    },
    "id": 381,
    "commune_name_ascii": "Ferkane",
    "commune_name": "فركان",
    "daira_name_ascii": "Negrine",
    "daira_name": "نقرين",
    "wilaya_code": "12",
    "wilaya_name_ascii": "Tebessa",
    "wilaya_name": "تبسة"
  },
  {
    "model": "base.commune",
    "pk": 372,
    "fields": {
      "postcode": 12009,
      "wilaya": 12,
      "name": "Negrine"
    },
    "id": 385,
    "commune_name_ascii": "Negrine",
    "commune_name": "نقرين",
    "daira_name_ascii": "Negrine",
    "daira_name": "نقرين",
    "wilaya_code": "12",
    "wilaya_name_ascii": "Tebessa",
    "wilaya_name": "تبسة"
  },
  {
    "id": 368,
    "commune_name_ascii": "Bir Mokkadem",
    "commune_name": "بئر مقدم",
    "daira_name_ascii": "Bir Mokadem",
    "daira_name": "بئر مقدم",
    "wilaya_code": "12",
    "wilaya_name_ascii": "Tebessa",
    "wilaya_name": "تبسة"
  },
  {
    "model": "base.commune",
    "pk": 377,
    "fields": {
      "postcode": 12014,
      "wilaya": 12,
      "name": "Bir Dheheb"
    },
    "id": 367,
    "commune_name_ascii": "Bir Dheheb",
    "commune_name": "بئر الذهب",
    "daira_name_ascii": "Morsott",
    "daira_name": "مرسط",
    "wilaya_code": "12",
    "wilaya_name_ascii": "Tebessa",
    "wilaya_name": "تبسة"
  },
  {
    "id": 388,
    "commune_name_ascii": "Saf Saf El Ouesra",
    "commune_name": "صفصاف الوسرى",
    "daira_name_ascii": "Oum Ali",
    "daira_name": "أم علي",
    "wilaya_code": "12",
    "wilaya_name_ascii": "Tebessa",
    "wilaya_name": "تبسة"
  },
  {
    "id": 382,
    "commune_name_ascii": "Guorriguer",
    "commune_name": "قريقر",
    "daira_name_ascii": "Bir Mokadem",
    "daira_name": "بئر مقدم",
    "wilaya_code": "12",
    "wilaya_name_ascii": "Tebessa",
    "wilaya_name": "تبسة"
  },
  {
    "model": "base.commune",
    "pk": 380,
    "fields": {
      "postcode": 12017,
      "wilaya": 12,
      "name": "Bekkaria"
    },
    "id": 366,
    "commune_name_ascii": "Bekkaria",
    "commune_name": "بكارية",
    "daira_name_ascii": "El Kouif",
    "daira_name": "الكويف",
    "wilaya_code": "12",
    "wilaya_name_ascii": "Tebessa",
    "wilaya_name": "تبسة"
  },
  {
    "model": "base.commune",
    "pk": 388,
    "fields": {
      "postcode": 12025,
      "wilaya": 12,
      "name": "Boulhaf Dyr"
    },
    "id": 371,
    "commune_name_ascii": "Boulhaf Dyr",
    "commune_name": "بولحاف الدير",
    "daira_name_ascii": "El Kouif",
    "daira_name": "الكويف",
    "wilaya_code": "12",
    "wilaya_name_ascii": "Tebessa",
    "wilaya_name": "تبسة"
  },
  {
    "model": "base.commune",
    "pk": 384,
    "fields": {
      "postcode": 12021,
      "wilaya": 12,
      "name": "Oum Ali"
    },
    "id": 387,
    "commune_name_ascii": "Oum Ali",
    "commune_name": "أم علي",
    "daira_name_ascii": "Oum Ali",
    "daira_name": "أم علي",
    "wilaya_code": "12",
    "wilaya_name_ascii": "Tebessa",
    "wilaya_name": "تبسة"
  },
  {
    "model": "base.commune",
    "pk": 381,
    "fields": {
      "postcode": 12018,
      "wilaya": 12,
      "name": "Boukhadra"
    },
    "id": 370,
    "commune_name_ascii": "Boukhadra",
    "commune_name": "بوخضرة",
    "daira_name_ascii": "El Aouinet",
    "daira_name": "العوينات",
    "wilaya_code": "12",
    "wilaya_name_ascii": "Tebessa",
    "wilaya_name": "تبسة"
  },
  {
    "id": 374,
    "commune_name_ascii": "El Malabiod",
    "commune_name": "الماء الابيض",
    "daira_name_ascii": "El Malabiod",
    "daira_name": "الماء الابيض",
    "wilaya_code": "12",
    "wilaya_name_ascii": "Tebessa",
    "wilaya_name": "تبسة"
  },
  {
    "model": "base.commune",
    "pk": 382,
    "fields": {
      "postcode": 12019,
      "wilaya": 12,
      "name": "Ouenza"
    },
    "id": 386,
    "commune_name_ascii": "Ouenza",
    "commune_name": "الونزة",
    "daira_name_ascii": "Ouenza",
    "daira_name": "الونزة",
    "wilaya_code": "12",
    "wilaya_name_ascii": "Tebessa",
    "wilaya_name": "تبسة"
  },
  {
    "model": "base.commune",
    "pk": 387,
    "fields": {
      "postcode": 12024,
      "wilaya": 12,
      "name": "El Meridj"
    },
    "id": 375,
    "commune_name_ascii": "El Meridj",
    "commune_name": "المريج",
    "daira_name_ascii": "Ouenza",
    "daira_name": "الونزة",
    "wilaya_code": "12",
    "wilaya_name_ascii": "Tebessa",
    "wilaya_name": "تبسة"
  },
  {
    "model": "base.commune",
    "pk": 386,
    "fields": {
      "postcode": 12023,
      "wilaya": 12,
      "name": "Ain Zerga"
    },
    "id": 364,
    "commune_name_ascii": "Ain Zerga",
    "commune_name": "عين الزرقاء",
    "daira_name_ascii": "Ouenza",
    "daira_name": "الونزة",
    "wilaya_code": "12",
    "wilaya_name_ascii": "Tebessa",
    "wilaya_name": "تبسة"
  },
  {
    "model": "base.commune",
    "pk": 367,
    "fields": {
      "postcode": 12004,
      "wilaya": 12,
      "name": "Stah Guentis"
    },
    "id": 389,
    "commune_name_ascii": "Stah Guentis",
    "commune_name": "سطح قنطيس",
    "daira_name_ascii": "El Ogla",
    "daira_name": "العقلة",
    "wilaya_code": "12",
    "wilaya_name_ascii": "Tebessa",
    "wilaya_name": "تبسة"
  },
  {
    "model": "base.commune",
    "pk": 376,
    "fields": {
      "postcode": 12013,
      "wilaya": 12,
      "name": "El Ogla"
    },
    "id": 377,
    "commune_name_ascii": "El Ogla",
    "commune_name": "العقلة",
    "daira_name_ascii": "El Ogla",
    "daira_name": "العقلة",
    "wilaya_code": "12",
    "wilaya_name_ascii": "Tebessa",
    "wilaya_name": "تبسة"
  },
  {
    "id": 376,
    "commune_name_ascii": "El Mezeraa",
    "commune_name": "المزرعة",
    "daira_name_ascii": "El Ogla",
    "daira_name": "العقلة",
    "wilaya_code": "12",
    "wilaya_name_ascii": "Tebessa",
    "wilaya_name": "تبسة"
  },
  {
    "model": "base.commune",
    "pk": 389,
    "fields": {
      "postcode": 12026,
      "wilaya": 12,
      "name": "Bedjene"
    },
    "id": 365,
    "commune_name_ascii": "Bedjene",
    "commune_name": "بجن",
    "daira_name_ascii": "El Ogla",
    "daira_name": "العقلة",
    "wilaya_code": "12",
    "wilaya_name_ascii": "Tebessa",
    "wilaya_name": "تبسة"
  },
  {
    "model": "base.commune",
    "pk": 375,
    "fields": {
      "postcode": 12012,
      "wilaya": 12,
      "name": "Morsott"
    },
    "id": 384,
    "commune_name_ascii": "Morsott",
    "commune_name": "مرسط",
    "daira_name_ascii": "Morsott",
    "daira_name": "مرسط",
    "wilaya_code": "12",
    "wilaya_name_ascii": "Tebessa",
    "wilaya_name": "تبسة"
  },
  {
    "id": 391,
    "commune_name_ascii": "Telidjen",
    "commune_name": "ثليجان",
    "daira_name_ascii": "Cheria",
    "daira_name": "الشريعة",
    "wilaya_code": "12",
    "wilaya_name_ascii": "Tebessa",
    "wilaya_name": "تبسة"
  },
  {
    "model": "base.commune",
    "pk": 366,
    "fields": {
      "postcode": 12003,
      "wilaya": 12,
      "name": "Cheria"
    },
    "id": 372,
    "commune_name_ascii": "Cheria",
    "commune_name": "الشريعة",
    "daira_name_ascii": "Cheria",
    "daira_name": "الشريعة",
    "wilaya_code": "12",
    "wilaya_name_ascii": "Tebessa",
    "wilaya_name": "تبسة"
  },
  {
    "model": "base.commune",
    "pk": 378,
    "fields": {
      "postcode": 12015,
      "wilaya": 12,
      "name": "El Ogla El Malha"
    },
    "id": 378,
    "commune_name_ascii": "El Ogla El Malha",
    "commune_name": "العقلة المالحة",
    "daira_name_ascii": "Bir-El-Ater",
    "daira_name": "بئر العاتر",
    "wilaya_code": "12",
    "wilaya_name_ascii": "Tebessa",
    "wilaya_name": "تبسة"
  },
  {
    "id": 369,
    "commune_name_ascii": "Bir-El-Ater",
    "commune_name": "بئر العاتر",
    "daira_name_ascii": "Bir-El-Ater",
    "daira_name": "بئر العاتر",
    "wilaya_code": "12",
    "wilaya_name_ascii": "Tebessa",
    "wilaya_name": "تبسة"
  },
  {
    "model": "base.commune",
    "pk": 364,
    "fields": {
      "postcode": 12001,
      "wilaya": 12,
      "name": "Tebessa"
    },
    "id": 390,
    "commune_name_ascii": "Tebessa",
    "commune_name": "تبسة",
    "daira_name_ascii": "Tebessa",
    "daira_name": "تبسة",
    "wilaya_code": "12",
    "wilaya_name_ascii": "Tebessa",
    "wilaya_name": "تبسة"
  },
  {
    "model": "base.commune",
    "pk": 371,
    "fields": {
      "postcode": 12008,
      "wilaya": 12,
      "name": "Hammamet"
    },
    "id": 383,
    "commune_name_ascii": "Hammamet",
    "commune_name": "الحمامات",
    "daira_name_ascii": "Bir Mokadem",
    "daira_name": "بئر مقدم",
    "wilaya_code": "12",
    "wilaya_name_ascii": "Tebessa",
    "wilaya_name": "تبسة"
  },
  {
    "model": "base.commune",
    "pk": 374,
    "fields": {
      "postcode": 12011,
      "wilaya": 12,
      "name": "El Kouif"
    },
    "id": 373,
    "commune_name_ascii": "El Kouif",
    "commune_name": "الكويف",
    "daira_name_ascii": "El Kouif",
    "daira_name": "الكويف",
    "wilaya_code": "12",
    "wilaya_name_ascii": "Tebessa",
    "wilaya_name": "تبسة"
  },
  {
    "model": "base.commune",
    "pk": 409,
    "fields": {
      "postcode": 13018,
      "wilaya": 13,
      "name": "Bab El Assa"
    },
    "id": 400,
    "commune_name_ascii": "Bab El Assa",
    "commune_name": "باب العسة",
    "daira_name_ascii": "Bab El Assa",
    "daira_name": "باب العسة",
    "wilaya_code": "13",
    "wilaya_name_ascii": "Tlemcen",
    "wilaya_name": "تلمسان"
  },
  {
    "id": 441,
    "commune_name_ascii": "Terny Beni Hediel",
    "commune_name": "تيرني بني هديل",
    "daira_name_ascii": "Mansourah",
    "daira_name": "منصورة",
    "wilaya_code": "13",
    "wilaya_name_ascii": "Tlemcen",
    "wilaya_name": "تلمسان"
  },
  {
    "model": "base.commune",
    "pk": 442,
    "fields": {
      "postcode": 13051,
      "wilaya": 13,
      "name": "Mansourah"
    },
    "id": 424,
    "commune_name_ascii": "Mansourah",
    "commune_name": "منصورة",
    "daira_name_ascii": "Mansourah",
    "daira_name": "منصورة",
    "wilaya_code": "13",
    "wilaya_name_ascii": "Tlemcen",
    "wilaya_name": "تلمسان"
  },
  {
    "model": "base.commune",
    "pk": 393,
    "fields": {
      "postcode": 13002,
      "wilaya": 13,
      "name": "Beni Mester"
    },
    "id": 404,
    "commune_name_ascii": "Beni Mester",
    "commune_name": "بني مستر",
    "daira_name_ascii": "Mansourah",
    "daira_name": "منصورة",
    "wilaya_code": "13",
    "wilaya_name_ascii": "Tlemcen",
    "wilaya_name": "تلمسان"
  },
  {
    "model": "base.commune",
    "pk": 440,
    "fields": {
      "postcode": 13049,
      "wilaya": 13,
      "name": "Ain Ghoraba"
    },
    "id": 394,
    "commune_name_ascii": "Ain Ghoraba",
    "commune_name": "عين غرابة",
    "daira_name_ascii": "Mansourah",
    "daira_name": "منصورة",
    "wilaya_code": "13",
    "wilaya_name_ascii": "Tlemcen",
    "wilaya_name": "تلمسان"
  },
  {
    "model": "base.commune",
    "pk": 441,
    "fields": {
      "postcode": 13050,
      "wilaya": 13,
      "name": "Chetouane"
    },
    "id": 411,
    "commune_name_ascii": "Chetouane",
    "commune_name": "شتوان",
    "daira_name_ascii": "Chetouane",
    "daira_name": "شتوان",
    "wilaya_code": "13",
    "wilaya_name_ascii": "Tlemcen",
    "wilaya_name": "تلمسان"
  },
  {
    "model": "base.commune",
    "pk": 405,
    "fields": {
      "postcode": 13014,
      "wilaya": 13,
      "name": "Amieur"
    },
    "id": 399,
    "commune_name_ascii": "Amieur",
    "commune_name": "عمير",
    "daira_name_ascii": "Chetouane",
    "daira_name": "شتوان",
    "wilaya_code": "13",
    "wilaya_name_ascii": "Tlemcen",
    "wilaya_name": "تلمسان"
  },
  {
    "model": "base.commune",
    "pk": 403,
    "fields": {
      "postcode": 13012,
      "wilaya": 13,
      "name": "Ain Fezza"
    },
    "id": 393,
    "commune_name_ascii": "Ain Fezza",
    "commune_name": "عين فزة",
    "daira_name_ascii": "Chetouane",
    "daira_name": "شتوان",
    "wilaya_code": "13",
    "wilaya_name_ascii": "Tlemcen",
    "wilaya_name": "تلمسان"
  },
  {
    "id": 422,
    "commune_name_ascii": "Honnaine",
    "commune_name": "هنين",
    "daira_name_ascii": "Honnaine",
    "daira_name": "هنين",
    "wilaya_code": "13",
    "wilaya_name_ascii": "Tlemcen",
    "wilaya_name": "تلمسان"
  },
  {
    "id": 403,
    "commune_name_ascii": "Beni Khellad",
    "commune_name": "بني خلاد",
    "daira_name_ascii": "Honnaine",
    "daira_name": "هنين",
    "wilaya_code": "13",
    "wilaya_name_ascii": "Tlemcen",
    "wilaya_name": "تلمسان"
  },
  {
    "model": "base.commune",
    "pk": 432,
    "fields": {
      "postcode": 13041,
      "wilaya": 13,
      "name": "Sidi Djillali"
    },
    "id": 436,
    "commune_name_ascii": "Sidi Djillali",
    "commune_name": "سيدي الجيلالي",
    "daira_name_ascii": "Sidi Djillali",
    "daira_name": "سيدي الجيلالي",
    "wilaya_code": "13",
    "wilaya_name_ascii": "Tlemcen",
    "wilaya_name": "تلمسان"
  },
  {
    "id": 410,
    "commune_name_ascii": "Bouihi",
    "commune_name": "البويهي",
    "daira_name_ascii": "Sidi Djillali",
    "daira_name": "سيدي الجيلالي",
    "wilaya_code": "13",
    "wilaya_name_ascii": "Tlemcen",
    "wilaya_name": "تلمسان"
  },
  {
    "model": "base.commune",
    "pk": 431,
    "fields": {
      "postcode": 13040,
      "wilaya": 13,
      "name": "Nedroma"
    },
    "id": 427,
    "commune_name_ascii": "Nedroma",
    "commune_name": "ندرومة",
    "daira_name_ascii": "Nedroma",
    "daira_name": "ندرومة",
    "wilaya_code": "13",
    "wilaya_name_ascii": "Tlemcen",
    "wilaya_name": "تلمسان"
  },
  {
    "id": 426,
    "commune_name_ascii": "MSirda Fouaga",
    "commune_name": "مسيردة الفواقة",
    "daira_name_ascii": "Marsa Ben Mehdi",
    "daira_name": "مرسى بن مهيدي",
    "wilaya_code": "13",
    "wilaya_name_ascii": "Tlemcen",
    "wilaya_name": "تلمسان"
  },
  {
    "id": 425,
    "commune_name_ascii": "Marsa Ben M'hidi",
    "commune_name": "مرسى بن مهيدي",
    "daira_name_ascii": "Marsa Ben Mehdi",
    "daira_name": "مرسى بن مهيدي",
    "wilaya_code": "13",
    "wilaya_name_ascii": "Tlemcen",
    "wilaya_name": "تلمسان"
  },
  {
    "model": "base.commune",
    "pk": 428,
    "fields": {
      "postcode": 13037,
      "wilaya": 13,
      "name": "Sidi Medjahed"
    },
    "id": 437,
    "commune_name_ascii": "Sidi Medjahed",
    "commune_name": "سيدي مجاهد",
    "daira_name_ascii": "Beni Boussaid",
    "daira_name": "بني بوسعيد",
    "wilaya_code": "13",
    "wilaya_name_ascii": "Tlemcen",
    "wilaya_name": "تلمسان"
  },
  {
    "model": "base.commune",
    "pk": 429,
    "fields": {
      "postcode": 13038,
      "wilaya": 13,
      "name": "Beni Boussaid"
    },
    "id": 402,
    "commune_name_ascii": "Beni Boussaid",
    "commune_name": "بني بوسعيد",
    "daira_name_ascii": "Beni Boussaid",
    "daira_name": "بني بوسعيد",
    "wilaya_code": "13",
    "wilaya_name_ascii": "Tlemcen",
    "wilaya_name": "تلمسان"
  },
  {
    "model": "base.commune",
    "pk": 426,
    "fields": {
      "postcode": 13035,
      "wilaya": 13,
      "name": "Sebdou"
    },
    "id": 434,
    "commune_name_ascii": "Sebdou",
    "commune_name": "سبدو",
    "daira_name_ascii": "Sebdou",
    "daira_name": "سبدو",
    "wilaya_code": "13",
    "wilaya_name_ascii": "Tlemcen",
    "wilaya_name": "تلمسان"
  },
  {
    "model": "base.commune",
    "pk": 401,
    "fields": {
      "postcode": 13010,
      "wilaya": 13,
      "name": "El Gor"
    },
    "id": 417,
    "commune_name_ascii": "El Gor",
    "commune_name": "القور",
    "daira_name_ascii": "Sebdou",
    "daira_name": "سبدو",
    "wilaya_code": "13",
    "wilaya_name_ascii": "Tlemcen",
    "wilaya_name": "تلمسان"
  },
  {
    "model": "base.commune",
    "pk": 423,
    "fields": {
      "postcode": 13032,
      "wilaya": 13,
      "name": "El Aricha"
    },
    "id": 414,
    "commune_name_ascii": "El Aricha",
    "commune_name": "العريشة",
    "daira_name_ascii": "Sebdou",
    "daira_name": "سبدو",
    "wilaya_code": "13",
    "wilaya_name_ascii": "Tlemcen",
    "wilaya_name": "تلمسان"
  },
  {
    "model": "base.commune",
    "pk": 438,
    "fields": {
      "postcode": 13047,
      "wilaya": 13,
      "name": "Bouhlou"
    },
    "id": 409,
    "commune_name_ascii": "Bouhlou",
    "commune_name": "بوحلو",
    "daira_name_ascii": "Sabra",
    "daira_name": "صبرة",
    "wilaya_code": "13",
    "wilaya_name_ascii": "Tlemcen",
    "wilaya_name": "تلمسان"
  },
  {
    "model": "base.commune",
    "pk": 418,
    "fields": {
      "postcode": 13027,
      "wilaya": 13,
      "name": "Maghnia"
    },
    "id": 423,
    "commune_name_ascii": "Maghnia",
    "commune_name": "مغنية",
    "daira_name_ascii": "Maghnia",
    "daira_name": "مغنية",
    "wilaya_code": "13",
    "wilaya_name_ascii": "Tlemcen",
    "wilaya_name": "تلمسان"
  },
  {
    "model": "base.commune",
    "pk": 419,
    "fields": {
      "postcode": 13028,
      "wilaya": 13,
      "name": "Hammam Boughrara"
    },
    "id": 420,
    "commune_name_ascii": "Hammam Boughrara",
    "commune_name": "حمام بوغرارة",
    "daira_name_ascii": "Maghnia",
    "daira_name": "مغنية",
    "wilaya_code": "13",
    "wilaya_name_ascii": "Tlemcen",
    "wilaya_name": "تلمسان"
  },
  {
    "model": "base.commune",
    "pk": 407,
    "fields": {
      "postcode": 13016,
      "wilaya": 13,
      "name": "Zenata"
    },
    "id": 444,
    "commune_name_ascii": "Zenata",
    "commune_name": "زناتة",
    "daira_name_ascii": "Hennaya",
    "daira_name": "الحناية",
    "wilaya_code": "13",
    "wilaya_name_ascii": "Tlemcen",
    "wilaya_name": "تلمسان"
  },
  {
    "model": "base.commune",
    "pk": 437,
    "fields": {
      "postcode": 13046,
      "wilaya": 13,
      "name": "Ouled Riyah"
    },
    "id": 430,
    "commune_name_ascii": "Ouled Riyah",
    "commune_name": "أولاد رياح",
    "daira_name_ascii": "Hennaya",
    "daira_name": "الحناية",
    "wilaya_code": "13",
    "wilaya_name_ascii": "Tlemcen",
    "wilaya_name": "تلمسان"
  },
  {
    "model": "base.commune",
    "pk": 417,
    "fields": {
      "postcode": 13026,
      "wilaya": 13,
      "name": "Hennaya"
    },
    "id": 421,
    "commune_name_ascii": "Hennaya",
    "commune_name": "الحناية",
    "daira_name_ascii": "Hennaya",
    "daira_name": "الحناية",
    "wilaya_code": "13",
    "wilaya_name_ascii": "Tlemcen",
    "wilaya_name": "تلمسان"
  },
  {
    "model": "base.commune",
    "pk": 425,
    "fields": {
      "postcode": 13034,
      "wilaya": 13,
      "name": "Sidi Abdelli"
    },
    "id": 435,
    "commune_name_ascii": "Sidi Abdelli",
    "commune_name": "سيدي العبدلي",
    "daira_name_ascii": "Bensekrane",
    "daira_name": "بن سكران",
    "wilaya_code": "13",
    "wilaya_name_ascii": "Tlemcen",
    "wilaya_name": "تلمسان"
  },
  {
    "id": 440,
    "commune_name_ascii": "Souk Tleta",
    "commune_name": "سوق الثلاثاء",
    "daira_name_ascii": "Bab El Assa",
    "daira_name": "باب العسة",
    "wilaya_code": "13",
    "wilaya_name_ascii": "Tlemcen",
    "wilaya_name": "تلمسان"
  },
  {
    "model": "base.commune",
    "pk": 415,
    "fields": {
      "postcode": 13024,
      "wilaya": 13,
      "name": "Bensekrane"
    },
    "id": 408,
    "commune_name_ascii": "Bensekrane",
    "commune_name": "بن سكران",
    "daira_name_ascii": "Bensekrane",
    "daira_name": "بن سكران",
    "wilaya_code": "13",
    "wilaya_name_ascii": "Tlemcen",
    "wilaya_name": "تلمسان"
  },
  {
    "model": "base.commune",
    "pk": 411,
    "fields": {
      "postcode": 13020,
      "wilaya": 13,
      "name": "Fellaoucene"
    },
    "id": 418,
    "commune_name_ascii": "Fellaoucene",
    "commune_name": "فلاوسن",
    "daira_name_ascii": "Fellaoucene",
    "daira_name": "فلاوسن",
    "wilaya_code": "13",
    "wilaya_name_ascii": "Tlemcen",
    "wilaya_name": "تلمسان"
  },
  {
    "model": "base.commune",
    "pk": 444,
    "fields": {
      "postcode": 13053,
      "wilaya": 13,
      "name": "Ain Kebira"
    },
    "id": 395,
    "commune_name_ascii": "Ain Kebira",
    "commune_name": "عين الكبيرة",
    "daira_name_ascii": "Fellaoucene",
    "daira_name": "فلاوسن",
    "wilaya_code": "13",
    "wilaya_name_ascii": "Tlemcen",
    "wilaya_name": "تلمسان"
  },
  {
    "model": "base.commune",
    "pk": 422,
    "fields": {
      "postcode": 13031,
      "wilaya": 13,
      "name": "Ain Fetah"
    },
    "id": 392,
    "commune_name_ascii": "Ain Fetah",
    "commune_name": "عين فتاح",
    "daira_name_ascii": "Fellaoucene",
    "daira_name": "فلاوسن",
    "wilaya_code": "13",
    "wilaya_name_ascii": "Tlemcen",
    "wilaya_name": "تلمسان"
  },
  {
    "model": "base.commune",
    "pk": 392,
    "fields": {
      "postcode": 13001,
      "wilaya": 13,
      "name": "Tlemcen"
    },
    "id": 443,
    "commune_name_ascii": "Tlemcen",
    "commune_name": "تلمسان",
    "daira_name_ascii": "Tlemcen",
    "daira_name": "تلمسان",
    "wilaya_code": "13",
    "wilaya_name_ascii": "Tlemcen",
    "wilaya_name": "تلمسان"
  },
  {
    "model": "base.commune",
    "pk": 416,
    "fields": {
      "postcode": 13025,
      "wilaya": 13,
      "name": "Ain Nehala"
    },
    "id": 396,
    "commune_name_ascii": "Ain Nehala",
    "commune_name": "عين النحالة",
    "daira_name_ascii": "Ain Tellout",
    "daira_name": "عين تالوت",
    "wilaya_code": "13",
    "wilaya_name_ascii": "Tlemcen",
    "wilaya_name": "تلمسان"
  },
  {
    "id": 397,
    "commune_name_ascii": "Ain Tellout",
    "commune_name": "عين تالوت",
    "daira_name_ascii": "Ain Tellout",
    "daira_name": "عين تالوت",
    "wilaya_code": "13",
    "wilaya_name_ascii": "Tlemcen",
    "wilaya_name": "تلمسان"
  },
  {
    "model": "base.commune",
    "pk": 406,
    "fields": {
      "postcode": 13015,
      "wilaya": 13,
      "name": "Ain Youcef"
    },
    "id": 398,
    "commune_name_ascii": "Ain Youcef",
    "commune_name": "عين يوسف",
    "daira_name_ascii": "Remchi",
    "daira_name": "الرمشي",
    "wilaya_code": "13",
    "wilaya_name_ascii": "Tlemcen",
    "wilaya_name": "تلمسان"
  },
  {
    "model": "base.commune",
    "pk": 427,
    "fields": {
      "postcode": 13036,
      "wilaya": 13,
      "name": "Beni Ouarsous"
    },
    "id": 405,
    "commune_name_ascii": "Beni Ouarsous",
    "commune_name": "بني وارسوس",
    "daira_name_ascii": "Remchi",
    "daira_name": "الرمشي",
    "wilaya_code": "13",
    "wilaya_name_ascii": "Tlemcen",
    "wilaya_name": "تلمسان"
  },
  {
    "model": "base.commune",
    "pk": 396,
    "fields": {
      "postcode": 13005,
      "wilaya": 13,
      "name": "El Fehoul"
    },
    "id": 416,
    "commune_name_ascii": "El Fehoul",
    "commune_name": "الفحول",
    "daira_name_ascii": "Remchi",
    "daira_name": "الرمشي",
    "wilaya_code": "13",
    "wilaya_name_ascii": "Tlemcen",
    "wilaya_name": "تلمسان"
  },
  {
    "model": "base.commune",
    "pk": 395,
    "fields": {
      "postcode": 13004,
      "wilaya": 13,
      "name": "Remchi"
    },
    "id": 431,
    "commune_name_ascii": "Remchi",
    "commune_name": "الرمشي",
    "daira_name_ascii": "Remchi",
    "daira_name": "الرمشي",
    "wilaya_code": "13",
    "wilaya_name_ascii": "Tlemcen",
    "wilaya_name": "تلمسان"
  },
  {
    "model": "base.commune",
    "pk": 413,
    "fields": {
      "postcode": 13022,
      "wilaya": 13,
      "name": "Sebbaa Chioukh"
    },
    "id": 433,
    "commune_name_ascii": "Sebbaa Chioukh",
    "commune_name": "سبعة شيوخ",
    "daira_name_ascii": "Remchi",
    "daira_name": "الرمشي",
    "wilaya_code": "13",
    "wilaya_name_ascii": "Tlemcen",
    "wilaya_name": "تلمسان"
  },
  {
    "model": "base.commune",
    "pk": 399,
    "fields": {
      "postcode": 13008,
      "wilaya": 13,
      "name": "Souani"
    },
    "id": 439,
    "commune_name_ascii": "Souani",
    "commune_name": "السواني",
    "daira_name_ascii": "Bab El Assa",
    "daira_name": "باب العسة",
    "wilaya_code": "13",
    "wilaya_name_ascii": "Tlemcen",
    "wilaya_name": "تلمسان"
  },
  {
    "model": "base.commune",
    "pk": 397,
    "fields": {
      "postcode": 13006,
      "wilaya": 13,
      "name": "Sabra"
    },
    "id": 432,
    "commune_name_ascii": "Sabra",
    "commune_name": "صبرة",
    "daira_name_ascii": "Sabra",
    "daira_name": "صبرة",
    "wilaya_code": "13",
    "wilaya_name_ascii": "Tlemcen",
    "wilaya_name": "تلمسان"
  },
  {
    "id": 412,
    "commune_name_ascii": "Dar Yaghmoracen",
    "commune_name": "دار يغمراسن",
    "daira_name_ascii": "Ghazaouet",
    "daira_name": "الغزوات",
    "wilaya_code": "13",
    "wilaya_name_ascii": "Tlemcen",
    "wilaya_name": "تلمسان"
  },
  {
    "model": "base.commune",
    "pk": 398,
    "fields": {
      "postcode": 13007,
      "wilaya": 13,
      "name": "Ghazaouet"
    },
    "id": 419,
    "commune_name_ascii": "Ghazaouet",
    "commune_name": "الغزوات",
    "daira_name_ascii": "Ghazaouet",
    "daira_name": "الغزوات",
    "wilaya_code": "13",
    "wilaya_name_ascii": "Tlemcen",
    "wilaya_name": "تلمسان"
  },
  {
    "model": "base.commune",
    "pk": 420,
    "fields": {
      "postcode": 13029,
      "wilaya": 13,
      "name": "Souahlia"
    },
    "id": 438,
    "commune_name_ascii": "Souahlia",
    "commune_name": "السواحلية",
    "daira_name_ascii": "Ghazaouet",
    "daira_name": "الغزوات",
    "wilaya_code": "13",
    "wilaya_name_ascii": "Tlemcen",
    "wilaya_name": "تلمسان"
  },
  {
    "model": "base.commune",
    "pk": 436,
    "fields": {
      "postcode": 13045,
      "wilaya": 13,
      "name": "Tianet"
    },
    "id": 442,
    "commune_name_ascii": "Tianet",
    "commune_name": "تيانت",
    "daira_name_ascii": "Ghazaouet",
    "daira_name": "الغزوات",
    "wilaya_code": "13",
    "wilaya_name_ascii": "Tlemcen",
    "wilaya_name": "تلمسان"
  },
  {
    "id": 406,
    "commune_name_ascii": "Beni Smiel",
    "commune_name": "بني صميل",
    "daira_name_ascii": "Ouled Mimoun",
    "daira_name": "أولاد ميمون",
    "wilaya_code": "13",
    "wilaya_name_ascii": "Tlemcen",
    "wilaya_name": "تلمسان"
  },
  {
    "id": 428,
    "commune_name_ascii": "Oued Lakhdar",
    "commune_name": "وادي الخضر",
    "daira_name_ascii": "Ouled Mimoun",
    "daira_name": "أولاد ميمون",
    "wilaya_code": "13",
    "wilaya_name_ascii": "Tlemcen",
    "wilaya_name": "تلمسان"
  },
  {
    "model": "base.commune",
    "pk": 404,
    "fields": {
      "postcode": 13013,
      "wilaya": 13,
      "name": "Ouled Mimoun"
    },
    "id": 429,
    "commune_name_ascii": "Ouled Mimoun",
    "commune_name": "أولاد ميمون",
    "daira_name_ascii": "Ouled Mimoun",
    "daira_name": "أولاد ميمون",
    "wilaya_code": "13",
    "wilaya_name_ascii": "Tlemcen",
    "wilaya_name": "تلمسان"
  },
  {
    "model": "base.commune",
    "pk": 433,
    "fields": {
      "postcode": 13042,
      "wilaya": 13,
      "name": "Beni Bahdel"
    },
    "id": 401,
    "commune_name_ascii": "Beni Bahdel",
    "commune_name": "بني بهدل",
    "daira_name_ascii": "Beni Snous",
    "daira_name": "بني سنوس",
    "wilaya_code": "13",
    "wilaya_name_ascii": "Tlemcen",
    "wilaya_name": "تلمسان"
  },
  {
    "model": "base.commune",
    "pk": 408,
    "fields": {
      "postcode": 13017,
      "wilaya": 13,
      "name": "Beni Snous"
    },
    "id": 407,
    "commune_name_ascii": "Beni Snous",
    "commune_name": "بني سنوس",
    "daira_name_ascii": "Beni Snous",
    "daira_name": "بني سنوس",
    "wilaya_code": "13",
    "wilaya_name_ascii": "Tlemcen",
    "wilaya_name": "تلمسان"
  },
  {
    "id": 415,
    "commune_name_ascii": "Azail",
    "commune_name": "العزايل",
    "daira_name_ascii": "Beni Snous",
    "daira_name": "بني سنوس",
    "wilaya_code": "13",
    "wilaya_name_ascii": "Tlemcen",
    "wilaya_name": "تلمسان"
  },
  {
    "model": "base.commune",
    "pk": 400,
    "fields": {
      "postcode": 13009,
      "wilaya": 13,
      "name": "Djebala"
    },
    "id": 413,
    "commune_name_ascii": "Djebala",
    "commune_name": "جبالة",
    "daira_name_ascii": "Nedroma",
    "daira_name": "ندرومة",
    "wilaya_code": "13",
    "wilaya_name_ascii": "Tlemcen",
    "wilaya_name": "تلمسان"
  },
  {
    "model": "base.commune",
    "pk": 459,
    "fields": {
      "postcode": 14015,
      "wilaya": 14,
      "name": "Mahdia"
    },
    "id": 461,
    "commune_name_ascii": "Mahdia",
    "commune_name": "مهدية",
    "daira_name_ascii": "Mahdia",
    "daira_name": "مهدية",
    "wilaya_code": "14",
    "wilaya_name_ascii": "Tiaret",
    "wilaya_name": "تيارت"
  },
  {
    "id": 447,
    "commune_name_ascii": "Ain Dzarit",
    "commune_name": "عين دزاريت",
    "daira_name_ascii": "Mahdia",
    "daira_name": "مهدية",
    "wilaya_code": "14",
    "wilaya_name_ascii": "Tiaret",
    "wilaya_name": "تيارت"
  },
  {
    "model": "base.commune",
    "pk": 469,
    "fields": {
      "postcode": 14025,
      "wilaya": 14,
      "name": "Sebaine"
    },
    "id": 472,
    "commune_name_ascii": "Sebaine",
    "commune_name": "السبعين",
    "daira_name_ascii": "Mahdia",
    "daira_name": "مهدية",
    "wilaya_code": "14",
    "wilaya_name_ascii": "Tiaret",
    "wilaya_name": "تيارت"
  },
  {
    "model": "base.commune",
    "pk": 485,
    "fields": {
      "postcode": 14041,
      "wilaya": 14,
      "name": "Faidja"
    },
    "id": 455,
    "commune_name_ascii": "Faidja",
    "commune_name": "الفايجة",
    "daira_name_ascii": "Sougueur",
    "daira_name": "السوقر",
    "wilaya_code": "14",
    "wilaya_name_ascii": "Tiaret",
    "wilaya_name": "تيارت"
  },
  {
    "id": 475,
    "commune_name_ascii": "Si Abdelghani",
    "commune_name": "سي عبد الغني",
    "daira_name_ascii": "Sougueur",
    "daira_name": "السوقر",
    "wilaya_code": "14",
    "wilaya_name_ascii": "Tiaret",
    "wilaya_name": "تيارت"
  },
  {
    "model": "base.commune",
    "pk": 460,
    "fields": {
      "postcode": 14016,
      "wilaya": 14,
      "name": "Sougueur"
    },
    "id": 480,
    "commune_name_ascii": "Sougueur",
    "commune_name": "السوقر",
    "daira_name_ascii": "Sougueur",
    "daira_name": "السوقر",
    "wilaya_code": "14",
    "wilaya_name_ascii": "Tiaret",
    "wilaya_name": "تيارت"
  },
  {
    "model": "base.commune",
    "pk": 470,
    "fields": {
      "postcode": 14026,
      "wilaya": 14,
      "name": "Tousnina"
    },
    "id": 485,
    "commune_name_ascii": "Tousnina",
    "commune_name": "توسنينة",
    "daira_name_ascii": "Sougueur",
    "daira_name": "السوقر",
    "wilaya_code": "14",
    "wilaya_name_ascii": "Tiaret",
    "wilaya_name": "تيارت"
  },
  {
    "model": "base.commune",
    "pk": 465,
    "fields": {
      "postcode": 14021,
      "wilaya": 14,
      "name": "Meghila"
    },
    "id": 465,
    "commune_name_ascii": "Meghila",
    "commune_name": "مغيلة",
    "daira_name_ascii": "Meghila",
    "daira_name": "مغيلة",
    "wilaya_code": "14",
    "wilaya_name_ascii": "Tiaret",
    "wilaya_name": "تيارت"
  },
  {
    "model": "base.commune",
    "pk": 455,
    "fields": {
      "postcode": 14011,
      "wilaya": 14,
      "name": "Sebt"
    },
    "id": 473,
    "commune_name_ascii": "Sebt",
    "commune_name": "السبت",
    "daira_name_ascii": "Meghila",
    "daira_name": "مغيلة",
    "wilaya_code": "14",
    "wilaya_name_ascii": "Tiaret",
    "wilaya_name": "تيارت"
  },
  {
    "model": "base.commune",
    "pk": 467,
    "fields": {
      "postcode": 14023,
      "wilaya": 14,
      "name": "Sidi Hosni"
    },
    "id": 479,
    "commune_name_ascii": "Sidi Hosni",
    "commune_name": "سيدي حسني",
    "daira_name_ascii": "Meghila",
    "daira_name": "مغيلة",
    "wilaya_code": "14",
    "wilaya_name_ascii": "Tiaret",
    "wilaya_name": "تيارت"
  },
  {
    "model": "base.commune",
    "pk": 462,
    "fields": {
      "postcode": 14018,
      "wilaya": 14,
      "name": "Ain El Hadid"
    },
    "id": 448,
    "commune_name_ascii": "Ain El Hadid",
    "commune_name": "عين الحديد",
    "daira_name_ascii": "Frenda",
    "daira_name": "فرندة",
    "wilaya_code": "14",
    "wilaya_name_ascii": "Tiaret",
    "wilaya_name": "تيارت"
  },
  {
    "model": "base.commune",
    "pk": 471,
    "fields": {
      "postcode": 14027,
      "wilaya": 14,
      "name": "Frenda"
    },
    "id": 456,
    "commune_name_ascii": "Frenda",
    "commune_name": "فرندة",
    "daira_name_ascii": "Frenda",
    "daira_name": "فرندة",
    "wilaya_code": "14",
    "wilaya_name_ascii": "Tiaret",
    "wilaya_name": "تيارت"
  },
  {
    "model": "base.commune",
    "pk": 481,
    "fields": {
      "postcode": 14037,
      "wilaya": 14,
      "name": "Takhemaret"
    },
    "id": 482,
    "commune_name_ascii": "Takhemaret",
    "commune_name": "تخمرت",
    "daira_name_ascii": "Frenda",
    "daira_name": "فرندة",
    "wilaya_code": "14",
    "wilaya_name_ascii": "Tiaret",
    "wilaya_name": "تيارت"
  },
  {
    "model": "base.commune",
    "pk": 472,
    "fields": {
      "postcode": 14028,
      "wilaya": 14,
      "name": "Ain Kermes"
    },
    "id": 449,
    "commune_name_ascii": "Ain Kermes",
    "commune_name": "عين كرمس",
    "daira_name_ascii": "Ain Kermes",
    "daira_name": "عين كرمس",
    "wilaya_code": "14",
    "wilaya_name_ascii": "Tiaret",
    "wilaya_name": "تيارت"
  },
  {
    "id": 453,
    "commune_name_ascii": "Djebilet Rosfa",
    "commune_name": "جبيلات الرصفاء",
    "daira_name_ascii": "Ain Kermes",
    "daira_name": "عين كرمس",
    "wilaya_code": "14",
    "wilaya_name_ascii": "Tiaret",
    "wilaya_name": "تيارت"
  },
  {
    "model": "base.commune",
    "pk": 454,
    "fields": {
      "postcode": 14010,
      "wilaya": 14,
      "name": "Madna"
    },
    "id": 460,
    "commune_name_ascii": "Madna",
    "commune_name": "مادنة",
    "daira_name_ascii": "Ain Kermes",
    "daira_name": "عين كرمس",
    "wilaya_code": "14",
    "wilaya_name_ascii": "Tiaret",
    "wilaya_name": "تيارت"
  },
  {
    "model": "base.commune",
    "pk": 452,
    "fields": {
      "postcode": 14008,
      "wilaya": 14,
      "name": "Medrissa"
    },
    "id": 463,
    "commune_name_ascii": "Medrissa",
    "commune_name": "مدريسة",
    "daira_name_ascii": "Ain Kermes",
    "daira_name": "عين كرمس",
    "wilaya_code": "14",
    "wilaya_name_ascii": "Tiaret",
    "wilaya_name": "تيارت"
  },
  {
    "model": "base.commune",
    "pk": 53,
    "fields": {
      "postcode": 2025,
      "wilaya": 2,
      "name": "Sidi Abderrahmane"
    },
    "id": 476,
    "commune_name_ascii": "Sidi Abderrahmane",
    "commune_name": "سيدي عبد الرحمن",
    "daira_name_ascii": "Ain Kermes",
    "daira_name": "عين كرمس",
    "wilaya_code": "14",
    "wilaya_name_ascii": "Tiaret",
    "wilaya_name": "تيارت"
  },
  {
    "model": "base.commune",
    "pk": 473,
    "fields": {
      "postcode": 14029,
      "wilaya": 14,
      "name": "Ksar Chellala"
    },
    "id": 459,
    "commune_name_ascii": "Ksar Chellala",
    "commune_name": "قصر الشلالة",
    "daira_name_ascii": "Ksar Chellala",
    "daira_name": "قصر الشلالة",
    "wilaya_code": "14",
    "wilaya_name_ascii": "Tiaret",
    "wilaya_name": "تيارت"
  },
  {
    "model": "base.commune",
    "pk": 466,
    "fields": {
      "postcode": 14022,
      "wilaya": 14,
      "name": "Guertoufa"
    },
    "id": 457,
    "commune_name_ascii": "Guertoufa",
    "commune_name": "قرطوفة",
    "daira_name_ascii": "Rahouia",
    "daira_name": "رحوية",
    "wilaya_code": "14",
    "wilaya_name_ascii": "Tiaret",
    "wilaya_name": "تيارت"
  },
  {
    "model": "base.commune",
    "pk": 483,
    "fields": {
      "postcode": 14039,
      "wilaya": 14,
      "name": "Serghine"
    },
    "id": 474,
    "commune_name_ascii": "Serghine",
    "commune_name": "سرغين",
    "daira_name_ascii": "Ksar Chellala",
    "daira_name": "قصر الشلالة",
    "wilaya_code": "14",
    "wilaya_name_ascii": "Tiaret",
    "wilaya_name": "تيارت"
  },
  {
    "id": 486,
    "commune_name_ascii": "Zmalet El Emir Abdelkade",
    "commune_name": "زمالة  الأمير عبد القادر",
    "daira_name_ascii": "Ksar Chellala",
    "daira_name": "قصر الشلالة",
    "wilaya_code": "14",
    "wilaya_name_ascii": "Tiaret",
    "wilaya_name": "تيارت"
  },
  {
    "model": "base.commune",
    "pk": 477,
    "fields": {
      "postcode": 14033,
      "wilaya": 14,
      "name": "Oued Lilli"
    },
    "id": 469,
    "commune_name_ascii": "Oued Lilli",
    "commune_name": "وادي ليلي",
    "daira_name_ascii": "Oued Lili",
    "daira_name": "وادي ليلي",
    "wilaya_code": "14",
    "wilaya_name_ascii": "Tiaret",
    "wilaya_name": "تيارت"
  },
  {
    "model": "base.commune",
    "pk": 448,
    "fields": {
      "postcode": 14004,
      "wilaya": 14,
      "name": "Sidi Ali Mellal"
    },
    "id": 477,
    "commune_name_ascii": "Sidi Ali Mellal",
    "commune_name": "سيدي علي ملال",
    "daira_name_ascii": "Oued Lili",
    "daira_name": "وادي ليلي",
    "wilaya_code": "14",
    "wilaya_name_ascii": "Tiaret",
    "wilaya_name": "تيارت"
  },
  {
    "model": "base.commune",
    "pk": 468,
    "fields": {
      "postcode": 14024,
      "wilaya": 14,
      "name": "Djillali Ben Amar"
    },
    "id": 454,
    "commune_name_ascii": "Djillali Ben Amar",
    "commune_name": "جيلالي بن عمار",
    "daira_name_ascii": "Mechraa Sfa",
    "daira_name": "مشرع الصفا",
    "wilaya_code": "14",
    "wilaya_name_ascii": "Tiaret",
    "wilaya_name": "تيارت"
  },
  {
    "model": "base.commune",
    "pk": 478,
    "fields": {
      "postcode": 14034,
      "wilaya": 14,
      "name": "Mechraa Safa"
    },
    "id": 462,
    "commune_name_ascii": "Mechraa Safa",
    "commune_name": "مشرع الصفا",
    "daira_name_ascii": "Mechraa Sfa",
    "daira_name": "مشرع الصفا",
    "wilaya_code": "14",
    "wilaya_name_ascii": "Tiaret",
    "wilaya_name": "تيارت"
  },
  {
    "id": 481,
    "commune_name_ascii": "Tagdempt",
    "commune_name": "تاقدمت",
    "daira_name_ascii": "Mechraa Sfa",
    "daira_name": "مشرع الصفا",
    "wilaya_code": "14",
    "wilaya_name_ascii": "Tiaret",
    "wilaya_name": "تيارت"
  },
  {
    "model": "base.commune",
    "pk": 305,
    "fields": {
      "postcode": 9026,
      "wilaya": 9,
      "name": "Bougara"
    },
    "id": 450,
    "commune_name_ascii": "Bougara",
    "commune_name": "بوقرة",
    "daira_name_ascii": "Hamadia",
    "daira_name": "حمادية",
    "wilaya_code": "14",
    "wilaya_name_ascii": "Tiaret",
    "wilaya_name": "تيارت"
  },
  {
    "model": "base.commune",
    "pk": 479,
    "fields": {
      "postcode": 14035,
      "wilaya": 14,
      "name": "Hamadia"
    },
    "id": 458,
    "commune_name_ascii": "Hamadia",
    "commune_name": "حمادية",
    "daira_name_ascii": "Hamadia",
    "daira_name": "حمادية",
    "wilaya_code": "14",
    "wilaya_name_ascii": "Tiaret",
    "wilaya_name": "تيارت"
  },
  {
    "model": "base.commune",
    "pk": 474,
    "fields": {
      "postcode": 14030,
      "wilaya": 14,
      "name": "Rechaiga"
    },
    "id": 471,
    "commune_name_ascii": "Rechaiga",
    "commune_name": "الرشايقة",
    "daira_name_ascii": "Hamadia",
    "daira_name": "حمادية",
    "wilaya_code": "14",
    "wilaya_name_ascii": "Tiaret",
    "wilaya_name": "تيارت"
  },
  {
    "model": "base.commune",
    "pk": 486,
    "fields": {
      "postcode": 14042,
      "wilaya": 14,
      "name": "Tidda"
    },
    "id": 484,
    "commune_name_ascii": "Tidda",
    "commune_name": "تيدة",
    "daira_name_ascii": "Oued Lili",
    "daira_name": "وادي ليلي",
    "wilaya_code": "14",
    "wilaya_name_ascii": "Tiaret",
    "wilaya_name": "تيارت"
  },
  {
    "model": "base.commune",
    "pk": 475,
    "fields": {
      "postcode": 14031,
      "wilaya": 14,
      "name": "Nadorah"
    },
    "id": 467,
    "commune_name_ascii": "Nadorah",
    "commune_name": "الناظورة",
    "daira_name_ascii": "Mahdia",
    "daira_name": "مهدية",
    "wilaya_code": "14",
    "wilaya_name_ascii": "Tiaret",
    "wilaya_name": "تيارت"
  },
  {
    "model": "base.commune",
    "pk": 445,
    "fields": {
      "postcode": 14001,
      "wilaya": 14,
      "name": "Tiaret"
    },
    "id": 483,
    "commune_name_ascii": "Tiaret",
    "commune_name": "تيارت",
    "daira_name_ascii": "Tiaret",
    "daira_name": "تيارت",
    "wilaya_code": "14",
    "wilaya_name_ascii": "Tiaret",
    "wilaya_name": "تيارت"
  },
  {
    "model": "base.commune",
    "pk": 446,
    "fields": {
      "postcode": 14002,
      "wilaya": 14,
      "name": "Medroussa"
    },
    "id": 464,
    "commune_name_ascii": "Medroussa",
    "commune_name": "مدروسة",
    "daira_name_ascii": "Medroussa",
    "daira_name": "مدروسة",
    "wilaya_code": "14",
    "wilaya_name_ascii": "Tiaret",
    "wilaya_name": "تيارت"
  },
  {
    "model": "base.commune",
    "pk": 456,
    "fields": {
      "postcode": 14012,
      "wilaya": 14,
      "name": "Mellakou"
    },
    "id": 466,
    "commune_name_ascii": "Mellakou",
    "commune_name": "ملاكو",
    "daira_name_ascii": "Medroussa",
    "daira_name": "مدروسة",
    "wilaya_code": "14",
    "wilaya_name_ascii": "Tiaret",
    "wilaya_name": "تيارت"
  },
  {
    "model": "base.commune",
    "pk": 451,
    "fields": {
      "postcode": 14007,
      "wilaya": 14,
      "name": "Sidi Bakhti"
    },
    "id": 478,
    "commune_name_ascii": "Sidi Bakhti",
    "commune_name": "سيدي بختي",
    "daira_name_ascii": "Medroussa",
    "daira_name": "مدروسة",
    "wilaya_code": "14",
    "wilaya_name_ascii": "Tiaret",
    "wilaya_name": "تيارت"
  },
  {
    "model": "base.commune",
    "pk": 450,
    "fields": {
      "postcode": 14006,
      "wilaya": 14,
      "name": "Ain Deheb"
    },
    "id": 446,
    "commune_name_ascii": "Ain Deheb",
    "commune_name": "عين الذهب",
    "daira_name_ascii": "Ain Deheb",
    "daira_name": "عين الذهب",
    "wilaya_code": "14",
    "wilaya_name_ascii": "Tiaret",
    "wilaya_name": "تيارت"
  },
  {
    "model": "base.commune",
    "pk": 480,
    "fields": {
      "postcode": 14036,
      "wilaya": 14,
      "name": "Chehaima"
    },
    "id": 451,
    "commune_name_ascii": "Chehaima",
    "commune_name": "شحيمة",
    "daira_name_ascii": "Ain Deheb",
    "daira_name": "عين الذهب",
    "wilaya_code": "14",
    "wilaya_name_ascii": "Tiaret",
    "wilaya_name": "تيارت"
  },
  {
    "model": "base.commune",
    "pk": 464,
    "fields": {
      "postcode": 14020,
      "wilaya": 14,
      "name": "Naima"
    },
    "id": 468,
    "commune_name_ascii": "Naima",
    "commune_name": "النعيمة",
    "daira_name_ascii": "Ain Deheb",
    "daira_name": "عين الذهب",
    "wilaya_code": "14",
    "wilaya_name_ascii": "Tiaret",
    "wilaya_name": "تيارت"
  },
  {
    "model": "base.commune",
    "pk": 447,
    "fields": {
      "postcode": 14003,
      "wilaya": 14,
      "name": "Ain Bouchekif"
    },
    "id": 445,
    "commune_name_ascii": "Ain Bouchekif",
    "commune_name": "عين بوشقيف",
    "daira_name_ascii": "Dahmouni",
    "daira_name": "دحموني",
    "wilaya_code": "14",
    "wilaya_name_ascii": "Tiaret",
    "wilaya_name": "تيارت"
  },
  {
    "model": "base.commune",
    "pk": 457,
    "fields": {
      "postcode": 14013,
      "wilaya": 14,
      "name": "Dahmouni"
    },
    "id": 452,
    "commune_name_ascii": "Dahmouni",
    "commune_name": "دحموني",
    "daira_name_ascii": "Dahmouni",
    "daira_name": "دحموني",
    "wilaya_code": "14",
    "wilaya_name_ascii": "Tiaret",
    "wilaya_name": "تيارت"
  },
  {
    "model": "base.commune",
    "pk": 458,
    "fields": {
      "postcode": 14014,
      "wilaya": 14,
      "name": "Rahouia"
    },
    "id": 470,
    "commune_name_ascii": "Rahouia",
    "commune_name": "الرحوية",
    "daira_name_ascii": "Rahouia",
    "daira_name": "رحوية",
    "wilaya_code": "14",
    "wilaya_name_ascii": "Tiaret",
    "wilaya_name": "تيارت"
  },
  {
    "model": "base.commune",
    "pk": 548,
    "fields": {
      "postcode": 15062,
      "wilaya": 15,
      "name": "Mizrana"
    },
    "id": 535,
    "commune_name_ascii": "Mizrana",
    "commune_name": "ميزرانـــة",
    "daira_name_ascii": "Tigzirt",
    "daira_name": "تيقزيرت",
    "wilaya_code": "15",
    "wilaya_name_ascii": "Tizi Ouzou",
    "wilaya_name": "تيزي وزو"
  },
  {
    "model": "base.commune",
    "pk": 535,
    "fields": {
      "postcode": 15049,
      "wilaya": 15,
      "name": "Idjeur"
    },
    "id": 522,
    "commune_name_ascii": "Idjeur",
    "commune_name": "إيجــار",
    "daira_name_ascii": "Bouzeguene",
    "daira_name": "بوزقن",
    "wilaya_code": "15",
    "wilaya_name_ascii": "Tizi Ouzou",
    "wilaya_name": "تيزي وزو"
  },
  {
    "id": 510,
    "commune_name_ascii": "Beni Douala",
    "commune_name": "بني دوالة",
    "daira_name_ascii": "Beni Douala",
    "daira_name": "بني دوالة",
    "wilaya_code": "15",
    "wilaya_name_ascii": "Tizi Ouzou",
    "wilaya_name": "تيزي وزو"
  },
  {
    "id": 512,
    "commune_name_ascii": "Beni Zikki",
    "commune_name": "بني زيكــي",
    "daira_name_ascii": "Bouzeguene",
    "daira_name": "بوزقن",
    "wilaya_code": "15",
    "wilaya_name_ascii": "Tizi Ouzou",
    "wilaya_name": "تيزي وزو"
  },
  {
    "id": 527,
    "commune_name_ascii": "Illoula Oumalou",
    "commune_name": "إيلولة أومـــالو",
    "daira_name_ascii": "Bouzeguene",
    "daira_name": "بوزقن",
    "wilaya_code": "15",
    "wilaya_name_ascii": "Tizi Ouzou",
    "wilaya_name": "تيزي وزو"
  },
  {
    "id": 489,
    "commune_name_ascii": "Agouni Gueghrane",
    "commune_name": "أقني قغران",
    "daira_name_ascii": "Ouadhias",
    "daira_name": "واضية",
    "wilaya_code": "15",
    "wilaya_name_ascii": "Tizi Ouzou",
    "wilaya_name": "تيزي وزو"
  },
  {
    "id": 493,
    "commune_name_ascii": "Ait Bouaddou",
    "commune_name": "أيت بــوادو",
    "daira_name_ascii": "Ouadhias",
    "daira_name": "واضية",
    "wilaya_code": "15",
    "wilaya_name_ascii": "Tizi Ouzou",
    "wilaya_name": "تيزي وزو"
  },
  {
    "id": 538,
    "commune_name_ascii": "Ouadhias",
    "commune_name": "واضية",
    "daira_name_ascii": "Ouadhias",
    "daira_name": "واضية",
    "wilaya_code": "15",
    "wilaya_name_ascii": "Tizi Ouzou",
    "wilaya_name": "تيزي وزو"
  },
  {
    "id": 547,
    "commune_name_ascii": "Tizi N'tleta",
    "commune_name": "تيزي نثلاثة",
    "daira_name_ascii": "Ouadhias",
    "daira_name": "واضية",
    "wilaya_code": "15",
    "wilaya_name_ascii": "Tizi Ouzou",
    "wilaya_name": "تيزي وزو"
  },
  {
    "id": 488,
    "commune_name_ascii": "Aghribs",
    "commune_name": "أغريب",
    "daira_name_ascii": "Azeffoun",
    "daira_name": "أزفون",
    "wilaya_code": "15",
    "wilaya_name_ascii": "Tizi Ouzou",
    "wilaya_name": "تيزي وزو"
  },
  {
    "id": 498,
    "commune_name_ascii": "Ait Chafaa",
    "commune_name": "أيت شافع",
    "daira_name_ascii": "Azeffoun",
    "daira_name": "أزفون",
    "wilaya_code": "15",
    "wilaya_name_ascii": "Tizi Ouzou",
    "wilaya_name": "تيزي وزو"
  },
  {
    "model": "base.commune",
    "pk": 530,
    "fields": {
      "postcode": 15044,
      "wilaya": 15,
      "name": "Akerrou"
    },
    "id": 504,
    "commune_name_ascii": "Akerrou",
    "commune_name": "أقرو",
    "daira_name_ascii": "Azeffoun",
    "daira_name": "أزفون",
    "wilaya_code": "15",
    "wilaya_name_ascii": "Tizi Ouzou",
    "wilaya_name": "تيزي وزو"
  },
  {
    "id": 507,
    "commune_name_ascii": "Azeffoun",
    "commune_name": "أزفون",
    "daira_name_ascii": "Azeffoun",
    "daira_name": "أزفون",
    "wilaya_code": "15",
    "wilaya_name_ascii": "Tizi Ouzou",
    "wilaya_name": "تيزي وزو"
  },
  {
    "model": "base.commune",
    "pk": 540,
    "fields": {
      "postcode": 15054,
      "wilaya": 15,
      "name": "Iflissen"
    },
    "id": 525,
    "commune_name_ascii": "Iflissen",
    "commune_name": "إفليـــسن",
    "daira_name_ascii": "Tigzirt",
    "daira_name": "تيقزيرت",
    "wilaya_code": "15",
    "wilaya_name_ascii": "Tizi Ouzou",
    "wilaya_name": "تيزي وزو"
  },
  {
    "model": "base.commune",
    "pk": 524,
    "fields": {
      "postcode": 15038,
      "wilaya": 15,
      "name": "Tigzirt"
    },
    "id": 544,
    "commune_name_ascii": "Tigzirt",
    "commune_name": "تيقـزيرت",
    "daira_name_ascii": "Tigzirt",
    "daira_name": "تيقزيرت",
    "wilaya_code": "15",
    "wilaya_name_ascii": "Tizi Ouzou",
    "wilaya_name": "تيزي وزو"
  },
  {
    "id": 505,
    "commune_name_ascii": "Assi Youcef",
    "commune_name": "أسي يوسف",
    "daira_name_ascii": "Boghni",
    "daira_name": "بوغني",
    "wilaya_code": "15",
    "wilaya_name_ascii": "Tizi Ouzou",
    "wilaya_name": "تيزي وزو"
  },
  {
    "model": "base.commune",
    "pk": 526,
    "fields": {
      "postcode": 15040,
      "wilaya": 15,
      "name": "Boghni"
    },
    "id": 513,
    "commune_name_ascii": "Boghni",
    "commune_name": "بوغني",
    "daira_name_ascii": "Boghni",
    "daira_name": "بوغني",
    "wilaya_code": "15",
    "wilaya_name_ascii": "Tizi Ouzou",
    "wilaya_name": "تيزي وزو"
  },
  {
    "model": "base.commune",
    "pk": 498,
    "fields": {
      "postcode": 15012,
      "wilaya": 15,
      "name": "Bounouh"
    },
    "id": 515,
    "commune_name_ascii": "Bounouh",
    "commune_name": "بونوح",
    "daira_name_ascii": "Boghni",
    "daira_name": "بوغني",
    "wilaya_code": "15",
    "wilaya_name_ascii": "Tizi Ouzou",
    "wilaya_name": "تيزي وزو"
  },
  {
    "id": 533,
    "commune_name_ascii": "Mechtras",
    "commune_name": "مشطراس",
    "daira_name_ascii": "Boghni",
    "daira_name": "بوغني",
    "wilaya_code": "15",
    "wilaya_name_ascii": "Tizi Ouzou",
    "wilaya_name": "تيزي وزو"
  },
  {
    "id": 517,
    "commune_name_ascii": "Draa Ben Khedda",
    "commune_name": "ذراع بن خدة",
    "daira_name_ascii": "Draa Ben Khedda",
    "daira_name": "ذراع بن خدة",
    "wilaya_code": "15",
    "wilaya_name_ascii": "Tizi Ouzou",
    "wilaya_name": "تيزي وزو"
  },
  {
    "id": 540,
    "commune_name_ascii": "Sidi Namane",
    "commune_name": "سيدي نعمان",
    "daira_name_ascii": "Draa Ben Khedda",
    "daira_name": "ذراع بن خدة",
    "wilaya_code": "15",
    "wilaya_name_ascii": "Tizi Ouzou",
    "wilaya_name": "تيزي وزو"
  },
  {
    "model": "base.commune",
    "pk": 550,
    "fields": {
      "postcode": 15064,
      "wilaya": 15,
      "name": "Tadmait"
    },
    "id": 543,
    "commune_name_ascii": "Tadmait",
    "commune_name": "تادمايت",
    "daira_name_ascii": "Draa Ben Khedda",
    "daira_name": "ذراع بن خدة",
    "wilaya_code": "15",
    "wilaya_name_ascii": "Tizi Ouzou",
    "wilaya_name": "تيزي وزو"
  },
  {
    "model": "base.commune",
    "pk": 529,
    "fields": {
      "postcode": 15043,
      "wilaya": 15,
      "name": "Tirmitine"
    },
    "id": 546,
    "commune_name_ascii": "Tirmitine",
    "commune_name": "تيرمتين",
    "daira_name_ascii": "Draa Ben Khedda",
    "daira_name": "ذراع بن خدة",
    "wilaya_code": "15",
    "wilaya_name_ascii": "Tizi Ouzou",
    "wilaya_name": "تيزي وزو"
  },
  {
    "id": 494,
    "commune_name_ascii": "Ait Boumahdi",
    "commune_name": "أيت بومهدي",
    "daira_name_ascii": "Ouacif",
    "daira_name": "واسيف",
    "wilaya_code": "15",
    "wilaya_name_ascii": "Tizi Ouzou",
    "wilaya_name": "تيزي وزو"
  },
  {
    "id": 501,
    "commune_name_ascii": "Ait Toudert",
    "commune_name": "أيت تودرت",
    "daira_name_ascii": "Ouacif",
    "daira_name": "واسيف",
    "wilaya_code": "15",
    "wilaya_name_ascii": "Tizi Ouzou",
    "wilaya_name": "تيزي وزو"
  },
  {
    "id": 509,
    "commune_name_ascii": "Beni Aissi",
    "commune_name": "بني عيسي",
    "daira_name_ascii": "Beni Douala",
    "daira_name": "بني دوالة",
    "wilaya_code": "15",
    "wilaya_name_ascii": "Tizi Ouzou",
    "wilaya_name": "تيزي وزو"
  },
  {
    "model": "base.commune",
    "pk": 534,
    "fields": {
      "postcode": 15048,
      "wilaya": 15,
      "name": "Ouacif"
    },
    "id": 537,
    "commune_name_ascii": "Ouacif",
    "commune_name": "واسيف",
    "daira_name_ascii": "Ouacif",
    "daira_name": "واسيف",
    "wilaya_code": "15",
    "wilaya_name_ascii": "Tizi Ouzou",
    "wilaya_name": "تيزي وزو"
  },
  {
    "id": 495,
    "commune_name_ascii": "Ait Khellili",
    "commune_name": "أيت خليلي",
    "daira_name_ascii": "Mekla",
    "daira_name": "مقلع",
    "wilaya_code": "15",
    "wilaya_name_ascii": "Tizi Ouzou",
    "wilaya_name": "تيزي وزو"
  },
  {
    "model": "base.commune",
    "pk": 536,
    "fields": {
      "postcode": 15050,
      "wilaya": 15,
      "name": "Mekla"
    },
    "id": 534,
    "commune_name_ascii": "Mekla",
    "commune_name": "مقــلع",
    "daira_name_ascii": "Mekla",
    "daira_name": "مقلع",
    "wilaya_code": "15",
    "wilaya_name_ascii": "Tizi Ouzou",
    "wilaya_name": "تيزي وزو"
  },
  {
    "id": 541,
    "commune_name_ascii": "Souama",
    "commune_name": "صوامـــع",
    "daira_name_ascii": "Mekla",
    "daira_name": "مقلع",
    "wilaya_code": "15",
    "wilaya_name_ascii": "Tizi Ouzou",
    "wilaya_name": "تيزي وزو"
  },
  {
    "id": 511,
    "commune_name_ascii": "Beni Yenni",
    "commune_name": "بني يني",
    "daira_name_ascii": "Benni Yenni",
    "daira_name": "بني يني",
    "wilaya_code": "15",
    "wilaya_name_ascii": "Tizi Ouzou",
    "wilaya_name": "تيزي وزو"
  },
  {
    "id": 521,
    "commune_name_ascii": "Iboudrarene",
    "commune_name": "إبودرارن",
    "daira_name_ascii": "Benni Yenni",
    "daira_name": "بني يني",
    "wilaya_code": "15",
    "wilaya_name_ascii": "Tizi Ouzou",
    "wilaya_name": "تيزي وزو"
  },
  {
    "id": 549,
    "commune_name_ascii": "Tizi Ouzou",
    "commune_name": "تيزي وزو",
    "daira_name_ascii": "Tizi Ouzou",
    "daira_name": "تيزي وزو",
    "wilaya_code": "15",
    "wilaya_name_ascii": "Tizi Ouzou",
    "wilaya_name": "تيزي وزو"
  },
  {
    "id": 487,
    "commune_name_ascii": "Abi Youcef",
    "commune_name": "أبي يوسف",
    "daira_name_ascii": "Ain El Hammam",
    "daira_name": "عين الحمام",
    "wilaya_code": "15",
    "wilaya_name_ascii": "Tizi Ouzou",
    "wilaya_name": "تيزي وزو"
  },
  {
    "id": 490,
    "commune_name_ascii": "Ain El Hammam",
    "commune_name": "عين الحمام",
    "daira_name_ascii": "Ain El Hammam",
    "daira_name": "عين الحمام",
    "wilaya_code": "15",
    "wilaya_name_ascii": "Tizi Ouzou",
    "wilaya_name": "تيزي وزو"
  },
  {
    "id": 502,
    "commune_name_ascii": "Ait Yahia",
    "commune_name": "أيت يحيى",
    "daira_name_ascii": "Ain El Hammam",
    "daira_name": "عين الحمام",
    "wilaya_code": "15",
    "wilaya_name_ascii": "Tizi Ouzou",
    "wilaya_name": "تيزي وزو"
  },
  {
    "model": "base.commune",
    "pk": 489,
    "fields": {
      "postcode": 15003,
      "wilaya": 15,
      "name": "Akbil"
    },
    "id": 503,
    "commune_name_ascii": "Akbil",
    "commune_name": "اقبيل",
    "daira_name_ascii": "Ain El Hammam",
    "daira_name": "عين الحمام",
    "wilaya_code": "15",
    "wilaya_name_ascii": "Tizi Ouzou",
    "wilaya_name": "تيزي وزو"
  },
  {
    "model": "base.commune",
    "pk": 541,
    "fields": {
      "postcode": 15055,
      "wilaya": 15,
      "name": "Boudjima"
    },
    "id": 514,
    "commune_name_ascii": "Boudjima",
    "commune_name": "بوجيمة",
    "daira_name_ascii": "Makouda",
    "daira_name": "ماكودة",
    "wilaya_code": "15",
    "wilaya_name_ascii": "Tizi Ouzou",
    "wilaya_name": "تيزي وزو"
  },
  {
    "model": "base.commune",
    "pk": 495,
    "fields": {
      "postcode": 15009,
      "wilaya": 15,
      "name": "Makouda"
    },
    "id": 532,
    "commune_name_ascii": "Makouda",
    "commune_name": "ماكودة",
    "daira_name_ascii": "Makouda",
    "daira_name": "ماكودة",
    "wilaya_code": "15",
    "wilaya_name_ascii": "Tizi Ouzou",
    "wilaya_name": "تيزي وزو"
  },
  {
    "id": 491,
    "commune_name_ascii": "Ain Zaouia",
    "commune_name": "عين الزاوية",
    "daira_name_ascii": "Draa El Mizan",
    "daira_name": "ذراع الميزان",
    "wilaya_code": "15",
    "wilaya_name_ascii": "Tizi Ouzou",
    "wilaya_name": "تيزي وزو"
  },
  {
    "model": "base.commune",
    "pk": 542,
    "fields": {
      "postcode": 15056,
      "wilaya": 15,
      "name": "Ait Yahia Moussa"
    },
    "id": 496,
    "commune_name_ascii": "Ait Yahia Moussa",
    "commune_name": "أيت يحي موسى",
    "daira_name_ascii": "Draa El Mizan",
    "daira_name": "ذراع الميزان",
    "wilaya_code": "15",
    "wilaya_name_ascii": "Tizi Ouzou",
    "wilaya_name": "تيزي وزو"
  },
  {
    "id": 518,
    "commune_name_ascii": "Draa El Mizan",
    "commune_name": "ذراع الميزان",
    "daira_name_ascii": "Draa El Mizan",
    "daira_name": "ذراع الميزان",
    "wilaya_code": "15",
    "wilaya_name_ascii": "Tizi Ouzou",
    "wilaya_name": "تيزي وزو"
  },
  {
    "model": "base.commune",
    "pk": 500,
    "fields": {
      "postcode": 15014,
      "wilaya": 15,
      "name": "Frikat"
    },
    "id": 520,
    "commune_name_ascii": "Frikat",
    "commune_name": "فريقات",
    "daira_name_ascii": "Draa El Mizan",
    "daira_name": "ذراع الميزان",
    "wilaya_code": "15",
    "wilaya_name_ascii": "Tizi Ouzou",
    "wilaya_name": "تيزي وزو"
  },
  {
    "id": 536,
    "commune_name_ascii": "M'kira",
    "commune_name": "مكيرة",
    "daira_name_ascii": "Tizi Ghenif",
    "daira_name": "تيزي غنيف",
    "wilaya_code": "15",
    "wilaya_name_ascii": "Tizi Ouzou",
    "wilaya_name": "تيزي وزو"
  },
  {
    "id": 548,
    "commune_name_ascii": "Tizi Gheniff",
    "commune_name": "تيزي غنيف",
    "daira_name_ascii": "Tizi Ghenif",
    "daira_name": "تيزي غنيف",
    "wilaya_code": "15",
    "wilaya_name_ascii": "Tizi Ouzou",
    "wilaya_name": "تيزي وزو"
  },
  {
    "id": 552,
    "commune_name_ascii": "Yatafene",
    "commune_name": "يطــافن",
    "daira_name_ascii": "Benni Yenni",
    "daira_name": "بني يني",
    "wilaya_code": "15",
    "wilaya_name_ascii": "Tizi Ouzou",
    "wilaya_name": "تيزي وزو"
  },
  {
    "model": "base.commune",
    "pk": 519,
    "fields": {
      "postcode": 15033,
      "wilaya": 15,
      "name": "Illilten"
    },
    "id": 526,
    "commune_name_ascii": "Illilten",
    "commune_name": "إيلـيــلتـن",
    "daira_name_ascii": "Iferhounene",
    "daira_name": "إفرحونان",
    "wilaya_code": "15",
    "wilaya_name_ascii": "Tizi Ouzou",
    "wilaya_name": "تيزي وزو"
  },
  {
    "model": "base.commune",
    "pk": 549,
    "fields": {
      "postcode": 15063,
      "wilaya": 15,
      "name": "Imsouhal"
    },
    "id": 528,
    "commune_name_ascii": "Imsouhal",
    "commune_name": "إمســوحال",
    "daira_name_ascii": "Iferhounene",
    "daira_name": "إفرحونان",
    "wilaya_code": "15",
    "wilaya_name_ascii": "Tizi Ouzou",
    "wilaya_name": "تيزي وزو"
  },
  {
    "model": "base.commune",
    "pk": 504,
    "fields": {
      "postcode": 15018,
      "wilaya": 15,
      "name": "Azazga"
    },
    "id": 506,
    "commune_name_ascii": "Azazga",
    "commune_name": "عزازقة",
    "daira_name_ascii": "Azazga",
    "daira_name": "عزازقة",
    "wilaya_code": "15",
    "wilaya_name_ascii": "Tizi Ouzou",
    "wilaya_name": "تيزي وزو"
  },
  {
    "model": "base.commune",
    "pk": 490,
    "fields": {
      "postcode": 15004,
      "wilaya": 15,
      "name": "Freha"
    },
    "id": 519,
    "commune_name_ascii": "Freha",
    "commune_name": "فريحة",
    "daira_name_ascii": "Azazga",
    "daira_name": "عزازقة",
    "wilaya_code": "15",
    "wilaya_name_ascii": "Tizi Ouzou",
    "wilaya_name": "تيزي وزو"
  },
  {
    "model": "base.commune",
    "pk": 527,
    "fields": {
      "postcode": 15041,
      "wilaya": 15,
      "name": "Ifigha"
    },
    "id": 524,
    "commune_name_ascii": "Ifigha",
    "commune_name": "إيفيغاء",
    "daira_name_ascii": "Azazga",
    "daira_name": "عزازقة",
    "wilaya_code": "15",
    "wilaya_name_ascii": "Tizi Ouzou",
    "wilaya_name": "تيزي وزو"
  },
  {
    "id": 551,
    "commune_name_ascii": "Yakourene",
    "commune_name": "إعــكورن",
    "daira_name_ascii": "Azazga",
    "daira_name": "عزازقة",
    "wilaya_code": "15",
    "wilaya_name_ascii": "Tizi Ouzou",
    "wilaya_name": "تيزي وزو"
  },
  {
    "model": "base.commune",
    "pk": 509,
    "fields": {
      "postcode": 15023,
      "wilaya": 15,
      "name": "Zekri"
    },
    "id": 553,
    "commune_name_ascii": "Zekri",
    "commune_name": "زكري",
    "daira_name_ascii": "Azazga",
    "daira_name": "عزازقة",
    "wilaya_code": "15",
    "wilaya_name_ascii": "Tizi Ouzou",
    "wilaya_name": "تيزي وزو"
  },
  {
    "model": "base.commune",
    "pk": 521,
    "fields": {
      "postcode": 15035,
      "wilaya": 15,
      "name": "Ait Aggouacha"
    },
    "id": 492,
    "commune_name_ascii": "Ait Aggouacha",
    "commune_name": "أيت عقـواشة",
    "daira_name_ascii": "Larbaa Nath Iraten",
    "daira_name": "الأربعاء ناث إيراثن",
    "wilaya_code": "15",
    "wilaya_name_ascii": "Tizi Ouzou",
    "wilaya_name": "تيزي وزو"
  },
  {
    "model": "base.commune",
    "pk": 493,
    "fields": {
      "postcode": 15007,
      "wilaya": 15,
      "name": "Irdjen"
    },
    "id": 529,
    "commune_name_ascii": "Irdjen",
    "commune_name": "إيرجـــن",
    "daira_name_ascii": "Larbaa Nath Iraten",
    "daira_name": "الأربعاء ناث إيراثن",
    "wilaya_code": "15",
    "wilaya_name_ascii": "Tizi Ouzou",
    "wilaya_name": "تيزي وزو"
  },
  {
    "id": 530,
    "commune_name_ascii": "Larbaa Nath Irathen",
    "commune_name": "الأربعــاء ناث إيراثن",
    "daira_name_ascii": "Larbaa Nath Iraten",
    "daira_name": "الأربعاء ناث إيراثن",
    "wilaya_code": "15",
    "wilaya_name_ascii": "Tizi Ouzou",
    "wilaya_name": "تيزي وزو"
  },
  {
    "id": 500,
    "commune_name_ascii": "Ait Oumalou",
    "commune_name": "أيت  أومالو",
    "daira_name_ascii": "Tizi Rached",
    "daira_name": "تيزي راشد",
    "wilaya_code": "15",
    "wilaya_name_ascii": "Tizi Ouzou",
    "wilaya_name": "تيزي وزو"
  },
  {
    "id": 550,
    "commune_name_ascii": "Tizi Rached",
    "commune_name": "تيزي راشد",
    "daira_name_ascii": "Tizi Rached",
    "daira_name": "تيزي راشد",
    "wilaya_code": "15",
    "wilaya_name_ascii": "Tizi Ouzou",
    "wilaya_name": "تيزي وزو"
  },
  {
    "id": 497,
    "commune_name_ascii": "Ait Aissa Mimoun",
    "commune_name": "أيت عيسى ميمون",
    "daira_name_ascii": "Ouaguenoun",
    "daira_name": "واقنون",
    "wilaya_code": "15",
    "wilaya_name_ascii": "Tizi Ouzou",
    "wilaya_name": "تيزي وزو"
  },
  {
    "model": "base.commune",
    "pk": 510,
    "fields": {
      "postcode": 15024,
      "wilaya": 15,
      "name": "Ouaguenoun"
    },
    "id": 539,
    "commune_name_ascii": "Ouaguenoun",
    "commune_name": "واقنون",
    "daira_name_ascii": "Ouaguenoun",
    "daira_name": "واقنون",
    "wilaya_code": "15",
    "wilaya_name_ascii": "Tizi Ouzou",
    "wilaya_name": "تيزي وزو"
  },
  {
    "model": "base.commune",
    "pk": 494,
    "fields": {
      "postcode": 15008,
      "wilaya": 15,
      "name": "Timizart"
    },
    "id": 545,
    "commune_name_ascii": "Timizart",
    "commune_name": "تيمـيزار",
    "daira_name_ascii": "Ouaguenoun",
    "daira_name": "واقنون",
    "wilaya_code": "15",
    "wilaya_name_ascii": "Tizi Ouzou",
    "wilaya_name": "تيزي وزو"
  },
  {
    "model": "base.commune",
    "pk": 515,
    "fields": {
      "postcode": 15029,
      "wilaya": 15,
      "name": "Maatkas"
    },
    "id": 531,
    "commune_name_ascii": "Maatkas",
    "commune_name": "معـــاتقة",
    "daira_name_ascii": "Maatkas",
    "daira_name": "معاتقة",
    "wilaya_code": "15",
    "wilaya_name_ascii": "Tizi Ouzou",
    "wilaya_name": "تيزي وزو"
  },
  {
    "id": 542,
    "commune_name_ascii": "Souk El Tenine",
    "commune_name": "سوق الإثنين",
    "daira_name_ascii": "Maatkas",
    "daira_name": "معاتقة",
    "wilaya_code": "15",
    "wilaya_name_ascii": "Tizi Ouzou",
    "wilaya_name": "تيزي وزو"
  },
  {
    "id": 499,
    "commune_name_ascii": "Ait Mahmoud",
    "commune_name": "أيت محمود",
    "daira_name_ascii": "Beni Douala",
    "daira_name": "بني دوالة",
    "wilaya_code": "15",
    "wilaya_name_ascii": "Tizi Ouzou",
    "wilaya_name": "تيزي وزو"
  },
  {
    "model": "base.commune",
    "pk": 502,
    "fields": {
      "postcode": 15016,
      "wilaya": 15,
      "name": "Beni Zmenzer"
    },
    "id": 508,
    "commune_name_ascii": "Beni Zmenzer",
    "commune_name": "بنــــي زمنزار",
    "daira_name_ascii": "Beni Douala",
    "daira_name": "بني دوالة",
    "wilaya_code": "15",
    "wilaya_name_ascii": "Tizi Ouzou",
    "wilaya_name": "تيزي وزو"
  },
  {
    "model": "base.commune",
    "pk": 503,
    "fields": {
      "postcode": 15017,
      "wilaya": 15,
      "name": "Iferhounene"
    },
    "id": 523,
    "commune_name_ascii": "Iferhounene",
    "commune_name": "إفــرحــونان",
    "daira_name_ascii": "Iferhounene",
    "daira_name": "إفرحونان",
    "wilaya_code": "15",
    "wilaya_name_ascii": "Tizi Ouzou",
    "wilaya_name": "تيزي وزو"
  },
  {
    "id": 516,
    "commune_name_ascii": "Bouzeguene",
    "commune_name": "بوزقــن",
    "daira_name_ascii": "Bouzeguene",
    "daira_name": "بوزقن",
    "wilaya_code": "15",
    "wilaya_name_ascii": "Tizi Ouzou",
    "wilaya_name": "تيزي وزو"
  },
  {
    "model": "base.commune",
    "pk": 570,
    "fields": {
      "postcode": 16017,
      "wilaya": 16,
      "name": "Hussein Dey"
    },
    "id": 588,
    "commune_name_ascii": "Hussein Dey",
    "commune_name": "حسين داي",
    "daira_name_ascii": "Hussein Dey",
    "daira_name": "حسين داي",
    "wilaya_code": "16",
    "wilaya_name_ascii": "Alger",
    "wilaya_name": "الجزائر"
  },
  {
    "model": "base.commune",
    "pk": 586,
    "fields": {
      "postcode": 16033,
      "wilaya": 16,
      "name": "Les Eucalyptus"
    },
    "id": 592,
    "commune_name_ascii": "Les Eucalyptus",
    "commune_name": "الكاليتوس",
    "daira_name_ascii": "Baraki",
    "daira_name": "براقي",
    "wilaya_code": "16",
    "wilaya_name_ascii": "Alger",
    "wilaya_name": "الجزائر"
  },
  {
    "model": "base.commune",
    "pk": 590,
    "fields": {
      "postcode": 16037,
      "wilaya": 16,
      "name": "Sidi Moussa"
    },
    "id": 606,
    "commune_name_ascii": "Sidi Moussa",
    "commune_name": "سيدي موسى",
    "daira_name_ascii": "Baraki",
    "daira_name": "براقي",
    "wilaya_code": "16",
    "wilaya_name_ascii": "Alger",
    "wilaya_name": "الجزائر"
  },
  {
    "model": "base.commune",
    "pk": 571,
    "fields": {
      "postcode": 16018,
      "wilaya": 16,
      "name": "Kouba"
    },
    "id": 591,
    "commune_name_ascii": "Kouba",
    "commune_name": "القبة",
    "daira_name_ascii": "Hussein Dey",
    "daira_name": "حسين داي",
    "wilaya_code": "16",
    "wilaya_name_ascii": "Alger",
    "wilaya_name": "الجزائر"
  },
  {
    "id": 594,
    "commune_name_ascii": "Mohamed Belouzdad",
    "commune_name": "محمد بلوزداد",
    "daira_name_ascii": "Hussein Dey",
    "daira_name": "حسين داي",
    "wilaya_code": "16",
    "wilaya_name_ascii": "Alger",
    "wilaya_name": "الجزائر"
  },
  {
    "model": "base.commune",
    "pk": 591,
    "fields": {
      "postcode": 16038,
      "wilaya": 16,
      "name": "Ain Taya"
    },
    "id": 555,
    "commune_name_ascii": "Ain Taya",
    "commune_name": "عين طاية",
    "daira_name_ascii": "Dar El Beida",
    "daira_name": "الدار البيضاء",
    "wilaya_code": "16",
    "wilaya_name_ascii": "Alger",
    "wilaya_name": "الجزائر"
  },
  {
    "id": 558,
    "commune_name_ascii": "Bab Ezzouar",
    "commune_name": "باب الزوار",
    "daira_name_ascii": "Dar El Beida",
    "daira_name": "الدار البيضاء",
    "wilaya_code": "16",
    "wilaya_name_ascii": "Alger",
    "wilaya_name": "الجزائر"
  },
  {
    "model": "base.commune",
    "pk": 583,
    "fields": {
      "postcode": 16030,
      "wilaya": 16,
      "name": "Bordj El Kiffan"
    },
    "id": 569,
    "commune_name_ascii": "Bordj El Kiffan",
    "commune_name": "برج الكيفان",
    "daira_name_ascii": "Dar El Beida",
    "daira_name": "الدار البيضاء",
    "wilaya_code": "16",
    "wilaya_name_ascii": "Alger",
    "wilaya_name": "الجزائر"
  },
  {
    "model": "base.commune",
    "pk": 573,
    "fields": {
      "postcode": 16020,
      "wilaya": 16,
      "name": "Dar El Beida"
    },
    "id": 574,
    "commune_name_ascii": "Dar El Beida",
    "commune_name": "الدار البيضاء",
    "daira_name_ascii": "Dar El Beida",
    "daira_name": "الدار البيضاء",
    "wilaya_code": "16",
    "wilaya_name_ascii": "Alger",
    "wilaya_name": "الجزائر"
  },
  {
    "model": "base.commune",
    "pk": 51,
    "fields": {
      "postcode": 2023,
      "wilaya": 2,
      "name": "El Marsa"
    },
    "id": 584,
    "commune_name_ascii": "El Marsa",
    "commune_name": "المرسى",
    "daira_name_ascii": "Dar El Beida",
    "daira_name": "الدار البيضاء",
    "wilaya_code": "16",
    "wilaya_name_ascii": "Alger",
    "wilaya_name": "الجزائر"
  },
  {
    "model": "base.commune",
    "pk": 582,
    "fields": {
      "postcode": 16029,
      "wilaya": 16,
      "name": "Mohammadia"
    },
    "id": 595,
    "commune_name_ascii": "Mohammadia",
    "commune_name": "المحمدية",
    "daira_name_ascii": "Dar El Beida",
    "daira_name": "الدار البيضاء",
    "wilaya_code": "16",
    "wilaya_name_ascii": "Alger",
    "wilaya_name": "الجزائر"
  },
  {
    "id": 566,
    "commune_name_ascii": "Bir Touta",
    "commune_name": "بئر توتة",
    "daira_name_ascii": "Birtouta",
    "daira_name": "بئر توتة",
    "wilaya_code": "16",
    "wilaya_name_ascii": "Alger",
    "wilaya_name": "الجزائر"
  },
  {
    "model": "base.commune",
    "pk": 589,
    "fields": {
      "postcode": 16036,
      "wilaya": 16,
      "name": "Ouled Chebel"
    },
    "id": 598,
    "commune_name_ascii": "Ouled Chebel",
    "commune_name": "اولاد شبل",
    "daira_name_ascii": "Birtouta",
    "daira_name": "بئر توتة",
    "wilaya_code": "16",
    "wilaya_name_ascii": "Alger",
    "wilaya_name": "الجزائر"
  },
  {
    "id": 609,
    "commune_name_ascii": "Tessala El Merdja",
    "commune_name": "تسالة المرجة",
    "daira_name_ascii": "Birtouta",
    "daira_name": "بئر توتة",
    "wilaya_code": "16",
    "wilaya_name_ascii": "Alger",
    "wilaya_name": "الجزائر"
  },
  {
    "id": 587,
    "commune_name_ascii": "Herraoua",
    "commune_name": "هراوة",
    "daira_name_ascii": "Rouiba",
    "daira_name": "الرويبة",
    "wilaya_code": "16",
    "wilaya_name_ascii": "Alger",
    "wilaya_name": "الجزائر"
  },
  {
    "model": "base.commune",
    "pk": 596,
    "fields": {
      "postcode": 16043,
      "wilaya": 16,
      "name": "Reghaia"
    },
    "id": 602,
    "commune_name_ascii": "Reghaia",
    "commune_name": "رغاية",
    "daira_name_ascii": "Rouiba",
    "daira_name": "الرويبة",
    "wilaya_code": "16",
    "wilaya_name_ascii": "Alger",
    "wilaya_name": "الجزائر"
  },
  {
    "model": "base.commune",
    "pk": 595,
    "fields": {
      "postcode": 16042,
      "wilaya": 16,
      "name": "Rouiba"
    },
    "id": 603,
    "commune_name_ascii": "Rouiba",
    "commune_name": "الرويبة",
    "daira_name_ascii": "Rouiba",
    "daira_name": "الرويبة",
    "wilaya_code": "16",
    "wilaya_name_ascii": "Alger",
    "wilaya_name": "الجزائر"
  },
  {
    "id": 593,
    "commune_name_ascii": "Maalma",
    "commune_name": "المعالمة",
    "daira_name_ascii": "Zeralda",
    "daira_name": "زرالدة",
    "wilaya_code": "16",
    "wilaya_name_ascii": "Alger",
    "wilaya_name": "الجزائر"
  },
  {
    "model": "base.commune",
    "pk": 601,
    "fields": {
      "postcode": 16048,
      "wilaya": 16,
      "name": "Rahmania"
    },
    "id": 600,
    "commune_name_ascii": "Rahmania",
    "commune_name": "الرحمانية",
    "daira_name_ascii": "Zeralda",
    "daira_name": "زرالدة",
    "wilaya_code": "16",
    "wilaya_name_ascii": "Alger",
    "wilaya_name": "الجزائر"
  },
  {
    "model": "base.commune",
    "pk": 602,
    "fields": {
      "postcode": 16049,
      "wilaya": 16,
      "name": "Souidania"
    },
    "id": 607,
    "commune_name_ascii": "Souidania",
    "commune_name": "سويدانية",
    "daira_name_ascii": "Zeralda",
    "daira_name": "زرالدة",
    "wilaya_code": "16",
    "wilaya_name_ascii": "Alger",
    "wilaya_name": "الجزائر"
  },
  {
    "model": "base.commune",
    "pk": 598,
    "fields": {
      "postcode": 16045,
      "wilaya": 16,
      "name": "Staoueli"
    },
    "id": 608,
    "commune_name_ascii": "Staoueli",
    "commune_name": "سطاوالي",
    "daira_name_ascii": "Zeralda",
    "daira_name": "زرالدة",
    "wilaya_code": "16",
    "wilaya_name_ascii": "Alger",
    "wilaya_name": "الجزائر"
  },
  {
    "model": "base.commune",
    "pk": 599,
    "fields": {
      "postcode": 16046,
      "wilaya": 16,
      "name": "Zeralda"
    },
    "id": 610,
    "commune_name_ascii": "Zeralda",
    "commune_name": "زرالدة",
    "daira_name_ascii": "Zeralda",
    "daira_name": "زرالدة",
    "wilaya_code": "16",
    "wilaya_name_ascii": "Alger",
    "wilaya_name": "الجزائر"
  },
  {
    "model": "base.commune",
    "pk": 608,
    "fields": {
      "postcode": 16055,
      "wilaya": 16,
      "name": "Baba Hassen"
    },
    "id": 559,
    "commune_name_ascii": "Baba Hassen",
    "commune_name": "بابا حسن",
    "daira_name_ascii": "Draria",
    "daira_name": "الدرارية",
    "wilaya_code": "16",
    "wilaya_name_ascii": "Alger",
    "wilaya_name": "الجزائر"
  },
  {
    "id": 577,
    "commune_name_ascii": "Douira",
    "commune_name": "الدويرة",
    "daira_name_ascii": "Draria",
    "daira_name": "الدرارية",
    "wilaya_code": "16",
    "wilaya_name_ascii": "Alger",
    "wilaya_name": "الجزائر"
  },
  {
    "model": "base.commune",
    "pk": 606,
    "fields": {
      "postcode": 16053,
      "wilaya": 16,
      "name": "Draria"
    },
    "id": 578,
    "commune_name_ascii": "Draria",
    "commune_name": "الدرارية",
    "daira_name_ascii": "Draria",
    "daira_name": "الدرارية",
    "wilaya_code": "16",
    "wilaya_name_ascii": "Alger",
    "wilaya_name": "الجزائر"
  },
  {
    "model": "base.commune",
    "pk": 605,
    "fields": {
      "postcode": 16052,
      "wilaya": 16,
      "name": "El Achour"
    },
    "id": 579,
    "commune_name_ascii": "El Achour",
    "commune_name": "العاشور",
    "daira_name_ascii": "Draria",
    "daira_name": "الدرارية",
    "wilaya_code": "16",
    "wilaya_name_ascii": "Alger",
    "wilaya_name": "الجزائر"
  },
  {
    "id": 590,
    "commune_name_ascii": "Kheraisia",
    "commune_name": "الخرايسية",
    "daira_name_ascii": "Draria",
    "daira_name": "الدرارية",
    "wilaya_code": "16",
    "wilaya_name_ascii": "Alger",
    "wilaya_name": "الجزائر"
  },
  {
    "model": "base.commune",
    "pk": 597,
    "fields": {
      "postcode": 16044,
      "wilaya": 16,
      "name": "Ain Benian"
    },
    "id": 554,
    "commune_name_ascii": "Ain Benian",
    "commune_name": "عين بنيان",
    "daira_name_ascii": "Cheraga",
    "daira_name": "الشراقة",
    "wilaya_code": "16",
    "wilaya_name_ascii": "Alger",
    "wilaya_name": "الجزائر"
  },
  {
    "model": "base.commune",
    "pk": 603,
    "fields": {
      "postcode": 16050,
      "wilaya": 16,
      "name": "Cheraga"
    },
    "id": 573,
    "commune_name_ascii": "Cheraga",
    "commune_name": "الشراقة",
    "daira_name_ascii": "Cheraga",
    "daira_name": "الشراقة",
    "wilaya_code": "16",
    "wilaya_name_ascii": "Alger",
    "wilaya_name": "الجزائر"
  },
  {
    "model": "base.commune",
    "pk": 576,
    "fields": {
      "postcode": 16023,
      "wilaya": 16,
      "name": "Dely Ibrahim"
    },
    "id": 575,
    "commune_name_ascii": "Dely Ibrahim",
    "commune_name": "دالي ابراهيم",
    "daira_name_ascii": "Cheraga",
    "daira_name": "الشراقة",
    "wilaya_code": "16",
    "wilaya_name_ascii": "Alger",
    "wilaya_name": "الجزائر"
  },
  {
    "model": "base.commune",
    "pk": 371,
    "fields": {
      "postcode": 12008,
      "wilaya": 12,
      "name": "Hammamet"
    },
    "id": 586,
    "commune_name_ascii": "Hammamet",
    "commune_name": "الحمامات",
    "daira_name_ascii": "Cheraga",
    "daira_name": "الشراقة",
    "wilaya_code": "16",
    "wilaya_name_ascii": "Alger",
    "wilaya_name": "الجزائر"
  },
  {
    "model": "base.commune",
    "pk": 604,
    "fields": {
      "postcode": 16051,
      "wilaya": 16,
      "name": "Ouled Fayet"
    },
    "id": 599,
    "commune_name_ascii": "Ouled Fayet",
    "commune_name": "اولاد فايت",
    "daira_name_ascii": "Cheraga",
    "daira_name": "الشراقة",
    "wilaya_code": "16",
    "wilaya_name_ascii": "Alger",
    "wilaya_name": "الجزائر"
  },
  {
    "model": "base.commune",
    "pk": 554,
    "fields": {
      "postcode": 16001,
      "wilaya": 16,
      "name": "Alger Centre"
    },
    "id": 556,
    "commune_name_ascii": "Alger Centre",
    "commune_name": "الجزائر الوسطى",
    "daira_name_ascii": "Sidi M'hamed",
    "daira_name": "سيدي امحمد",
    "wilaya_code": "16",
    "wilaya_name_ascii": "Alger",
    "wilaya_name": "الجزائر"
  },
  {
    "model": "base.commune",
    "pk": 556,
    "fields": {
      "postcode": 16003,
      "wilaya": 16,
      "name": "El Madania"
    },
    "id": 582,
    "commune_name_ascii": "El Madania",
    "commune_name": "المدنية",
    "daira_name_ascii": "Sidi M'hamed",
    "daira_name": "سيدي امحمد",
    "wilaya_code": "16",
    "wilaya_name_ascii": "Alger",
    "wilaya_name": "الجزائر"
  },
  {
    "model": "base.commune",
    "pk": 580,
    "fields": {
      "postcode": 16027,
      "wilaya": 16,
      "name": "El Mouradia"
    },
    "id": 585,
    "commune_name_ascii": "El Mouradia",
    "commune_name": "المرادية",
    "daira_name_ascii": "Sidi M'hamed",
    "daira_name": "سيدي امحمد",
    "wilaya_code": "16",
    "wilaya_name_ascii": "Alger",
    "wilaya_name": "الجزائر"
  },
  {
    "id": 605,
    "commune_name_ascii": "Sidi M'hamed",
    "commune_name": "سيدي امحمد",
    "daira_name_ascii": "Sidi M'hamed",
    "daira_name": "سيدي امحمد",
    "wilaya_code": "16",
    "wilaya_name_ascii": "Alger",
    "wilaya_name": "الجزائر"
  },
  {
    "id": 604,
    "commune_name_ascii": "Sehaoula",
    "commune_name": "السحاولة",
    "daira_name_ascii": "Bir Mourad Rais",
    "daira_name": "بئر مراد رايس",
    "wilaya_code": "16",
    "wilaya_name_ascii": "Alger",
    "wilaya_name": "الجزائر"
  },
  {
    "id": 567,
    "commune_name_ascii": "Bologhine Ibnou Ziri",
    "commune_name": "بولوغين بن زيري",
    "daira_name_ascii": "Bab El Oued",
    "daira_name": "باب الوادي",
    "wilaya_code": "16",
    "wilaya_name_ascii": "Alger",
    "wilaya_name": "الجزائر"
  },
  {
    "model": "base.commune",
    "pk": 560,
    "fields": {
      "postcode": 16007,
      "wilaya": 16,
      "name": "Casbah"
    },
    "id": 572,
    "commune_name_ascii": "Casbah",
    "commune_name": "القصبة",
    "daira_name_ascii": "Bab El Oued",
    "daira_name": "باب الوادي",
    "wilaya_code": "16",
    "wilaya_name_ascii": "Alger",
    "wilaya_name": "الجزائر"
  },
  {
    "model": "base.commune",
    "pk": 561,
    "fields": {
      "postcode": 16008,
      "wilaya": 16,
      "name": "Oued Koriche"
    },
    "id": 596,
    "commune_name_ascii": "Oued Koriche",
    "commune_name": "وادي قريش",
    "daira_name_ascii": "Bab El Oued",
    "daira_name": "باب الوادي",
    "wilaya_code": "16",
    "wilaya_name_ascii": "Alger",
    "wilaya_name": "الجزائر"
  },
  {
    "model": "base.commune",
    "pk": 578,
    "fields": {
      "postcode": 16025,
      "wilaya": 16,
      "name": "Rais Hamidou"
    },
    "id": 601,
    "commune_name_ascii": "Rais Hamidou",
    "commune_name": "الرايس حميدو",
    "daira_name_ascii": "Bab El Oued",
    "daira_name": "باب الوادي",
    "wilaya_code": "16",
    "wilaya_name_ascii": "Alger",
    "wilaya_name": "الجزائر"
  },
  {
    "model": "base.commune",
    "pk": 562,
    "fields": {
      "postcode": 16009,
      "wilaya": 16,
      "name": "Bir Mourad Rais"
    },
    "id": 564,
    "commune_name_ascii": "Bir Mourad Rais",
    "commune_name": "بئر مراد رايس",
    "daira_name_ascii": "Bir Mourad Rais",
    "daira_name": "بئر مراد رايس",
    "wilaya_code": "16",
    "wilaya_name_ascii": "Alger",
    "wilaya_name": "الجزائر"
  },
  {
    "model": "base.commune",
    "pk": 565,
    "fields": {
      "postcode": 16012,
      "wilaya": 16,
      "name": "Birkhadem"
    },
    "id": 565,
    "commune_name_ascii": "Birkhadem",
    "commune_name": "بئر خادم",
    "daira_name_ascii": "Bir Mourad Rais",
    "daira_name": "بئر مراد رايس",
    "wilaya_code": "16",
    "wilaya_name_ascii": "Alger",
    "wilaya_name": "الجزائر"
  },
  {
    "model": "base.commune",
    "pk": 579,
    "fields": {
      "postcode": 16026,
      "wilaya": 16,
      "name": "Djasr Kasentina"
    },
    "id": 576,
    "commune_name_ascii": "Djasr Kasentina",
    "commune_name": "جسر قسنطينة",
    "daira_name_ascii": "Bir Mourad Rais",
    "daira_name": "بئر مراد رايس",
    "wilaya_code": "16",
    "wilaya_name_ascii": "Alger",
    "wilaya_name": "الجزائر"
  },
  {
    "model": "base.commune",
    "pk": 581,
    "fields": {
      "postcode": 16028,
      "wilaya": 16,
      "name": "Hydra"
    },
    "id": 589,
    "commune_name_ascii": "Hydra",
    "commune_name": "حيدرة",
    "daira_name_ascii": "Bir Mourad Rais",
    "daira_name": "بئر مراد رايس",
    "wilaya_code": "16",
    "wilaya_name_ascii": "Alger",
    "wilaya_name": "الجزائر"
  },
  {
    "model": "base.commune",
    "pk": 584,
    "fields": {
      "postcode": 16031,
      "wilaya": 16,
      "name": "El Magharia"
    },
    "id": 583,
    "commune_name_ascii": "El Magharia",
    "commune_name": "المغارية",
    "daira_name_ascii": "Hussein Dey",
    "daira_name": "حسين داي",
    "wilaya_code": "16",
    "wilaya_name_ascii": "Alger",
    "wilaya_name": "الجزائر"
  },
  {
    "model": "base.commune",
    "pk": 575,
    "fields": {
      "postcode": 16022,
      "wilaya": 16,
      "name": "Ben Aknoun"
    },
    "id": 562,
    "commune_name_ascii": "Ben Aknoun",
    "commune_name": "ابن عكنون",
    "daira_name_ascii": "Bouzareah",
    "daira_name": "بوزريعة",
    "wilaya_code": "16",
    "wilaya_name_ascii": "Alger",
    "wilaya_name": "الجزائر"
  },
  {
    "model": "base.commune",
    "pk": 585,
    "fields": {
      "postcode": 16032,
      "wilaya": 16,
      "name": "Beni Messous"
    },
    "id": 563,
    "commune_name_ascii": "Beni Messous",
    "commune_name": "بني مسوس",
    "daira_name_ascii": "Bouzareah",
    "daira_name": "بوزريعة",
    "wilaya_code": "16",
    "wilaya_name_ascii": "Alger",
    "wilaya_name": "الجزائر"
  },
  {
    "model": "base.commune",
    "pk": 564,
    "fields": {
      "postcode": 16011,
      "wilaya": 16,
      "name": "Bouzareah"
    },
    "id": 571,
    "commune_name_ascii": "Bouzareah",
    "commune_name": "بوزريعة",
    "daira_name_ascii": "Bouzareah",
    "daira_name": "بوزريعة",
    "wilaya_code": "16",
    "wilaya_name_ascii": "Alger",
    "wilaya_name": "الجزائر"
  },
  {
    "model": "base.commune",
    "pk": 563,
    "fields": {
      "postcode": 16010,
      "wilaya": 16,
      "name": "El Biar"
    },
    "id": 580,
    "commune_name_ascii": "El Biar",
    "commune_name": "الابيار",
    "daira_name_ascii": "Bouzareah",
    "daira_name": "بوزريعة",
    "wilaya_code": "16",
    "wilaya_name_ascii": "Alger",
    "wilaya_name": "الجزائر"
  },
  {
    "model": "base.commune",
    "pk": 572,
    "fields": {
      "postcode": 16019,
      "wilaya": 16,
      "name": "Bachedjerah"
    },
    "id": 560,
    "commune_name_ascii": "Bachedjerah",
    "commune_name": "باش جراح",
    "daira_name_ascii": "El Harrach",
    "daira_name": "الحراش",
    "wilaya_code": "16",
    "wilaya_name_ascii": "Alger",
    "wilaya_name": "الجزائر"
  },
  {
    "model": "base.commune",
    "pk": 569,
    "fields": {
      "postcode": 16016,
      "wilaya": 16,
      "name": "Bourouba"
    },
    "id": 570,
    "commune_name_ascii": "Bourouba",
    "commune_name": "بوروبة",
    "daira_name_ascii": "El Harrach",
    "daira_name": "الحراش",
    "wilaya_code": "16",
    "wilaya_name_ascii": "Alger",
    "wilaya_name": "الجزائر"
  },
  {
    "model": "base.commune",
    "pk": 566,
    "fields": {
      "postcode": 16013,
      "wilaya": 16,
      "name": "El Harrach"
    },
    "id": 581,
    "commune_name_ascii": "El Harrach",
    "commune_name": "الحراش",
    "daira_name_ascii": "El Harrach",
    "daira_name": "الحراش",
    "wilaya_code": "16",
    "wilaya_name_ascii": "Alger",
    "wilaya_name": "الجزائر"
  },
  {
    "model": "base.commune",
    "pk": 568,
    "fields": {
      "postcode": 16015,
      "wilaya": 16,
      "name": "Oued Smar"
    },
    "id": 597,
    "commune_name_ascii": "Oued Smar",
    "commune_name": "وادي السمار",
    "daira_name_ascii": "El Harrach",
    "daira_name": "الحراش",
    "wilaya_code": "16",
    "wilaya_name_ascii": "Alger",
    "wilaya_name": "الجزائر"
  },
  {
    "model": "base.commune",
    "pk": 567,
    "fields": {
      "postcode": 16014,
      "wilaya": 16,
      "name": "Baraki"
    },
    "id": 561,
    "commune_name_ascii": "Baraki",
    "commune_name": "براقي",
    "daira_name_ascii": "Baraki",
    "daira_name": "براقي",
    "wilaya_code": "16",
    "wilaya_name_ascii": "Alger",
    "wilaya_name": "الجزائر"
  },
  {
    "model": "base.commune",
    "pk": 592,
    "fields": {
      "postcode": 16039,
      "wilaya": 16,
      "name": "Bordj El Bahri"
    },
    "id": 568,
    "commune_name_ascii": "Bordj El Bahri",
    "commune_name": "برج البحري",
    "daira_name_ascii": "Dar El Beida",
    "daira_name": "الدار البيضاء",
    "wilaya_code": "16",
    "wilaya_name_ascii": "Alger",
    "wilaya_name": "الجزائر"
  },
  {
    "model": "base.commune",
    "pk": 558,
    "fields": {
      "postcode": 16005,
      "wilaya": 16,
      "name": "Bab El Oued"
    },
    "id": 557,
    "commune_name_ascii": "Bab El Oued",
    "commune_name": "باب الوادي",
    "daira_name_ascii": "Bab El Oued",
    "daira_name": "باب الوادي",
    "wilaya_code": "16",
    "wilaya_name_ascii": "Alger",
    "wilaya_name": "الجزائر"
  },
  {
    "model": "base.commune",
    "pk": 626,
    "fields": {
      "postcode": 17016,
      "wilaya": 17,
      "name": "Hassi El Euch"
    },
    "id": 634,
    "commune_name_ascii": "Hassi El Euch",
    "commune_name": "حاسي العش",
    "daira_name_ascii": "Hassi Bahbah",
    "daira_name": "حاسي بحبح",
    "wilaya_code": "17",
    "wilaya_name_ascii": "Djelfa",
    "wilaya_name": "الجلفة"
  },
  {
    "model": "base.commune",
    "pk": 640,
    "fields": {
      "postcode": 17030,
      "wilaya": 17,
      "name": "Ain El Ibel"
    },
    "id": 612,
    "commune_name_ascii": "Ain El Ibel",
    "commune_name": "عين الإبل",
    "daira_name_ascii": "Ain El Ibel",
    "daira_name": "عين الإبل",
    "wilaya_code": "17",
    "wilaya_name_ascii": "Djelfa",
    "wilaya_name": "الجلفة"
  },
  {
    "model": "base.commune",
    "pk": 613,
    "fields": {
      "postcode": 17003,
      "wilaya": 17,
      "name": "El Guedid"
    },
    "id": 626,
    "commune_name_ascii": "El Guedid",
    "commune_name": "القديد",
    "daira_name_ascii": "Charef",
    "daira_name": "الشارف",
    "wilaya_code": "17",
    "wilaya_name_ascii": "Djelfa",
    "wilaya_name": "الجلفة"
  },
  {
    "model": "base.commune",
    "pk": 636,
    "fields": {
      "postcode": 17026,
      "wilaya": 17,
      "name": "Charef"
    },
    "id": 621,
    "commune_name_ascii": "Charef",
    "commune_name": "الشارف",
    "daira_name_ascii": "Charef",
    "daira_name": "الشارف",
    "wilaya_code": "17",
    "wilaya_name_ascii": "Djelfa",
    "wilaya_name": "الجلفة"
  },
  {
    "id": 618,
    "commune_name_ascii": "Benyagoub",
    "commune_name": "بن يعقوب",
    "daira_name_ascii": "Charef",
    "daira_name": "الشارف",
    "wilaya_code": "17",
    "wilaya_name_ascii": "Djelfa",
    "wilaya_name": "الجلفة"
  },
  {
    "model": "base.commune",
    "pk": 622,
    "fields": {
      "postcode": 17012,
      "wilaya": 17,
      "name": "Sidi Baizid"
    },
    "id": 642,
    "commune_name_ascii": "Sidi Baizid",
    "commune_name": "سيدي بايزيد",
    "daira_name_ascii": "Dar Chioukh",
    "daira_name": "دار الشيوخ",
    "wilaya_code": "17",
    "wilaya_name_ascii": "Djelfa",
    "wilaya_name": "الجلفة"
  },
  {
    "id": 637,
    "commune_name_ascii": "M'liliha",
    "commune_name": "مليليحة",
    "daira_name_ascii": "Dar Chioukh",
    "daira_name": "دار الشيوخ",
    "wilaya_code": "17",
    "wilaya_name_ascii": "Djelfa",
    "wilaya_name": "الجلفة"
  },
  {
    "id": 622,
    "commune_name_ascii": "Dar Chioukh",
    "commune_name": "دار الشيوخ",
    "daira_name_ascii": "Dar Chioukh",
    "daira_name": "دار الشيوخ",
    "wilaya_code": "17",
    "wilaya_name_ascii": "Djelfa",
    "wilaya_name": "الجلفة"
  },
  {
    "id": 644,
    "commune_name_ascii": "Taadmit",
    "commune_name": "تعظميت",
    "daira_name_ascii": "Ain El Ibel",
    "daira_name": "عين الإبل",
    "wilaya_code": "17",
    "wilaya_name_ascii": "Djelfa",
    "wilaya_name": "الجلفة"
  },
  {
    "model": "base.commune",
    "pk": 630,
    "fields": {
      "postcode": 17020,
      "wilaya": 17,
      "name": "Had Sahary"
    },
    "id": 632,
    "commune_name_ascii": "Had Sahary",
    "commune_name": "حد الصحاري",
    "daira_name_ascii": "Had Sahary",
    "daira_name": "حد الصحاري",
    "wilaya_code": "17",
    "wilaya_name_ascii": "Djelfa",
    "wilaya_name": "الجلفة"
  },
  {
    "id": 620,
    "commune_name_ascii": "Bouira Lahdab",
    "commune_name": "بويرة الأحداب",
    "daira_name_ascii": "Had Sahary",
    "daira_name": "حد الصحاري",
    "wilaya_code": "17",
    "wilaya_name_ascii": "Djelfa",
    "wilaya_name": "الجلفة"
  },
  {
    "model": "base.commune",
    "pk": 645,
    "fields": {
      "postcode": 17035,
      "wilaya": 17,
      "name": "Ain Fekka"
    },
    "id": 613,
    "commune_name_ascii": "Ain Fekka",
    "commune_name": "عين فقه",
    "daira_name_ascii": "Had Sahary",
    "daira_name": "حد الصحاري",
    "wilaya_code": "17",
    "wilaya_name_ascii": "Djelfa",
    "wilaya_name": "الجلفة"
  },
  {
    "id": 643,
    "commune_name_ascii": "Sidi Laadjel",
    "commune_name": "سيدي لعجال",
    "daira_name_ascii": "Sidi Laadjel",
    "daira_name": "سيدي لعجال",
    "wilaya_code": "17",
    "wilaya_name_ascii": "Djelfa",
    "wilaya_name": "الجلفة"
  },
  {
    "model": "base.commune",
    "pk": 643,
    "fields": {
      "postcode": 17033,
      "wilaya": 17,
      "name": "Hassi Fedoul"
    },
    "id": 635,
    "commune_name_ascii": "Hassi Fedoul",
    "commune_name": "حاسي فدول",
    "daira_name_ascii": "Sidi Laadjel",
    "daira_name": "سيدي لعجال",
    "wilaya_code": "17",
    "wilaya_name_ascii": "Djelfa",
    "wilaya_name": "الجلفة"
  },
  {
    "model": "base.commune",
    "pk": 621,
    "fields": {
      "postcode": 17011,
      "wilaya": 17,
      "name": "El Khemis"
    },
    "id": 628,
    "commune_name_ascii": "El Khemis",
    "commune_name": "الخميس",
    "daira_name_ascii": "Sidi Laadjel",
    "daira_name": "سيدي لعجال",
    "wilaya_code": "17",
    "wilaya_name_ascii": "Djelfa",
    "wilaya_name": "الجلفة"
  },
  {
    "model": "base.commune",
    "pk": 632,
    "fields": {
      "postcode": 17022,
      "wilaya": 17,
      "name": "Selmana"
    },
    "id": 641,
    "commune_name_ascii": "Selmana",
    "commune_name": "سلمانة",
    "daira_name_ascii": "Messaad",
    "daira_name": "مسعد",
    "wilaya_code": "17",
    "wilaya_name_ascii": "Djelfa",
    "wilaya_name": "الجلفة"
  },
  {
    "model": "base.commune",
    "pk": 616,
    "fields": {
      "postcode": 17006,
      "wilaya": 17,
      "name": "Sed Rahal"
    },
    "id": 640,
    "commune_name_ascii": "Sed Rahal",
    "commune_name": "سد الرحال",
    "daira_name_ascii": "Messaad",
    "daira_name": "مسعد",
    "wilaya_code": "17",
    "wilaya_name_ascii": "Djelfa",
    "wilaya_name": "الجلفة"
  },
  {
    "model": "base.commune",
    "pk": 627,
    "fields": {
      "postcode": 17017,
      "wilaya": 17,
      "name": "Messaad"
    },
    "id": 636,
    "commune_name_ascii": "Messaad",
    "commune_name": "مسعد",
    "daira_name_ascii": "Messaad",
    "daira_name": "مسعد",
    "wilaya_code": "17",
    "wilaya_name_ascii": "Djelfa",
    "wilaya_name": "الجلفة"
  },
  {
    "model": "base.commune",
    "pk": 628,
    "fields": {
      "postcode": 17018,
      "wilaya": 17,
      "name": "Guettara"
    },
    "id": 631,
    "commune_name_ascii": "Guettara",
    "commune_name": "قطارة",
    "daira_name_ascii": "Messaad",
    "daira_name": "مسعد",
    "wilaya_code": "17",
    "wilaya_name_ascii": "Djelfa",
    "wilaya_name": "الجلفة"
  },
  {
    "model": "base.commune",
    "pk": 17,
    "fields": {
      "postcode": 1017,
      "wilaya": 1,
      "name": "Deldoul"
    },
    "id": 623,
    "commune_name_ascii": "Deldoul",
    "commune_name": "دلدول",
    "daira_name_ascii": "Messaad",
    "daira_name": "مسعد",
    "wilaya_code": "17",
    "wilaya_name_ascii": "Djelfa",
    "wilaya_name": "الجلفة"
  },
  {
    "model": "base.commune",
    "pk": 620,
    "fields": {
      "postcode": 17010,
      "wilaya": 17,
      "name": "Zaccar"
    },
    "id": 646,
    "commune_name_ascii": "Zaccar",
    "commune_name": "زكار",
    "daira_name_ascii": "Ain El Ibel",
    "daira_name": "عين الإبل",
    "wilaya_code": "17",
    "wilaya_name_ascii": "Djelfa",
    "wilaya_name": "الجلفة"
  },
  {
    "model": "base.commune",
    "pk": 625,
    "fields": {
      "postcode": 17015,
      "wilaya": 17,
      "name": "Douis"
    },
    "id": 625,
    "commune_name_ascii": "Douis",
    "commune_name": "دويس",
    "daira_name_ascii": "El Idrissia",
    "daira_name": "الادريسية",
    "wilaya_code": "17",
    "wilaya_name_ascii": "Djelfa",
    "wilaya_name": "الجلفة"
  },
  {
    "model": "base.commune",
    "pk": 624,
    "fields": {
      "postcode": 17014,
      "wilaya": 17,
      "name": "El Idrissia"
    },
    "id": 627,
    "commune_name_ascii": "El Idrissia",
    "commune_name": "الادريسية",
    "daira_name_ascii": "El Idrissia",
    "daira_name": "الادريسية",
    "wilaya_code": "17",
    "wilaya_name_ascii": "Djelfa",
    "wilaya_name": "الجلفة"
  },
  {
    "model": "base.commune",
    "pk": 633,
    "fields": {
      "postcode": 17023,
      "wilaya": 17,
      "name": "Ain Chouhada"
    },
    "id": 611,
    "commune_name_ascii": "Ain Chouhada",
    "commune_name": "عين الشهداء",
    "daira_name_ascii": "El Idrissia",
    "daira_name": "الادريسية",
    "wilaya_code": "17",
    "wilaya_name_ascii": "Djelfa",
    "wilaya_name": "الجلفة"
  },
  {
    "model": "base.commune",
    "pk": 611,
    "fields": {
      "postcode": 17001,
      "wilaya": 17,
      "name": "Djelfa"
    },
    "id": 624,
    "commune_name_ascii": "Djelfa",
    "commune_name": "الجلفة",
    "daira_name_ascii": "Djelfa",
    "daira_name": "الجلفة",
    "wilaya_code": "17",
    "wilaya_name_ascii": "Djelfa",
    "wilaya_name": "الجلفة"
  },
  {
    "model": "base.commune",
    "pk": 618,
    "fields": {
      "postcode": 17008,
      "wilaya": 17,
      "name": "Birine"
    },
    "id": 619,
    "commune_name_ascii": "Birine",
    "commune_name": "بيرين",
    "daira_name_ascii": "Birine",
    "daira_name": "بيرين",
    "wilaya_code": "17",
    "wilaya_name_ascii": "Djelfa",
    "wilaya_name": "الجلفة"
  },
  {
    "model": "base.commune",
    "pk": 634,
    "fields": {
      "postcode": 17024,
      "wilaya": 17,
      "name": "Oum Laadham"
    },
    "id": 639,
    "commune_name_ascii": "Oum Laadham",
    "commune_name": "أم العظام",
    "daira_name_ascii": "Faidh El Botma",
    "daira_name": "فيض البطمة",
    "wilaya_code": "17",
    "wilaya_name_ascii": "Djelfa",
    "wilaya_name": "الجلفة"
  },
  {
    "id": 629,
    "commune_name_ascii": "Faidh El Botma",
    "commune_name": "فيض البطمة",
    "daira_name_ascii": "Faidh El Botma",
    "daira_name": "فيض البطمة",
    "wilaya_code": "17",
    "wilaya_name_ascii": "Djelfa",
    "wilaya_name": "الجلفة"
  },
  {
    "model": "base.commune",
    "pk": 644,
    "fields": {
      "postcode": 17034,
      "wilaya": 17,
      "name": "Amourah"
    },
    "id": 616,
    "commune_name_ascii": "Amourah",
    "commune_name": "عمورة",
    "daira_name_ascii": "Faidh El Botma",
    "daira_name": "فيض البطمة",
    "wilaya_code": "17",
    "wilaya_name_ascii": "Djelfa",
    "wilaya_name": "الجلفة"
  },
  {
    "model": "base.commune",
    "pk": 638,
    "fields": {
      "postcode": 17028,
      "wilaya": 17,
      "name": "Zaafrane"
    },
    "id": 645,
    "commune_name_ascii": "Zaafrane",
    "commune_name": "زعفران",
    "daira_name_ascii": "Hassi Bahbah",
    "daira_name": "حاسي بحبح",
    "wilaya_code": "17",
    "wilaya_name_ascii": "Djelfa",
    "wilaya_name": "الجلفة"
  },
  {
    "model": "base.commune",
    "pk": 631,
    "fields": {
      "postcode": 17021,
      "wilaya": 17,
      "name": "Guernini"
    },
    "id": 630,
    "commune_name_ascii": "Guernini",
    "commune_name": "قرنيني",
    "daira_name_ascii": "Ain Oussera",
    "daira_name": "عين وسارة",
    "wilaya_code": "17",
    "wilaya_name_ascii": "Djelfa",
    "wilaya_name": "الجلفة"
  },
  {
    "model": "base.commune",
    "pk": 641,
    "fields": {
      "postcode": 17031,
      "wilaya": 17,
      "name": "Ain Oussera"
    },
    "id": 615,
    "commune_name_ascii": "Ain Oussera",
    "commune_name": "عين وسارة",
    "daira_name_ascii": "Ain Oussera",
    "daira_name": "عين وسارة",
    "wilaya_code": "17",
    "wilaya_name_ascii": "Djelfa",
    "wilaya_name": "الجلفة"
  },
  {
    "model": "base.commune",
    "pk": 642,
    "fields": {
      "postcode": 17032,
      "wilaya": 17,
      "name": "Benhar"
    },
    "id": 617,
    "commune_name_ascii": "Benhar",
    "commune_name": "بنهار",
    "daira_name_ascii": "Birine",
    "daira_name": "بيرين",
    "wilaya_code": "17",
    "wilaya_name_ascii": "Djelfa",
    "wilaya_name": "الجلفة"
  },
  {
    "model": "base.commune",
    "pk": 615,
    "fields": {
      "postcode": 17005,
      "wilaya": 17,
      "name": "Ain Maabed"
    },
    "id": 614,
    "commune_name_ascii": "Ain Maabed",
    "commune_name": "عين معبد",
    "daira_name_ascii": "Hassi Bahbah",
    "daira_name": "حاسي بحبح",
    "wilaya_code": "17",
    "wilaya_name_ascii": "Djelfa",
    "wilaya_name": "الجلفة"
  },
  {
    "model": "base.commune",
    "pk": 614,
    "fields": {
      "postcode": 17004,
      "wilaya": 17,
      "name": "Hassi Bahbah"
    },
    "id": 633,
    "commune_name_ascii": "Hassi Bahbah",
    "commune_name": "حاسي بحبح",
    "daira_name_ascii": "Hassi Bahbah",
    "daira_name": "حاسي بحبح",
    "wilaya_code": "17",
    "wilaya_name_ascii": "Djelfa",
    "wilaya_name": "الجلفة"
  },
  {
    "model": "base.commune",
    "pk": 612,
    "fields": {
      "postcode": 17002,
      "wilaya": 17,
      "name": "Moudjebara"
    },
    "id": 638,
    "commune_name_ascii": "Moudjebara",
    "commune_name": "مجبارة",
    "daira_name_ascii": "Ain El Ibel",
    "daira_name": "عين الإبل",
    "wilaya_code": "17",
    "wilaya_name_ascii": "Djelfa",
    "wilaya_name": "الجلفة"
  },
  {
    "model": "base.commune",
    "pk": 647,
    "fields": {
      "postcode": 18001,
      "wilaya": 18,
      "name": "Jijel"
    },
    "id": 662,
    "commune_name_ascii": "Jijel",
    "commune_name": "جيجل",
    "daira_name_ascii": "Jijel",
    "daira_name": "جيجل",
    "wilaya_code": "18",
    "wilaya_name_ascii": "Jijel",
    "wilaya_name": "جيجل"
  },
  {
    "model": "base.commune",
    "pk": 649,
    "fields": {
      "postcode": 18003,
      "wilaya": 18,
      "name": "El Aouana"
    },
    "id": 656,
    "commune_name_ascii": "El Aouana",
    "commune_name": "العوانة",
    "daira_name_ascii": "El Aouana",
    "daira_name": "العوانة",
    "wilaya_code": "18",
    "wilaya_name_ascii": "Jijel",
    "wilaya_name": "جيجل"
  },
  {
    "model": "base.commune",
    "pk": 664,
    "fields": {
      "postcode": 18018,
      "wilaya": 18,
      "name": "Selma Benziada"
    },
    "id": 668,
    "commune_name_ascii": "Selma Benziada",
    "commune_name": "سلمى بن زيادة",
    "daira_name_ascii": "El Aouana",
    "daira_name": "العوانة",
    "wilaya_code": "18",
    "wilaya_name_ascii": "Jijel",
    "wilaya_name": "جيجل"
  },
  {
    "id": 660,
    "commune_name_ascii": "Erraguene Souissi",
    "commune_name": "أراقن سويسي",
    "daira_name_ascii": "Ziamah Mansouriah",
    "daira_name": "زيامة منصورية",
    "wilaya_code": "18",
    "wilaya_name_ascii": "Jijel",
    "wilaya_name": "جيجل"
  },
  {
    "model": "base.commune",
    "pk": 665,
    "fields": {
      "postcode": 18019,
      "wilaya": 18,
      "name": "Boussif Ouled Askeur"
    },
    "id": 650,
    "commune_name_ascii": "Boussif Ouled Askeur",
    "commune_name": "بوسيف أولاد عسكر",
    "daira_name_ascii": "Taher",
    "daira_name": "الطاهير",
    "wilaya_code": "18",
    "wilaya_name_ascii": "Jijel",
    "wilaya_name": "جيجل"
  },
  {
    "id": 674,
    "commune_name_ascii": "Ziama Mansouriah",
    "commune_name": "زيامة منصورية",
    "daira_name_ascii": "Ziamah Mansouriah",
    "daira_name": "زيامة منصورية",
    "wilaya_code": "18",
    "wilaya_name_ascii": "Jijel",
    "wilaya_name": "جيجل"
  },
  {
    "model": "base.commune",
    "pk": 654,
    "fields": {
      "postcode": 18008,
      "wilaya": 18,
      "name": "Chahna"
    },
    "id": 651,
    "commune_name_ascii": "Chahna",
    "commune_name": "الشحنة",
    "daira_name_ascii": "Taher",
    "daira_name": "الطاهير",
    "wilaya_code": "18",
    "wilaya_name_ascii": "Jijel",
    "wilaya_name": "جيجل"
  },
  {
    "model": "base.commune",
    "pk": 652,
    "fields": {
      "postcode": 18006,
      "wilaya": 18,
      "name": "Emir Abdelkader"
    },
    "id": 659,
    "commune_name_ascii": "Emir Abdelkader",
    "commune_name": "الامير عبد القادر",
    "daira_name_ascii": "Taher",
    "daira_name": "الطاهير",
    "wilaya_code": "18",
    "wilaya_name_ascii": "Jijel",
    "wilaya_name": "جيجل"
  },
  {
    "id": 665,
    "commune_name_ascii": "Oudjana",
    "commune_name": "وجانة",
    "daira_name_ascii": "Taher",
    "daira_name": "الطاهير",
    "wilaya_code": "18",
    "wilaya_name_ascii": "Jijel",
    "wilaya_name": "جيجل"
  },
  {
    "model": "base.commune",
    "pk": 651,
    "fields": {
      "postcode": 18005,
      "wilaya": 18,
      "name": "Taher"
    },
    "id": 672,
    "commune_name_ascii": "Taher",
    "commune_name": "الطاهير",
    "daira_name_ascii": "Taher",
    "daira_name": "الطاهير",
    "wilaya_code": "18",
    "wilaya_name_ascii": "Jijel",
    "wilaya_name": "جيجل"
  },
  {
    "model": "base.commune",
    "pk": 653,
    "fields": {
      "postcode": 18007,
      "wilaya": 18,
      "name": "Chekfa"
    },
    "id": 652,
    "commune_name_ascii": "Chekfa",
    "commune_name": "الشقفة",
    "daira_name_ascii": "Chekfa",
    "daira_name": "الشقفة",
    "wilaya_code": "18",
    "wilaya_name_ascii": "Jijel",
    "wilaya_name": "جيجل"
  },
  {
    "model": "base.commune",
    "pk": 666,
    "fields": {
      "postcode": 18020,
      "wilaya": 18,
      "name": "El Kennar Nouchfi"
    },
    "id": 657,
    "commune_name_ascii": "El Kennar Nouchfi",
    "commune_name": "القنار نشفي",
    "daira_name_ascii": "Chekfa",
    "daira_name": "الشقفة",
    "wilaya_code": "18",
    "wilaya_name_ascii": "Jijel",
    "wilaya_name": "جيجل"
  },
  {
    "model": "base.commune",
    "pk": 659,
    "fields": {
      "postcode": 18013,
      "wilaya": 18,
      "name": "Sidi Abdelaziz"
    },
    "id": 670,
    "commune_name_ascii": "Sidi Abdelaziz",
    "commune_name": "سيدي عبد العزيز",
    "daira_name_ascii": "Chekfa",
    "daira_name": "الشقفة",
    "wilaya_code": "18",
    "wilaya_name_ascii": "Jijel",
    "wilaya_name": "جيجل"
  },
  {
    "model": "base.commune",
    "pk": 655,
    "fields": {
      "postcode": 18009,
      "wilaya": 18,
      "name": "El Milia"
    },
    "id": 658,
    "commune_name_ascii": "El Milia",
    "commune_name": "الميلية",
    "daira_name_ascii": "El Milia",
    "daira_name": "الميلية",
    "wilaya_code": "18",
    "wilaya_name_ascii": "Jijel",
    "wilaya_name": "جيجل"
  },
  {
    "model": "base.commune",
    "pk": 667,
    "fields": {
      "postcode": 18021,
      "wilaya": 18,
      "name": "Ouled Yahia Khadrouch"
    },
    "id": 667,
    "commune_name_ascii": "Ouled Yahia Khadrouch",
    "commune_name": "أولاد يحيى خدروش",
    "daira_name_ascii": "El Milia",
    "daira_name": "الميلية",
    "wilaya_code": "18",
    "wilaya_name_ascii": "Jijel",
    "wilaya_name": "جيجل"
  },
  {
    "model": "base.commune",
    "pk": 673,
    "fields": {
      "postcode": 18027,
      "wilaya": 18,
      "name": "Ouled Rabah"
    },
    "id": 666,
    "commune_name_ascii": "Ouled Rabah",
    "commune_name": "أولاد رابح",
    "daira_name_ascii": "Sidi Marouf",
    "daira_name": "سيدي معروف",
    "wilaya_code": "18",
    "wilaya_name_ascii": "Jijel",
    "wilaya_name": "جيجل"
  },
  {
    "id": 671,
    "commune_name_ascii": "Sidi Marouf",
    "commune_name": "سيدي معروف",
    "daira_name_ascii": "Sidi Marouf",
    "daira_name": "سيدي معروف",
    "wilaya_code": "18",
    "wilaya_name_ascii": "Jijel",
    "wilaya_name": "جيجل"
  },
  {
    "model": "base.commune",
    "pk": 661,
    "fields": {
      "postcode": 18015,
      "wilaya": 18,
      "name": "Ghebala"
    },
    "id": 661,
    "commune_name_ascii": "Ghebala",
    "commune_name": "غبالة",
    "daira_name_ascii": "Settara",
    "daira_name": "السطارة",
    "wilaya_code": "18",
    "wilaya_name_ascii": "Jijel",
    "wilaya_name": "جيجل"
  },
  {
    "model": "base.commune",
    "pk": 657,
    "fields": {
      "postcode": 18011,
      "wilaya": 18,
      "name": "Settara"
    },
    "id": 669,
    "commune_name_ascii": "Settara",
    "commune_name": "السطارة",
    "daira_name_ascii": "Settara",
    "daira_name": "السطارة",
    "wilaya_code": "18",
    "wilaya_name_ascii": "Jijel",
    "wilaya_name": "جيجل"
  },
  {
    "model": "base.commune",
    "pk": 662,
    "fields": {
      "postcode": 18016,
      "wilaya": 18,
      "name": "Bouraoui Belhadef"
    },
    "id": 649,
    "commune_name_ascii": "Bouraoui Belhadef",
    "commune_name": "بوراوي بلهادف",
    "daira_name_ascii": "El Ancer",
    "daira_name": "العنصر",
    "wilaya_code": "18",
    "wilaya_name_ascii": "Jijel",
    "wilaya_name": "جيجل"
  },
  {
    "model": "base.commune",
    "pk": 658,
    "fields": {
      "postcode": 18012,
      "wilaya": 18,
      "name": "El Ancer"
    },
    "id": 655,
    "commune_name_ascii": "El Ancer",
    "commune_name": "العنصر",
    "daira_name_ascii": "El Ancer",
    "daira_name": "العنصر",
    "wilaya_code": "18",
    "wilaya_name_ascii": "Jijel",
    "wilaya_name": "جيجل"
  },
  {
    "id": 664,
    "commune_name_ascii": "Khiri Oued Adjoul",
    "commune_name": "خيري واد عجول",
    "daira_name_ascii": "El Ancer",
    "daira_name": "العنصر",
    "wilaya_code": "18",
    "wilaya_name_ascii": "Jijel",
    "wilaya_name": "جيجل"
  },
  {
    "id": 654,
    "commune_name_ascii": "Djimla",
    "commune_name": "جيملة",
    "daira_name_ascii": "Djimla",
    "daira_name": "جيملة",
    "wilaya_code": "18",
    "wilaya_name_ascii": "Jijel",
    "wilaya_name": "جيجل"
  },
  {
    "model": "base.commune",
    "pk": 660,
    "fields": {
      "postcode": 18014,
      "wilaya": 18,
      "name": "Kaous"
    },
    "id": 663,
    "commune_name_ascii": "Kaous",
    "commune_name": "قاوس",
    "daira_name_ascii": "Texenna",
    "daira_name": "تاكسنة",
    "wilaya_code": "18",
    "wilaya_name_ascii": "Jijel",
    "wilaya_name": "جيجل"
  },
  {
    "id": 673,
    "commune_name_ascii": "Texenna",
    "commune_name": "تاكسنة",
    "daira_name_ascii": "Texenna",
    "daira_name": "تاكسنة",
    "wilaya_code": "18",
    "wilaya_name_ascii": "Jijel",
    "wilaya_name": "جيجل"
  },
  {
    "id": 647,
    "commune_name_ascii": "Bordj T'har",
    "commune_name": "برج الطهر",
    "daira_name_ascii": "Chekfa",
    "daira_name": "الشقفة",
    "wilaya_code": "18",
    "wilaya_name_ascii": "Jijel",
    "wilaya_name": "جيجل"
  },
  {
    "id": 648,
    "commune_name_ascii": "Boudria Beniyadjis",
    "commune_name": "بودريعة بني  ياجيس",
    "daira_name_ascii": "Djimla",
    "daira_name": "جيملة",
    "wilaya_code": "18",
    "wilaya_name_ascii": "Jijel",
    "wilaya_name": "جيجل"
  },
  {
    "model": "base.commune",
    "pk": 671,
    "fields": {
      "postcode": 18025,
      "wilaya": 18,
      "name": "Djemaa Beni Habibi"
    },
    "id": 653,
    "commune_name_ascii": "Djemaa Beni Habibi",
    "commune_name": "الجمعة بني حبيبي",
    "daira_name_ascii": "El Ancer",
    "daira_name": "العنصر",
    "wilaya_code": "18",
    "wilaya_name_ascii": "Jijel",
    "wilaya_name": "جيجل"
  },
  {
    "model": "base.commune",
    "pk": 697,
    "fields": {
      "postcode": 19023,
      "wilaya": 19,
      "name": "Rosfa"
    },
    "id": 726,
    "commune_name_ascii": "Rosfa",
    "commune_name": "الرصفة",
    "daira_name_ascii": "Salah Bey",
    "daira_name": "صالح باي",
    "wilaya_code": "19",
    "wilaya_name_ascii": "Setif",
    "wilaya_name": "سطيف"
  },
  {
    "id": 721,
    "commune_name_ascii": "Oued El Bared",
    "commune_name": "واد البارد",
    "daira_name_ascii": "Amoucha",
    "daira_name": "عموشة",
    "wilaya_code": "19",
    "wilaya_name_ascii": "Setif",
    "wilaya_name": "سطيف"
  },
  {
    "id": 734,
    "commune_name_ascii": "Tizi N'bechar",
    "commune_name": "تيزي نبشار",
    "daira_name_ascii": "Amoucha",
    "daira_name": "عموشة",
    "wilaya_code": "19",
    "wilaya_name_ascii": "Setif",
    "wilaya_name": "سطيف"
  },
  {
    "model": "base.commune",
    "pk": 707,
    "fields": {
      "postcode": 19033,
      "wilaya": 19,
      "name": "Mezloug"
    },
    "id": 720,
    "commune_name_ascii": "Mezloug",
    "commune_name": "مزلوق",
    "daira_name_ascii": "Ain Arnat",
    "daira_name": "عين أرنات",
    "wilaya_code": "19",
    "wilaya_name_ascii": "Setif",
    "wilaya_name": "سطيف"
  },
  {
    "model": "base.commune",
    "pk": 722,
    "fields": {
      "postcode": 19048,
      "wilaya": 19,
      "name": "Guellal"
    },
    "id": 709,
    "commune_name_ascii": "Guellal",
    "commune_name": "قلال",
    "daira_name_ascii": "Ain Oulmene",
    "daira_name": "عين ولمان",
    "wilaya_code": "19",
    "wilaya_name_ascii": "Setif",
    "wilaya_name": "سطيف"
  },
  {
    "id": 717,
    "commune_name_ascii": "Kasr El Abtal",
    "commune_name": "قصر الابطال",
    "daira_name_ascii": "Ain Oulmene",
    "daira_name": "عين ولمان",
    "wilaya_code": "19",
    "wilaya_name_ascii": "Setif",
    "wilaya_name": "سطيف"
  },
  {
    "id": 724,
    "commune_name_ascii": "Ouled Si Ahmed",
    "commune_name": "أولاد سي أحمد",
    "daira_name_ascii": "Ain Oulmene",
    "daira_name": "عين ولمان",
    "wilaya_code": "19",
    "wilaya_name_ascii": "Setif",
    "wilaya_name": "سطيف"
  },
  {
    "model": "base.commune",
    "pk": 725,
    "fields": {
      "postcode": 19051,
      "wilaya": 19,
      "name": "Ait Naoual Mezada"
    },
    "id": 684,
    "commune_name_ascii": "Ait Naoual Mezada",
    "commune_name": "أيت نوال مزادة",
    "daira_name_ascii": "Bouandas",
    "daira_name": "بوعنداس",
    "wilaya_code": "19",
    "wilaya_name_ascii": "Setif",
    "wilaya_name": "سطيف"
  },
  {
    "id": 685,
    "commune_name_ascii": "Ait Tizi",
    "commune_name": "ايت تيزي",
    "daira_name_ascii": "Bouandas",
    "daira_name": "بوعنداس",
    "wilaya_code": "19",
    "wilaya_name_ascii": "Setif",
    "wilaya_name": "سطيف"
  },
  {
    "model": "base.commune",
    "pk": 704,
    "fields": {
      "postcode": 19030,
      "wilaya": 19,
      "name": "Bouandas"
    },
    "id": 699,
    "commune_name_ascii": "Bouandas",
    "commune_name": "بوعنداس",
    "daira_name_ascii": "Bouandas",
    "daira_name": "بوعنداس",
    "wilaya_code": "19",
    "wilaya_name_ascii": "Setif",
    "wilaya_name": "سطيف"
  },
  {
    "model": "base.commune",
    "pk": 693,
    "fields": {
      "postcode": 19019,
      "wilaya": 19,
      "name": "Bousselam"
    },
    "id": 701,
    "commune_name_ascii": "Bousselam",
    "commune_name": "بوسلام",
    "daira_name_ascii": "Bouandas",
    "daira_name": "بوعنداس",
    "wilaya_code": "19",
    "wilaya_name_ascii": "Setif",
    "wilaya_name": "سطيف"
  },
  {
    "id": 713,
    "commune_name_ascii": "Hamam Soukhna",
    "commune_name": "حمام السخنة",
    "daira_name_ascii": "Hammam Sokhna",
    "daira_name": "حمام السخنة",
    "wilaya_code": "19",
    "wilaya_name_ascii": "Setif",
    "wilaya_name": "سطيف"
  },
  {
    "model": "base.commune",
    "pk": 732,
    "fields": {
      "postcode": 19058,
      "wilaya": 19,
      "name": "Taya"
    },
    "id": 732,
    "commune_name_ascii": "Taya",
    "commune_name": "الطاية",
    "daira_name_ascii": "Hammam Sokhna",
    "daira_name": "حمام السخنة",
    "wilaya_code": "19",
    "wilaya_name_ascii": "Setif",
    "wilaya_name": "سطيف"
  },
  {
    "model": "base.commune",
    "pk": 734,
    "fields": {
      "postcode": 19060,
      "wilaya": 19,
      "name": "Tella"
    },
    "id": 733,
    "commune_name_ascii": "Tella",
    "commune_name": "التلة",
    "daira_name_ascii": "Hammam Sokhna",
    "daira_name": "حمام السخنة",
    "wilaya_code": "19",
    "wilaya_name_ascii": "Setif",
    "wilaya_name": "سطيف"
  },
  {
    "id": 680,
    "commune_name_ascii": "Ain Oulmene",
    "commune_name": "عين ولمان",
    "daira_name_ascii": "Ain Oulmene",
    "daira_name": "عين ولمان",
    "wilaya_code": "19",
    "wilaya_name_ascii": "Setif",
    "wilaya_name": "سطيف"
  },
  {
    "model": "base.commune",
    "pk": 679,
    "fields": {
      "postcode": 19005,
      "wilaya": 19,
      "name": "Boutaleb"
    },
    "id": 702,
    "commune_name_ascii": "Boutaleb",
    "commune_name": "بوطالب",
    "daira_name_ascii": "Salah Bey",
    "daira_name": "صالح باي",
    "wilaya_code": "19",
    "wilaya_name_ascii": "Setif",
    "wilaya_name": "سطيف"
  },
  {
    "model": "base.commune",
    "pk": 685,
    "fields": {
      "postcode": 19011,
      "wilaya": 19,
      "name": "Hamma"
    },
    "id": 714,
    "commune_name_ascii": "Hamma",
    "commune_name": "الحامة",
    "daira_name_ascii": "Salah Bey",
    "daira_name": "صالح باي",
    "wilaya_code": "19",
    "wilaya_name_ascii": "Setif",
    "wilaya_name": "سطيف"
  },
  {
    "model": "base.commune",
    "pk": 684,
    "fields": {
      "postcode": 19010,
      "wilaya": 19,
      "name": "Ouled Tebben"
    },
    "id": 725,
    "commune_name_ascii": "Ouled Tebben",
    "commune_name": "أولاد تبان",
    "daira_name_ascii": "Salah Bey",
    "daira_name": "صالح باي",
    "wilaya_code": "19",
    "wilaya_name_ascii": "Setif",
    "wilaya_name": "سطيف"
  },
  {
    "model": "base.commune",
    "pk": 701,
    "fields": {
      "postcode": 19027,
      "wilaya": 19,
      "name": "Amoucha"
    },
    "id": 686,
    "commune_name_ascii": "Amoucha",
    "commune_name": "عموشة",
    "daira_name_ascii": "Amoucha",
    "daira_name": "عموشة",
    "wilaya_code": "19",
    "wilaya_name_ascii": "Setif",
    "wilaya_name": "سطيف"
  },
  {
    "model": "base.commune",
    "pk": 713,
    "fields": {
      "postcode": 19039,
      "wilaya": 19,
      "name": "Salah Bey"
    },
    "id": 727,
    "commune_name_ascii": "Salah Bey",
    "commune_name": "صالح باي",
    "daira_name_ascii": "Salah Bey",
    "daira_name": "صالح باي",
    "wilaya_code": "19",
    "wilaya_name_ascii": "Setif",
    "wilaya_name": "سطيف"
  },
  {
    "id": 677,
    "commune_name_ascii": "Ain Azel",
    "commune_name": "عين أزال",
    "daira_name_ascii": "Ain Azel",
    "daira_name": "عين أزال",
    "wilaya_code": "19",
    "wilaya_name_ascii": "Setif",
    "wilaya_name": "سطيف"
  },
  {
    "model": "base.commune",
    "pk": 692,
    "fields": {
      "postcode": 19018,
      "wilaya": 19,
      "name": "Ain Lahdjar"
    },
    "id": 679,
    "commune_name_ascii": "Ain Lahdjar",
    "commune_name": "عين الحجر",
    "daira_name_ascii": "Ain Azel",
    "daira_name": "عين أزال",
    "wilaya_code": "19",
    "wilaya_name_ascii": "Setif",
    "wilaya_name": "سطيف"
  },
  {
    "model": "base.commune",
    "pk": 703,
    "fields": {
      "postcode": 19029,
      "wilaya": 19,
      "name": "Beidha Bordj"
    },
    "id": 689,
    "commune_name_ascii": "Beidha Bordj",
    "commune_name": "بيضاء برج",
    "daira_name_ascii": "Ain Azel",
    "daira_name": "عين أزال",
    "wilaya_code": "19",
    "wilaya_name_ascii": "Setif",
    "wilaya_name": "سطيف"
  },
  {
    "model": "base.commune",
    "pk": 708,
    "fields": {
      "postcode": 19034,
      "wilaya": 19,
      "name": "Bir Haddada"
    },
    "id": 697,
    "commune_name_ascii": "Bir Haddada",
    "commune_name": "بئر حدادة",
    "daira_name_ascii": "Ain Azel",
    "daira_name": "عين أزال",
    "wilaya_code": "19",
    "wilaya_name_ascii": "Setif",
    "wilaya_name": "سطيف"
  },
  {
    "model": "base.commune",
    "pk": 715,
    "fields": {
      "postcode": 19041,
      "wilaya": 19,
      "name": "Guenzet"
    },
    "id": 711,
    "commune_name_ascii": "Guenzet",
    "commune_name": "قنزات",
    "daira_name_ascii": "Guenzet",
    "daira_name": "قنزات",
    "wilaya_code": "19",
    "wilaya_name_ascii": "Setif",
    "wilaya_name": "سطيف"
  },
  {
    "model": "base.commune",
    "pk": 710,
    "fields": {
      "postcode": 19036,
      "wilaya": 19,
      "name": "Harbil"
    },
    "id": 716,
    "commune_name_ascii": "Harbil",
    "commune_name": "حربيل",
    "daira_name_ascii": "Guenzet",
    "daira_name": "قنزات",
    "wilaya_code": "19",
    "wilaya_name_ascii": "Setif",
    "wilaya_name": "سطيف"
  },
  {
    "id": 682,
    "commune_name_ascii": "Ain Roua",
    "commune_name": "عين الروى",
    "daira_name_ascii": "Bougaa",
    "daira_name": "بوقاعة",
    "wilaya_code": "19",
    "wilaya_name_ascii": "Setif",
    "wilaya_name": "سطيف"
  },
  {
    "id": 694,
    "commune_name_ascii": "Beni Oussine",
    "commune_name": "بني وسين",
    "daira_name_ascii": "Bougaa",
    "daira_name": "بوقاعة",
    "wilaya_code": "19",
    "wilaya_name_ascii": "Setif",
    "wilaya_name": "سطيف"
  },
  {
    "model": "base.commune",
    "pk": 711,
    "fields": {
      "postcode": 19037,
      "wilaya": 19,
      "name": "El Ouricia"
    },
    "id": 707,
    "commune_name_ascii": "El Ouricia",
    "commune_name": "أوريسيا",
    "daira_name_ascii": "Ain Arnat",
    "daira_name": "عين أرنات",
    "wilaya_code": "19",
    "wilaya_name_ascii": "Setif",
    "wilaya_name": "سطيف"
  },
  {
    "model": "base.commune",
    "pk": 717,
    "fields": {
      "postcode": 19043,
      "wilaya": 19,
      "name": "Bougaa"
    },
    "id": 700,
    "commune_name_ascii": "Bougaa",
    "commune_name": "بوقاعة",
    "daira_name_ascii": "Bougaa",
    "daira_name": "بوقاعة",
    "wilaya_code": "19",
    "wilaya_name_ascii": "Setif",
    "wilaya_name": "سطيف"
  },
  {
    "id": 705,
    "commune_name_ascii": "Draa Kebila",
    "commune_name": "ذراع قبيلة",
    "daira_name_ascii": "Hammam Guergour",
    "daira_name": "حمام قرقور",
    "wilaya_code": "19",
    "wilaya_name_ascii": "Setif",
    "wilaya_name": "سطيف"
  },
  {
    "model": "base.commune",
    "pk": 724,
    "fields": {
      "postcode": 19050,
      "wilaya": 19,
      "name": "Hammam Guergour"
    },
    "id": 715,
    "commune_name_ascii": "Hammam Guergour",
    "commune_name": "حمام قرقور",
    "daira_name_ascii": "Hammam Guergour",
    "daira_name": "حمام قرقور",
    "wilaya_code": "19",
    "wilaya_name_ascii": "Setif",
    "wilaya_name": "سطيف"
  },
  {
    "model": "base.commune",
    "pk": 675,
    "fields": {
      "postcode": 19001,
      "wilaya": 19,
      "name": "Setif"
    },
    "id": 729,
    "commune_name_ascii": "Setif",
    "commune_name": "سطيف",
    "daira_name_ascii": "Setif",
    "daira_name": "سطيف",
    "wilaya_code": "19",
    "wilaya_name_ascii": "Setif",
    "wilaya_name": "سطيف"
  },
  {
    "model": "base.commune",
    "pk": 676,
    "fields": {
      "postcode": 19002,
      "wilaya": 19,
      "name": "Ain El Kebira"
    },
    "id": 678,
    "commune_name_ascii": "Ain El Kebira",
    "commune_name": "عين الكبيرة",
    "daira_name_ascii": "Ain El Kebira",
    "daira_name": "عين الكبيرة",
    "wilaya_code": "19",
    "wilaya_name_ascii": "Setif",
    "wilaya_name": "سطيف"
  },
  {
    "model": "base.commune",
    "pk": 689,
    "fields": {
      "postcode": 19015,
      "wilaya": 19,
      "name": "Dehamcha"
    },
    "id": 703,
    "commune_name_ascii": "Dehamcha",
    "commune_name": "الدهامشة",
    "daira_name_ascii": "Ain El Kebira",
    "daira_name": "عين الكبيرة",
    "wilaya_code": "19",
    "wilaya_name_ascii": "Setif",
    "wilaya_name": "سطيف"
  },
  {
    "model": "base.commune",
    "pk": 698,
    "fields": {
      "postcode": 19024,
      "wilaya": 19,
      "name": "Ouled Addouane"
    },
    "id": 722,
    "commune_name_ascii": "Ouled Addouane",
    "commune_name": "أولاد عدوان",
    "daira_name_ascii": "Ain El Kebira",
    "daira_name": "عين الكبيرة",
    "wilaya_code": "19",
    "wilaya_name_ascii": "Setif",
    "wilaya_name": "سطيف"
  },
  {
    "id": 683,
    "commune_name_ascii": "Ain Sebt",
    "commune_name": "عين السبت",
    "daira_name_ascii": "Beni Aziz",
    "daira_name": "بني عزيز",
    "wilaya_code": "19",
    "wilaya_name_ascii": "Setif",
    "wilaya_name": "سطيف"
  },
  {
    "id": 695,
    "commune_name_ascii": "Beni Aziz",
    "commune_name": "بني عزيز",
    "daira_name_ascii": "Beni Aziz",
    "daira_name": "بني عزيز",
    "wilaya_code": "19",
    "wilaya_name_ascii": "Setif",
    "wilaya_name": "سطيف"
  },
  {
    "model": "base.commune",
    "pk": 686,
    "fields": {
      "postcode": 19012,
      "wilaya": 19,
      "name": "Maaouia"
    },
    "id": 718,
    "commune_name_ascii": "Maaouia",
    "commune_name": "معاوية",
    "daira_name_ascii": "Beni Aziz",
    "daira_name": "بني عزيز",
    "wilaya_code": "19",
    "wilaya_name_ascii": "Setif",
    "wilaya_name": "سطيف"
  },
  {
    "id": 690,
    "commune_name_ascii": "Bellaa",
    "commune_name": "بلاعة",
    "daira_name_ascii": "Bir El Arch",
    "daira_name": "بئر العرش",
    "wilaya_code": "19",
    "wilaya_name_ascii": "Setif",
    "wilaya_name": "سطيف"
  },
  {
    "id": 698,
    "commune_name_ascii": "Bir El Arch",
    "commune_name": "بئر العرش",
    "daira_name_ascii": "Bir El Arch",
    "daira_name": "بئر العرش",
    "wilaya_code": "19",
    "wilaya_name_ascii": "Setif",
    "wilaya_name": "سطيف"
  },
  {
    "id": 708,
    "commune_name_ascii": "El Ouldja",
    "commune_name": "الولجة",
    "daira_name_ascii": "Bir El Arch",
    "daira_name": "بئر العرش",
    "wilaya_code": "19",
    "wilaya_name_ascii": "Setif",
    "wilaya_name": "سطيف"
  },
  {
    "model": "base.commune",
    "pk": 719,
    "fields": {
      "postcode": 19045,
      "wilaya": 19,
      "name": "Tachouda"
    },
    "id": 730,
    "commune_name_ascii": "Tachouda",
    "commune_name": "تاشودة",
    "daira_name_ascii": "Bir El Arch",
    "daira_name": "بئر العرش",
    "wilaya_code": "19",
    "wilaya_name_ascii": "Setif",
    "wilaya_name": "سطيف"
  },
  {
    "id": 731,
    "commune_name_ascii": "Tala Ifacene",
    "commune_name": "تالة إيفاسن",
    "daira_name_ascii": "Maoklane",
    "daira_name": "ماوكلان",
    "wilaya_code": "19",
    "wilaya_name_ascii": "Setif",
    "wilaya_name": "سطيف"
  },
  {
    "id": 728,
    "commune_name_ascii": "Serdj El Ghoul",
    "commune_name": "سرج الغول",
    "daira_name_ascii": "Babor",
    "daira_name": "بابور",
    "wilaya_code": "19",
    "wilaya_name_ascii": "Setif",
    "wilaya_name": "سطيف"
  },
  {
    "model": "base.commune",
    "pk": 691,
    "fields": {
      "postcode": 19017,
      "wilaya": 19,
      "name": "Guidjel"
    },
    "id": 712,
    "commune_name_ascii": "Guidjel",
    "commune_name": "قجال",
    "daira_name_ascii": "Guidjel",
    "daira_name": "قجال",
    "wilaya_code": "19",
    "wilaya_name_ascii": "Setif",
    "wilaya_name": "سطيف"
  },
  {
    "model": "base.commune",
    "pk": 721,
    "fields": {
      "postcode": 19047,
      "wilaya": 19,
      "name": "Ouled Sabor"
    },
    "id": 723,
    "commune_name_ascii": "Ouled Sabor",
    "commune_name": "أولاد صابر",
    "daira_name_ascii": "Guidjel",
    "daira_name": "قجال",
    "wilaya_code": "19",
    "wilaya_name_ascii": "Setif",
    "wilaya_name": "سطيف"
  },
  {
    "id": 688,
    "commune_name_ascii": "Bazer Sakra",
    "commune_name": "بازر سكرة",
    "daira_name_ascii": "El Eulma",
    "daira_name": "العلمة",
    "wilaya_code": "19",
    "wilaya_name_ascii": "Setif",
    "wilaya_name": "سطيف"
  },
  {
    "model": "base.commune",
    "pk": 694,
    "fields": {
      "postcode": 19020,
      "wilaya": 19,
      "name": "El Eulma"
    },
    "id": 706,
    "commune_name_ascii": "El Eulma",
    "commune_name": "العلمة",
    "daira_name_ascii": "El Eulma",
    "daira_name": "العلمة",
    "wilaya_code": "19",
    "wilaya_name_ascii": "Setif",
    "wilaya_name": "سطيف"
  },
  {
    "model": "base.commune",
    "pk": 730,
    "fields": {
      "postcode": 19056,
      "wilaya": 19,
      "name": "Guelta Zerka"
    },
    "id": 710,
    "commune_name_ascii": "Guelta Zerka",
    "commune_name": "قلتة زرقاء",
    "daira_name_ascii": "El Eulma",
    "daira_name": "العلمة",
    "wilaya_code": "19",
    "wilaya_name_ascii": "Setif",
    "wilaya_name": "سطيف"
  },
  {
    "model": "base.commune",
    "pk": 718,
    "fields": {
      "postcode": 19044,
      "wilaya": 19,
      "name": "Beni Fouda"
    },
    "id": 692,
    "commune_name_ascii": "Beni Fouda",
    "commune_name": "بني فودة",
    "daira_name_ascii": "Djemila",
    "daira_name": "جميلة",
    "wilaya_code": "19",
    "wilaya_name_ascii": "Setif",
    "wilaya_name": "سطيف"
  },
  {
    "model": "base.commune",
    "pk": 695,
    "fields": {
      "postcode": 19021,
      "wilaya": 19,
      "name": "Djemila"
    },
    "id": 704,
    "commune_name_ascii": "Djemila",
    "commune_name": "جميلة",
    "daira_name_ascii": "Djemila",
    "daira_name": "جميلة",
    "wilaya_code": "19",
    "wilaya_name_ascii": "Setif",
    "wilaya_name": "سطيف"
  },
  {
    "id": 681,
    "commune_name_ascii": "Ain Legradj",
    "commune_name": "عين لقراج",
    "daira_name_ascii": "Beni Ourtilane",
    "daira_name": "بني ورتيلان",
    "wilaya_code": "19",
    "wilaya_name_ascii": "Setif",
    "wilaya_name": "سطيف"
  },
  {
    "model": "base.commune",
    "pk": 683,
    "fields": {
      "postcode": 19009,
      "wilaya": 19,
      "name": "Beni Chebana"
    },
    "id": 691,
    "commune_name_ascii": "Beni Chebana",
    "commune_name": "بني شبانة",
    "daira_name_ascii": "Beni Ourtilane",
    "daira_name": "بني ورتيلان",
    "wilaya_code": "19",
    "wilaya_name_ascii": "Setif",
    "wilaya_name": "سطيف"
  },
  {
    "id": 693,
    "commune_name_ascii": "Beni Ourtilane",
    "commune_name": "بني ورتيلان",
    "daira_name_ascii": "Beni Ourtilane",
    "daira_name": "بني ورتيلان",
    "wilaya_code": "19",
    "wilaya_name_ascii": "Setif",
    "wilaya_name": "سطيف"
  },
  {
    "id": 696,
    "commune_name_ascii": "Beni Mouhli",
    "commune_name": "بني موحلي",
    "daira_name_ascii": "Beni Ourtilane",
    "daira_name": "بني ورتيلان",
    "wilaya_code": "19",
    "wilaya_name_ascii": "Setif",
    "wilaya_name": "سطيف"
  },
  {
    "model": "base.commune",
    "pk": 688,
    "fields": {
      "postcode": 19014,
      "wilaya": 19,
      "name": "Ain Abessa"
    },
    "id": 675,
    "commune_name_ascii": "Ain Abessa",
    "commune_name": "عين عباسة",
    "daira_name_ascii": "Ain Arnat",
    "daira_name": "عين أرنات",
    "wilaya_code": "19",
    "wilaya_name_ascii": "Setif",
    "wilaya_name": "سطيف"
  },
  {
    "model": "base.commune",
    "pk": 700,
    "fields": {
      "postcode": 19026,
      "wilaya": 19,
      "name": "Ain Arnat"
    },
    "id": 676,
    "commune_name_ascii": "Ain Arnat",
    "commune_name": "عين أرنات",
    "daira_name_ascii": "Ain Arnat",
    "daira_name": "عين أرنات",
    "wilaya_code": "19",
    "wilaya_name_ascii": "Setif",
    "wilaya_name": "سطيف"
  },
  {
    "model": "base.commune",
    "pk": 690,
    "fields": {
      "postcode": 19016,
      "wilaya": 19,
      "name": "Babor"
    },
    "id": 687,
    "commune_name_ascii": "Babor",
    "commune_name": "بابور",
    "daira_name_ascii": "Babor",
    "daira_name": "بابور",
    "wilaya_code": "19",
    "wilaya_name_ascii": "Setif",
    "wilaya_name": "سطيف"
  },
  {
    "id": 719,
    "commune_name_ascii": "Maouaklane",
    "commune_name": "ماوكلان",
    "daira_name_ascii": "Maoklane",
    "daira_name": "ماوكلان",
    "wilaya_code": "19",
    "wilaya_name_ascii": "Setif",
    "wilaya_name": "سطيف"
  },
  {
    "model": "base.commune",
    "pk": 735,
    "fields": {
      "postcode": 20001,
      "wilaya": 20,
      "name": "Saida"
    },
    "id": 745,
    "commune_name_ascii": "Saida",
    "commune_name": "سعيدة",
    "daira_name_ascii": "Saida",
    "daira_name": "سعيدة",
    "wilaya_code": "20",
    "wilaya_name_ascii": "Saida",
    "wilaya_name": "سعيدة"
  },
  {
    "model": "base.commune",
    "pk": 749,
    "fields": {
      "postcode": 20015,
      "wilaya": 20,
      "name": "Tircine"
    },
    "id": 749,
    "commune_name_ascii": "Tircine",
    "commune_name": "تيرسين",
    "daira_name_ascii": "Ouled Brahim",
    "daira_name": "أولاد ابراهيم",
    "wilaya_code": "20",
    "wilaya_name_ascii": "Saida",
    "wilaya_name": "سعيدة"
  },
  {
    "model": "base.commune",
    "pk": 748,
    "fields": {
      "postcode": 20014,
      "wilaya": 20,
      "name": "Ouled Brahim"
    },
    "id": 743,
    "commune_name_ascii": "Ouled Brahim",
    "commune_name": "أولاد إبراهيم",
    "daira_name_ascii": "Ouled Brahim",
    "daira_name": "أولاد ابراهيم",
    "wilaya_code": "20",
    "wilaya_name_ascii": "Saida",
    "wilaya_name": "سعيدة"
  },
  {
    "model": "base.commune",
    "pk": 750,
    "fields": {
      "postcode": 20016,
      "wilaya": 20,
      "name": "Ain Soltane"
    },
    "id": 737,
    "commune_name_ascii": "Ain Soltane",
    "commune_name": "عين السلطان",
    "daira_name_ascii": "Ouled Brahim",
    "daira_name": "أولاد ابراهيم",
    "wilaya_code": "20",
    "wilaya_name_ascii": "Saida",
    "wilaya_name": "سعيدة"
  },
  {
    "model": "base.commune",
    "pk": 347,
    "fields": {
      "postcode": 10039,
      "wilaya": 10,
      "name": "Maamora"
    },
    "id": 741,
    "commune_name_ascii": "Maamora",
    "commune_name": "المعمورة",
    "daira_name_ascii": "El Hassasna",
    "daira_name": "الحساسنة",
    "wilaya_code": "20",
    "wilaya_name_ascii": "Saida",
    "wilaya_name": "سعيدة"
  },
  {
    "model": "base.commune",
    "pk": 744,
    "fields": {
      "postcode": 20010,
      "wilaya": 20,
      "name": "El Hassasna"
    },
    "id": 739,
    "commune_name_ascii": "El Hassasna",
    "commune_name": "الحساسنة",
    "daira_name_ascii": "El Hassasna",
    "daira_name": "الحساسنة",
    "wilaya_code": "20",
    "wilaya_name_ascii": "Saida",
    "wilaya_name": "سعيدة"
  },
  {
    "model": "base.commune",
    "pk": 747,
    "fields": {
      "postcode": 20013,
      "wilaya": 20,
      "name": "Ain Sekhouna"
    },
    "id": 736,
    "commune_name_ascii": "Ain Sekhouna",
    "commune_name": "عين السخونة",
    "daira_name_ascii": "El Hassasna",
    "daira_name": "الحساسنة",
    "wilaya_code": "20",
    "wilaya_name_ascii": "Saida",
    "wilaya_name": "سعيدة"
  },
  {
    "model": "base.commune",
    "pk": 743,
    "fields": {
      "postcode": 20009,
      "wilaya": 20,
      "name": "Sidi Boubekeur"
    },
    "id": 748,
    "commune_name_ascii": "Sidi Boubekeur",
    "commune_name": "سيدي بوبكر",
    "daira_name_ascii": "Sidi Boubekeur",
    "daira_name": "سيدي بوبكر",
    "wilaya_code": "20",
    "wilaya_name_ascii": "Saida",
    "wilaya_name": "سعيدة"
  },
  {
    "model": "base.commune",
    "pk": 738,
    "fields": {
      "postcode": 20004,
      "wilaya": 20,
      "name": "Ouled Khaled"
    },
    "id": 744,
    "commune_name_ascii": "Ouled Khaled",
    "commune_name": "أولاد خالد",
    "daira_name_ascii": "Sidi Boubekeur",
    "daira_name": "سيدي بوبكر",
    "wilaya_code": "20",
    "wilaya_name_ascii": "Saida",
    "wilaya_name": "سعيدة"
  },
  {
    "model": "base.commune",
    "pk": 741,
    "fields": {
      "postcode": 20007,
      "wilaya": 20,
      "name": "Hounet"
    },
    "id": 740,
    "commune_name_ascii": "Hounet",
    "commune_name": "هونت",
    "daira_name_ascii": "Sidi Boubekeur",
    "daira_name": "سيدي بوبكر",
    "wilaya_code": "20",
    "wilaya_name_ascii": "Saida",
    "wilaya_name": "سعيدة"
  },
  {
    "model": "base.commune",
    "pk": 740,
    "fields": {
      "postcode": 20006,
      "wilaya": 20,
      "name": "Youb"
    },
    "id": 750,
    "commune_name_ascii": "Youb",
    "commune_name": "يوب",
    "daira_name_ascii": "Youb",
    "daira_name": "يوب",
    "wilaya_code": "20",
    "wilaya_name_ascii": "Saida",
    "wilaya_name": "سعيدة"
  },
  {
    "model": "base.commune",
    "pk": 736,
    "fields": {
      "postcode": 20002,
      "wilaya": 20,
      "name": "Doui Thabet"
    },
    "id": 738,
    "commune_name_ascii": "Doui Thabet",
    "commune_name": "دوي ثابت",
    "daira_name_ascii": "Youb",
    "daira_name": "يوب",
    "wilaya_code": "20",
    "wilaya_name_ascii": "Saida",
    "wilaya_name": "سعيدة"
  },
  {
    "model": "base.commune",
    "pk": 746,
    "fields": {
      "postcode": 20012,
      "wilaya": 20,
      "name": "Sidi Ahmed"
    },
    "id": 746,
    "commune_name_ascii": "Sidi Ahmed",
    "commune_name": "سيدي احمد",
    "daira_name_ascii": "Ain El Hadjar",
    "daira_name": "عين الحجر",
    "wilaya_code": "20",
    "wilaya_name_ascii": "Saida",
    "wilaya_name": "سعيدة"
  },
  {
    "model": "base.commune",
    "pk": 739,
    "fields": {
      "postcode": 20005,
      "wilaya": 20,
      "name": "Moulay Larbi"
    },
    "id": 742,
    "commune_name_ascii": "Moulay Larbi",
    "commune_name": "مولاي العربي",
    "daira_name_ascii": "Ain El Hadjar",
    "daira_name": "عين الحجر",
    "wilaya_code": "20",
    "wilaya_name_ascii": "Saida",
    "wilaya_name": "سعيدة"
  },
  {
    "model": "base.commune",
    "pk": 333,
    "fields": {
      "postcode": 10025,
      "wilaya": 10,
      "name": "Ain El Hadjar"
    },
    "id": 735,
    "commune_name_ascii": "Ain El Hadjar",
    "commune_name": "عين الحجر",
    "daira_name_ascii": "Ain El Hadjar",
    "daira_name": "عين الحجر",
    "wilaya_code": "20",
    "wilaya_name_ascii": "Saida",
    "wilaya_name": "سعيدة"
  },
  {
    "model": "base.commune",
    "pk": 742,
    "fields": {
      "postcode": 20008,
      "wilaya": 20,
      "name": "Sidi Amar"
    },
    "id": 747,
    "commune_name_ascii": "Sidi Amar",
    "commune_name": "سيدي عمر",
    "daira_name_ascii": "Sidi Boubekeur",
    "daira_name": "سيدي بوبكر",
    "wilaya_code": "20",
    "wilaya_name_ascii": "Saida",
    "wilaya_name": "سعيدة"
  },
  {
    "model": "base.commune",
    "pk": 772,
    "fields": {
      "postcode": 21022,
      "wilaya": 21,
      "name": "Ain Bouziane"
    },
    "id": 751,
    "commune_name_ascii": "Ain Bouziane",
    "commune_name": "عين بوزيان",
    "daira_name_ascii": "Sidi Mezghiche",
    "daira_name": "سيدي مزغيش",
    "wilaya_code": "21",
    "wilaya_name_ascii": "Skikda",
    "wilaya_name": "سكيكدة"
  },
  {
    "model": "base.commune",
    "pk": 775,
    "fields": {
      "postcode": 21025,
      "wilaya": 21,
      "name": "Salah Bouchaour"
    },
    "id": 783,
    "commune_name_ascii": "Salah Bouchaour",
    "commune_name": "صالح بو الشعور",
    "daira_name_ascii": "El Harrouch",
    "daira_name": "الحروش",
    "wilaya_code": "21",
    "wilaya_name_ascii": "Skikda",
    "wilaya_name": "سكيكدة"
  },
  { 
    "pk": 753  ,"fields": { "postcode": 21003,  "wilaya":   21, "name": "El Hadaik" },
    "id": 768,
    "commune_name_ascii": "El Hadaiek",
    "commune_name": "الحدائق",
    "daira_name_ascii": "El Hadaiek",
    "daira_name": "الحدائق",
    "wilaya_code": "21",
    "wilaya_name_ascii": "Skikda",
    "wilaya_name": "سكيكدة"
  },
  {
    "pk": 767  ,"fields": { "postcode": 21017,  "wilaya":   21, "name": "Zerdazas" },
    "id": 787,
    "commune_name_ascii": "Zerdezas",
    "commune_name": "زردازة",
    "daira_name_ascii": "El Harrouch",
    "daira_name": "الحروش",
    "wilaya_code": "21",
    "wilaya_name_ascii": "Skikda",
    "wilaya_name": "سكيكدة"
  },
  {
    "pk": 768  ,"fields": { "postcode": 21018,  "wilaya":   21, "name": "Ouled Hebaba" },
    "id": 780,
    "commune_name_ascii": "Ouled Habbaba",
    "commune_name": "أولاد حبابة",
    "daira_name_ascii": "El Harrouch",
    "daira_name": "الحروش",
    "wilaya_code": "21",
    "wilaya_name_ascii": "Skikda",
    "wilaya_name": "سكيكدة"
  },
  {
    "model": "base.commune",
    "pk": 771,
    "fields": {
      "postcode": 21021,
      "wilaya": 21,
      "name": "Beni Oulbane"
    },
    "id": 759,
    "commune_name_ascii": "Beni Oulbane",
    "commune_name": "بني ولبان",
    "daira_name_ascii": "Sidi Mezghiche",
    "daira_name": "سيدي مزغيش",
    "wilaya_code": "21",
    "wilaya_name_ascii": "Skikda",
    "wilaya_name": "سكيكدة"
  },
  {
    "model": "base.commune",
    "pk": 769,
    "fields": {
      "postcode": 21019,
      "wilaya": 21,
      "name": "Sidi Mezghiche"
    },
    "id": 784,
    "commune_name_ascii": "Sidi Mezghiche",
    "commune_name": "سيدي مزغيش",
    "daira_name_ascii": "Sidi Mezghiche",
    "daira_name": "سيدي مزغيش",
    "wilaya_code": "21",
    "wilaya_name_ascii": "Skikda",
    "wilaya_name": "سكيكدة"
  },
  {
    "pk": 774  ,"fields": { "postcode": 21024,  "wilaya":   21, "name": "Beni Bachir" },
    "id": 758,
    "commune_name_ascii": "Beni Bechir",
    "commune_name": "بني بشير",
    "daira_name_ascii": "Ramdane Djamel",
    "daira_name": "رمضان جمال",
    "wilaya_code": "21",
    "wilaya_name_ascii": "Skikda",
    "wilaya_name": "سكيكدة"
  },
  {
    "model": "base.commune",
    "pk": 773,
    "fields": {
      "postcode": 21023,
      "wilaya": 21,
      "name": "Ramdane Djamel"
    },
    "id": 782,
    "commune_name_ascii": "Ramdane Djamel",
    "commune_name": "رمضان جمال",
    "daira_name_ascii": "Ramdane Djamel",
    "daira_name": "رمضان جمال",
    "wilaya_code": "21",
    "wilaya_name_ascii": "Skikda",
    "wilaya_name": "سكيكدة"
  },
  {
    "pk": 779  ,"fields": { "postcode": 21029,  "wilaya":   21, "name": "Bein El Ouiden" },
    "id": 761,
    "commune_name_ascii": "Bin El Ouiden",
    "commune_name": "بين الويدان",
    "daira_name_ascii": "Tamalous",
    "daira_name": "تمالوس",
    "wilaya_code": "21",
    "wilaya_name_ascii": "Skikda",
    "wilaya_name": "سكيكدة"
  },
  {
    "pk": 770  ,"fields": { "postcode": 21020,  "wilaya":   21, "name": "Emdjez Edchich" },
    "id": 770,
    "commune_name_ascii": "Emjez Edchich",
    "commune_name": "مجاز الدشيش",
    "daira_name_ascii": "El Harrouch",
    "daira_name": "الحروش",
    "wilaya_code": "21",
    "wilaya_name_ascii": "Skikda",
    "wilaya_name": "سكيكدة"
  },
  {
    "model": "base.commune",
    "pk": 776,
    "fields": {
      "postcode": 21026,
      "wilaya": 21,
      "name": "Tamalous"
    },
    "id": 786,
    "commune_name_ascii": "Tamalous",
    "commune_name": "تمالوس",
    "daira_name_ascii": "Tamalous",
    "daira_name": "تمالوس",
    "wilaya_code": "21",
    "wilaya_name_ascii": "Skikda",
    "wilaya_name": "سكيكدة"
  },
  {
    "model": "base.commune",
    "pk": 777,
    "fields": {
      "postcode": 21027,
      "wilaya": 21,
      "name": "Ain Kechra"
    },
    "id": 753,
    "commune_name_ascii": "Ain Kechra",
    "commune_name": "عين قشرة",
    "daira_name_ascii": "Ain Kechra",
    "daira_name": "عين قشرة",
    "wilaya_code": "21",
    "wilaya_name_ascii": "Skikda",
    "wilaya_name": "سكيكدة"
  },
  {
    "model": "base.commune",
    "pk": 785,
    "fields": {
      "postcode": 21035,
      "wilaya": 21,
      "name": "Ouldja Boulbalout"
    },
    "id": 778,
    "commune_name_ascii": "Ouldja Boulbalout",
    "commune_name": "الولجة بولبلوط",
    "daira_name_ascii": "Ain Kechra",
    "daira_name": "عين قشرة",
    "wilaya_code": "21",
    "wilaya_name_ascii": "Skikda",
    "wilaya_name": "سكيكدة"
  },
  {
    "model": "base.commune",
    "pk": 778,
    "fields": {
      "postcode": 21028,
      "wilaya": 21,
      "name": "Oum Toub"
    },
    "id": 781,
    "commune_name_ascii": "Oum Toub",
    "commune_name": "أم الطوب",
    "daira_name_ascii": "Oum Toub",
    "daira_name": "أم الطوب",
    "wilaya_code": "21",
    "wilaya_name_ascii": "Skikda",
    "wilaya_name": "سكيكدة"
  },
  {
    "model": "base.commune",
    "pk": 783,
    "fields": {
      "postcode": 21033,
      "wilaya": 21,
      "name": "El Ghedir"
    },
    "id": 767,
    "commune_name_ascii": "El Ghedir",
    "commune_name": "الغدير",
    "daira_name_ascii": "Azzaba",
    "daira_name": "عزابة",
    "wilaya_code": "21",
    "wilaya_name_ascii": "Skikda",
    "wilaya_name": "سكيكدة"
  },
  {
    "pk": 762  ,"fields": { "postcode": 21012,  "wilaya":   21, "name": "Kerkera" },
    "id": 775,
    "commune_name_ascii": "Kerkara",
    "commune_name": "الكركرة",
    "daira_name_ascii": "Tamalous",
    "daira_name": "تمالوس",
    "wilaya_code": "21",
    "wilaya_name_ascii": "Skikda",
    "wilaya_name": "سكيكدة"
  },
  {
    "pk": 766  ,"fields": { "postcode": 21016,  "wilaya":   21, "name": "El Harrouch" },
    "id": 766,
    "commune_name_ascii": "El Arrouch",
    "commune_name": "الحروش",
    "daira_name_ascii": "El Harrouch",
    "daira_name": "الحروش",
    "wilaya_code": "21",
    "wilaya_name_ascii": "Skikda",
    "wilaya_name": "سكيكدة"
  },
  {
    "model": "base.commune",
    "pk": 765,
    "fields": {
      "postcode": 21015,
      "wilaya": 21,
      "name": "Zitouna"
    },
    "id": 788,
    "commune_name_ascii": "Zitouna",
    "commune_name": "الزيتونة",
    "daira_name_ascii": "Zitouna",
    "daira_name": "الزيتونة",
    "wilaya_code": "21",
    "wilaya_name_ascii": "Skikda",
    "wilaya_name": "سكيكدة"
  },
  {
    "model": "base.commune",
    "pk": 763,
    "fields": {
      "postcode": 21013,
      "wilaya": 21,
      "name": "Ouled Attia"
    },
    "id": 779,
    "commune_name_ascii": "Ouled Attia",
    "commune_name": "أولاد عطية",
    "daira_name_ascii": "Ouled Attia",
    "daira_name": "أولاد عطية",
    "wilaya_code": "21",
    "wilaya_name_ascii": "Skikda",
    "wilaya_name": "سكيكدة"
  },
  {
    "pk": 764  ,"fields": { "postcode": 21014,  "wilaya":   21, "name": "Oued Zehour" },
    "id": 777,
    "commune_name_ascii": "Oued Zhour",
    "commune_name": "وادي الزهور",
    "daira_name_ascii": "Ouled Attia",
    "daira_name": "أولاد عطية",
    "wilaya_code": "21",
    "wilaya_name_ascii": "Skikda",
    "wilaya_name": "سكيكدة"
  },
  {
    "model": "base.commune",
    "pk": 760,
    "fields": {
      "postcode": 21010,
      "wilaya": 21,
      "name": "Collo"
    },
    "id": 764,
    "commune_name_ascii": "Collo",
    "commune_name": "القل",
    "daira_name_ascii": "Collo",
    "daira_name": "القل",
    "wilaya_code": "21",
    "wilaya_name_ascii": "Skikda",
    "wilaya_name": "سكيكدة"
  },
  {
    "model": "base.commune",
    "pk": 781,
    "fields": {
      "postcode": 21031,
      "wilaya": 21,
      "name": "Cheraia"
    },
    "id": 763,
    "commune_name_ascii": "Cheraia",
    "commune_name": "الشرايع",
    "daira_name_ascii": "Collo",
    "daira_name": "القل",
    "wilaya_code": "21",
    "wilaya_name_ascii": "Skikda",
    "wilaya_name": "سكيكدة"
  },
  {
    "model": "base.commune",
    "pk": 761,
    "fields": {
      "postcode": 21011,
      "wilaya": 21,
      "name": "Beni Zid"
    },
    "id": 760,
    "commune_name_ascii": "Beni Zid",
    "commune_name": "بني زيد",
    "daira_name_ascii": "Collo",
    "daira_name": "القل",
    "wilaya_code": "21",
    "wilaya_name_ascii": "Skikda",
    "wilaya_name": "سكيكدة"
  },
  {
    "pk": 786  ,"fields": { "postcode": 21036,  "wilaya":   21, "name": "Kheneg Mayoum" },
    "id": 776,
    "commune_name_ascii": "Khenag Maoune",
    "commune_name": "خناق مايو",
    "daira_name_ascii": "Ouled Attia",
    "daira_name": "أولاد عطية",
    "wilaya_code": "21",
    "wilaya_name_ascii": "Skikda",
    "wilaya_name": "سكيكدة"
  },
  {
    "model": "base.commune",
    "pk": 51,
    "fields": {
      "postcode": 2023,
      "wilaya": 2,
      "name": "El Marsa"
    },
    "id": 769,
    "commune_name_ascii": "El Marsa",
    "commune_name": "المرسى",
    "daira_name_ascii": "Ben Azzouz",
    "daira_name": "بن عزوز",
    "wilaya_code": "21",
    "wilaya_name_ascii": "Skikda",
    "wilaya_name": "سكيكدة"
  },
  {
    "pk": 758  ,"fields": { "postcode": 21008,  "wilaya":   21, "name": "Benazouz" },
    "id": 757,
    "commune_name_ascii": "Ben Azzouz",
    "commune_name": "بن عزوز",
    "daira_name_ascii": "Ben Azzouz",
    "daira_name": "بن عزوز",
    "wilaya_code": "21",
    "wilaya_name_ascii": "Skikda",
    "wilaya_name": "سكيكدة"
  },
  {
    "model": "base.commune",
    "pk": 757,
    "fields": {
      "postcode": 21007,
      "wilaya": 21,
      "name": "Bekkouche Lakhdar"
    },
    "id": 756,
    "commune_name_ascii": "Bekkouche Lakhdar",
    "commune_name": "بكوش لخضر",
    "daira_name_ascii": "Ben Azzouz",
    "daira_name": "بن عزوز",
    "wilaya_code": "21",
    "wilaya_name_ascii": "Skikda",
    "wilaya_name": "سكيكدة"
  },
  {
    "model": "base.commune",
    "pk": 759,
    "fields": {
      "postcode": 21009,
      "wilaya": 21,
      "name": "Es Sebt"
    },
    "id": 771,
    "commune_name_ascii": "Es Sebt",
    "commune_name": "السبت",
    "daira_name_ascii": "Azzaba",
    "daira_name": "عزابة",
    "wilaya_code": "21",
    "wilaya_name_ascii": "Skikda",
    "wilaya_name": "سكيكدة"
  },
  {
    "pk": 756  ,"fields": { "postcode": 21006,  "wilaya":   21, "name": "Ain Cherchar" },
    "id": 752,
    "commune_name_ascii": "Ain Charchar",
    "commune_name": "عين شرشار",
    "daira_name_ascii": "Azzaba",
    "daira_name": "عزابة",
    "wilaya_code": "21",
    "wilaya_name_ascii": "Skikda",
    "wilaya_name": "سكيكدة"
  },
  {
    "model": "base.commune",
    "pk": 754,
    "fields": {
      "postcode": 21004,
      "wilaya": 21,
      "name": "Azzaba"
    },
    "id": 755,
    "commune_name_ascii": "Azzaba",
    "commune_name": "عزابة",
    "daira_name_ascii": "Azzaba",
    "daira_name": "عزابة",
    "wilaya_code": "21",
    "wilaya_name_ascii": "Skikda",
    "wilaya_name": "سكيكدة"
  },
  {
    "pk": 784  ,"fields": { "postcode": 21034,  "wilaya":   21, "name": "Bouchtata" },
    "id": 762,
    "commune_name_ascii": "Bouchetata",
    "commune_name": "بوشطاطة",
    "daira_name_ascii": "El Hadaiek",
    "daira_name": "الحدائق",
    "wilaya_code": "21",
    "wilaya_name_ascii": "Skikda",
    "wilaya_name": "سكيكدة"
  },
  {
    "pk": 780  ,"fields": { "postcode": 21030,  "wilaya":   21, "name": "Fil Fila" },
    "id": 772,
    "commune_name_ascii": "Filfila",
    "commune_name": "فلفلة",
    "daira_name_ascii": "Skikda",
    "daira_name": "سكيكدة",
    "wilaya_code": "21",
    "wilaya_name_ascii": "Skikda",
    "wilaya_name": "سكيكدة"
  },
  {
    "pk": 787  ,"fields": { "postcode": 21037,  "wilaya":   21, "name": "Hamadi Krouma" },
    "id": 773,
    "commune_name_ascii": "Hammadi Krouma",
    "commune_name": "حمادي كرومة",
    "daira_name_ascii": "Skikda",
    "daira_name": "سكيكدة",
    "wilaya_code": "21",
    "wilaya_name_ascii": "Skikda",
    "wilaya_name": "سكيكدة"
  },
  {
    "model": "base.commune",
    "pk": 751,
    "fields": {
      "postcode": 21001,
      "wilaya": 21,
      "name": "Skikda"
    },
    "id": 785,
    "commune_name_ascii": "Skikda",
    "commune_name": "سكيكدة",
    "daira_name_ascii": "Skikda",
    "daira_name": "سكيكدة",
    "wilaya_code": "21",
    "wilaya_name_ascii": "Skikda",
    "wilaya_name": "سكيكدة"
  },
  {
    "model": "base.commune",
    "pk": 752,
    "fields": {
      "postcode": 21002,
      "wilaya": 21,
      "name": "Ain Zouit"
    },
    "id": 754,
    "commune_name_ascii": "Ain Zouit",
    "commune_name": "عين زويت",
    "daira_name_ascii": "El Hadaiek",
    "daira_name": "الحدائق",
    "wilaya_code": "21",
    "wilaya_name_ascii": "Skikda",
    "wilaya_name": "سكيكدة"
  },
  {
    "model": "base.commune",
    "pk": 755,
    "fields": {
      "postcode": 21005,
      "wilaya": 21,
      "name": "Djendel Saadi Mohamed"
    },
    "id": 765,
    "commune_name_ascii": "Djendel Saadi Mohamed",
    "commune_name": "جندل سعدي محمد",
    "daira_name_ascii": "Azzaba",
    "daira_name": "عزابة",
    "wilaya_code": "21",
    "wilaya_name_ascii": "Skikda",
    "wilaya_name": "سكيكدة"
  },
  {
    "model": "base.commune",
    "pk": 782,
    "fields": {
      "postcode": 21032,
      "wilaya": 21,
      "name": "Kanoua"
    },
    "id": 774,
    "commune_name_ascii": "Kanoua",
    "commune_name": "قنواع",
    "daira_name_ascii": "Zitouna",
    "daira_name": "الزيتونة",
    "wilaya_code": "21",
    "wilaya_name_ascii": "Skikda",
    "wilaya_name": "سكيكدة"
  },
  {
    "model": "base.commune",
    "pk": 834,
    "fields": {
      "postcode": 22046,
      "wilaya": 22,
      "name": "Sidi Ali Benyoub"
    },
    "id": 822,
    "commune_name_ascii": "Sidi Ali Benyoub",
    "commune_name": "سيدي علي بن يوب",
    "daira_name_ascii": "Sidi Ali Ben Youb",
    "daira_name": "سيدي علي بن يوب",
    "wilaya_code": "22",
    "wilaya_name_ascii": "Sidi Bel Abbes",
    "wilaya_name": "سيدي بلعباس"
  },
  {
    "model": "base.commune",
    "pk": 806,
    "fields": {
      "postcode": 22018,
      "wilaya": 22,
      "name": "Moulay Slissen"
    },
    "id": 814,
    "commune_name_ascii": "Moulay Slissen",
    "commune_name": "مولاي سليسن",
    "daira_name_ascii": "Moulay Slissen",
    "daira_name": "مولاي سليسن",
    "wilaya_code": "22",
    "wilaya_name_ascii": "Sidi Bel Abbes",
    "wilaya_name": "سيدي بلعباس"
  },
  {
    "model": "base.commune",
    "pk": 807,
    "fields": {
      "postcode": 22019,
      "wilaya": 22,
      "name": "El Hacaiba"
    },
    "id": 804,
    "commune_name_ascii": "El Hacaiba",
    "commune_name": "الحصيبة",
    "daira_name_ascii": "Moulay Slissen",
    "daira_name": "مولاي سليسن",
    "wilaya_code": "22",
    "wilaya_name_ascii": "Sidi Bel Abbes",
    "wilaya_name": "سيدي بلعباس"
  },
  {
    "model": "base.commune",
    "pk": 812,
    "fields": {
      "postcode": 22024,
      "wilaya": 22,
      "name": "Ain Tindamine"
    },
    "id": 792,
    "commune_name_ascii": "Ain Tindamine",
    "commune_name": "عين تندمين",
    "daira_name_ascii": "Moulay Slissen",
    "daira_name": "مولاي سليسن",
    "wilaya_code": "22",
    "wilaya_name_ascii": "Sidi Bel Abbes",
    "wilaya_name": "سيدي بلعباس"
  },
  {
    "model": "base.commune",
    "pk": 805,
    "fields": {
      "postcode": 22017,
      "wilaya": 22,
      "name": "Tenira"
    },
    "id": 837,
    "commune_name_ascii": "Tenira",
    "commune_name": "تنيرة",
    "daira_name_ascii": "Tenira",
    "daira_name": "تنيرة",
    "wilaya_code": "22",
    "wilaya_name_ascii": "Sidi Bel Abbes",
    "wilaya_name": "سيدي بلعباس"
  },
  {
    "model": "base.commune",
    "pk": 831,
    "fields": {
      "postcode": 22043,
      "wilaya": 22,
      "name": "Oued Sefioun"
    },
    "id": 816,
    "commune_name_ascii": "Oued Sefioun",
    "commune_name": "وادي سفيون",
    "daira_name_ascii": "Tenira",
    "daira_name": "تنيرة",
    "wilaya_code": "22",
    "wilaya_name_ascii": "Sidi Bel Abbes",
    "wilaya_name": "سيدي بلعباس"
  },
  {
    "model": "base.commune",
    "pk": 840,
    "fields": {
      "postcode": 22052,
      "wilaya": 22,
      "name": "Hassi Dahou"
    },
    "id": 805,
    "commune_name_ascii": "Hassi Dahou",
    "commune_name": "حاسي دحو",
    "daira_name_ascii": "Tenira",
    "daira_name": "تنيرة",
    "wilaya_code": "22",
    "wilaya_name_ascii": "Sidi Bel Abbes",
    "wilaya_name": "سيدي بلعباس"
  },
  {
    "model": "base.commune",
    "pk": 819,
    "fields": {
      "postcode": 22031,
      "wilaya": 22,
      "name": "Oued Taourira"
    },
    "id": 817,
    "commune_name_ascii": "Oued Taourira",
    "commune_name": "وادي تاوريرة",
    "daira_name_ascii": "Merine",
    "daira_name": "مرين",
    "wilaya_code": "22",
    "wilaya_name_ascii": "Sidi Bel Abbes",
    "wilaya_name": "سيدي بلعباس"
  },
  {
    "model": "base.commune",
    "pk": 839,
    "fields": {
      "postcode": 22051,
      "wilaya": 22,
      "name": "Benachiba Chelia"
    },
    "id": 798,
    "commune_name_ascii": "Benachiba Chelia",
    "commune_name": "بن عشيبة شلية",
    "daira_name_ascii": "Tenira",
    "daira_name": "تنيرة",
    "wilaya_code": "22",
    "wilaya_name_ascii": "Sidi Bel Abbes",
    "wilaya_name": "سيدي بلعباس"
  },
  {
    "model": "base.commune",
    "pk": 828,
    "fields": {
      "postcode": 22040,
      "wilaya": 22,
      "name": "Sidi Yacoub"
    },
    "id": 831,
    "commune_name_ascii": "Sidi Yacoub",
    "commune_name": "سيدي يعقوب",
    "daira_name_ascii": "Sidi Lahcene",
    "daira_name": "سيدي لحسن",
    "wilaya_code": "22",
    "wilaya_name_ascii": "Sidi Bel Abbes",
    "wilaya_name": "سيدي بلعباس"
  },
  {
    "model": "base.commune",
    "pk": 802,
    "fields": {
      "postcode": 22014,
      "wilaya": 22,
      "name": "Sidi Lahcene"
    },
    "id": 830,
    "commune_name_ascii": "Sidi Lahcene",
    "commune_name": "سيدي لحسن",
    "daira_name_ascii": "Sidi Lahcene",
    "daira_name": "سيدي لحسن",
    "wilaya_code": "22",
    "wilaya_name_ascii": "Sidi Bel Abbes",
    "wilaya_name": "سيدي بلعباس"
  },
  {
    "model": "base.commune",
    "pk": 237,
    "fields": {
      "postcode": 7008,
      "wilaya": 7,
      "name": "Sidi Khaled"
    },
    "id": 829,
    "commune_name_ascii": "Sidi Khaled",
    "commune_name": "سيدي خالد",
    "daira_name_ascii": "Sidi Lahcene",
    "daira_name": "سيدي لحسن",
    "wilaya_code": "22",
    "wilaya_name_ascii": "Sidi Bel Abbes",
    "wilaya_name": "سيدي بلعباس"
  },
  {
    "model": "base.commune",
    "pk": 809,
    "fields": {
      "postcode": 22021,
      "wilaya": 22,
      "name": "Tabia"
    },
    "id": 832,
    "commune_name_ascii": "Tabia",
    "commune_name": "طابية",
    "daira_name_ascii": "Sidi Ali Ben Youb",
    "daira_name": "سيدي علي بن يوب",
    "wilaya_code": "22",
    "wilaya_name_ascii": "Sidi Bel Abbes",
    "wilaya_name": "سيدي بلعباس"
  },
  {
    "model": "base.commune",
    "pk": 791,
    "fields": {
      "postcode": 22003,
      "wilaya": 22,
      "name": "Sidi Brahim"
    },
    "id": 825,
    "commune_name_ascii": "Sidi Brahim",
    "commune_name": "سيدي ابراهيم",
    "daira_name_ascii": "Ain El Berd",
    "daira_name": "عين البرد",
    "wilaya_code": "22",
    "wilaya_name_ascii": "Sidi Bel Abbes",
    "wilaya_name": "سيدي بلعباس"
  },
  {
    "model": "base.commune",
    "pk": 800,
    "fields": {
      "postcode": 22012,
      "wilaya": 22,
      "name": "Amarnas"
    },
    "id": 794,
    "commune_name_ascii": "Amarnas",
    "commune_name": "العمارنة",
    "daira_name_ascii": "Sidi Lahcene",
    "daira_name": "سيدي لحسن",
    "wilaya_code": "22",
    "wilaya_name_ascii": "Sidi Bel Abbes",
    "wilaya_name": "سيدي بلعباس"
  },
  {
    "pk": 795  ,"fields": { "postcode": 22007,  "wilaya":   22, "name": "Boukhanafis" },
    "id": 801,
    "commune_name_ascii": "Boukhanefis",
    "commune_name": "بوخنفيس",
    "daira_name_ascii": "Sidi Ali Ben Youb",
    "daira_name": "سيدي علي بن يوب",
    "wilaya_code": "22",
    "wilaya_name_ascii": "Sidi Bel Abbes",
    "wilaya_name": "سيدي بلعباس"
  },
  {
    "pk": 808  ,"fields": { "postcode": 22020,  "wilaya":   22, "name": "Hassi Zehana" },
    "id": 806,
    "commune_name_ascii": "Hassi Zahana",
    "commune_name": "حاسي زهانة",
    "daira_name_ascii": "Ben Badis",
    "daira_name": "بن باديس",
    "wilaya_code": "22",
    "wilaya_name_ascii": "Sidi Bel Abbes",
    "wilaya_name": "سيدي بلعباس"
  },
  {
    "model": "base.commune",
    "pk": 835,
    "fields": {
      "postcode": 22047,
      "wilaya": 22,
      "name": "Chetouane Belaila"
    },
    "id": 802,
    "commune_name_ascii": "Chetouane Belaila",
    "commune_name": "شيطوان البلايلة",
    "daira_name_ascii": "Ben Badis",
    "daira_name": "بن باديس",
    "wilaya_code": "22",
    "wilaya_name_ascii": "Sidi Bel Abbes",
    "wilaya_name": "سيدي بلعباس"
  },
  {
    "model": "base.commune",
    "pk": 833,
    "fields": {
      "postcode": 22045,
      "wilaya": 22,
      "name": "Ben Badis"
    },
    "id": 797,
    "commune_name_ascii": "Ben Badis",
    "commune_name": "بن باديس",
    "daira_name_ascii": "Ben Badis",
    "daira_name": "بن باديس",
    "wilaya_code": "22",
    "wilaya_name_ascii": "Sidi Bel Abbes",
    "wilaya_name": "سيدي بلعباس"
  },
  {
    "pk": 797  ,"fields": { "postcode": 22009,  "wilaya":   22, "name": "Badredine El Mokrani" },
    "id": 795,
    "commune_name_ascii": "Bedrabine El Mokrani",
    "commune_name": "بضرابين المقراني",
    "daira_name_ascii": "Ben Badis",
    "daira_name": "بن باديس",
    "wilaya_code": "22",
    "wilaya_name_ascii": "Sidi Bel Abbes",
    "wilaya_name": "سيدي بلعباس"
  },
  {
    "pk": 817  ,"fields": { "postcode": 22029,  "wilaya":   22, "name": "Sfissef" },
    "id": 821,
    "commune_name_ascii": "Sfisef",
    "commune_name": "سفيزف",
    "daira_name_ascii": "Sfisef",
    "daira_name": "سفيزف",
    "wilaya_code": "22",
    "wilaya_name_ascii": "Sidi Bel Abbes",
    "wilaya_name": "سيدي بلعباس"
  },
  {
    "pk": 814  ,"fields": { "postcode": 22026,  "wilaya":   22, "name": "Mcid" },
    "id": 810,
    "commune_name_ascii": "M'cid",
    "commune_name": "مسيد",
    "daira_name_ascii": "Sfisef",
    "daira_name": "سفيزف",
    "wilaya_code": "22",
    "wilaya_name_ascii": "Sidi Bel Abbes",
    "wilaya_name": "سيدي بلعباس"
  },
  {
    "model": "base.commune",
    "pk": 826,
    "fields": {
      "postcode": 22038,
      "wilaya": 22,
      "name": "Boudjebaa El Bordj"
    },
    "id": 800,
    "commune_name_ascii": "Boudjebaa El Bordj",
    "commune_name": "بوجبهة البرج",
    "daira_name_ascii": "Sfisef",
    "daira_name": "سفيزف",
    "wilaya_code": "22",
    "wilaya_name_ascii": "Sidi Bel Abbes",
    "wilaya_name": "سيدي بلعباس"
  },
  {
    "pk": 818  ,"fields": { "postcode": 22030,  "wilaya":   22, "name": "Ain Adden" },
    "id": 793,
    "commune_name_ascii": "Ain  Adden",
    "commune_name": "عين أدن",
    "daira_name_ascii": "Sfisef",
    "daira_name": "سفيزف",
    "wilaya_code": "22",
    "wilaya_name_ascii": "Sidi Bel Abbes",
    "wilaya_name": "سيدي بلعباس"
  },
  {
    "model": "base.commune",
    "pk": 829,
    "fields": {
      "postcode": 22041,
      "wilaya": 22,
      "name": "Sidi Hamadouche"
    },
    "id": 828,
    "commune_name_ascii": "Sidi Hamadouche",
    "commune_name": "سيدي حمادوش",
    "daira_name_ascii": "Ain El Berd",
    "daira_name": "عين البرد",
    "wilaya_code": "22",
    "wilaya_name_ascii": "Sidi Bel Abbes",
    "wilaya_name": "سيدي بلعباس"
  },
  {
    "model": "base.commune",
    "pk": 823,
    "fields": {
      "postcode": 22035,
      "wilaya": 22,
      "name": "Sidi Chaib"
    },
    "id": 826,
    "commune_name_ascii": "Sidi Chaib",
    "commune_name": "سيدي شعيب",
    "daira_name_ascii": "Marhoum",
    "daira_name": "مرحوم",
    "wilaya_code": "22",
    "wilaya_name_ascii": "Sidi Bel Abbes",
    "wilaya_name": "سيدي بلعباس"
  },
  {
    "model": "base.commune",
    "pk": 804,
    "fields": {
      "postcode": 22016,
      "wilaya": 22,
      "name": "Makedra"
    },
    "id": 808,
    "commune_name_ascii": "Makedra",
    "commune_name": "مكدرة",
    "daira_name_ascii": "Ain El Berd",
    "daira_name": "عين البرد",
    "wilaya_code": "22",
    "wilaya_name_ascii": "Sidi Bel Abbes",
    "wilaya_name": "سيدي بلعباس"
  },
  {
    "model": "base.commune",
    "pk": 816,
    "fields": {
      "postcode": 22028,
      "wilaya": 22,
      "name": "Ain El Berd"
    },
    "id": 789,
    "commune_name_ascii": "Ain El Berd",
    "commune_name": "عين البرد",
    "daira_name_ascii": "Ain El Berd",
    "daira_name": "عين البرد",
    "wilaya_code": "22",
    "wilaya_name_ascii": "Sidi Bel Abbes",
    "wilaya_name": "سيدي بلعباس"
  },
  {
    "model": "base.commune",
    "pk": 838,
    "fields": {
      "postcode": 22050,
      "wilaya": 22,
      "name": "Redjem Demouche"
    },
    "id": 819,
    "commune_name_ascii": "Redjem Demouche",
    "commune_name": "رجم دموش",
    "daira_name_ascii": "Ras El Ma",
    "daira_name": "راس الماء",
    "wilaya_code": "22",
    "wilaya_name_ascii": "Sidi Bel Abbes",
    "wilaya_name": "سيدي بلعباس"
  },
  {
    "model": "base.commune",
    "pk": 811,
    "fields": {
      "postcode": 22023,
      "wilaya": 22,
      "name": "Ras El Ma"
    },
    "id": 818,
    "commune_name_ascii": "Ras El Ma",
    "commune_name": "راس الماء",
    "daira_name_ascii": "Ras El Ma",
    "daira_name": "راس الماء",
    "wilaya_code": "22",
    "wilaya_name_ascii": "Sidi Bel Abbes",
    "wilaya_name": "سيدي بلعباس"
  },
  {
    "pk": 825  ,"fields": { "postcode": 22037,  "wilaya":   22, "name": "Oued Sbaa" },
    "id": 815,
    "commune_name_ascii": "Oued Sebaa",
    "commune_name": "وادي السبع",
    "daira_name_ascii": "Ras El Ma",
    "daira_name": "راس الماء",
    "wilaya_code": "22",
    "wilaya_name_ascii": "Sidi Bel Abbes",
    "wilaya_name": "سيدي بلعباس"
  },
  {
    "model": "base.commune",
    "pk": 798,
    "fields": {
      "postcode": 22010,
      "wilaya": 22,
      "name": "Marhoum"
    },
    "id": 809,
    "commune_name_ascii": "Marhoum",
    "commune_name": "مرحوم",
    "daira_name_ascii": "Marhoum",
    "daira_name": "مرحوم",
    "wilaya_code": "22",
    "wilaya_name_ascii": "Sidi Bel Abbes",
    "wilaya_name": "سيدي بلعباس"
  },
  {
    "pk": 789  ,"fields": { "postcode": 22001,  "wilaya":   22, "name": "Sidi Bel Abbes" },
    "id": 824,
    "commune_name_ascii": "Sidi Bel Abbes",
    "commune_name": "سيدي بلعباس",
    "daira_name_ascii": "Sidi Bel Abbes",
    "daira_name": "سيدي بلعباس",
    "wilaya_code": "22",
    "wilaya_name_ascii": "Sidi Bel Abbes",
    "wilaya_name": "سيدي بلعباس"
  },
  {
    "model": "base.commune",
    "pk": 803,
    "fields": {
      "postcode": 22015,
      "wilaya": 22,
      "name": "Ain Thrid"
    },
    "id": 791,
    "commune_name_ascii": "Ain Thrid",
    "commune_name": "عين الثريد",
    "daira_name_ascii": "Tessala",
    "daira_name": "تسالة",
    "wilaya_code": "22",
    "wilaya_name_ascii": "Sidi Bel Abbes",
    "wilaya_name": "سيدي بلعباس"
  },
  {
    "model": "base.commune",
    "pk": 827,
    "fields": {
      "postcode": 22039,
      "wilaya": 22,
      "name": "Sehala Thaoura"
    },
    "id": 820,
    "commune_name_ascii": "Sehala Thaoura",
    "commune_name": "السهالة الثورة",
    "daira_name_ascii": "Tessala",
    "daira_name": "تسالة",
    "wilaya_code": "22",
    "wilaya_name_ascii": "Sidi Bel Abbes",
    "wilaya_name": "سيدي بلعباس"
  },
  {
    "model": "base.commune",
    "pk": 790,
    "fields": {
      "postcode": 22002,
      "wilaya": 22,
      "name": "Tessala"
    },
    "id": 838,
    "commune_name_ascii": "Tessala",
    "commune_name": "تسالة",
    "daira_name_ascii": "Tessala",
    "daira_name": "تسالة",
    "wilaya_code": "22",
    "wilaya_name_ascii": "Sidi Bel Abbes",
    "wilaya_name": "سيدي بلعباس"
  },
  {
    "model": "base.commune",
    "pk": 830,
    "fields": {
      "postcode": 22042,
      "wilaya": 22,
      "name": "Belarbi"
    },
    "id": 796,
    "commune_name_ascii": "Belarbi",
    "commune_name": "بلعربي",
    "daira_name_ascii": "Mostefa  Ben Brahim",
    "daira_name": "مصطفى بن ابراهيم",
    "wilaya_code": "22",
    "wilaya_name_ascii": "Sidi Bel Abbes",
    "wilaya_name": "سيدي بلعباس"
  },
  {
    "pk": 792  ,"fields": { "postcode": 22004,  "wilaya":   22, "name": "Mostefa Ben Brahim" },
    "id": 813,
    "commune_name_ascii": "Mostefa  Ben Brahim",
    "commune_name": "مصطفى بن ابراهيم",
    "daira_name_ascii": "Mostefa  Ben Brahim",
    "daira_name": "مصطفى بن ابراهيم",
    "wilaya_code": "22",
    "wilaya_name_ascii": "Sidi Bel Abbes",
    "wilaya_name": "سيدي بلعباس"
  },
  {
    "model": "base.commune",
    "pk": 801,
    "fields": {
      "postcode": 22013,
      "wilaya": 22,
      "name": "Tilmouni"
    },
    "id": 839,
    "commune_name_ascii": "Tilmouni",
    "commune_name": "تلموني",
    "daira_name_ascii": "Mostefa  Ben Brahim",
    "daira_name": "مصطفى بن ابراهيم",
    "wilaya_code": "22",
    "wilaya_name_ascii": "Sidi Bel Abbes",
    "wilaya_name": "سيدي بلعباس"
  },
  {
    "model": "base.commune",
    "pk": 821,
    "fields": {
      "postcode": 22033,
      "wilaya": 22,
      "name": "Zerouala"
    },
    "id": 840,
    "commune_name_ascii": "Zerouala",
    "commune_name": "زروالة",
    "daira_name_ascii": "Mostefa  Ben Brahim",
    "daira_name": "مصطفى بن ابراهيم",
    "wilaya_code": "22",
    "wilaya_name_ascii": "Sidi Bel Abbes",
    "wilaya_name": "سيدي بلعباس"
  },
  {
    "model": "base.commune",
    "pk": 820,
    "fields": {
      "postcode": 22032,
      "wilaya": 22,
      "name": "Dhaya"
    },
    "id": 803,
    "commune_name_ascii": "Dhaya",
    "commune_name": "الضاية",
    "daira_name_ascii": "Telagh",
    "daira_name": "تلاغ",
    "wilaya_code": "22",
    "wilaya_name_ascii": "Sidi Bel Abbes",
    "wilaya_name": "سيدي بلعباس"
  },
  {
    "model": "base.commune",
    "pk": 794,
    "fields": {
      "postcode": 22006,
      "wilaya": 22,
      "name": "Mezaourou"
    },
    "id": 812,
    "commune_name_ascii": "Mezaourou",
    "commune_name": "مزاورو",
    "daira_name_ascii": "Telagh",
    "daira_name": "تلاغ",
    "wilaya_code": "22",
    "wilaya_name_ascii": "Sidi Bel Abbes",
    "wilaya_name": "سيدي بلعباس"
  },
  {
    "model": "base.commune",
    "pk": 832,
    "fields": {
      "postcode": 22044,
      "wilaya": 22,
      "name": "Teghalimet"
    },
    "id": 835,
    "commune_name_ascii": "Teghalimet",
    "commune_name": "تغاليمت",
    "daira_name_ascii": "Telagh",
    "daira_name": "تلاغ",
    "wilaya_code": "22",
    "wilaya_name_ascii": "Sidi Bel Abbes",
    "wilaya_name": "سيدي بلعباس"
  },
  {
    "model": "base.commune",
    "pk": 793,
    "fields": {
      "postcode": 22005,
      "wilaya": 22,
      "name": "Telagh"
    },
    "id": 836,
    "commune_name_ascii": "Telagh",
    "commune_name": "تلاغ",
    "daira_name_ascii": "Telagh",
    "daira_name": "تلاغ",
    "wilaya_code": "22",
    "wilaya_name_ascii": "Sidi Bel Abbes",
    "wilaya_name": "سيدي بلعباس"
  },
  {
    "model": "base.commune",
    "pk": 813,
    "fields": {
      "postcode": 22025,
      "wilaya": 22,
      "name": "Ain Kada"
    },
    "id": 790,
    "commune_name_ascii": "Ain Kada",
    "commune_name": "عين قادة",
    "daira_name_ascii": "Sidi Ali Boussidi",
    "daira_name": "سيدي علي بوسيدي",
    "wilaya_code": "22",
    "wilaya_name_ascii": "Sidi Bel Abbes",
    "wilaya_name": "سيدي بلعباس"
  },
  {
    "model": "base.commune",
    "pk": 822,
    "fields": {
      "postcode": 22034,
      "wilaya": 22,
      "name": "Lamtar"
    },
    "id": 807,
    "commune_name_ascii": "Lamtar",
    "commune_name": "لمطار",
    "daira_name_ascii": "Sidi Ali Boussidi",
    "daira_name": "سيدي علي بوسيدي",
    "wilaya_code": "22",
    "wilaya_name_ascii": "Sidi Bel Abbes",
    "wilaya_name": "سيدي بلعباس"
  },
  {
    "model": "base.commune",
    "pk": 796,
    "fields": {
      "postcode": 22008,
      "wilaya": 22,
      "name": "Sidi Ali Boussidi"
    },
    "id": 823,
    "commune_name_ascii": "Sidi Ali Boussidi",
    "commune_name": "سيدي علي بوسيدي",
    "daira_name_ascii": "Sidi Ali Boussidi",
    "daira_name": "سيدي علي بوسيدي",
    "wilaya_code": "22",
    "wilaya_name_ascii": "Sidi Bel Abbes",
    "wilaya_name": "سيدي بلعباس"
  },
  {
    "pk": 824  ,"fields": { "postcode": 22036,  "wilaya":   22, "name": "Sidi Dahou Dezairs" },
    "id": 827,
    "commune_name_ascii": "Sidi Dahou Zairs",
    "commune_name": "سيدي دحو الزاير",
    "daira_name_ascii": "Sidi Ali Boussidi",
    "daira_name": "سيدي علي بوسيدي",
    "wilaya_code": "22",
    "wilaya_name_ascii": "Sidi Bel Abbes",
    "wilaya_name": "سيدي بلعباس"
  },
  {
    "model": "base.commune",
    "pk": 836,
    "fields": {
      "postcode": 22048,
      "wilaya": 22,
      "name": "Bir El Hammam"
    },
    "id": 799,
    "commune_name_ascii": "Bir El Hammam",
    "commune_name": "بئر الحمام",
    "daira_name_ascii": "Marhoum",
    "daira_name": "مرحوم",
    "wilaya_code": "22",
    "wilaya_name_ascii": "Sidi Bel Abbes",
    "wilaya_name": "سيدي بلعباس"
  },
  {
    "model": "base.commune",
    "pk": 810,
    "fields": {
      "postcode": 22022,
      "wilaya": 22,
      "name": "Merine"
    },
    "id": 811,
    "commune_name_ascii": "Merine",
    "commune_name": "مرين",
    "daira_name_ascii": "Merine",
    "daira_name": "مرين",
    "wilaya_code": "22",
    "wilaya_name_ascii": "Sidi Bel Abbes",
    "wilaya_name": "سيدي بلعباس"
  },
  {
    "pk": 799  ,"fields": { "postcode": 22011,  "wilaya":   22, "name": "Tafissour" },
    "id": 834,
    "commune_name_ascii": "Tefessour",
    "commune_name": "تفسور",
    "daira_name_ascii": "Merine",
    "daira_name": "مرين",
    "wilaya_code": "22",
    "wilaya_name_ascii": "Sidi Bel Abbes",
    "wilaya_name": "سيدي بلعباس"
  },
  {
    "model": "base.commune",
    "pk": 837,
    "fields": {
      "postcode": 22049,
      "wilaya": 22,
      "name": "Taoudmout"
    },
    "id": 833,
    "commune_name_ascii": "Taoudmout",
    "commune_name": "تاودموت",
    "daira_name_ascii": "Merine",
    "daira_name": "مرين",
    "wilaya_code": "22",
    "wilaya_name_ascii": "Sidi Bel Abbes",
    "wilaya_name": "سيدي بلعباس"
  },
  {
    "model": "base.commune",
    "pk": 841,
    "fields": {
      "postcode": 23001,
      "wilaya": 23,
      "name": "Annaba"
    },
    "id": 842,
    "commune_name_ascii": "Annaba",
    "commune_name": "عنابة",
    "daira_name_ascii": "Annaba",
    "daira_name": "عنابة",
    "wilaya_code": "23",
    "wilaya_name_ascii": "Annaba",
    "wilaya_name": "عنابة"
  },
  {
    "model": "base.commune",
    "pk": 848,
    "fields": {
      "postcode": 23008,
      "wilaya": 23,
      "name": "Seraidi"
    },
    "id": 850,
    "commune_name_ascii": "Seraidi",
    "commune_name": "سرايدي",
    "daira_name_ascii": "Annaba",
    "daira_name": "عنابة",
    "wilaya_code": "23",
    "wilaya_name_ascii": "Annaba",
    "wilaya_name": "عنابة"
  },
  {
    "pk": 842  ,"fields": { "postcode": 23002,  "wilaya":   23, "name": "Berrahel" },
    "id": 843,
    "commune_name_ascii": "Berrahal",
    "commune_name": "برحال",
    "daira_name_ascii": "Berrahal",
    "daira_name": "برحال",
    "wilaya_code": "23",
    "wilaya_name_ascii": "Annaba",
    "wilaya_name": "عنابة"
  },
  {
    "model": "base.commune",
    "pk": 846,
    "fields": {
      "postcode": 23006,
      "wilaya": 23,
      "name": "Oued El Aneb"
    },
    "id": 849,
    "commune_name_ascii": "Oued El Aneb",
    "commune_name": "واد العنب",
    "daira_name_ascii": "Berrahal",
    "daira_name": "برحال",
    "wilaya_code": "23",
    "wilaya_name_ascii": "Annaba",
    "wilaya_name": "عنابة"
  },
  {
    "model": "base.commune",
    "pk": 843,
    "fields": {
      "postcode": 23003,
      "wilaya": 23,
      "name": "El Hadjar"
    },
    "id": 848,
    "commune_name_ascii": "El Hadjar",
    "commune_name": "الحجار",
    "daira_name_ascii": "El Hadjar",
    "daira_name": "الحجار",
    "wilaya_code": "23",
    "wilaya_name_ascii": "Annaba",
    "wilaya_name": "عنابة"
  },
  {
    "model": "base.commune",
    "pk": 742,
    "fields": {
      "postcode": 20008,
      "wilaya": 20,
      "name": "Sidi Amar"
    },
    "id": 851,
    "commune_name_ascii": "Sidi Amar",
    "commune_name": "سيدي عمار",
    "daira_name_ascii": "El Hadjar",
    "daira_name": "الحجار",
    "wilaya_code": "23",
    "wilaya_name_ascii": "Annaba",
    "wilaya_name": "عنابة"
  },
  {
    "model": "base.commune",
    "pk": 845,
    "fields": {
      "postcode": 23005,
      "wilaya": 23,
      "name": "El Bouni"
    },
    "id": 846,
    "commune_name_ascii": "El Bouni",
    "commune_name": "البوني",
    "daira_name_ascii": "El Bouni",
    "daira_name": "البوني",
    "wilaya_code": "23",
    "wilaya_name_ascii": "Annaba",
    "wilaya_name": "عنابة"
  },
  {
    "pk": 849  ,"fields": { "postcode": 23009,  "wilaya":   23, "name": "Ain Berda" },
    "id": 841,
    "commune_name_ascii": "Ain El Berda",
    "commune_name": "عين الباردة",
    "daira_name_ascii": "Ain El Berda",
    "daira_name": "عين الباردة",
    "wilaya_code": "23",
    "wilaya_name_ascii": "Annaba",
    "wilaya_name": "عنابة"
  },
  {
    "model": "base.commune",
    "pk": 847,
    "fields": {
      "postcode": 23007,
      "wilaya": 23,
      "name": "Cheurfa"
    },
    "id": 845,
    "commune_name_ascii": "Cheurfa",
    "commune_name": "الشرفة",
    "daira_name_ascii": "Ain El Berda",
    "daira_name": "عين الباردة",
    "wilaya_code": "23",
    "wilaya_name_ascii": "Annaba",
    "wilaya_name": "عنابة"
  },
  {
    "model": "base.commune",
    "pk": 694,
    "fields": {
      "postcode": 19020,
      "wilaya": 19,
      "name": "El Eulma"
    },
    "id": 847,
    "commune_name_ascii": "El Eulma",
    "commune_name": "العلمة",
    "daira_name_ascii": "Ain El Berda",
    "daira_name": "عين الباردة",
    "wilaya_code": "23",
    "wilaya_name_ascii": "Annaba",
    "wilaya_name": "عنابة"
  },
  {
    "model": "base.commune",
    "pk": 852,
    "fields": {
      "postcode": 23012,
      "wilaya": 23,
      "name": "Treat"
    },
    "id": 852,
    "commune_name_ascii": "Treat",
    "commune_name": "التريعات",
    "daira_name_ascii": "Berrahal",
    "daira_name": "برحال",
    "wilaya_code": "23",
    "wilaya_name_ascii": "Annaba",
    "wilaya_name": "عنابة"
  },
  {
    "model": "base.commune",
    "pk": 850,
    "fields": {
      "postcode": 23010,
      "wilaya": 23,
      "name": "Chetaibi"
    },
    "id": 844,
    "commune_name_ascii": "Chetaibi",
    "commune_name": "شطايبي",
    "daira_name_ascii": "Chetaibi",
    "daira_name": "شطايبي",
    "wilaya_code": "23",
    "wilaya_name_ascii": "Annaba",
    "wilaya_name": "عنابة"
  },
  {
    "model": "base.commune",
    "pk": 854,
    "fields": {
      "postcode": 24002,
      "wilaya": 24,
      "name": "Nechmaya"
    },
    "id": 875,
    "commune_name_ascii": "Nechmaya",
    "commune_name": "نشماية",
    "daira_name_ascii": "Guelaat Bousbaa",
    "daira_name": "قلعة بوصبع",
    "wilaya_code": "24",
    "wilaya_name_ascii": "Guelma",
    "wilaya_name": "قالمة"
  },
  {
    "model": "base.commune",
    "pk": 864,
    "fields": {
      "postcode": 24012,
      "wilaya": 24,
      "name": "Bou Hamdane"
    },
    "id": 863,
    "commune_name_ascii": "Bou Hamdane",
    "commune_name": "بوحمدان",
    "daira_name_ascii": "Hammam Debagh",
    "daira_name": "حمام دباغ",
    "wilaya_code": "24",
    "wilaya_name_ascii": "Guelma",
    "wilaya_name": "قالمة"
  },
  {
    /*                               غير موجوود                                  */
    "id": 872,
    "commune_name_ascii": "Hammam Debagh",
    "commune_name": "حمام دباغ",
    "daira_name_ascii": "Hammam Debagh",
    "daira_name": "حمام دباغ",
    "wilaya_code": "24",
    "wilaya_name_ascii": "Guelma",
    "wilaya_name": "قالمة"
  },
  {
    "model": "base.commune",
    "pk": 880,
    "fields": {
      "postcode": 24028,
      "wilaya": 24,
      "name": "Roknia"
    },
    "id": 884,
    "commune_name_ascii": "Roknia",
    "commune_name": "الركنية",
    "daira_name_ascii": "Hammam Debagh",
    "daira_name": "حمام دباغ",
    "wilaya_code": "24",
    "wilaya_name_ascii": "Guelma",
    "wilaya_name": "قالمة"
  },
  {
    "model": "base.commune",
    "pk": 861,
    "fields": {
      "postcode": 24009,
      "wilaya": 24,
      "name": "Dahouara"
    },
    "id": 867,
    "commune_name_ascii": "Dahouara",
    "commune_name": "الدهوارة",
    "daira_name_ascii": "Hammam N'bails",
    "daira_name": "حمام النبايل",
    "wilaya_code": "24",
    "wilaya_name_ascii": "Guelma",
    "wilaya_name": "قالمة"
  },
  {
    "pk": 874  ,"fields": { "postcode": 24022,  "wilaya":   24, "name": "Hamman Nbail"  },
    "id": 873,
    "commune_name_ascii": "Hammam N'bail",
    "commune_name": "حمام النبايل",
    "daira_name_ascii": "Hammam N'bails",
    "daira_name": "حمام النبايل",
    "wilaya_code": "24",
    "wilaya_name_ascii": "Guelma",
    "wilaya_name": "قالمة"
  },
  {
    "model": "base.commune",
    "pk": 853,
    "fields": {
      "postcode": 24001,
      "wilaya": 24,
      "name": "Guelma"
    },
    "id": 871,
    "commune_name_ascii": "Guelma",
    "commune_name": "قالمة",
    "daira_name_ascii": "Guelma",
    "daira_name": "قالمة",
    "wilaya_code": "24",
    "wilaya_name_ascii": "Guelma",
    "wilaya_name": "قالمة"
  },
  {
    "model": "base.commune",
    "pk": 883,
    "fields": {
      "postcode": 24031,
      "wilaya": 24,
      "name": "Boumahra Ahmed"
    },
    "id": 866,
    "commune_name_ascii": "Boumahra Ahmed",
    "commune_name": "بومهرة أحمد",
    "daira_name_ascii": "Guelaat Bousbaa",
    "daira_name": "قلعة بوصبع",
    "wilaya_code": "24",
    "wilaya_name_ascii": "Guelma",
    "wilaya_name": "قالمة"
  },
  {
    "model": "base.commune",
    "pk": 866,
    "fields": {
      "postcode": 24014,
      "wilaya": 24,
      "name": "Ain Ben Beida"
    },
    "id": 853,
    "commune_name_ascii": "Ain Ben Beida",
    "commune_name": "عين بن بيضاء",
    "daira_name_ascii": "Bouchegouf",
    "daira_name": "بوشقوف",
    "wilaya_code": "24",
    "wilaya_name_ascii": "Guelma",
    "wilaya_name": "قالمة"
  },
  {
    "model": "base.commune",
    "pk": 877,
    "fields": {
      "postcode": 24025,
      "wilaya": 24,
      "name": "Bouchegouf"
    },
    "id": 865,
    "commune_name_ascii": "Bouchegouf",
    "commune_name": "بوشقوف",
    "daira_name_ascii": "Bouchegouf",
    "daira_name": "بوشقوف",
    "wilaya_code": "24",
    "wilaya_name_ascii": "Guelma",
    "wilaya_name": "قالمة"
  },
  {
    "model": "base.commune",
    "pk": 882,
    "fields": {
      "postcode": 24030,
      "wilaya": 24,
      "name": "Medjez Sfa"
    },
    "id": 878,
    "commune_name_ascii": "Medjez Sfa",
    "commune_name": "مجاز الصفاء",
    "daira_name_ascii": "Bouchegouf",
    "daira_name": "بوشقوف",
    "wilaya_code": "24",
    "wilaya_name_ascii": "Guelma",
    "wilaya_name": "قالمة"
  },
  {
    "pk": 858  ,"fields": { "postcode": 24006,  "wilaya":   24, "name": "Oued Fragha" },
    "id": 881,
    "commune_name_ascii": "Oued Ferragha",
    "commune_name": "وادي فراغة",
    "daira_name_ascii": "Bouchegouf",
    "daira_name": "بوشقوف",
    "wilaya_code": "24",
    "wilaya_name_ascii": "Guelma",
    "wilaya_name": "قالمة"
  },
  {
    "model": "base.commune",
    "pk": 855,
    "fields": {
      "postcode": 24003,
      "wilaya": 24,
      "name": "Bouati Mahmoud"
    },
    "id": 864,
    "commune_name_ascii": "Bouati Mahmoud",
    "commune_name": "بوعاتي محمود",
    "daira_name_ascii": "Heliopolis",
    "daira_name": "هيليوبوليس",
    "wilaya_code": "24",
    "wilaya_name_ascii": "Guelma",
    "wilaya_name": "قالمة"
  },
  {
    "model": "base.commune",
    "pk": 872,
    "fields": {
      "postcode": 24020,
      "wilaya": 24,
      "name": "El Fedjoudj"
    },
    "id": 869,
    "commune_name_ascii": "El Fedjoudj",
    "commune_name": "الفجوج",
    "daira_name_ascii": "Heliopolis",
    "daira_name": "هيليوبوليس",
    "wilaya_code": "24",
    "wilaya_name_ascii": "Guelma",
    "wilaya_name": "قالمة"
  },
  {
    "model": "base.commune",
    "pk": 878,
    "fields": {
      "postcode": 24026,
      "wilaya": 24,
      "name": "Heliopolis"
    },
    "id": 874,
    "commune_name_ascii": "Heliopolis",
    "commune_name": "هيليوبوليس",
    "daira_name_ascii": "Heliopolis",
    "daira_name": "هيليوبوليس",
    "wilaya_code": "24",
    "wilaya_name_ascii": "Guelma",
    "wilaya_name": "قالمة"
  },
  {
    "model": "base.commune",
    "pk": 876,
    "fields": {
      "postcode": 24024,
      "wilaya": 24,
      "name": "Medjez Amar"
    },
    "id": 877,
    "commune_name_ascii": "Medjez Amar",
    "commune_name": "مجاز عمار",
    "daira_name_ascii": "Ain Hessainia",
    "daira_name": "عين حساينية",
    "wilaya_code": "24",
    "wilaya_name_ascii": "Guelma",
    "wilaya_name": "قالمة"
  },
  {
    /*                                                                                                        */
    "id": 879,
    "commune_name_ascii": "Houari Boumedienne",
    "commune_name": "هواري بومدين",
    "daira_name_ascii": "Ain Hessainia",
    "daira_name": "عين حساينية",
    "wilaya_code": "24",
    "wilaya_name_ascii": "Guelma",
    "wilaya_name": "قالمة"
  },
  {
    "model": "base.commune",
    "pk": 860,
    "fields": {
      "postcode": 24008,
      "wilaya": 24,
      "name": "Ras El Agba"
    },
    "id": 883,
    "commune_name_ascii": "Ras El Agba",
    "commune_name": "رأس العقبة",
    "daira_name_ascii": "Ain Hessainia",
    "daira_name": "عين حساينية",
    "wilaya_code": "24",
    "wilaya_name_ascii": "Guelma",
    "wilaya_name": "قالمة"
  },
  {
    "pk": 881  ,"fields": { "postcode": 24029,  "wilaya":   24, "name": "Salaoua Announa" },
    "id": 885,
    "commune_name_ascii": "Sellaoua Announa",
    "commune_name": "سلاوة عنونة",
    "daira_name_ascii": "Ain Hessainia",
    "daira_name": "عين حساينية",
    "wilaya_code": "24",
    "wilaya_name_ascii": "Guelma",
    "wilaya_name": "قالمة"
  },
  {
    "model": "base.commune",
    "pk": 886,
    "fields": {
      "postcode": 24034,
      "wilaya": 24,
      "name": "Djeballah Khemissi"
    },
    "id": 868,
    "commune_name_ascii": "Djeballah Khemissi",
    "commune_name": "جبالة الخميسي",
    "daira_name_ascii": "Guelaat Bousbaa",
    "daira_name": "قلعة بوصبع",
    "wilaya_code": "24",
    "wilaya_name_ascii": "Guelma",
    "wilaya_name": "قالمة"
  },
  {
    "pk": 873  ,"fields": { "postcode": 24021,  "wilaya":   24, "name": "Bordj Sabat" },
    "id": 861,
    "commune_name_ascii": "Bordj Sabath",
    "commune_name": "برج صباط",
    "daira_name_ascii": "Oued Zenati",
    "daira_name": "وادي الزناتي",
    "wilaya_code": "24",
    "wilaya_name_ascii": "Guelma",
    "wilaya_name": "قالمة"
  },
  {
    "model": "base.commune",
    "pk": 856,
    "fields": {
      "postcode": 24004,
      "wilaya": 24,
      "name": "Oued Zenati"
    },
    "id": 882,
    "commune_name_ascii": "Oued Zenati",
    "commune_name": "وادي الزناتي",
    "daira_name_ascii": "Oued Zenati",
    "daira_name": "وادي الزناتي",
    "wilaya_code": "24",
    "wilaya_name_ascii": "Guelma",
    "wilaya_name": "قالمة"
  },
  {
    "pk": 884  ,"fields": { "postcode": 24032,  "wilaya":   24, "name": "Ain Reggada" },
    "id": 856,
    "commune_name_ascii": "Ain Regada",
    "commune_name": "عين رقادة",
    "daira_name_ascii": "Oued Zenati",
    "daira_name": "وادي الزناتي",
    "wilaya_code": "24",
    "wilaya_name_ascii": "Guelma",
    "wilaya_name": "قالمة"
  },
  {
    "model": "base.commune",
    "pk": 875,
    "fields": {
      "postcode": 24023,
      "wilaya": 24,
      "name": "Ain Larbi"
    },
    "id": 854,
    "commune_name_ascii": "Ain Larbi",
    "commune_name": "عين العربي",
    "daira_name_ascii": "Ain Makhlouf",
    "daira_name": "عين مخلوف",
    "wilaya_code": "24",
    "wilaya_name_ascii": "Guelma",
    "wilaya_name": "قالمة"
  },
  {
    "model": "base.commune",
    "pk": 865,
    "fields": {
      "postcode": 24013,
      "wilaya": 24,
      "name": "Ain Makhlouf"
    },
    "id": 855,
    "commune_name_ascii": "Ain Makhlouf",
    "commune_name": "عين مخلوف",
    "daira_name_ascii": "Ain Makhlouf",
    "daira_name": "عين مخلوف",
    "wilaya_code": "24",
    "wilaya_name_ascii": "Guelma",
    "wilaya_name": "قالمة"
  },
  {
    "model": "base.commune",
    "pk": 857,
    "fields": {
      "postcode": 24005,
      "wilaya": 24,
      "name": "Tamlouka"
    },
    "id": 886,
    "commune_name_ascii": "Tamlouka",
    "commune_name": "تاملوكة",
    "daira_name_ascii": "Ain Makhlouf",
    "daira_name": "عين مخلوف",
    "wilaya_code": "24",
    "wilaya_name_ascii": "Guelma",
    "wilaya_name": "قالمة"
  },
  {
    "model": "base.commune",
    "pk": 859,
    "fields": {
      "postcode": 24007,
      "wilaya": 24,
      "name": "Ain Sandel"
    },
    "id": 857,
    "commune_name_ascii": "Ain Sandel",
    "commune_name": "عين صندل",
    "daira_name_ascii": "Khezaras",
    "daira_name": "خزارة",
    "wilaya_code": "24",
    "wilaya_name_ascii": "Guelma",
    "wilaya_name": "قالمة"
  },
  {
    "model": "base.commune",
    "pk": 869,
    "fields": {
      "postcode": 24017,
      "wilaya": 24,
      "name": "Bou Hachana"
    },
    "id": 862,
    "commune_name_ascii": "Bou Hachana",
    "commune_name": "بوحشانة",
    "daira_name_ascii": "Khezaras",
    "daira_name": "خزارة",
    "wilaya_code": "24",
    "wilaya_name_ascii": "Guelma",
    "wilaya_name": "قالمة"
  },
  {
    "pk": 867  ,"fields": { "postcode": 24015,  "wilaya":   24, "name": "Khezara" },
    "id": 876,
    "commune_name_ascii": "Khezaras",
    "commune_name": "لخزارة",
    "daira_name_ascii": "Khezaras",
    "daira_name": "خزارة",
    "wilaya_code": "24",
    "wilaya_name_ascii": "Guelma",
    "wilaya_name": "قالمة"
  },
  {
    "pk": 862  ,"fields": { "postcode": 24010,  "wilaya":   24, "name": "Belkhir" },
    "id": 858,
    "commune_name_ascii": "Belkheir",
    "commune_name": "بلخير",
    "daira_name_ascii": "Guelaat Bousbaa",
    "daira_name": "قلعة بوصبع",
    "wilaya_code": "24",
    "wilaya_name_ascii": "Guelma",
    "wilaya_name": "قالمة"
  },
  {
    "model": "base.commune",
    "pk": 868,
    "fields": {
      "postcode": 24016,
      "wilaya": 24,
      "name": "Beni Mezline"
    },
    "id": 860,
    "commune_name_ascii": "Beni Mezline",
    "commune_name": "بني مزلين",
    "daira_name_ascii": "Guelaat Bousbaa",
    "daira_name": "قلعة بوصبع",
    "wilaya_code": "24",
    "wilaya_name_ascii": "Guelma",
    "wilaya_name": "قالمة"
  },
  {
    "model": "base.commune",
    "pk": 870,
    "fields": {
      "postcode": 24018,
      "wilaya": 24,
      "name": "Guelaat Bou Sbaa"
    },
    "id": 870,
    "commune_name_ascii": "Guelaat Bou Sbaa",
    "commune_name": "قلعة بوصبع",
    "daira_name_ascii": "Guelaat Bousbaa",
    "daira_name": "قلعة بوصبع",
    "wilaya_code": "24",
    "wilaya_name_ascii": "Guelma",
    "wilaya_name": "قالمة"
  },
  {
    "model": "base.commune",
    "pk": 885,
    "fields": {
      "postcode": 24033,
      "wilaya": 24,
      "name": "Oued Cheham"
    },
    "id": 880,
    "commune_name_ascii": "Oued Cheham",
    "commune_name": "وادي الشحم",
    "daira_name_ascii": "Hammam N'bails",
    "daira_name": "حمام النبايل",
    "wilaya_code": "24",
    "wilaya_name_ascii": "Guelma",
    "wilaya_name": "قالمة"
  },
  {
    "pk": 863  ,"fields": { "postcode": 24011,  "wilaya":   24, "name": "Ben Djarah" },
    "id": 859,
    "commune_name_ascii": "Bendjarah",
    "commune_name": "بن جراح",
    "daira_name_ascii": "Guelma",
    "daira_name": "قالمة",
    "wilaya_code": "24",
    "wilaya_name_ascii": "Guelma",
    "wilaya_name": "قالمة"
  },
  {
    "model": "base.commune",
    "pk": 891,
    "fields": {
      "postcode": 25005,
      "wilaya": 25,
      "name": "Didouche Mourad"
    },
    "id": 892,
    "commune_name_ascii": "Didouche Mourad",
    "commune_name": "ديدوش مراد",
    "daira_name_ascii": "Hamma Bouziane",
    "daira_name": "حامة بوزيان",
    "wilaya_code": "25",
    "wilaya_name_ascii": "Constantine",
    "wilaya_name": "قسنطينة"
  },
  {
    "model": "base.commune",
    "pk": 888,
    "fields": {
      "postcode": 25002,
      "wilaya": 25,
      "name": "Hamma Bouziane"
    },
    "id": 894,
    "commune_name_ascii": "Hamma Bouziane",
    "commune_name": "حامة بوزيان",
    "daira_name_ascii": "Hamma Bouziane",
    "daira_name": "حامة بوزيان",
    "wilaya_code": "25",
    "wilaya_name_ascii": "Constantine",
    "wilaya_name": "قسنطينة"
  },
  {
    "pk": 894  ,"fields": { "postcode": 25008,  "wilaya":   25, "name": "Beni Hamiden" },
    "id": 890,
    "commune_name_ascii": "Beni Hamidane",
    "commune_name": "بني حميدان",
    "daira_name_ascii": "Zighoud Youcef",
    "daira_name": "زيغود يوسف",
    "wilaya_code": "25",
    "wilaya_name_ascii": "Constantine",
    "wilaya_name": "قسنطينة"
  },
  {
    "model": "base.commune",
    "pk": 890,
    "fields": {
      "postcode": 25004,
      "wilaya": 25,
      "name": "Zighoud Youcef"
    },
    "id": 898,
    "commune_name_ascii": "Zighoud Youcef",
    "commune_name": "زيغود يوسف",
    "daira_name_ascii": "Zighoud Youcef",
    "daira_name": "زيغود يوسف",
    "wilaya_code": "25",
    "wilaya_name_ascii": "Constantine",
    "wilaya_name": "قسنطينة"
  },
  {
    "model": "base.commune",
    "pk": 896,
    "fields": {
      "postcode": 25010,
      "wilaya": 25,
      "name": "Ain Smara"
    },
    "id": 888,
    "commune_name_ascii": "Ain Smara",
    "commune_name": "عين السمارة",
    "daira_name_ascii": "El Khroub",
    "daira_name": "الخروب",
    "wilaya_code": "25",
    "wilaya_name_ascii": "Constantine",
    "wilaya_name": "قسنطينة"
  },
  {
    "model": "base.commune",
    "pk": 892,
    "fields": {
      "postcode": 25006,
      "wilaya": 25,
      "name": "El Khroub"
    },
    "id": 893,
    "commune_name_ascii": "El Khroub",
    "commune_name": "الخروب",
    "daira_name_ascii": "El Khroub",
    "daira_name": "الخروب",
    "wilaya_code": "25",
    "wilaya_name_ascii": "Constantine",
    "wilaya_name": "قسنطينة"
  },
  {
    "pk": 895  ,"fields": { "postcode": 25009,  "wilaya":   25, "name": "Ouled Rahmoune" },
    "id": 897,
    "commune_name_ascii": "Ouled Rahmoun",
    "commune_name": "أولاد رحمون",
    "daira_name_ascii": "El Khroub",
    "daira_name": "الخروب",
    "wilaya_code": "25",
    "wilaya_name_ascii": "Constantine",
    "wilaya_name": "قسنطينة"
  },
  {
    "model": "base.commune",
    "pk": 893,
    "fields": {
      "postcode": 25007,
      "wilaya": 25,
      "name": "Ain Abid"
    },
    "id": 887,
    "commune_name_ascii": "Ain Abid",
    "commune_name": "عين عبيد",
    "daira_name_ascii": "Ain Abid",
    "daira_name": "عين عبيد",
    "wilaya_code": "25",
    "wilaya_name_ascii": "Constantine",
    "wilaya_name": "قسنطينة"
  },
  {
    "model": "base.commune",
    "pk": 833,
    "fields": {
      "postcode": 22045,
      "wilaya": 22,
      "name": "Ben Badis"
    },
    "id": 889,
    "commune_name_ascii": "Ben Badis",
    "commune_name": "أبن باديس الهرية",
    "daira_name_ascii": "Ain Abid",
    "daira_name": "عين عبيد",
    "wilaya_code": "25",
    "wilaya_name_ascii": "Constantine",
    "wilaya_name": "قسنطينة"
  },
  {
    "model": "base.commune",
    "pk": 898,
    "fields": {
      "postcode": 25012,
      "wilaya": 25,
      "name": "Ibn Ziad"
    },
    "id": 895,
    "commune_name_ascii": "Ibn Ziad",
    "commune_name": "ابن زياد",
    "daira_name_ascii": "Ibn Ziad",
    "daira_name": "ابن زياد",
    "wilaya_code": "25",
    "wilaya_name_ascii": "Constantine",
    "wilaya_name": "قسنطينة"
  },
  {
    "pk": 897  ,"fields": { "postcode": 25011,  "wilaya":   25, "name": "Mesaoud Boudjeriou" },
    "id": 896,
    "commune_name_ascii": "Messaoud Boudjeriou",
    "commune_name": "بوجريو مسعود",
    "daira_name_ascii": "Ibn Ziad",
    "daira_name": "ابن زياد",
    "wilaya_code": "25",
    "wilaya_name_ascii": "Constantine",
    "wilaya_name": "قسنطينة"
  },
  {
    "model": "base.commune",
    "pk": 887,
    "fields": {
      "postcode": 25001,
      "wilaya": 25,
      "name": "Constantine"
    },
    "id": 891,
    "commune_name_ascii": "Constantine",
    "commune_name": "قسنطينة",
    "daira_name_ascii": "Constantine",
    "daira_name": "قسنطينة",
    "wilaya_code": "25",
    "wilaya_name_ascii": "Constantine",
    "wilaya_name": "قسنطينة"
  },
  {
    "model": "base.commune",
    "pk": 920,
    "fields": {
      "postcode": 26022,
      "wilaya": 26,
      "name": "Ouled Hellal"
    },
    "id": 943,
    "commune_name_ascii": "Ouled Hellal",
    "commune_name": "أولاد هلال",
    "daira_name_ascii": "Ouled Antar",
    "daira_name": "أولاد عنتر",
    "wilaya_code": "26",
    "wilaya_name_ascii": "Medea",
    "wilaya_name": "المدية"
  },
  {
    "model": "base.commune",
    "pk": 931,
    "fields": {
      "postcode": 26033,
      "wilaya": 26,
      "name": "Souagui"
    },
    "id": 956,
    "commune_name_ascii": "Souagui",
    "commune_name": "السواقي",
    "daira_name_ascii": "Souaghi",
    "daira_name": "السواقي",
    "wilaya_code": "26",
    "wilaya_name_ascii": "Medea",
    "wilaya_name": "المدية"
  },
  {
    "model": "base.commune",
    "pk": 933,
    "fields": {
      "postcode": 26035,
      "wilaya": 26,
      "name": "Ksar El Boukhari"
    },
    "id": 929,
    "commune_name_ascii": "Ksar El Boukhari",
    "commune_name": "قصر البخاري",
    "daira_name_ascii": "Ksar El Boukhari",
    "daira_name": "قصر البخاري",
    "wilaya_code": "26",
    "wilaya_name_ascii": "Medea",
    "wilaya_name": "المدية"
  },
  {
    "pk": 947  ,"fields": { "postcode": 26049,  "wilaya":   26, "name": "Meftaha" },
    "id": 934,
    "commune_name_ascii": "M'fatha",
    "commune_name": "مفاتحة",
    "daira_name_ascii": "Ksar El Boukhari",
    "daira_name": "قصر البخاري",
    "wilaya_code": "26",
    "wilaya_name_ascii": "Medea",
    "wilaya_name": "المدية"
  },
  {
    "model": "base.commune",
    "pk": 962,
    "fields": {
      "postcode": 26064,
      "wilaya": 26,
      "name": "Saneg"
    },
    "id": 947,
    "commune_name_ascii": "Saneg",
    "commune_name": "السانق",
    "daira_name_ascii": "Ksar El Boukhari",
    "daira_name": "قصر البخاري",
    "wilaya_code": "26",
    "wilaya_name_ascii": "Medea",
    "wilaya_name": "المدية"
  },
  {
    "model": "base.commune",
    "pk": 934,
    "fields": {
      "postcode": 26036,
      "wilaya": 26,
      "name": "El Azizia"
    },
    "id": 920,
    "commune_name_ascii": "El Azizia",
    "commune_name": "العزيزية",
    "daira_name_ascii": "El Azizia",
    "daira_name": "العزيزية",
    "wilaya_code": "26",
    "wilaya_name_ascii": "Medea",
    "wilaya_name": "المدية"
  },
  {
    "pk": 937  ,"fields": { "postcode": 26039,  "wilaya":   26, "name": "Meghraoua" },
    "id": 930,
    "commune_name_ascii": "Maghraoua",
    "commune_name": "مغراوة",
    "daira_name_ascii": "El Azizia",
    "daira_name": "العزيزية",
    "wilaya_code": "26",
    "wilaya_name_ascii": "Medea",
    "wilaya_name": "المدية"
  },
  {
    "model": "base.commune",
    "pk": 948,
    "fields": {
      "postcode": 26050,
      "wilaya": 26,
      "name": "Mihoub"
    },
    "id": 935,
    "commune_name_ascii": "Mihoub",
    "commune_name": "ميهوب",
    "daira_name_ascii": "El Azizia",
    "daira_name": "العزيزية",
    "wilaya_code": "26",
    "wilaya_name_ascii": "Medea",
    "wilaya_name": "المدية"
  },
  {
    "model": "base.commune",
    "pk": 908,
    "fields": {
      "postcode": 26010,
      "wilaya": 26,
      "name": "Bouaiche"
    },
    "id": 909,
    "commune_name_ascii": "Bouaiche",
    "commune_name": "بوعيش",
    "daira_name_ascii": "Chahbounia",
    "daira_name": "الشهبونية",
    "wilaya_code": "26",
    "wilaya_name_ascii": "Medea",
    "wilaya_name": "المدية"
  },
  {
    "pk": 949  ,"fields": { "postcode": 26051,  "wilaya":   26, "name": "Boughezoul" },
    "id": 912,
    "commune_name_ascii": "Boughzoul",
    "commune_name": "بوغزول",
    "daira_name_ascii": "Chahbounia",
    "daira_name": "الشهبونية",
    "wilaya_code": "26",
    "wilaya_name_ascii": "Medea",
    "wilaya_name": "المدية"
  },
  {
    "pk": 936  ,"fields": { "postcode": 26038,  "wilaya":   26, "name": "Chahbounia" },
    "id": 914,
    "commune_name_ascii": "Chabounia",
    "commune_name": "الشهبونية",
    "daira_name_ascii": "Chahbounia",
    "daira_name": "الشهبونية",
    "wilaya_code": "26",
    "wilaya_name_ascii": "Medea",
    "wilaya_name": "المدية"
  },
  {
    "model": "base.commune",
    "pk": 958,
    "fields": {
      "postcode": 26060,
      "wilaya": 26,
      "name": "Hannacha"
    },
    "id": 926,
    "commune_name_ascii": "Hannacha",
    "commune_name": "حناشة",
    "daira_name_ascii": "Ouamri",
    "daira_name": "عوامري",
    "wilaya_code": "26",
    "wilaya_name_ascii": "Medea",
    "wilaya_name": "المدية"
  },
  {
    "model": "base.commune",
    "pk": 941,
    "fields": {
      "postcode": 26043,
      "wilaya": 26,
      "name": "Ouamri"
    },
    "id": 936,
    "commune_name_ascii": "Ouamri",
    "commune_name": "عوامري",
    "daira_name_ascii": "Ouamri",
    "daira_name": "عوامري",
    "wilaya_code": "26",
    "wilaya_name_ascii": "Medea",
    "wilaya_name": "المدية"
  },
  {
    "model": "base.commune",
    "pk": 927,
    "fields": {
      "postcode": 26029,
      "wilaya": 26,
      "name": "Oued Harbil"
    },
    "id": 937,
    "commune_name_ascii": "Oued Harbil",
    "commune_name": "وادي حربيل",
    "daira_name_ascii": "Ouamri",
    "daira_name": "عوامري",
    "wilaya_code": "26",
    "wilaya_name_ascii": "Medea",
    "wilaya_name": "المدية"
  },
  {
    "model": "base.commune",
    "pk": 944,
    "fields": {
      "postcode": 26046,
      "wilaya": 26,
      "name": "Beni Slimane"
    },
    "id": 905,
    "commune_name_ascii": "Beni Slimane",
    "commune_name": "بني سليمان",
    "daira_name_ascii": "Beni Slimane",
    "daira_name": "بني سليمان",
    "wilaya_code": "26",
    "wilaya_name_ascii": "Medea",
    "wilaya_name": "المدية"
  },
  {
    "model": "base.commune",
    "pk": 957,
    "fields": {
      "postcode": 26059,
      "wilaya": 26,
      "name": "Bouaichoune"
    },
    "id": 910,
    "commune_name_ascii": "Bouaichoune",
    "commune_name": "بوعيشون",
    "daira_name_ascii": "Si Mahdjoub",
    "daira_name": "سي المحجوب",
    "wilaya_code": "26",
    "wilaya_name_ascii": "Medea",
    "wilaya_name": "المدية"
  },
  {
    "model": "base.commune",
    "pk": 925,
    "fields": {
      "postcode": 26027,
      "wilaya": 26,
      "name": "Ouled Bouachra"
    },
    "id": 939,
    "commune_name_ascii": "Ouled Bouachra",
    "commune_name": "أولاد بوعشرة",
    "daira_name_ascii": "Si Mahdjoub",
    "daira_name": "سي المحجوب",
    "wilaya_code": "26",
    "wilaya_name_ascii": "Medea",
    "wilaya_name": "المدية"
  },
  {
    "model": "base.commune",
    "pk": 942,
    "fields": {
      "postcode": 26044,
      "wilaya": 26,
      "name": "Si Mahdjoub"
    },
    "id": 950,
    "commune_name_ascii": "Si Mahdjoub",
    "commune_name": "سي المحجوب",
    "daira_name_ascii": "Si Mahdjoub",
    "daira_name": "سي المحجوب",
    "wilaya_code": "26",
    "wilaya_name_ascii": "Medea",
    "wilaya_name": "المدية"
  },
  {
    "model": "base.commune",
    "pk": 917,
    "fields": {
      "postcode": 26019,
      "wilaya": 26,
      "name": "Bouskene"
    },
    "id": 913,
    "commune_name_ascii": "Bouskene",
    "commune_name": "بوسكن",
    "daira_name_ascii": "Beni Slimane",
    "daira_name": "بني سليمان",
    "wilaya_code": "26",
    "wilaya_name_ascii": "Medea",
    "wilaya_name": "المدية"
  },
  {
    "pk": 953  ,"fields": { "postcode": 26055,  "wilaya":   26, "name": "Sidi Errabia" },
    "id": 953,
    "commune_name_ascii": "Sidi Rabie",
    "commune_name": "سيدي الربيع",
    "daira_name_ascii": "Beni Slimane",
    "daira_name": "بني سليمان",
    "wilaya_code": "26",
    "wilaya_name_ascii": "Medea",
    "wilaya_name": "المدية"
  },
  {
    "model": "base.commune",
    "pk": 945,
    "fields": {
      "postcode": 26047,
      "wilaya": 26,
      "name": "Berrouaghia"
    },
    "id": 906,
    "commune_name_ascii": "Berrouaghia",
    "commune_name": "البرواقية",
    "daira_name_ascii": "Berrouaghia",
    "daira_name": "البرواقية",
    "wilaya_code": "26",
    "wilaya_name_ascii": "Medea",
    "wilaya_name": "المدية"
  },
  {
    "pk": 904  ,"fields": { "postcode": 26006,  "wilaya":   26, "name": "Ouled Deide" },
    "id": 941,
    "commune_name_ascii": "Ouled Deid",
    "commune_name": "أولاد دايد",
    "daira_name_ascii": "Berrouaghia",
    "daira_name": "البرواقية",
    "wilaya_code": "26",
    "wilaya_name_ascii": "Medea",
    "wilaya_name": "المدية"
  },
  {
    "model": "base.commune",
    "pk": 918,
    "fields": {
      "postcode": 26020,
      "wilaya": 26,
      "name": "Rebaia"
    },
    "id": 946,
    "commune_name_ascii": "Rebaia",
    "commune_name": "الربعية",
    "daira_name_ascii": "Berrouaghia",
    "daira_name": "البرواقية",
    "wilaya_code": "26",
    "wilaya_name_ascii": "Medea",
    "wilaya_name": "المدية"
  },
  {
    "model": "base.commune",
    "pk": 960,
    "fields": {
      "postcode": 26062,
      "wilaya": 26,
      "name": "Medjebar"
    },
    "id": 932,
    "commune_name_ascii": "Medjebar",
    "commune_name": "مجبر",
    "daira_name_ascii": "Seghouane",
    "daira_name": "سغوان",
    "wilaya_code": "26",
    "wilaya_name_ascii": "Medea",
    "wilaya_name": "المدية"
  },
  {
    "pk": 943  ,"fields": { "postcode": 26045,  "wilaya":   26, "name": "Tlatet Eddoair" },
    "id": 961,
    "commune_name_ascii": "Tletat Ed Douair",
    "commune_name": "ثلاث دوائر",
    "daira_name_ascii": "Seghouane",
    "daira_name": "سغوان",
    "wilaya_code": "26",
    "wilaya_name_ascii": "Medea",
    "wilaya_name": "المدية"
  },
  {
    "model": "base.commune",
    "pk": 932,
    "fields": {
      "postcode": 26034,
      "wilaya": 26,
      "name": "Zoubiria"
    },
    "id": 962,
    "commune_name_ascii": "Zoubiria",
    "commune_name": "الزبيرية",
    "daira_name_ascii": "Seghouane",
    "daira_name": "سغوان",
    "wilaya_code": "26",
    "wilaya_name_ascii": "Medea",
    "wilaya_name": "المدية"
  },
  {
    "model": "base.commune",
    "pk": 903,
    "fields": {
      "postcode": 26005,
      "wilaya": 26,
      "name": "Aissaouia"
    },
    "id": 901,
    "commune_name_ascii": "Aissaouia",
    "commune_name": "العيساوية",
    "daira_name_ascii": "Tablat",
    "daira_name": "تابلاط",
    "wilaya_code": "26",
    "wilaya_name_ascii": "Medea",
    "wilaya_name": "المدية"
  },
  {
    /*                                                                             */
    "id": 923,
    "commune_name_ascii": "El Haoudane",
    "commune_name": "الحوضان",
    "daira_name_ascii": "Tablat",
    "daira_name": "تابلاط",
    "wilaya_code": "26",
    "wilaya_name_ascii": "Medea",
    "wilaya_name": "المدية"
  },
  {
    "pk": 909  ,"fields": { "postcode": 26011,  "wilaya":   26, "name": "Mezerena" },
    "id": 933,
    "commune_name_ascii": "Mezerana",
    "commune_name": "مزغنة",
    "daira_name_ascii": "Tablat",
    "daira_name": "تابلاط",
    "wilaya_code": "26",
    "wilaya_name_ascii": "Medea",
    "wilaya_name": "المدية"
  },
  {
    "model": "base.commune",
    "pk": 950,
    "fields": {
      "postcode": 26052,
      "wilaya": 26,
      "name": "Tablat"
    },
    "id": 957,
    "commune_name_ascii": "Tablat",
    "commune_name": "تابلاط",
    "daira_name_ascii": "Tablat",
    "daira_name": "تابلاط",
    "wilaya_code": "26",
    "wilaya_name_ascii": "Medea",
    "wilaya_name": "المدية"
  },
  {
    "model": "base.commune",
    "pk": 923,
    "fields": {
      "postcode": 26025,
      "wilaya": 26,
      "name": "Boghar"
    },
    "id": 908,
    "commune_name_ascii": "Boghar",
    "commune_name": "بوغار",
    "daira_name_ascii": "Ouled Antar",
    "daira_name": "أولاد عنتر",
    "wilaya_code": "26",
    "wilaya_name_ascii": "Medea",
    "wilaya_name": "المدية"
  },
  {
    "model": "base.commune",
    "pk": 946,
    "fields": {
      "postcode": 26048,
      "wilaya": 26,
      "name": "Seghouane"
    },
    "id": 949,
    "commune_name_ascii": "Seghouane",
    "commune_name": "سغوان",
    "daira_name_ascii": "Seghouane",
    "daira_name": "سغوان",
    "wilaya_code": "26",
    "wilaya_name_ascii": "Medea",
    "wilaya_name": "المدية"
  },
  {
    "pk": 952  ,"fields": { "postcode": 26054,  "wilaya":   26, "name": "Draa Essamar" },
    "id": 919,
    "commune_name_ascii": "Draa Esmar",
    "commune_name": "ذراع السمار",
    "daira_name_ascii": "Medea",
    "daira_name": "المدية",
    "wilaya_code": "26",
    "wilaya_name_ascii": "Medea",
    "wilaya_name": "المدية"
  },
  {
    "model": "base.commune",
    "pk": 899,
    "fields": {
      "postcode": 26001,
      "wilaya": 26,
      "name": "Medea"
    },
    "id": 931,
    "commune_name_ascii": "Medea",
    "commune_name": "المدية",
    "daira_name_ascii": "Medea",
    "daira_name": "المدية",
    "wilaya_code": "26",
    "wilaya_name_ascii": "Medea",
    "wilaya_name": "المدية"
  },
  {
    "model": "base.commune",
    "pk": 913,
    "fields": {
      "postcode": 26015,
      "wilaya": 26,
      "name": "Tamesguida"
    },
    "id": 959,
    "commune_name_ascii": "Tamesguida",
    "commune_name": "تمسقيدة",
    "daira_name_ascii": "Medea",
    "daira_name": "المدية",
    "wilaya_code": "26",
    "wilaya_name_ascii": "Medea",
    "wilaya_name": "المدية"
  },
  {
    "pk": 928  ,"fields": { "postcode": 26030,  "wilaya":   26, "name": "Benchicao" },
    "id": 904,
    "commune_name_ascii": "Ben Chicao",
    "commune_name": "بن شكاو",
    "daira_name_ascii": "Ouzera",
    "daira_name": "وزرة",
    "wilaya_code": "26",
    "wilaya_name_ascii": "Medea",
    "wilaya_name": "المدية"
  },
  {
    "model": "base.commune",
    "pk": 914,
    "fields": {
      "postcode": 26016,
      "wilaya": 26,
      "name": "El Hamdania"
    },
    "id": 922,
    "commune_name_ascii": "El Hamdania",
    "commune_name": "الحمدانية",
    "daira_name_ascii": "Ouzera",
    "daira_name": "وزرة",
    "wilaya_code": "26",
    "wilaya_name_ascii": "Medea",
    "wilaya_name": "المدية"
  },
  {
    "model": "base.commune",
    "pk": 900,
    "fields": {
      "postcode": 26002,
      "wilaya": 26,
      "name": "Ouzera"
    },
    "id": 945,
    "commune_name_ascii": "Ouzera",
    "commune_name": "وزرة",
    "daira_name_ascii": "Ouzera",
    "daira_name": "وزرة",
    "wilaya_code": "26",
    "wilaya_name_ascii": "Medea",
    "wilaya_name": "المدية"
  },
  {
    "id": 960,
    "commune_name_ascii": "Tizi Mahdi",
    "commune_name": "تيزي مهدي",
    "daira_name_ascii": "Ouzera",
    "daira_name": "وزرة",
    "wilaya_code": "26",
    "wilaya_name_ascii": "Medea",
    "wilaya_name": "المدية"
  },
  {
    "model": "base.commune",
    "pk": 902,
    "fields": {
      "postcode": 26004,
      "wilaya": 26,
      "name": "Ain Boucif"
    },
    "id": 899,
    "commune_name_ascii": "Ain Boucif",
    "commune_name": "عين بوسيف",
    "daira_name_ascii": "Ain Boucif",
    "daira_name": "عين بوسيف",
    "wilaya_code": "26",
    "wilaya_name_ascii": "Medea",
    "wilaya_name": "المدية"
  },
  {
    "model": "base.commune",
    "pk": 955,
    "fields": {
      "postcode": 26057,
      "wilaya": 26,
      "name": "El Ouinet"
    },
    "id": 925,
    "commune_name_ascii": "El Ouinet",
    "commune_name": "العوينات",
    "daira_name_ascii": "Ain Boucif",
    "daira_name": "عين بوسيف",
    "wilaya_code": "26",
    "wilaya_name_ascii": "Medea",
    "wilaya_name": "المدية"
  },
  {
    "model": "base.commune",
    "pk": 915,
    "fields": {
      "postcode": 26017,
      "wilaya": 26,
      "name": "Kef Lakhdar"
    },
    "id": 927,
    "commune_name_ascii": "Kef Lakhdar",
    "commune_name": "الكاف الاخضر",
    "daira_name_ascii": "Ain Boucif",
    "daira_name": "عين بوسيف",
    "wilaya_code": "26",
    "wilaya_name_ascii": "Medea",
    "wilaya_name": "المدية"
  },
  {
    "pk": 901  ,"fields": { "postcode": 26003,  "wilaya":   26, "name": "Ouled Maaref" },
    "id": 942,
    "commune_name_ascii": "Ouled Emaaraf",
    "commune_name": "أولاد امعرف",
    "daira_name_ascii": "Ain Boucif",
    "daira_name": "عين بوسيف",
    "wilaya_code": "26",
    "wilaya_name_ascii": "Medea",
    "wilaya_name": "المدية"
  },
  {
    "pk": 929  ,"fields": { "postcode": 26031,  "wilaya":   26, "name": "Sidi Damed" },
    "id": 951,
    "commune_name_ascii": "Sidi Demed",
    "commune_name": "سيدي دامد",
    "daira_name_ascii": "Ain Boucif",
    "daira_name": "عين بوسيف",
    "wilaya_code": "26",
    "wilaya_name_ascii": "Medea",
    "wilaya_name": "المدية"
  },
  {
    "model": "base.commune",
    "pk": 922,
    "fields": {
      "postcode": 26024,
      "wilaya": 26,
      "name": "Baata"
    },
    "id": 903,
    "commune_name_ascii": "Baata",
    "commune_name": "بعطة",
    "daira_name_ascii": "El Omaria",
    "daira_name": "العمارية",
    "wilaya_code": "26",
    "wilaya_name_ascii": "Medea",
    "wilaya_name": "المدية"
  },
  {
    "model": "base.commune",
    "pk": 905,
    "fields": {
      "postcode": 26007,
      "wilaya": 26,
      "name": "El Omaria"
    },
    "id": 924,
    "commune_name_ascii": "El Omaria",
    "commune_name": "العمارية",
    "daira_name_ascii": "El Omaria",
    "daira_name": "العمارية",
    "wilaya_code": "26",
    "wilaya_name_ascii": "Medea",
    "wilaya_name": "المدية"
  },
  {
    "model": "base.commune",
    "pk": 748,
    "fields": {
      "postcode": 20014,
      "wilaya": 20,
      "name": "Ouled Brahim"
    },
    "id": 940,
    "commune_name_ascii": "Ouled Brahim",
    "commune_name": "أولاد إبراهيم",
    "daira_name_ascii": "El Omaria",
    "daira_name": "العمارية",
    "wilaya_code": "26",
    "wilaya_name_ascii": "Medea",
    "wilaya_name": "المدية"
  },
  {
    "model": "base.commune",
    "pk": 954,
    "fields": {
      "postcode": 26056,
      "wilaya": 26,
      "name": "Bir Ben Laabed"
    },
    "id": 907,
    "commune_name_ascii": "Bir Ben Laabed",
    "commune_name": "بئر بن عابد",
    "daira_name_ascii": "Guelb El Kebir",
    "daira_name": "القلب الكبير",
    "wilaya_code": "26",
    "wilaya_name_ascii": "Medea",
    "wilaya_name": "المدية"
  },
  {
    "model": "base.commune",
    "pk": 907,
    "fields": {
      "postcode": 26009,
      "wilaya": 26,
      "name": "El Guelbelkebir"
    },
    "id": 921,
    "commune_name_ascii": "El Guelbelkebir",
    "commune_name": "القلب الكبير",
    "daira_name_ascii": "Guelb El Kebir",
    "daira_name": "القلب الكبير",
    "wilaya_code": "26",
    "wilaya_name_ascii": "Medea",
    "wilaya_name": "المدية"
  },
  {
    "pk": 959  ,"fields": { "postcode": 26061,  "wilaya":   26, "name": "Sedraia" },
    "id": 948,
    "commune_name_ascii": "Sedraya",
    "commune_name": "سدراية",
    "daira_name_ascii": "Guelb El Kebir",
    "daira_name": "القلب الكبير",
    "wilaya_code": "26",
    "wilaya_name_ascii": "Medea",
    "wilaya_name": "المدية"
  },
  {
    "model": "base.commune",
    "pk": 939,
    "fields": {
      "postcode": 26041,
      "wilaya": 26,
      "name": "Ain Ouksir"
    },
    "id": 900,
    "commune_name_ascii": "Ain Ouksir",
    "commune_name": "عين اقصير",
    "daira_name_ascii": "Chellalat El Adhaoura",
    "daira_name": "شلالة العذاورة",
    "wilaya_code": "26",
    "wilaya_name_ascii": "Medea",
    "wilaya_name": "المدية"
  },
  {
    "model": "base.commune",
    "pk": 916,
    "fields": {
      "postcode": 26018,
      "wilaya": 26,
      "name": "Chelalet El Adhaoura"
    },
    "id": 915,
    "commune_name_ascii": "Chelalet El Adhaoura",
    "commune_name": "شلالة العذاورة",
    "daira_name_ascii": "Chellalat El Adhaoura",
    "daira_name": "شلالة العذاورة",
    "wilaya_code": "26",
    "wilaya_name_ascii": "Medea",
    "wilaya_name": "المدية"
  },
  {
    "model": "base.commune",
    "pk": 938,
    "fields": {
      "postcode": 26040,
      "wilaya": 26,
      "name": "Cheniguel"
    },
    "id": 916,
    "commune_name_ascii": "Cheniguel",
    "commune_name": "شنيقل",
    "daira_name_ascii": "Chellalat El Adhaoura",
    "daira_name": "شلالة العذاورة",
    "wilaya_code": "26",
    "wilaya_name_ascii": "Medea",
    "wilaya_name": "المدية"
  },
  {
    "model": "base.commune",
    "pk": 921,
    "fields": {
      "postcode": 26023,
      "wilaya": 26,
      "name": "Tafraout"
    },
    "id": 958,
    "commune_name_ascii": "Tafraout",
    "commune_name": "تفراوت",
    "daira_name_ascii": "Chellalat El Adhaoura",
    "daira_name": "شلالة العذاورة",
    "wilaya_code": "26",
    "wilaya_name_ascii": "Medea",
    "wilaya_name": "المدية"
  },
  {
    "model": "base.commune",
    "pk": 919,
    "fields": {
      "postcode": 26021,
      "wilaya": 26,
      "name": "Bouchrahil"
    },
    "id": 911,
    "commune_name_ascii": "Bouchrahil",
    "commune_name": "بوشراحيل",
    "daira_name_ascii": "Sidi Naamane",
    "daira_name": "سيدي نعمان",
    "wilaya_code": "26",
    "wilaya_name_ascii": "Medea",
    "wilaya_name": "المدية"
  },
  {
    "model": "base.commune",
    "pk": 961,
    "fields": {
      "postcode": 26063,
      "wilaya": 26,
      "name": "Khams Djouamaa"
    },
    "id": 928,
    "commune_name_ascii": "Khams Djouamaa",
    "commune_name": "خمس جوامع",
    "daira_name_ascii": "Sidi Naamane",
    "daira_name": "سيدي نعمان",
    "wilaya_code": "26",
    "wilaya_name_ascii": "Medea",
    "wilaya_name": "المدية"
  },
  {
    "model": "base.commune",
    "pk": 545,
    "fields": {
      "postcode": 15059,
      "wilaya": 15,
      "name": "Sidi Naamane"
    },
    "id": 952,
    "commune_name_ascii": "Sidi Naamane",
    "commune_name": "سيدي نعمان",
    "daira_name_ascii": "Sidi Naamane",
    "daira_name": "سيدي نعمان",
    "wilaya_code": "26",
    "wilaya_name_ascii": "Medea",
    "wilaya_name": "المدية"
  },
  {
    "model": "base.commune",
    "pk": 930,
    "fields": {
      "postcode": 26032,
      "wilaya": 26,
      "name": "Aziz"
    },
    "id": 902,
    "commune_name_ascii": "Aziz",
    "commune_name": "عزيز",
    "daira_name_ascii": "Aziz",
    "daira_name": "عزيز",
    "wilaya_code": "26",
    "wilaya_name_ascii": "Medea",
    "wilaya_name": "المدية"
  },
  {
    "model": "base.commune",
    "pk": 906,
    "fields": {
      "postcode": 26008,
      "wilaya": 26,
      "name": "Derrag"
    },
    "id": 917,
    "commune_name_ascii": "Derrag",
    "commune_name": "دراق",
    "daira_name_ascii": "Aziz",
    "daira_name": "عزيز",
    "wilaya_code": "26",
    "wilaya_name_ascii": "Medea",
    "wilaya_name": "المدية"
  },
  {
    "pk": 940  ,"fields": { "postcode": 26042,  "wilaya":   26, "name": "Oum El Djalil" },
    "id": 944,
    "commune_name_ascii": "Oum El Djellil",
    "commune_name": "أم الجليل",
    "daira_name_ascii": "Aziz",
    "daira_name": "عزيز",
    "wilaya_code": "26",
    "wilaya_name_ascii": "Medea",
    "wilaya_name": "المدية"
  },
  {
    "model": "base.commune",
    "pk": 935,
    "fields": {
      "postcode": 26037,
      "wilaya": 26,
      "name": "Djouab"
    },
    "id": 918,
    "commune_name_ascii": "Djouab",
    "commune_name": "جواب",
    "daira_name_ascii": "Souaghi",
    "daira_name": "السواقي",
    "wilaya_code": "26",
    "wilaya_name_ascii": "Medea",
    "wilaya_name": "المدية"
  },
  {
    "model": "base.commune",
    "pk": 926,
    "fields": {
      "postcode": 26028,
      "wilaya": 26,
      "name": "Sidi Zahar"
    },
    "id": 954,
    "commune_name_ascii": "Sidi Zahar",
    "commune_name": "سيدي زهار",
    "daira_name_ascii": "Souaghi",
    "daira_name": "السواقي",
    "wilaya_code": "26",
    "wilaya_name_ascii": "Medea",
    "wilaya_name": "المدية"
  },
  {
    "model": "base.commune",
    "pk": 912,
    "fields": {
      "postcode": 26014,
      "wilaya": 26,
      "name": "Sidi Ziane"
    },
    "id": 955,
    "commune_name_ascii": "Sidi Ziane",
    "commune_name": "سيدي زيان",
    "daira_name_ascii": "Souaghi",
    "daira_name": "السواقي",
    "wilaya_code": "26",
    "wilaya_name_ascii": "Medea",
    "wilaya_name": "المدية"
  },
  {
    "model": "base.commune",
    "pk": 956,
    "fields": {
      "postcode": 26058,
      "wilaya": 26,
      "name": "Ouled Antar"
    },
    "id": 938,
    "commune_name_ascii": "Ouled Antar",
    "commune_name": "أولاد عنتر",
    "daira_name_ascii": "Ouled Antar",
    "daira_name": "أولاد عنتر",
    "wilaya_code": "26",
    "wilaya_name_ascii": "Medea",
    "wilaya_name": "المدية"
  },
  {
    "model": "base.commune",
    "pk": 965,
    "fields": {
      "postcode": 27003,
      "wilaya": 27,
      "name": "Fornaka"
    },
    "id": 970,
    "commune_name_ascii": "Fornaka",
    "commune_name": "فرناقة",
    "daira_name_ascii": "Ain Nouicy",
    "daira_name": "عين نويسي",
    "wilaya_code": "27",
    "wilaya_name_ascii": "Mostaganem",
    "wilaya_name": "مستغانم"
  },
  {
    "model": "base.commune",
    "pk": 971,
    "fields": {
      "postcode": 27009,
      "wilaya": 27,
      "name": "Oued El Kheir"
    },
    "id": 981,
    "commune_name_ascii": "Oued El Kheir",
    "commune_name": "وادي الخير",
    "daira_name_ascii": "Ain Tedeles",
    "daira_name": "عين تادلس",
    "wilaya_code": "27",
    "wilaya_name_ascii": "Mostaganem",
    "wilaya_name": "مستغانم"
  },
  {
    "pk": 994  ,"fields": { "postcode": 27032,  "wilaya":   27, "name": "El Hassiane" },
    "id": 973,
    "commune_name_ascii": "Hassiane",
    "commune_name": "الحسيان (بني ياحي",
    "daira_name_ascii": "Ain Nouicy",
    "daira_name": "عين نويسي",
    "wilaya_code": "27",
    "wilaya_name_ascii": "Mostaganem",
    "wilaya_name": "مستغانم"
  },
  {
    "pk": 968  ,"fields": { "postcode": 27006,  "wilaya":   27, "name": "Hassi Maameche" },
    "id": 972,
    "commune_name_ascii": "Hassi Mameche",
    "commune_name": "حاسي ماماش",
    "daira_name_ascii": "Hassi Mameche",
    "daira_name": "حاسي ماماش",
    "wilaya_code": "27",
    "wilaya_name_ascii": "Mostaganem",
    "wilaya_name": "مستغانم"
  },
  {
    "pk": 989  ,"fields": { "postcode": 27027,  "wilaya":   27, "name": "Mezghrane" },
    "id": 977,
    "commune_name_ascii": "Mazagran",
    "commune_name": "مزغران",
    "daira_name_ascii": "Hassi Mameche",
    "daira_name": "حاسي ماماش",
    "wilaya_code": "27",
    "wilaya_name_ascii": "Mostaganem",
    "wilaya_name": "مستغانم"
  },
  {
    "model": "base.commune",
    "pk": 966,
    "fields": {
      "postcode": 27004,
      "wilaya": 27,
      "name": "Stidia"
    },
    "id": 992,
    "commune_name_ascii": "Stidia",
    "commune_name": "ستيدية",
    "daira_name_ascii": "Hassi Mameche",
    "daira_name": "حاسي ماماش",
    "wilaya_code": "27",
    "wilaya_name_ascii": "Mostaganem",
    "wilaya_name": "مستغانم"
  },
  {
    "pk": 969  ,"fields": { "postcode": 27007,  "wilaya":   27, "name": "Ain Tadles" },
    "id": 967,
    "commune_name_ascii": "Ain Tedles",
    "commune_name": "عين تادلس",
    "daira_name_ascii": "Ain Tedeles",
    "daira_name": "عين تادلس",
    "wilaya_code": "27",
    "wilaya_name_ascii": "Mostaganem",
    "wilaya_name": "مستغانم"
  },
  {
    "pk": 972  ,"fields": { "postcode": 27010,  "wilaya":   27, "name": "Sidi Bellater" },
    "id": 987,
    "commune_name_ascii": "Sidi Belaattar",
    "commune_name": "سيدي بلعطار",
    "daira_name_ascii": "Ain Tedeles",
    "daira_name": "عين تادلس",
    "wilaya_code": "27",
    "wilaya_name_ascii": "Mostaganem",
    "wilaya_name": "مستغانم"
  },
  {
    "model": "base.commune",
    "pk": 970,
    "fields": {
      "postcode": 27008,
      "wilaya": 27,
      "name": "Sour"
    },
    "id": 991,
    "commune_name_ascii": "Sour",
    "commune_name": "سور",
    "daira_name_ascii": "Ain Tedeles",
    "daira_name": "عين تادلس",
    "wilaya_code": "27",
    "wilaya_name_ascii": "Mostaganem",
    "wilaya_name": "مستغانم"
  },
  {
    "pk": 990  ,"fields": { "postcode": 27028,  "wilaya":   27, "name": "Ain Boudinar" },
    "id": 964,
    "commune_name_ascii": "Ain Boudinar",
    "commune_name": "عين بودينار",
    "daira_name_ascii": "Kheir Eddine",
    "daira_name": "خير الدين",
    "wilaya_code": "27",
    "wilaya_name_ascii": "Mostaganem",
    "wilaya_name": "مستغانم"
  },
  {
    "pk": 973  ,"fields": { "postcode": 27011,  "wilaya":   27, "name": "Kheiredine " },
    "id": 975,
    "commune_name_ascii": "Kheir Eddine",
    "commune_name": "خير الدين",
    "daira_name_ascii": "Kheir Eddine",
    "daira_name": "خير الدين",
    "wilaya_code": "27",
    "wilaya_name_ascii": "Mostaganem",
    "wilaya_name": "مستغانم"
  },
  {
    "model": "base.commune",
    "pk": 964,
    "fields": {
      "postcode": 27002,
      "wilaya": 27,
      "name": "Sayada"
    },
    "id": 985,
    "commune_name_ascii": "Sayada",
    "commune_name": "صيادة",
    "daira_name_ascii": "Kheir Eddine",
    "daira_name": "خير الدين",
    "wilaya_code": "27",
    "wilaya_name_ascii": "Mostaganem",
    "wilaya_name": "مستغانم"
  },
  {
    "model": "base.commune",
    "pk": 974,
    "fields": {
      "postcode": 27012,
      "wilaya": 27,
      "name": "Sidi Ali"
    },
    "id": 986,
    "commune_name_ascii": "Sidi Ali",
    "commune_name": "سيدي علي",
    "daira_name_ascii": "Sidi Ali",
    "daira_name": "سيدي علي",
    "wilaya_code": "27",
    "wilaya_name_ascii": "Mostaganem",
    "wilaya_name": "مستغانم"
  },
  {
    "model": "base.commune",
    "pk": 991,
    "fields": {
      "postcode": 27029,
      "wilaya": 27,
      "name": "Tazgait"
    },
    "id": 993,
    "commune_name_ascii": "Tazgait",
    "commune_name": "تزقايت",
    "daira_name_ascii": "Sidi Ali",
    "daira_name": "سيدي علي",
    "wilaya_code": "27",
    "wilaya_name_ascii": "Mostaganem",
    "wilaya_name": "مستغانم"
  },
  {
    "pk": 975  ,"fields": { "postcode": 27013,  "wilaya":   27, "name": "Abdelmalek Ramdane" },
    "id": 968,
    "commune_name_ascii": "Benabdelmalek Ramdane",
    "commune_name": "بن عبد المالك رمضان",
    "daira_name_ascii": "Sidi Lakhdar",
    "daira_name": "سيدي لخضر",
    "wilaya_code": "27",
    "wilaya_name_ascii": "Mostaganem",
    "wilaya_name": "مستغانم"
  },
  {
    "model": "base.commune",
    "pk": 963,
    "fields": {
      "postcode": 27001,
      "wilaya": 27,
      "name": "Mostaganem"
    },
    "id": 979,
    "commune_name_ascii": "Mostaganem",
    "commune_name": "مستغانم",
    "daira_name_ascii": "Mostaganem",
    "daira_name": "مستغانم",
    "wilaya_code": "27",
    "wilaya_name_ascii": "Mostaganem",
    "wilaya_name": "مستغانم"
  },
  {
    "model": "base.commune",
    "pk": 976,
    "fields": {
      "postcode": 27014,
      "wilaya": 27,
      "name": "Hadjadj"
    },
    "id": 971,
    "commune_name_ascii": "Hadjadj",
    "commune_name": "حجاج",
    "daira_name_ascii": "Sidi Lakhdar",
    "daira_name": "سيدي لخضر",
    "wilaya_code": "27",
    "wilaya_name_ascii": "Mostaganem",
    "wilaya_name": "مستغانم"
  },
  {
    "pk": 978  ,"fields": { "postcode": 27016,  "wilaya":   27, "name": "Sidi Lakhdar" },
    "id": 988,
    "commune_name_ascii": "Sidi Lakhdar",
    "commune_name": "سيدي لخضر",
    "daira_name_ascii": "Sidi Lakhdar",
    "daira_name": "سيدي لخضر",
    "wilaya_code": "27",
    "wilaya_name_ascii": "Mostaganem",
    "wilaya_name": "مستغانم"
  },
  {
    "model": "base.commune",
    "pk": 979,
    "fields": {
      "postcode": 27017,
      "wilaya": 27,
      "name": "Achaacha"
    },
    "id": 963,
    "commune_name_ascii": "Achaacha",
    "commune_name": "عشعاشة",
    "daira_name_ascii": "Achaacha",
    "daira_name": "عشعاشة",
    "wilaya_code": "27",
    "wilaya_name_ascii": "Mostaganem",
    "wilaya_name": "مستغانم"
  },
  {
    "model": "base.commune",
    "pk": 980,
    "fields": {
      "postcode": 27018,
      "wilaya": 27,
      "name": "Khadra"
    },
    "id": 974,
    "commune_name_ascii": "Khadra",
    "commune_name": "خضرة",
    "daira_name_ascii": "Achaacha",
    "daira_name": "عشعاشة",
    "wilaya_code": "27",
    "wilaya_name_ascii": "Mostaganem",
    "wilaya_name": "مستغانم"
  },
  {
    "model": "base.commune",
    "pk": 977,
    "fields": {
      "postcode": 27015,
      "wilaya": 27,
      "name": "Nekmaria"
    },
    "id": 980,
    "commune_name_ascii": "Nekmaria",
    "commune_name": "نكمارية",
    "daira_name_ascii": "Achaacha",
    "daira_name": "عشعاشة",
    "wilaya_code": "27",
    "wilaya_name_ascii": "Mostaganem",
    "wilaya_name": "مستغانم"
  },
  {
    "model": "base.commune",
    "pk": 987,
    "fields": {
      "postcode": 27025,
      "wilaya": 27,
      "name": "Ouled Boughalem"
    },
    "id": 982,
    "commune_name_ascii": "Ouled Boughalem",
    "commune_name": "أولاد بوغالم",
    "daira_name_ascii": "Achaacha",
    "daira_name": "عشعاشة",
    "wilaya_code": "27",
    "wilaya_name_ascii": "Mostaganem",
    "wilaya_name": "مستغانم"
  },
  {
    "model": "base.commune",
    "pk": 981,
    "fields": {
      "postcode": 27019,
      "wilaya": 27,
      "name": "Bouguirat"
    },
    "id": 969,
    "commune_name_ascii": "Bouguirat",
    "commune_name": "بوقيراط",
    "daira_name_ascii": "Bouguirat",
    "daira_name": "بوقيراط",
    "wilaya_code": "27",
    "wilaya_name_ascii": "Mostaganem",
    "wilaya_name": "مستغانم"
  },
  {
    "model": "base.commune",
    "pk": 992,
    "fields": {
      "postcode": 27030,
      "wilaya": 27,
      "name": "Safsaf"
    },
    "id": 984,
    "commune_name_ascii": "Safsaf",
    "commune_name": "صفصاف",
    "daira_name_ascii": "Bouguirat",
    "daira_name": "بوقيراط",
    "wilaya_code": "27",
    "wilaya_name_ascii": "Mostaganem",
    "wilaya_name": "مستغانم"
  },
  {
    "model": "base.commune",
    "pk": 982,
    "fields": {
      "postcode": 27020,
      "wilaya": 27,
      "name": "Sirat"
    },
    "id": 989,
    "commune_name_ascii": "Sirat",
    "commune_name": "سيرات",
    "daira_name_ascii": "Bouguirat",
    "daira_name": "بوقيراط",
    "wilaya_code": "27",
    "wilaya_name_ascii": "Mostaganem",
    "wilaya_name": "مستغانم"
  },
  {
    "model": "base.commune",
    "pk": 986,
    "fields": {
      "postcode": 27024,
      "wilaya": 27,
      "name": "Souaflia"
    },
    "id": 990,
    "commune_name_ascii": "Souaflia",
    "commune_name": "السوافلية",
    "daira_name_ascii": "Bouguirat",
    "daira_name": "بوقيراط",
    "wilaya_code": "27",
    "wilaya_name_ascii": "Mostaganem",
    "wilaya_name": "مستغانم"
  },
  {
    "pk": 983  ,"fields": { "postcode": 27021,  "wilaya":   27, "name": "Ain Sidi Cherif" },
    "id": 966,
    "commune_name_ascii": "Ain Sidi Cherif",
    "commune_name": "عين سيدي الشريف",
    "daira_name_ascii": "Mesra",
    "daira_name": "ماسرة",
    "wilaya_code": "27",
    "wilaya_name_ascii": "Mostaganem",
    "wilaya_name": "مستغانم"
  },
  {
    "model": "base.commune",
    "pk": 442,
    "fields": {
      "postcode": 13051,
      "wilaya": 13,
      "name": "Mansourah"
    },
    "id": 976,
    "commune_name_ascii": "Mansourah",
    "commune_name": "منصورة",
    "daira_name_ascii": "Mesra",
    "daira_name": "ماسرة",
    "wilaya_code": "27",
    "wilaya_name_ascii": "Mostaganem",
    "wilaya_name": "مستغانم"
  },
  {
    "model": "base.commune",
    "pk": 984,
    "fields": {
      "postcode": 27022,
      "wilaya": 27,
      "name": "Mesra"
    },
    "id": 978,
    "commune_name_ascii": "Mesra",
    "commune_name": "ماسرة",
    "daira_name_ascii": "Mesra",
    "daira_name": "ماسرة",
    "wilaya_code": "27",
    "wilaya_name_ascii": "Mostaganem",
    "wilaya_name": "مستغانم"
  },
  {
    "model": "base.commune",
    "pk": 993,
    "fields": {
      "postcode": 27031,
      "wilaya": 27,
      "name": "Touahria"
    },
    "id": 994,
    "commune_name_ascii": "Touahria",
    "commune_name": "الطواهرية",
    "daira_name_ascii": "Mesra",
    "daira_name": "ماسرة",
    "wilaya_code": "27",
    "wilaya_name_ascii": "Mostaganem",
    "wilaya_name": "مستغانم"
  },
  {
    "pk": 967  ,"fields": { "postcode": 27005,  "wilaya":   27, "name": "Ain Nouissy" },
    "id": 965,
    "commune_name_ascii": "Ain Nouissy",
    "commune_name": "عين نويسي",
    "daira_name_ascii": "Ain Nouicy",
    "daira_name": "عين نويسي",
    "wilaya_code": "27",
    "wilaya_name_ascii": "Mostaganem",
    "wilaya_name": "مستغانم"
  },
  {
    "pk": 988  ,"fields": { "postcode": 27026,  "wilaya":   27, "name": "Ouled Maallah" },
    "id": 983,
    "commune_name_ascii": "Ouled Maalah",
    "commune_name": "أولاد مع الله",
    "daira_name_ascii": "Sidi Ali",
    "daira_name": "سيدي علي",
    "wilaya_code": "27",
    "wilaya_name_ascii": "Mostaganem",
    "wilaya_name": "مستغانم"
  },
  {
    "model": "base.commune",
    "pk": 1003,
    "fields": {
      "postcode": 28009,
      "wilaya": 28,
      "name": "Chellal"
    },
    "id": 1008,
    "commune_name_ascii": "Chellal",
    "commune_name": "شلال",
    "daira_name_ascii": "Chellal",
    "daira_name": "شلال",
    "wilaya_code": "28",
    "wilaya_name_ascii": "M'Sila",
    "wilaya_name": "المسيلة"
  },
  {
    "model": "base.commune",
    "pk": 1004,
    "fields": {
      "postcode": 28010,
      "wilaya": 28,
      "name": "Ouled Madhi"
    },
    "id": 1028,
    "commune_name_ascii": "Ouled Madhi",
    "commune_name": "أولاد ماضي",
    "daira_name_ascii": "Chellal",
    "daira_name": "شلال",
    "wilaya_code": "28",
    "wilaya_name_ascii": "M'Sila",
    "wilaya_name": "المسيلة"
  },
  {
    "pk": 1026  ,"fields": { "postcode": 28032,  "wilaya":   28, "name": "Khettouti Sed Djir" },
    "id": 1014,
    "commune_name_ascii": "Khettouti Sed El Jir",
    "commune_name": "خطوطي سد الجير",
    "daira_name_ascii": "Chellal",
    "daira_name": "شلال",
    "wilaya_code": "28",
    "wilaya_name_ascii": "M'Sila",
    "wilaya_name": "المسيلة"
  },
  {
    "model": "base.commune",
    "pk": 1009,
    "fields": {
      "postcode": 28015,
      "wilaya": 28,
      "name": "Belaiba"
    },
    "id": 1000,
    "commune_name_ascii": "Belaiba",
    "commune_name": "بلعايبة",
    "daira_name_ascii": "Magra",
    "daira_name": "مقرة",
    "wilaya_code": "28",
    "wilaya_name_ascii": "M'Sila",
    "wilaya_name": "المسيلة"
  },
  {
    "model": "base.commune",
    "pk": 1006,
    "fields": {
      "postcode": 28012,
      "wilaya": 28,
      "name": "Berhoum"
    },
    "id": 1004,
    "commune_name_ascii": "Berhoum",
    "commune_name": "برهوم",
    "daira_name_ascii": "Magra",
    "daira_name": "مقرة",
    "wilaya_code": "28",
    "wilaya_name_ascii": "M'Sila",
    "wilaya_name": "المسيلة"
  },
  {
    "model": "base.commune",
    "pk": 1024,
    "fields": {
      "postcode": 28030,
      "wilaya": 28,
      "name": "Dehahna"
    },
    "id": 1009,
    "commune_name_ascii": "Dehahna",
    "commune_name": "دهاهنة",
    "daira_name_ascii": "Magra",
    "daira_name": "مقرة",
    "wilaya_code": "28",
    "wilaya_name_ascii": "M'Sila",
    "wilaya_name": "المسيلة"
  },
  {
    "model": "base.commune",
    "pk": 1005,
    "fields": {
      "postcode": 28011,
      "wilaya": 28,
      "name": "Magra"
    },
    "id": 1018,
    "commune_name_ascii": "Magra",
    "commune_name": "مقرة",
    "daira_name_ascii": "Magra",
    "daira_name": "مقرة",
    "wilaya_code": "28",
    "wilaya_name_ascii": "M'Sila",
    "wilaya_name": "المسيلة"
  },
  {
    "model": "base.commune",
    "pk": 1039,
    "fields": {
      "postcode": 28045,
      "wilaya": 28,
      "name": "Beni Ilmane"
    },
    "id": 1002,
    "commune_name_ascii": "Beni Ilmane",
    "commune_name": "بني يلمان",
    "daira_name_ascii": "Sidi Aissa",
    "daira_name": "سيدي عيسى",
    "wilaya_code": "28",
    "wilaya_name_ascii": "M'Sila",
    "wilaya_name": "المسيلة"
  },
  {
    "pk": 1025  ,"fields": { "postcode": 28031,  "wilaya":   28, "name": "Bouti Sayah" },
    "id": 1007,
    "commune_name_ascii": "Bouti Sayeh",
    "commune_name": "بوطي السايح",
    "daira_name_ascii": "Sidi Aissa",
    "daira_name": "سيدي عيسى",
    "wilaya_code": "28",
    "wilaya_name_ascii": "M'Sila",
    "wilaya_name": "المسيلة"
  },
  {
    "model": "base.commune",
    "pk": 1010,
    "fields": {
      "postcode": 28016,
      "wilaya": 28,
      "name": "Sidi Aissa"
    },
    "id": 1033,
    "commune_name_ascii": "Sidi Aissa",
    "commune_name": "سيدي عيسى",
    "daira_name_ascii": "Sidi Aissa",
    "daira_name": "سيدي عيسى",
    "wilaya_code": "28",
    "wilaya_name_ascii": "M'Sila",
    "wilaya_name": "المسيلة"
  },
  {
    "model": "base.commune",
    "pk": 1011,
    "fields": {
      "postcode": 28017,
      "wilaya": 28,
      "name": "Ain El Hadjel"
    },
    "id": 995,
    "commune_name_ascii": "Ain El Hadjel",
    "commune_name": "عين الحجل",
    "daira_name_ascii": "Ain El Hadjel",
    "daira_name": "عين الحجل",
    "wilaya_code": "28",
    "wilaya_name_ascii": "M'Sila",
    "wilaya_name": "المسيلة"
  },
  {
    "model": "base.commune",
    "pk": 1012,
    "fields": {
      "postcode": 28018,
      "wilaya": 28,
      "name": "Sidi Hadjeres"
    },
    "id": 1035,
    "commune_name_ascii": "Sidi Hadjeres",
    "commune_name": "سيدي هجرس",
    "daira_name_ascii": "Ain El Hadjel",
    "daira_name": "عين الحجل",
    "wilaya_code": "28",
    "wilaya_name_ascii": "M'Sila",
    "wilaya_name": "المسيلة"
  },
  {
    "model": "base.commune",
    "pk": 1014,
    "fields": {
      "postcode": 28020,
      "wilaya": 28,
      "name": "Bou Saada"
    },
    "id": 1006,
    "commune_name_ascii": "Bou Saada",
    "commune_name": "بوسعادة",
    "daira_name_ascii": "Bousaada",
    "daira_name": "بوسعادة",
    "wilaya_code": "28",
    "wilaya_name_ascii": "M'Sila",
    "wilaya_name": "المسيلة"
  },
  {
    "model": "base.commune",
    "pk": 1021,
    "fields": {
      "postcode": 28027,
      "wilaya": 28,
      "name": "El Hamel"
    },
    "id": 1011,
    "commune_name_ascii": "El Hamel",
    "commune_name": "الهامل",
    "daira_name_ascii": "Bousaada",
    "daira_name": "بوسعادة",
    "wilaya_code": "28",
    "wilaya_name_ascii": "M'Sila",
    "wilaya_name": "المسيلة"
  },
  {
    "pk": 1040  ,"fields": { "postcode": 28046,  "wilaya":   28, "name": "Oultene" },
    "id": 1032,
    "commune_name_ascii": "Oulteme",
    "commune_name": "ولتام",
    "daira_name_ascii": "Bousaada",
    "daira_name": "بوسعادة",
    "wilaya_code": "28",
    "wilaya_name_ascii": "M'Sila",
    "wilaya_name": "المسيلة"
  },
  {
    "model": "base.commune",
    "pk": 1029,
    "fields": {
      "postcode": 28035,
      "wilaya": 28,
      "name": "Benzouh"
    },
    "id": 1003,
    "commune_name_ascii": "Benzouh",
    "commune_name": "بن زوه",
    "daira_name_ascii": "Ouled Sidi Brahim",
    "daira_name": "أولاد سيدي ابراهيم",
    "wilaya_code": "28",
    "wilaya_name_ascii": "M'Sila",
    "wilaya_name": "المسيلة"
  },
  {
    "model": "base.commune",
    "pk": 1015,
    "fields": {
      "postcode": 28021,
      "wilaya": 28,
      "name": "Ouled Sidi Brahim"
    },
    "id": 1030,
    "commune_name_ascii": "Ouled Sidi Brahim",
    "commune_name": "أولاد سيدي ابراهيم",
    "daira_name_ascii": "Ouled Sidi Brahim",
    "daira_name": "أولاد سيدي ابراهيم",
    "wilaya_code": "28",
    "wilaya_name_ascii": "M'Sila",
    "wilaya_name": "المسيلة"
  },
  {
    "model": "base.commune",
    "pk": 1016,
    "fields": {
      "postcode": 28022,
      "wilaya": 28,
      "name": "Sidi Ameur"
    },
    "id": 1034,
    "commune_name_ascii": "Sidi Ameur",
    "commune_name": "سيدي عامر",
    "daira_name_ascii": "Sidi Ameur",
    "daira_name": "سيدي عامر",
    "wilaya_code": "28",
    "wilaya_name_ascii": "M'Sila",
    "wilaya_name": "المسيلة"
  },
  {
    "model": "base.commune",
    "pk": 1017,
    "fields": {
      "postcode": 28023,
      "wilaya": 28,
      "name": "Tamsa"
    },
    "id": 1039,
    "commune_name_ascii": "Tamsa",
    "commune_name": "تامسة",
    "daira_name_ascii": "Sidi Ameur",
    "daira_name": "سيدي عامر",
    "wilaya_code": "28",
    "wilaya_name_ascii": "M'Sila",
    "wilaya_name": "المسيلة"
  },
  {
    "model": "base.commune",
    "pk": 1018,
    "fields": {
      "postcode": 28024,
      "wilaya": 28,
      "name": "Ben Srour"
    },
    "id": 1001,
    "commune_name_ascii": "Ben Srour",
    "commune_name": "بن سرور",
    "daira_name_ascii": "Ben Srour",
    "daira_name": "بن سرور",
    "wilaya_code": "28",
    "wilaya_name_ascii": "M'Sila",
    "wilaya_name": "المسيلة"
  },
  {
    /*                                                                                                           */
    "id": 1022,
    "commune_name_ascii": "Mohamed Boudiaf",
    "commune_name": "محمد بوضياف",
    "daira_name_ascii": "Ben Srour",
    "daira_name": "بن سرور",
    "wilaya_code": "28",
    "wilaya_name_ascii": "M'Sila",
    "wilaya_name": "المسيلة"
  },
  {
    "model": "base.commune",
    "pk": 1019,
    "fields": {
      "postcode": 28025,
      "wilaya": 28,
      "name": "Ouled Slimane"
    },
    "id": 1031,
    "commune_name_ascii": "Ouled Slimane",
    "commune_name": "أولاد سليمان",
    "daira_name_ascii": "Ben Srour",
    "daira_name": "بن سرور",
    "wilaya_code": "28",
    "wilaya_name_ascii": "M'Sila",
    "wilaya_name": "المسيلة"
  },
  {
    "model": "base.commune",
    "pk": 1027,
    "fields": {
      "postcode": 28033,
      "wilaya": 28,
      "name": "Zarzour"
    },
    "id": 1041,
    "commune_name_ascii": "Zarzour",
    "commune_name": "زرزور",
    "daira_name_ascii": "Ben Srour",
    "daira_name": "بن سرور",
    "wilaya_code": "28",
    "wilaya_name_ascii": "M'Sila",
    "wilaya_name": "المسيلة"
  },
  {
    "model": "base.commune",
    "pk": 1035,
    "fields": {
      "postcode": 28041,
      "wilaya": 28,
      "name": "Ain El Melh"
    },
    "id": 996,
    "commune_name_ascii": "Ain El Melh",
    "commune_name": "عين الملح",
    "daira_name_ascii": "Ain El Melh",
    "daira_name": "عين الملح",
    "wilaya_code": "28",
    "wilaya_name_ascii": "M'Sila",
    "wilaya_name": "المسيلة"
  },
  {
    "model": "base.commune",
    "pk": 1031,
    "fields": {
      "postcode": 28037,
      "wilaya": 28,
      "name": "Ain Fares"
    },
    "id": 997,
    "commune_name_ascii": "Ain Fares",
    "commune_name": "عين فارس",
    "daira_name_ascii": "Ain El Melh",
    "daira_name": "عين الملح",
    "wilaya_code": "28",
    "wilaya_name_ascii": "M'Sila",
    "wilaya_name": "المسيلة"
  },
  {
    "pk": 1038  ,"fields": { "postcode": 28044,  "wilaya":   28, "name": "Ain Errich" },
    "id": 999,
    "commune_name_ascii": "Ain Rich",
    "commune_name": "عين الريش",
    "daira_name_ascii": "Ain El Melh",
    "daira_name": "عين الملح",
    "wilaya_code": "28",
    "wilaya_name_ascii": "M'Sila",
    "wilaya_name": "المسيلة"
  },
  {
    "model": "base.commune",
    "pk": 1030,
    "fields": {
      "postcode": 28036,
      "wilaya": 28,
      "name": "Bir Foda"
    },
    "id": 1005,
    "commune_name_ascii": "Bir Foda",
    "commune_name": "بئر فضة",
    "daira_name_ascii": "Ain El Melh",
    "daira_name": "عين الملح",
    "wilaya_code": "28",
    "wilaya_name_ascii": "M'Sila",
    "wilaya_name": "المسيلة"
  },
  {
    "pk": 1032  ,"fields": { "postcode": 28038,  "wilaya":   28, "name": "Sidi Mhamed" },
    "id": 1036,
    "commune_name_ascii": "Sidi M'hamed",
    "commune_name": "سيدي امحمد",
    "daira_name_ascii": "Ain El Melh",
    "daira_name": "عين الملح",
    "wilaya_code": "28",
    "wilaya_name_ascii": "M'Sila",
    "wilaya_name": "المسيلة"
  },
  {
    "model": "base.commune",
    "pk": 1036,
    "fields": {
      "postcode": 28042,
      "wilaya": 28,
      "name": "Medjedel"
    },
    "id": 1020,
    "commune_name_ascii": "Medjedel",
    "commune_name": "امجدل",
    "daira_name_ascii": "Medjedel",
    "daira_name": "امجدل",
    "wilaya_code": "28",
    "wilaya_name_ascii": "M'Sila",
    "wilaya_name": "المسيلة"
  },
  {
    "model": "base.commune",
    "pk": 122,
    "fields": {
      "postcode": 5006,
      "wilaya": 5,
      "name": "Menaa"
    },
    "id": 1021,
    "commune_name_ascii": "Menaa",
    "commune_name": "مناعة",
    "daira_name_ascii": "Medjedel",
    "daira_name": "امجدل",
    "wilaya_code": "28",
    "wilaya_name_ascii": "M'Sila",
    "wilaya_name": "المسيلة"
  },
  {
    "model": "base.commune",
    "pk": 1041,
    "fields": {
      "postcode": 28047,
      "wilaya": 28,
      "name": "Djebel Messaad"
    },
    "id": 1010,
    "commune_name_ascii": "Djebel Messaad",
    "commune_name": "جبل مساعد",
    "daira_name_ascii": "Djebel Messaad",
    "daira_name": "جبل مساعد",
    "wilaya_code": "28",
    "wilaya_name_ascii": "M'Sila",
    "wilaya_name": "المسيلة"
  },
  {
    "model": "base.commune",
    "pk": 1037,
    "fields": {
      "postcode": 28043,
      "wilaya": 28,
      "name": "Slim"
    },
    "id": 1037,
    "commune_name_ascii": "Slim",
    "commune_name": "سليم",
    "daira_name_ascii": "Djebel Messaad",
    "daira_name": "جبل مساعد",
    "wilaya_code": "28",
    "wilaya_name_ascii": "M'Sila",
    "wilaya_name": "المسيلة"
  },
  {
    "pk": 995  ,"fields": { "postcode": 28001,  "wilaya":   28, "name": "Msila" },
    "id": 1023,
    "commune_name_ascii": "M'sila",
    "commune_name": "المسيلة",
    "daira_name_ascii": "M'sila",
    "daira_name": "المسيلة",
    "wilaya_code": "28",
    "wilaya_name_ascii": "M'Sila",
    "wilaya_name": "المسيلة"
  },
  {
    "pk": 997  ,"fields": { "postcode": 28003,  "wilaya":   28, "name": "Hammam Dhalaa" },
    "id": 1013,
    "commune_name_ascii": "Hammam Dalaa",
    "commune_name": "حمام الضلعة",
    "daira_name_ascii": "Hammam Dalaa",
    "daira_name": "حمام الضلعة",
    "wilaya_code": "28",
    "wilaya_name_ascii": "M'Sila",
    "wilaya_name": "المسيلة"
  },
  {
    "model": "base.commune",
    "pk": 1013,
    "fields": {
      "postcode": 28019,
      "wilaya": 28,
      "name": "Ouanougha"
    },
    "id": 1025,
    "commune_name_ascii": "Ouanougha",
    "commune_name": "ونوغة",
    "daira_name_ascii": "Hammam Dalaa",
    "daira_name": "حمام الضلعة",
    "wilaya_code": "28",
    "wilaya_name_ascii": "M'Sila",
    "wilaya_name": "المسيلة"
  },
  {
    "model": "base.commune",
    "pk": 1022,
    "fields": {
      "postcode": 28028,
      "wilaya": 28,
      "name": "Ouled Mansour"
    },
    "id": 1029,
    "commune_name_ascii": "Ouled Mansour",
    "commune_name": "أولاد منصور",
    "daira_name_ascii": "Hammam Dalaa",
    "daira_name": "حمام الضلعة",
    "wilaya_code": "28",
    "wilaya_name_ascii": "M'Sila",
    "wilaya_name": "المسيلة"
  },
  {
    "model": "base.commune",
    "pk": 999,
    "fields": {
      "postcode": 28005,
      "wilaya": 28,
      "name": "Tarmount"
    },
    "id": 1040,
    "commune_name_ascii": "Tarmount",
    "commune_name": "تارمونت",
    "daira_name_ascii": "Hammam Dalaa",
    "daira_name": "حمام الضلعة",
    "wilaya_code": "28",
    "wilaya_name_ascii": "M'Sila",
    "wilaya_name": "المسيلة"
  },
  {
    "model": "base.commune",
    "pk": 996,
    "fields": {
      "postcode": 28002,
      "wilaya": 28,
      "name": "Maadid"
    },
    "id": 1016,
    "commune_name_ascii": "Maadid",
    "commune_name": "المعاضيد",
    "daira_name_ascii": "Ouled Derradj",
    "daira_name": "أولاد دراج",
    "wilaya_code": "28",
    "wilaya_name_ascii": "M'Sila",
    "wilaya_name": "المسيلة"
  },
  {
    "pk": 1000  ,"fields": { "postcode": 28006,  "wilaya":   28, "name": "Mtarfa" },
    "id": 1024,
    "commune_name_ascii": "M'tarfa",
    "commune_name": "المطارفة",
    "daira_name_ascii": "Ouled Derradj",
    "daira_name": "أولاد دراج",
    "wilaya_code": "28",
    "wilaya_name_ascii": "M'Sila",
    "wilaya_name": "المسيلة"
  },
  {
    "model": "base.commune",
    "pk": 1023,
    "fields": {
      "postcode": 28029,
      "wilaya": 28,
      "name": "Maarif"
    },
    "id": 1017,
    "commune_name_ascii": "Maarif",
    "commune_name": "معاريف",
    "daira_name_ascii": "Chellal",
    "daira_name": "شلال",
    "wilaya_code": "28",
    "wilaya_name_ascii": "M'Sila",
    "wilaya_name": "المسيلة"
  },
  {
    "model": "base.commune",
    "pk": 998,
    "fields": {
      "postcode": 28004,
      "wilaya": 28,
      "name": "Ouled Derradj"
    },
    "id": 1027,
    "commune_name_ascii": "Ouled Derradj",
    "commune_name": "أولاد دراج",
    "daira_name_ascii": "Ouled Derradj",
    "daira_name": "أولاد دراج",
    "wilaya_code": "28",
    "wilaya_name_ascii": "M'Sila",
    "wilaya_name": "المسيلة"
  },
  {
    "model": "base.commune",
    "pk": 491,
    "fields": {
      "postcode": 15005,
      "wilaya": 15,
      "name": "Souamaa"
    },
    "id": 1038,
    "commune_name_ascii": "Souamaa",
    "commune_name": "السوامع",
    "daira_name_ascii": "Ouled Derradj",
    "daira_name": "أولاد دراج",
    "wilaya_code": "28",
    "wilaya_name_ascii": "M'Sila",
    "wilaya_name": "المسيلة"
  },
  {
    "model": "base.commune",
    "pk": 1020,
    "fields": {
      "postcode": 28026,
      "wilaya": 28,
      "name": "El Houamed"
    },
    "id": 1012,
    "commune_name_ascii": "El Houamed",
    "commune_name": "الحوامد",
    "daira_name_ascii": "Khoubana",
    "daira_name": "خبانة",
    "wilaya_code": "28",
    "wilaya_name_ascii": "M'Sila",
    "wilaya_name": "المسيلة"
  },
  {
    "model": "base.commune",
    "pk": 1001,
    "fields": {
      "postcode": 28007,
      "wilaya": 28,
      "name": "Khoubana"
    },
    "id": 1015,
    "commune_name_ascii": "Khoubana",
    "commune_name": "خبانة",
    "daira_name_ascii": "Khoubana",
    "daira_name": "خبانة",
    "wilaya_code": "28",
    "wilaya_name_ascii": "M'Sila",
    "wilaya_name": "المسيلة"
  },
  {
    "pk": 1002  ,"fields": { "postcode": 28008,  "wilaya":   28, "name": "Mcif" },
    "id": 1019,
    "commune_name_ascii": "M'cif",
    "commune_name": "مسيف",
    "daira_name_ascii": "Khoubana",
    "daira_name": "خبانة",
    "wilaya_code": "28",
    "wilaya_name_ascii": "M'Sila",
    "wilaya_name": "المسيلة"
  },
  {
    "model": "base.commune",
    "pk": 1007,
    "fields": {
      "postcode": 28013,
      "wilaya": 28,
      "name": "Ain Khadra"
    },
    "id": 998,
    "commune_name_ascii": "Ain Khadra",
    "commune_name": "عين الخضراء",
    "daira_name_ascii": "Magra",
    "daira_name": "مقرة",
    "wilaya_code": "28",
    "wilaya_name_ascii": "M'Sila",
    "wilaya_name": "المسيلة"
  },
  {
    "model": "base.commune",
    "pk": 1008,
    "fields": {
      "postcode": 28014,
      "wilaya": 28,
      "name": "Ouled Addi Guebala"
    },
    "id": 1026,
    "commune_name_ascii": "Ouled Addi Guebala",
    "commune_name": "أولاد عدي لقبالة",
    "daira_name_ascii": "Ouled Derradj",
    "daira_name": "أولاد دراج",
    "wilaya_code": "28",
    "wilaya_name_ascii": "M'Sila",
    "wilaya_name": "المسيلة"
  },
  {
    "model": "base.commune",
    "pk": 1051,
    "fields": {
      "postcode": 29010,
      "wilaya": 29,
      "name": "Oued El Abtal"
    },
    "id": 1075,
    "commune_name_ascii": "Oued El Abtal",
    "commune_name": "وادي الأبطال",
    "daira_name_ascii": "Oued El Abtal",
    "daira_name": "وادي الأبطال",
    "wilaya_code": "29",
    "wilaya_name_ascii": "Mascara",
    "wilaya_name": "معسكر"
  },
  {
    "model": "base.commune",
    "pk": 1073,
    "fields": {
      "postcode": 29032,
      "wilaya": 29,
      "name": "Sidi Abdelmoumene"
    },
    "id": 1081,
    "commune_name_ascii": "Sidi Abdelmoumene",
    "commune_name": "سيدي عبد المومن",
    "daira_name_ascii": "Mohammadia",
    "daira_name": "المحمدية",
    "wilaya_code": "29",
    "wilaya_name_ascii": "Mascara",
    "wilaya_name": "معسكر"
  },
  {
    "model": "base.commune",
    "pk": 1076,
    "fields": {
      "postcode": 29035,
      "wilaya": 29,
      "name": "Sedjerara"
    },
    "id": 1078,
    "commune_name_ascii": "Sedjerara",
    "commune_name": "سجرارة",
    "daira_name_ascii": "Mohammadia",
    "daira_name": "المحمدية",
    "wilaya_code": "29",
    "wilaya_name_ascii": "Mascara",
    "wilaya_name": "معسكر"
  },
  {
    "model": "base.commune",
    "pk": 582,
    "fields": {
      "postcode": 16029,
      "wilaya": 16,
      "name": "Mohammadia"
    },
    "id": 1072,
    "commune_name_ascii": "Mohammadia",
    "commune_name": "المحمدية",
    "daira_name_ascii": "Mohammadia",
    "daira_name": "المحمدية",
    "wilaya_code": "29",
    "wilaya_name_ascii": "Mascara",
    "wilaya_name": "معسكر"
  },
  {
    "pk": 1047  ,"fields": { "postcode": 29006,  "wilaya":   29, "name": "Teghennif" },
    "id": 1085,
    "commune_name_ascii": "Tighennif",
    "commune_name": "تيغنيف",
    "daira_name_ascii": "Tighennif",
    "daira_name": "تيغنيف",
    "wilaya_code": "29",
    "wilaya_name_ascii": "Mascara",
    "wilaya_name": "معسكر"
  },
  {
    "pk": 1077  ,"fields": { "postcode": 29036,  "wilaya":   29, "name": "Moctadouz" },
    "id": 1071,
    "commune_name_ascii": "Mocta Douz",
    "commune_name": "مقطع الدوز",
    "daira_name_ascii": "Mohammadia",
    "daira_name": "المحمدية",
    "wilaya_code": "29",
    "wilaya_name_ascii": "Mascara",
    "wilaya_name": "معسكر"
  },
  {
    "model": "base.commune",
    "pk": 1074,
    "fields": {
      "postcode": 29033,
      "wilaya": 29,
      "name": "Ferraguig"
    },
    "id": 1060,
    "commune_name_ascii": "Ferraguig",
    "commune_name": "فراقيق",
    "daira_name_ascii": "Mohammadia",
    "daira_name": "المحمدية",
    "wilaya_code": "29",
    "wilaya_name_ascii": "Mascara",
    "wilaya_name": "معسكر"
  },
  {
    "model": "base.commune",
    "pk": 1075,
    "fields": {
      "postcode": 29034,
      "wilaya": 29,
      "name": "El Ghomri"
    },
    "id": 1054,
    "commune_name_ascii": "El Ghomri",
    "commune_name": "الغمري",
    "daira_name_ascii": "Mohammadia",
    "daira_name": "المحمدية",
    "wilaya_code": "29",
    "wilaya_name_ascii": "Mascara",
    "wilaya_name": "معسكر"
  },
  {
    "model": "base.commune",
    "pk": 1071,
    "fields": {
      "postcode": 29030,
      "wilaya": 29,
      "name": "Zahana"
    },
    "id": 1087,
    "commune_name_ascii": "Zahana",
    "commune_name": "زهانة",
    "daira_name_ascii": "Zahana",
    "daira_name": "زهانة",
    "wilaya_code": "29",
    "wilaya_name_ascii": "Mascara",
    "wilaya_name": "معسكر"
  },
  {
    "model": "base.commune",
    "pk": 1070,
    "fields": {
      "postcode": 29029,
      "wilaya": 29,
      "name": "El Gaada"
    },
    "id": 1053,
    "commune_name_ascii": "El Gaada",
    "commune_name": "القعدة",
    "daira_name_ascii": "Zahana",
    "daira_name": "زهانة",
    "wilaya_code": "29",
    "wilaya_name_ascii": "Mascara",
    "wilaya_name": "معسكر"
  },
  {
    "pk": 1085  ,"fields": { "postcode": 29044,  "wilaya":   29, "name": "Ras Ain Amirouche" },
    "id": 1077,
    "commune_name_ascii": "Ras El Ain Amirouche",
    "commune_name": "رأس عين عميروش",
    "daira_name_ascii": "Oggaz",
    "daira_name": "عقاز",
    "wilaya_code": "29",
    "wilaya_name_ascii": "Mascara",
    "wilaya_name": "معسكر"
  },
  {
    "model": "base.commune",
    "pk": 1068,
    "fields": {
      "postcode": 29027,
      "wilaya": 29,
      "name": "Oggaz"
    },
    "id": 1074,
    "commune_name_ascii": "Oggaz",
    "commune_name": "عقاز",
    "daira_name_ascii": "Oggaz",
    "daira_name": "عقاز",
    "wilaya_code": "29",
    "wilaya_name_ascii": "Mascara",
    "wilaya_name": "معسكر"
  },
  {
    "model": "base.commune",
    "pk": 1069,
    "fields": {
      "postcode": 29028,
      "wilaya": 29,
      "name": "Alaimia"
    },
    "id": 1046,
    "commune_name_ascii": "Alaimia",
    "commune_name": "العلايمية",
    "daira_name_ascii": "Oggaz",
    "daira_name": "عقاز",
    "wilaya_code": "29",
    "wilaya_name_ascii": "Mascara",
    "wilaya_name": "معسكر"
  },
  {
    "model": "base.commune",
    "pk": 1067,
    "fields": {
      "postcode": 29026,
      "wilaya": 29,
      "name": "Sig"
    },
    "id": 1084,
    "commune_name_ascii": "Sig",
    "commune_name": "سيق",
    "daira_name_ascii": "Sig",
    "daira_name": "سيق",
    "wilaya_code": "29",
    "wilaya_name_ascii": "Mascara",
    "wilaya_name": "معسكر"
  },
  {
    "model": "base.commune",
    "pk": 325,
    "fields": {
      "postcode": 10017,
      "wilaya": 10,
      "name": "Chorfa"
    },
    "id": 1051,
    "commune_name_ascii": "Chorfa",
    "commune_name": "الشرفاء",
    "daira_name_ascii": "Sig",
    "daira_name": "سيق",
    "wilaya_code": "29",
    "wilaya_name_ascii": "Mascara",
    "wilaya_name": "معسكر"
  },
  {
    "model": "base.commune",
    "pk": 1078,
    "fields": {
      "postcode": 29037,
      "wilaya": 29,
      "name": "Bou Henni"
    },
    "id": 1049,
    "commune_name_ascii": "Bou Henni",
    "commune_name": "بوهني",
    "daira_name_ascii": "Sig",
    "daira_name": "سيق",
    "wilaya_code": "29",
    "wilaya_name_ascii": "Mascara",
    "wilaya_name": "معسكر"
  },
  {
    "model": "base.commune",
    "pk": 1080,
    "fields": {
      "postcode": 29039,
      "wilaya": 29,
      "name": "El Mamounia"
    },
    "id": 1058,
    "commune_name_ascii": "El Mamounia",
    "commune_name": "المأمونية",
    "daira_name_ascii": "Ain Fares",
    "daira_name": "عين فارس",
    "wilaya_code": "29",
    "wilaya_name_ascii": "Mascara",
    "wilaya_name": "معسكر"
  },
  {
    "pk": 1079  ,"fields": { "postcode": 29038,  "wilaya":   29, "name": "Guettena" },
    "id": 1055,
    "commune_name_ascii": "El Gueitena",
    "commune_name": "القطنة",
    "daira_name_ascii": "Bouhanifia",
    "daira_name": "بوحنيفية",
    "wilaya_code": "29",
    "wilaya_name_ascii": "Mascara",
    "wilaya_name": "معسكر"
  },
  {
    "model": "base.commune",
    "pk": 1031,
    "fields": {
      "postcode": 28037,
      "wilaya": 28,
      "name": "Ain Fares"
    },
    "id": 1042,
    "commune_name_ascii": "Ain Fares",
    "commune_name": "عين فارس",
    "daira_name_ascii": "Ain Fares",
    "daira_name": "عين فارس",
    "wilaya_code": "29",
    "wilaya_name_ascii": "Mascara",
    "wilaya_name": "معسكر"
  },
  {
    "model": "base.commune",
    "pk": 1082,
    "fields": {
      "postcode": 29041,
      "wilaya": 29,
      "name": "Gharrous"
    },
    "id": 1062,
    "commune_name_ascii": "Gharrous",
    "commune_name": "غروس",
    "daira_name_ascii": "Aouf",
    "daira_name": "عوف",
    "wilaya_code": "29",
    "wilaya_name_ascii": "Mascara",
    "wilaya_name": "معسكر"
  },
  {
    "model": "base.commune",
    "pk": 1060,
    "fields": {
      "postcode": 29019,
      "wilaya": 29,
      "name": "Benian"
    },
    "id": 1048,
    "commune_name_ascii": "Benian",
    "commune_name": "بنيان",
    "daira_name_ascii": "Aouf",
    "daira_name": "عوف",
    "wilaya_code": "29",
    "wilaya_name_ascii": "Mascara",
    "wilaya_name": "معسكر"
  },
  {
    "model": "base.commune",
    "pk": 1064,
    "fields": {
      "postcode": 29023,
      "wilaya": 29,
      "name": "Aouf"
    },
    "id": 1047,
    "commune_name_ascii": "Aouf",
    "commune_name": "عوف",
    "daira_name_ascii": "Aouf",
    "daira_name": "عوف",
    "wilaya_code": "29",
    "wilaya_name_ascii": "Mascara",
    "wilaya_name": "معسكر"
  },
  {
    "pk": 1083  ,"fields": { "postcode": 29042,  "wilaya":   29, "name": "Gherdjoum" },
    "id": 1064,
    "commune_name_ascii": "Guerdjoum",
    "commune_name": "قرجوم",
    "daira_name_ascii": "Oued Taria",
    "daira_name": "وادي التاغية",
    "wilaya_code": "29",
    "wilaya_name_ascii": "Mascara",
    "wilaya_name": "معسكر"
  },
  {
    "model": "base.commune",
    "pk": 1066,
    "fields": {
      "postcode": 29025,
      "wilaya": 29,
      "name": "Ain Frass"
    },
    "id": 1045,
    "commune_name_ascii": "Ain Frass",
    "commune_name": "عين أفرص",
    "daira_name_ascii": "Ain Fekan",
    "daira_name": "عين فكان",
    "wilaya_code": "29",
    "wilaya_name_ascii": "Mascara",
    "wilaya_name": "معسكر"
  },
  {
    "model": "base.commune",
    "pk": 1059,
    "fields": {
      "postcode": 29018,
      "wilaya": 29,
      "name": "Ain Fekan"
    },
    "id": 1043,
    "commune_name_ascii": "Ain Fekan",
    "commune_name": "عين فكان",
    "daira_name_ascii": "Ain Fekan",
    "daira_name": "عين فكان",
    "wilaya_code": "29",
    "wilaya_name_ascii": "Mascara",
    "wilaya_name": "معسكر"
  },
  {
    "model": "base.commune",
    "pk": 1061,
    "fields": {
      "postcode": 29020,
      "wilaya": 29,
      "name": "Khalouia"
    },
    "id": 1066,
    "commune_name_ascii": "Khalouia",
    "commune_name": "خلوية",
    "daira_name_ascii": "El Bordj",
    "daira_name": "البرج",
    "wilaya_code": "29",
    "wilaya_name_ascii": "Mascara",
    "wilaya_name": "معسكر"
  },
  {
    "model": "base.commune",
    "pk": 1062,
    "fields": {
      "postcode": 29021,
      "wilaya": 29,
      "name": "El Menaouer"
    },
    "id": 1059,
    "commune_name_ascii": "El Menaouer",
    "commune_name": "المنور",
    "daira_name_ascii": "El Bordj",
    "daira_name": "البرج",
    "wilaya_code": "29",
    "wilaya_name_ascii": "Mascara",
    "wilaya_name": "معسكر"
  },
  {
    "model": "base.commune",
    "pk": 1058,
    "fields": {
      "postcode": 29017,
      "wilaya": 29,
      "name": "El Bordj"
    },
    "id": 1052,
    "commune_name_ascii": "El Bordj",
    "commune_name": "البرج",
    "daira_name_ascii": "El Bordj",
    "daira_name": "البرج",
    "wilaya_code": "29",
    "wilaya_name_ascii": "Mascara",
    "wilaya_name": "معسكر"
  },
  {
    "model": "base.commune",
    "pk": 1057,
    "fields": {
      "postcode": 29016,
      "wilaya": 29,
      "name": "Sidi Boussaid"
    },
    "id": 1082,
    "commune_name_ascii": "Sidi Boussaid",
    "commune_name": "سيدي بوسعيد",
    "daira_name_ascii": "Ghriss",
    "daira_name": "غريس",
    "wilaya_code": "29",
    "wilaya_name_ascii": "Mascara",
    "wilaya_name": "معسكر"
  },
  {
    "model": "base.commune",
    "pk": 1055,
    "fields": {
      "postcode": 29014,
      "wilaya": 29,
      "name": "Matemore"
    },
    "id": 1070,
    "commune_name_ascii": "Matemore",
    "commune_name": "المطمور",
    "daira_name_ascii": "Ghriss",
    "daira_name": "غريس",
    "wilaya_code": "29",
    "wilaya_name_ascii": "Mascara",
    "wilaya_name": "معسكر"
  },
  {
    "model": "base.commune",
    "pk": 1049,
    "fields": {
      "postcode": 29008,
      "wilaya": 29,
      "name": "Sidi Kada"
    },
    "id": 1083,
    "commune_name_ascii": "Sidi Kada",
    "commune_name": "سيدي قادة",
    "daira_name_ascii": "Tighennif",
    "daira_name": "تيغنيف",
    "wilaya_code": "29",
    "wilaya_name_ascii": "Mascara",
    "wilaya_name": "معسكر"
  },
  {
    "pk": 1056  ,"fields": { "postcode": 29015,  "wilaya":   29, "name": "Makdha" },
    "id": 1067,
    "commune_name_ascii": "Makhda",
    "commune_name": "ماقضة",
    "daira_name_ascii": "Ghriss",
    "daira_name": "غريس",
    "wilaya_code": "29",
    "wilaya_name_ascii": "Mascara",
    "wilaya_name": "معسكر"
  },
  {
    "model": "base.commune",
    "pk": 1042,
    "fields": {
      "postcode": 29001,
      "wilaya": 29,
      "name": "Mascara"
    },
    "id": 1069,
    "commune_name_ascii": "Mascara",
    "commune_name": "معسكر",
    "daira_name_ascii": "Mascara",
    "daira_name": "معسكر",
    "wilaya_code": "29",
    "wilaya_name_ascii": "Mascara",
    "wilaya_name": "معسكر"
  },
  {
    "pk": 1043  ,"fields": { "postcode": 29002,  "wilaya":   29, "name": "Bou Hanifia" },
    "id": 1050,
    "commune_name_ascii": "Bouhanifia",
    "commune_name": "بوحنيفية",
    "daira_name_ascii": "Bouhanifia",
    "daira_name": "بوحنيفية",
    "wilaya_code": "29",
    "wilaya_name_ascii": "Mascara",
    "wilaya_name": "معسكر"
  },
  {
    "model": "base.commune",
    "pk": 1053,
    "fields": {
      "postcode": 29012,
      "wilaya": 29,
      "name": "Ghriss"
    },
    "id": 1063,
    "commune_name_ascii": "Ghriss",
    "commune_name": "غريس",
    "daira_name_ascii": "Ghriss",
    "daira_name": "غريس",
    "wilaya_code": "29",
    "wilaya_name_ascii": "Mascara",
    "wilaya_name": "معسكر"
  },
  {
    "model": "base.commune",
    "pk": 1045,
    "fields": {
      "postcode": 29004,
      "wilaya": 29,
      "name": "Hacine"
    },
    "id": 1065,
    "commune_name_ascii": "Hacine",
    "commune_name": "حسين",
    "daira_name_ascii": "Bouhanifia",
    "daira_name": "بوحنيفية",
    "wilaya_code": "29",
    "wilaya_name_ascii": "Mascara",
    "wilaya_name": "معسكر"
  },
  {
    "model": "base.commune",
    "pk": 1081,
    "fields": {
      "postcode": 29040,
      "wilaya": 29,
      "name": "El Keurt"
    },
    "id": 1057,
    "commune_name_ascii": "El Keurt",
    "commune_name": "القرط",
    "daira_name_ascii": "Tizi",
    "daira_name": "تيزي",
    "wilaya_code": "29",
    "wilaya_name_ascii": "Mascara",
    "wilaya_name": "معسكر"
  },
  {
    "model": "base.commune",
    "pk": 1054,
    "fields": {
      "postcode": 29013,
      "wilaya": 29,
      "name": "Froha"
    },
    "id": 1061,
    "commune_name_ascii": "Froha",
    "commune_name": "فروحة",
    "daira_name_ascii": "Tizi",
    "daira_name": "تيزي",
    "wilaya_code": "29",
    "wilaya_name_ascii": "Mascara",
    "wilaya_name": "معسكر"
  },
  {
    "model": "base.commune",
    "pk": 1044,
    "fields": {
      "postcode": 29003,
      "wilaya": 29,
      "name": "Tizi"
    },
    "id": 1086,
    "commune_name_ascii": "Tizi",
    "commune_name": "تيزي",
    "daira_name_ascii": "Tizi",
    "daira_name": "تيزي",
    "wilaya_code": "29",
    "wilaya_name_ascii": "Mascara",
    "wilaya_name": "معسكر"
  },
  {
    "model": "base.commune",
    "pk": 1088,
    "fields": {
      "postcode": 29047,
      "wilaya": 29,
      "name": "Sehailia"
    },
    "id": 1079,
    "commune_name_ascii": "Sehailia",
    "commune_name": "السهايلية",
    "daira_name_ascii": "Tighennif",
    "daira_name": "تيغنيف",
    "wilaya_code": "29",
    "wilaya_name_ascii": "Mascara",
    "wilaya_name": "معسكر"
  },
  {
    "model": "base.commune",
    "pk": 1046,
    "fields": {
      "postcode": 29005,
      "wilaya": 29,
      "name": "Maoussa"
    },
    "id": 1068,
    "commune_name_ascii": "Maoussa",
    "commune_name": "ماوسة",
    "daira_name_ascii": "Ghriss",
    "daira_name": "غريس",
    "wilaya_code": "29",
    "wilaya_name_ascii": "Mascara",
    "wilaya_name": "معسكر"
  },
  {
    "model": "base.commune",
    "pk": 1087,
    "fields": {
      "postcode": 29046,
      "wilaya": 29,
      "name": "Sidi Abdeldjebar"
    },
    "id": 1080,
    "commune_name_ascii": "Sidi Abdeldjebar",
    "commune_name": "سيدي عبد الجبار",
    "daira_name_ascii": "Oued El Abtal",
    "daira_name": "وادي الأبطال",
    "wilaya_code": "29",
    "wilaya_name_ascii": "Mascara",
    "wilaya_name": "معسكر"
  },
  {
    "model": "base.commune",
    "pk": 1048,
    "fields": {
      "postcode": 29007,
      "wilaya": 29,
      "name": "El Hachem"
    },
    "id": 1056,
    "commune_name_ascii": "El Hachem",
    "commune_name": "الحشم",
    "daira_name_ascii": "Hachem",
    "daira_name": "الحشم",
    "wilaya_code": "29",
    "wilaya_name_ascii": "Mascara",
    "wilaya_name": "معسكر"
  },
  {
    "model": "base.commune",
    "pk": 1086,
    "fields": {
      "postcode": 29045,
      "wilaya": 29,
      "name": "Nesmot"
    },
    "id": 1073,
    "commune_name_ascii": "Nesmot",
    "commune_name": "نسمط",
    "daira_name_ascii": "Hachem",
    "daira_name": "الحشم",
    "wilaya_code": "29",
    "wilaya_name_ascii": "Mascara",
    "wilaya_name": "معسكر"
  },
  {
    "pk": 1050  ,"fields": { "postcode": 29009,  "wilaya":   29, "name": "Zelmata" },
    "id": 1088,
    "commune_name_ascii": "Zelamta",
    "commune_name": "زلامطة",
    "daira_name_ascii": "Hachem",
    "daira_name": "الحشم",
    "wilaya_code": "29",
    "wilaya_name_ascii": "Mascara",
    "wilaya_name": "معسكر"
  },
  {
    "model": "base.commune",
    "pk": 1052,
    "fields": {
      "postcode": 29011,
      "wilaya": 29,
      "name": "Ain Ferah"
    },
    "id": 1044,
    "commune_name_ascii": "Ain Ferah",
    "commune_name": "عين فراح",
    "daira_name_ascii": "Oued El Abtal",
    "daira_name": "وادي الأبطال",
    "wilaya_code": "29",
    "wilaya_name_ascii": "Mascara",
    "wilaya_name": "معسكر"
  },
  {
    "model": "base.commune",
    "pk": 1063,
    "fields": {
      "postcode": 29022,
      "wilaya": 29,
      "name": "Oued Taria"
    },
    "id": 1076,
    "commune_name_ascii": "Oued Taria",
    "commune_name": "وادي التاغية",
    "daira_name_ascii": "Oued Taria",
    "daira_name": "وادي التاغية",
    "wilaya_code": "29",
    "wilaya_name_ascii": "Mascara",
    "wilaya_name": "معسكر"
  },
  {
    "model": "base.commune",
    "pk": 1089,
    "fields": {
      "postcode": 30001,
      "wilaya": 30,
      "name": "Ouargla"
    },
    "id": 1101,
    "commune_name_ascii": "Ouargla",
    "commune_name": "ورقلة",
    "daira_name_ascii": "Ouargla",
    "daira_name": "ورقلة",
    "wilaya_code": "30",
    "wilaya_name_ascii": "Ouargla",
    "wilaya_name": "ورقلة"
  },
  {
    "model": "base.commune",
    "pk": 1092,
    "fields": {
      "postcode": 30004,
      "wilaya": 30,
      "name": "Hassi Messaoud"
    },
    "id": 1096,
    "commune_name_ascii": "Hassi Messaoud",
    "commune_name": "حاسي مسعود",
    "daira_name_ascii": "Hassi Messaoud",
    "daira_name": "حاسي مسعود",
    "wilaya_code": "30",
    "wilaya_name_ascii": "Ouargla",
    "wilaya_name": "ورقلة"
  },
  {
    "model": "base.commune",
    "pk": 89,
    "fields": {
      "postcode": 4002,
      "wilaya": 4,
      "name": "Ain Beida"
    },
    "id": 1089,
    "commune_name_ascii": "Ain Beida",
    "commune_name": "عين البيضاء",
    "daira_name_ascii": "Sidi Khouiled",
    "daira_name": "سيدي خويلد",
    "wilaya_code": "30",
    "wilaya_name_ascii": "Ouargla",
    "wilaya_name": "ورقلة"
  },
  {
    "model": "base.commune",
    "pk": 1100,
    "fields": {
      "postcode": 30012,
      "wilaya": 30,
      "name": "Hassi Ben Abdellah"
    },
    "id": 1095,
    "commune_name_ascii": "Hassi Ben Abdellah",
    "commune_name": "حاسي بن عبد الله",
    "daira_name_ascii": "Sidi Khouiled",
    "daira_name": "سيدي خويلد",
    "wilaya_code": "30",
    "wilaya_name_ascii": "Ouargla",
    "wilaya_name": "ورقلة"
  },
  {
    "model": "base.commune",
    "pk": 1099,
    "fields": {
      "postcode": 30011,
      "wilaya": 30,
      "name": "Sidi Khouiled"
    },
    "id": 1103,
    "commune_name_ascii": "Sidi Khouiled",
    "commune_name": "سيدي خويلد",
    "daira_name_ascii": "Sidi Khouiled",
    "daira_name": "سيدي خويلد",
    "wilaya_code": "30",
    "wilaya_name_ascii": "Ouargla",
    "wilaya_name": "ورقلة"
  },
  {
    "model": "base.commune",
    "pk": 1109,
    "fields": {
      "postcode": 30021,
      "wilaya": 30,
      "name": "El Borma"
    },
    "id": 1093,
    "commune_name_ascii": "El Borma",
    "commune_name": "البرمة",
    "daira_name_ascii": "El Borma",
    "daira_name": "البرمة",
    "wilaya_code": "30",
    "wilaya_name_ascii": "Ouargla",
    "wilaya_name": "ورقلة"
  },
  {
    "model": "base.commune",
    "pk": 1093,
    "fields": {
      "postcode": 30005,
      "wilaya": 30,
      "name": "Rouissat"
    },
    "id": 1102,
    "commune_name_ascii": "Rouissat",
    "commune_name": "الرويسات",
    "daira_name_ascii": "Ouargla",
    "daira_name": "ورقلة",
    "wilaya_code": "30",
    "wilaya_name_ascii": "Ouargla",
    "wilaya_name": "ورقلة"
  },
  {
    "pk": 1091  ,"fields": { "postcode": 30003,  "wilaya":   30, "name": "Ngoussa" },
    "id": 1100,
    "commune_name_ascii": "N'goussa",
    "commune_name": "انقوسة",
    "daira_name_ascii": "N'goussa",
    "daira_name": "انقوسة",
    "wilaya_code": "30",
    "wilaya_name_ascii": "Ouargla",
    "wilaya_name": "ورقلة"
  },
  {
    "model": "base.commune",
    "pk": 1122,
    "fields": {
      "postcode": 31013,
      "wilaya": 31,
      "name": "Sidi Chami"
    },
    "id": 1134,
    "commune_name_ascii": "Sidi Chami",
    "commune_name": "سيدي الشحمي",
    "daira_name_ascii": "Es Senia",
    "daira_name": "السانية",
    "wilaya_code": "31",
    "wilaya_name_ascii": "Oran",
    "wilaya_name": "وهران"
  },
  {
    "model": "base.commune",
    "pk": 1130,
    "fields": {
      "postcode": 31021,
      "wilaya": 31,
      "name": "Hassi Mefsoukh"
    },
    "id": 1127,
    "commune_name_ascii": "Hassi Mefsoukh",
    "commune_name": "حاسي مفسوخ",
    "daira_name_ascii": "Gdyel",
    "daira_name": "قديل",
    "wilaya_code": "31",
    "wilaya_name_ascii": "Oran",
    "wilaya_name": "وهران"
  },
  {
    "model": "base.commune",
    "pk": 1112,
    "fields": {
      "postcode": 31003,
      "wilaya": 31,
      "name": "Bir El Djir"
    },
    "id": 1116,
    "commune_name_ascii": "Bir El Djir",
    "commune_name": "بئر الجير",
    "daira_name_ascii": "Bir El Djir",
    "daira_name": "بئر الجير",
    "wilaya_code": "31",
    "wilaya_name_ascii": "Oran",
    "wilaya_name": "وهران"
  },
  {
    "model": "base.commune",
    "pk": 1128,
    "fields": {
      "postcode": 31019,
      "wilaya": 31,
      "name": "Hassi Ben Okba"
    },
    "id": 1125,
    "commune_name_ascii": "Hassi Ben Okba",
    "commune_name": "حاسي بن عقبة",
    "daira_name_ascii": "Bir El Djir",
    "daira_name": "بئر الجير",
    "wilaya_code": "31",
    "wilaya_name_ascii": "Oran",
    "wilaya_name": "وهران"
  },
  {
    "model": "base.commune",
    "pk": 1111,
    "fields": {
      "postcode": 31002,
      "wilaya": 31,
      "name": "Gdyel"
    },
    "id": 1124,
    "commune_name_ascii": "Gdyel",
    "commune_name": "قديل",
    "daira_name_ascii": "Gdyel",
    "daira_name": "قديل",
    "wilaya_code": "31",
    "wilaya_name_ascii": "Oran",
    "wilaya_name": "وهران"
  },
  {
    "model": "base.commune",
    "pk": 1113,
    "fields": {
      "postcode": 31004,
      "wilaya": 31,
      "name": "Hassi Bounif"
    },
    "id": 1126,
    "commune_name_ascii": "Hassi Bounif",
    "commune_name": "حاسي بونيف",
    "daira_name_ascii": "Bir El Djir",
    "daira_name": "بئر الجير",
    "wilaya_code": "31",
    "wilaya_name_ascii": "Oran",
    "wilaya_name": "وهران"
  },
  {
    "pk": 1134  ,"fields": { "postcode": 31025,  "wilaya":   31, "name": "Ain Kerma" },
    "id": 1122,
    "commune_name_ascii": "El Kerma",
    "commune_name": "الكرمة",
    "daira_name_ascii": "Es Senia",
    "daira_name": "السانية",
    "wilaya_code": "31",
    "wilaya_name_ascii": "Oran",
    "wilaya_name": "وهران"
  },
  {
    "model": "base.commune",
    "pk": 1114,
    "fields": {
      "postcode": 31005,
      "wilaya": 31,
      "name": "Es Senia"
    },
    "id": 1123,
    "commune_name_ascii": "Es Senia",
    "commune_name": "السانية",
    "daira_name_ascii": "Es Senia",
    "daira_name": "السانية",
    "wilaya_code": "31",
    "wilaya_name_ascii": "Oran",
    "wilaya_name": "وهران"
  },
  {
    "model": "base.commune",
    "pk": 1129,
    "fields": {
      "postcode": 31020,
      "wilaya": 31,
      "name": "Ben Freha"
    },
    "id": 1114,
    "commune_name_ascii": "Ben Freha",
    "commune_name": "بن فريحة",
    "daira_name_ascii": "Gdyel",
    "daira_name": "قديل",
    "wilaya_code": "31",
    "wilaya_name_ascii": "Oran",
    "wilaya_name": "وهران"
  },
  {
    "model": "base.commune",
    "pk": 1115,
    "fields": {
      "postcode": 31006,
      "wilaya": 31,
      "name": "Arzew"
    },
    "id": 1113,
    "commune_name_ascii": "Arzew",
    "commune_name": "أرزيو",
    "daira_name_ascii": "Arzew",
    "daira_name": "أرزيو",
    "wilaya_code": "31",
    "wilaya_name_ascii": "Oran",
    "wilaya_name": "وهران"
  },
  {
    "pk": 1131  ,"fields": { "postcode": 31022,  "wilaya":   31, "name": "Sidi Ben Yabka" },
    "id": 1133,
    "commune_name_ascii": "Sidi Ben Yebka",
    "commune_name": "سيدي بن يبقى",
    "daira_name_ascii": "Arzew",
    "daira_name": "أرزيو",
    "wilaya_code": "31",
    "wilaya_name_ascii": "Oran",
    "wilaya_name": "وهران"
  },
  {
    "model": "base.commune",
    "pk": 1135,
    "fields": {
      "postcode": 31026,
      "wilaya": 31,
      "name": "Ain Biya"
    },
    "id": 1110,
    "commune_name_ascii": "Ain Biya",
    "commune_name": "عين البية",
    "daira_name_ascii": "Bethioua",
    "daira_name": "بطيوة",
    "wilaya_code": "31",
    "wilaya_name_ascii": "Oran",
    "wilaya_name": "وهران"
  },
  {
    "model": "base.commune",
    "pk": 1116,
    "fields": {
      "postcode": 31007,
      "wilaya": 31,
      "name": "Bethioua"
    },
    "id": 1115,
    "commune_name_ascii": "Bethioua",
    "commune_name": "بطيوة",
    "daira_name_ascii": "Bethioua",
    "daira_name": "بطيوة",
    "wilaya_code": "31",
    "wilaya_name_ascii": "Oran",
    "wilaya_name": "وهران"
  },
  {
    "model": "base.commune",
    "pk": 1117,
    "fields": {
      "postcode": 31008,
      "wilaya": 31,
      "name": "Marsat El Hadjadj"
    },
    "id": 1128,
    "commune_name_ascii": "Marsat El Hadjadj",
    "commune_name": "مرسى الحجاج",
    "daira_name_ascii": "Bethioua",
    "daira_name": "بطيوة",
    "wilaya_code": "31",
    "wilaya_name_ascii": "Oran",
    "wilaya_name": "وهران"
  },
  {
    "model": "base.commune",
    "pk": 337,
    "fields": {
      "postcode": 10029,
      "wilaya": 10,
      "name": "Ain Turk"
    },
    "id": 1112,
    "commune_name_ascii": "Ain Turk",
    "commune_name": "عين الترك",
    "daira_name_ascii": "Ain Turk",
    "daira_name": "عين الترك",
    "wilaya_code": "31",
    "wilaya_name_ascii": "Oran",
    "wilaya_name": "وهران"
  },
  {
    "model": "base.commune",
    "pk": 1110,
    "fields": {
      "postcode": 31001,
      "wilaya": 31,
      "name": "Oran"
    },
    "id": 1131,
    "commune_name_ascii": "Oran",
    "commune_name": "وهران",
    "daira_name_ascii": "Oran",
    "daira_name": "وهران",
    "wilaya_code": "31",
    "wilaya_name_ascii": "Oran",
    "wilaya_name": "وهران"
  },
  {
    "pk": 1119  ,"fields": { "postcode": 31010,  "wilaya":   31, "name": "El Ancar" },
    "id": 1120,
    "commune_name_ascii": "El Ancor",
    "commune_name": "العنصر",
    "daira_name_ascii": "Ain Turk",
    "daira_name": "عين الترك",
    "wilaya_code": "31",
    "wilaya_name_ascii": "Oran",
    "wilaya_name": "وهران"
  },
  {
    "model": "base.commune",
    "pk": 1124,
    "fields": {
      "postcode": 31015,
      "wilaya": 31,
      "name": "Mers El Kebir"
    },
    "id": 1129,
    "commune_name_ascii": "Mers El Kebir",
    "commune_name": "المرسى الكبير",
    "daira_name_ascii": "Ain Turk",
    "daira_name": "عين الترك",
    "wilaya_code": "31",
    "wilaya_name_ascii": "Oran",
    "wilaya_name": "وهران"
  },
  {
    "model": "base.commune",
    "pk": 1123,
    "fields": {
      "postcode": 31014,
      "wilaya": 31,
      "name": "Boufatis"
    },
    "id": 1117,
    "commune_name_ascii": "Boufatis",
    "commune_name": "بوفاتيس",
    "daira_name_ascii": "Oued Tlelat",
    "daira_name": "وادي تليلات",
    "wilaya_code": "31",
    "wilaya_name_ascii": "Oran",
    "wilaya_name": "وهران"
  },
  {
    "model": "base.commune",
    "pk": 1127,
    "fields": {
      "postcode": 31018,
      "wilaya": 31,
      "name": "El Braya"
    },
    "id": 1121,
    "commune_name_ascii": "El Braya",
    "commune_name": "البراية",
    "daira_name_ascii": "Oued Tlelat",
    "daira_name": "وادي تليلات",
    "wilaya_code": "31",
    "wilaya_name_ascii": "Oran",
    "wilaya_name": "وهران"
  },
  {
    "model": "base.commune",
    "pk": 1120,
    "fields": {
      "postcode": 31011,
      "wilaya": 31,
      "name": "Oued Tlelat"
    },
    "id": 1132,
    "commune_name_ascii": "Oued Tlelat",
    "commune_name": "وادي تليلات",
    "daira_name_ascii": "Oued Tlelat",
    "daira_name": "وادي تليلات",
    "wilaya_code": "31",
    "wilaya_name_ascii": "Oran",
    "wilaya_name": "وهران"
  },
  {
    "model": "base.commune",
    "pk": 1134,
    "fields": {
      "postcode": 31025,
      "wilaya": 31,
      "name": "Ain Kerma"
    },
    "id": 1111,
    "commune_name_ascii": "Ain Kerma",
    "commune_name": "عين الكرمة",
    "daira_name_ascii": "Boutlelis",
    "daira_name": "بوتليليس",
    "wilaya_code": "31",
    "wilaya_name_ascii": "Oran",
    "wilaya_name": "وهران"
  },
  {
    "model": "base.commune",
    "pk": 1133,
    "fields": {
      "postcode": 31024,
      "wilaya": 31,
      "name": "Boutlelis"
    },
    "id": 1119,
    "commune_name_ascii": "Boutlelis",
    "commune_name": "بوتليليس",
    "daira_name_ascii": "Boutlelis",
    "daira_name": "بوتليليس",
    "wilaya_code": "31",
    "wilaya_name_ascii": "Oran",
    "wilaya_name": "وهران"
  },
  {
    "model": "base.commune",
    "pk": 1132,
    "fields": {
      "postcode": 31023,
      "wilaya": 31,
      "name": "Messerghin"
    },
    "id": 1130,
    "commune_name_ascii": "Messerghin",
    "commune_name": "مسرغين",
    "daira_name_ascii": "Boutlelis",
    "daira_name": "بوتليليس",
    "wilaya_code": "31",
    "wilaya_name_ascii": "Oran",
    "wilaya_name": "وهران"
  },
  {
    "model": "base.commune",
    "pk": 1125,
    "fields": {
      "postcode": 31016,
      "wilaya": 31,
      "name": "Bousfer"
    },
    "id": 1118,
    "commune_name_ascii": "Bousfer",
    "commune_name": "بوسفر",
    "daira_name_ascii": "Ain Turk",
    "daira_name": "عين الترك",
    "wilaya_code": "31",
    "wilaya_name_ascii": "Oran",
    "wilaya_name": "وهران"
  },
  {
    "model": "base.commune",
    "pk": 1121,
    "fields": {
      "postcode": 31012,
      "wilaya": 31,
      "name": "Tafraoui"
    },
    "id": 1135,
    "commune_name_ascii": "Tafraoui",
    "commune_name": "طفراوي",
    "daira_name_ascii": "Oued Tlelat",
    "daira_name": "وادي تليلات",
    "wilaya_code": "31",
    "wilaya_name_ascii": "Oran",
    "wilaya_name": "وهران"
  },
  {
    "model": "base.commune",
    "pk": 1143,
    "fields": {
      "postcode": 32008,
      "wilaya": 32,
      "name": "Ain El Orak"
    },
    "id": 1136,
    "commune_name_ascii": "Ain El Orak",
    "commune_name": "عين العراك",
    "daira_name_ascii": "Labiodh Sidi Cheikh",
    "daira_name": "الأبيض سيدي الشيخ",
    "wilaya_code": "32",
    "wilaya_name_ascii": "El Bayadh",
    "wilaya_name": "البيض"
  },
  {
    "model": "base.commune",
    "pk": 1150,
    "fields": {
      "postcode": 32015,
      "wilaya": 32,
      "name": "Krakda"
    },
    "id": 1151,
    "commune_name_ascii": "Krakda",
    "commune_name": "كراكدة",
    "daira_name_ascii": "Brezina",
    "daira_name": "بريزينة",
    "wilaya_code": "32",
    "wilaya_name_ascii": "El Bayadh",
    "wilaya_name": "البيض"
  },
  {
    "model": "base.commune",
    "pk": 1098,
    "fields": {
      "postcode": 30010,
      "wilaya": 30,
      "name": "Sidi Slimane"
    },
    "id": 1154,
    "commune_name_ascii": "Sidi Slimane",
    "commune_name": "سيدي سليمان",
    "daira_name_ascii": "Boualem",
    "daira_name": "بوعلام",
    "wilaya_code": "32",
    "wilaya_name_ascii": "El Bayadh",
    "wilaya_name": "البيض"
  },
  {
    "model": "base.commune",
    "pk": 1016,
    "fields": {
      "postcode": 28022,
      "wilaya": 28,
      "name": "Sidi Ameur"
    },
    "id": 1153,
    "commune_name_ascii": "Sidi Ameur",
    "commune_name": "سيدي عامر",
    "daira_name_ascii": "Boualem",
    "daira_name": "بوعلام",
    "wilaya_code": "32",
    "wilaya_name_ascii": "El Bayadh",
    "wilaya_name": "البيض"
  },
  {
    "model": "base.commune",
    "pk": 1141,
    "fields": {
      "postcode": 32006,
      "wilaya": 32,
      "name": "Boualem"
    },
    "id": 1138,
    "commune_name_ascii": "Boualem",
    "commune_name": "بوعلام",
    "daira_name_ascii": "Boualem",
    "daira_name": "بوعلام",
    "wilaya_code": "32",
    "wilaya_name_ascii": "El Bayadh",
    "wilaya_name": "البيض"
  },
  {
    "model": "base.commune",
    "pk": 1151,
    "fields": {
      "postcode": 32016,
      "wilaya": 32,
      "name": "El Bnoud"
    },
    "id": 1146,
    "commune_name_ascii": "El Bnoud",
    "commune_name": "البنود",
    "daira_name_ascii": "Labiodh Sidi Cheikh",
    "daira_name": "الأبيض سيدي الشيخ",
    "wilaya_code": "32",
    "wilaya_name_ascii": "El Bayadh",
    "wilaya_name": "البيض"
  },
  {
    "model": "base.commune",
    "pk": 1145,
    "fields": {
      "postcode": 32010,
      "wilaya": 32,
      "name": "Bougtoub"
    },
    "id": 1139,
    "commune_name_ascii": "Bougtoub",
    "commune_name": "بوقطب",
    "daira_name_ascii": "Bougtoub",
    "daira_name": "بوقطب",
    "wilaya_code": "32",
    "wilaya_name_ascii": "El Bayadh",
    "wilaya_name": "البيض"
  },
  {
    "pk": 1146  ,"fields": { "postcode": 32011,  "wilaya":   32, "name": "El Kheither" },
    "id": 1147,
    "commune_name_ascii": "El Kheiter",
    "commune_name": "الخيثر",
    "daira_name_ascii": "Bougtoub",
    "daira_name": "بوقطب",
    "wilaya_code": "32",
    "wilaya_name_ascii": "El Bayadh",
    "wilaya_name": "البيض"
  },
  {
    "model": "base.commune",
    "pk": 1155,
    "fields": {
      "postcode": 32020,
      "wilaya": 32,
      "name": "Tousmouline"
    },
    "id": 1157,
    "commune_name_ascii": "Tousmouline",
    "commune_name": "توسمولين",
    "daira_name_ascii": "Bougtoub",
    "daira_name": "بوقطب",
    "wilaya_code": "32",
    "wilaya_name_ascii": "El Bayadh",
    "wilaya_name": "البيض"
  },
  {
    "pk": 1157  ,"fields": { "postcode": 32022,  "wilaya":   32, "name": "Sidi Tifour" },
    "id": 1155,
    "commune_name_ascii": "Sidi Tiffour",
    "commune_name": "سيدي طيفور",
    "daira_name_ascii": "Boualem",
    "daira_name": "بوعلام",
    "wilaya_code": "32",
    "wilaya_name_ascii": "El Bayadh",
    "wilaya_name": "البيض"
  },
  {
    "model": "base.commune",
    "pk": 1138,
    "fields": {
      "postcode": 32003,
      "wilaya": 32,
      "name": "Stitten"
    },
    "id": 1156,
    "commune_name_ascii": "Stitten",
    "commune_name": "ستيتن",
    "daira_name_ascii": "Boualem",
    "daira_name": "بوعلام",
    "wilaya_code": "32",
    "wilaya_name_ascii": "El Bayadh",
    "wilaya_name": "البيض"
  },
  {
    "model": "base.commune",
    "pk": 1136,
    "fields": {
      "postcode": 32001,
      "wilaya": 32,
      "name": "El Bayadh"
    },
    "id": 1144,
    "commune_name_ascii": "El Bayadh",
    "commune_name": "البيض",
    "daira_name_ascii": "El Bayadh",
    "daira_name": "البيض",
    "wilaya_code": "32",
    "wilaya_name_ascii": "El Bayadh",
    "wilaya_name": "البيض"
  },
  {
    "model": "base.commune",
    "pk": 1137,
    "fields": {
      "postcode": 32002,
      "wilaya": 32,
      "name": "Rogassa"
    },
    "id": 1152,
    "commune_name_ascii": "Rogassa",
    "commune_name": "رقاصة",
    "daira_name_ascii": "Rogassa",
    "daira_name": "رقاصة",
    "wilaya_code": "32",
    "wilaya_name_ascii": "El Bayadh",
    "wilaya_name": "البيض"
  },
  {
    "model": "base.commune",
    "pk": 1154,
    "fields": {
      "postcode": 32019,
      "wilaya": 32,
      "name": "El Mehara"
    },
    "id": 1148,
    "commune_name_ascii": "El Mehara",
    "commune_name": "المحرة",
    "daira_name_ascii": "Chellala",
    "daira_name": "شلالة",
    "wilaya_code": "32",
    "wilaya_name_ascii": "El Bayadh",
    "wilaya_name": "البيض"
  },
  {
    "model": "base.commune",
    "pk": 1147,
    "fields": {
      "postcode": 32012,
      "wilaya": 32,
      "name": "Kef El Ahmar"
    },
    "id": 1150,
    "commune_name_ascii": "Kef El Ahmar",
    "commune_name": "الكاف الأحمر",
    "daira_name_ascii": "Rogassa",
    "daira_name": "رقاصة",
    "wilaya_code": "32",
    "wilaya_name_ascii": "El Bayadh",
    "wilaya_name": "البيض"
  },
  {
    "model": "base.commune",
    "pk": 1139,
    "fields": {
      "postcode": 32004,
      "wilaya": 32,
      "name": "Brezina"
    },
    "id": 1141,
    "commune_name_ascii": "Brezina",
    "commune_name": "بريزينة",
    "daira_name_ascii": "Brezina",
    "daira_name": "بريزينة",
    "wilaya_code": "32",
    "wilaya_name_ascii": "El Bayadh",
    "wilaya_name": "البيض"
  },
  {
    "model": "base.commune",
    "pk": 1140,
    "fields": {
      "postcode": 32005,
      "wilaya": 32,
      "name": "Ghassoul"
    },
    "id": 1149,
    "commune_name_ascii": "Ghassoul",
    "commune_name": "الغاسول",
    "daira_name_ascii": "Brezina",
    "daira_name": "بريزينة",
    "wilaya_code": "32",
    "wilaya_name_ascii": "El Bayadh",
    "wilaya_name": "البيض"
  },
  {
    "pk": 1142  ,"fields": { "postcode": 32007,  "wilaya":   32, "name": "El Abiodh Sidi Cheikh" },
    "id": 1145,
    "commune_name_ascii": "Labiodh Sidi Cheikh",
    "commune_name": "الأبيض سيدي الشيخ",
    "daira_name_ascii": "Labiodh Sidi Cheikh",
    "daira_name": "الأبيض سيدي الشيخ",
    "wilaya_code": "32",
    "wilaya_name_ascii": "El Bayadh",
    "wilaya_name": "البيض"
  },
  {
    "model": "base.commune",
    "pk": 1148,
    "fields": {
      "postcode": 32013,
      "wilaya": 32,
      "name": "Boussemghoun"
    },
    "id": 1140,
    "commune_name_ascii": "Boussemghoun",
    "commune_name": "بوسمغون",
    "daira_name_ascii": "Boussemghoun",
    "daira_name": "بوسمغون",
    "wilaya_code": "32",
    "wilaya_name_ascii": "El Bayadh",
    "wilaya_name": "البيض"
  },
  {
    "model": "base.commune",
    "pk": 1152,
    "fields": {
      "postcode": 32017,
      "wilaya": 32,
      "name": "Cheguig"
    },
    "id": 1142,
    "commune_name_ascii": "Cheguig",
    "commune_name": "الشقيق",
    "daira_name_ascii": "Rogassa",
    "daira_name": "رقاصة",
    "wilaya_code": "32",
    "wilaya_name_ascii": "El Bayadh",
    "wilaya_name": "البيض"
  },
  {
    "model": "base.commune",
    "pk": 1149,
    "fields": {
      "postcode": 32014,
      "wilaya": 32,
      "name": "Chellala"
    },
    "id": 1143,
    "commune_name_ascii": "Chellala",
    "commune_name": "شلالة",
    "daira_name_ascii": "Chellala",
    "daira_name": "شلالة",
    "wilaya_code": "32",
    "wilaya_name_ascii": "El Bayadh",
    "wilaya_name": "البيض"
  },
  {
    "model": "base.commune",
    "pk": 1144,
    "fields": {
      "postcode": 32009,
      "wilaya": 32,
      "name": "Arbaouat"
    },
    "id": 1137,
    "commune_name_ascii": "Arbaouat",
    "commune_name": "اربوات",
    "daira_name_ascii": "Labiodh Sidi Cheikh",
    "daira_name": "الأبيض سيدي الشيخ",
    "wilaya_code": "32",
    "wilaya_name_ascii": "El Bayadh",
    "wilaya_name": "البيض"
  },
  {
    "model": "base.commune",
    "pk": 1161,
    "fields": {
      "postcode": 33004,
      "wilaya": 33,
      "name": "Bordj Omar Driss"
    },
    "id": 1159,
    "commune_name_ascii": "Bordj Omar Driss",
    "commune_name": "برج عمر إدريس",
    "daira_name_ascii": "In Amenas",
    "daira_name": "إن أمناس",
    "wilaya_code": "33",
    "wilaya_name_ascii": "Illizi",
    "wilaya_name": "إليزي"
  },
  {
    "model": "base.commune",
    "pk": 1160,
    "fields": {
      "postcode": 33003,
      "wilaya": 33,
      "name": "Debdeb"
    },
    "id": 1160,
    "commune_name_ascii": "Debdeb",
    "commune_name": "دبداب",
    "daira_name_ascii": "In Amenas",
    "daira_name": "إن أمناس",
    "wilaya_code": "33",
    "wilaya_name_ascii": "Illizi",
    "wilaya_name": "إليزي"
  },
  {
    "model": "base.commune",
    "pk": 1163,
    "fields": {
      "postcode": 33006,
      "wilaya": 33,
      "name": "In Amenas"
    },
    "id": 1163,
    "commune_name_ascii": "In Amenas",
    "commune_name": "إن أمناس",
    "daira_name_ascii": "In Amenas",
    "daira_name": "إن أمناس",
    "wilaya_code": "33",
    "wilaya_name_ascii": "Illizi",
    "wilaya_name": "إليزي"
  },
  {
    "model": "base.commune",
    "pk": 1158,
    "fields": {
      "postcode": 33001,
      "wilaya": 33,
      "name": "Illizi"
    },
    "id": 1162,
    "commune_name_ascii": "Illizi",
    "commune_name": "إيليزي",
    "daira_name_ascii": "Illizi",
    "daira_name": "إيليزي",
    "wilaya_code": "33",
    "wilaya_name_ascii": "Illizi",
    "wilaya_name": "إليزي"
  },
  {
    "pk": 1174  ,"fields": { "postcode": 34011,  "wilaya":   34, "name": "El Hamadia" },
    "id": 1177,
    "commune_name_ascii": "Elhammadia",
    "commune_name": "الحمادية",
    "daira_name_ascii": "El Hamadia",
    "daira_name": "الحمادية",
    "wilaya_code": "34",
    "wilaya_name_ascii": "Bordj Bou Arreridj",
    "wilaya_name": "برج بوعريريج"
  },
  {
    "pk": 1186  ,"fields": { "postcode": 34023,  "wilaya":   34, "name": "Ouled Sidi Brahim" },
    "id": 1189,
    "commune_name_ascii": "Ouled Sidi Brahim",
    "commune_name": "أولاد سيدي ابراهيم",
    "daira_name_ascii": "Mansourah",
    "daira_name": "المنصورة",
    "wilaya_code": "34",
    "wilaya_name_ascii": "Bordj Bou Arreridj",
    "wilaya_name": "برج بوعريريج"
  },
  {
    "model": "base.commune",
    "pk": 1171,
    "fields": {
      "postcode": 34008,
      "wilaya": 34,
      "name": "Ain Taghrout"
    },
    "id": 1164,
    "commune_name_ascii": "Ain Taghrout",
    "commune_name": "عين تاغروت",
    "daira_name_ascii": "Ain Taghrout",
    "daira_name": "عين تاغروت",
    "wilaya_code": "34",
    "wilaya_name_ascii": "Bordj Bou Arreridj",
    "wilaya_name": "برج بوعريريج"
  },
  {
    "model": "base.commune",
    "pk": 1189,
    "fields": {
      "postcode": 34026,
      "wilaya": 34,
      "name": "Tixter"
    },
    "id": 1197,
    "commune_name_ascii": "Tixter",
    "commune_name": "تيكستار",
    "daira_name_ascii": "Ain Taghrout",
    "daira_name": "عين تاغروت",
    "wilaya_code": "34",
    "wilaya_name_ascii": "Bordj Bou Arreridj",
    "wilaya_name": "برج بوعريريج"
  },
  {
    "model": "base.commune",
    "pk": 1175,
    "fields": {
      "postcode": 34012,
      "wilaya": 34,
      "name": "Belimour"
    },
    "id": 1167,
    "commune_name_ascii": "Belimour",
    "commune_name": "بليمور",
    "daira_name_ascii": "Bordj Ghedir",
    "daira_name": "برج الغدير",
    "wilaya_code": "34",
    "wilaya_name_ascii": "Bordj Bou Arreridj",
    "wilaya_name": "برج بوعريريج"
  },
  {
    "pk": 1191  ,"fields": { "postcode": 34028,  "wilaya":   34, "name": "El Anseur" },
    "id": 1176,
    "commune_name_ascii": "El Annasseur",
    "commune_name": "العناصر",
    "daira_name_ascii": "Bordj Ghedir",
    "daira_name": "برج الغدير",
    "wilaya_code": "34",
    "wilaya_name_ascii": "Bordj Bou Arreridj",
    "wilaya_name": "برج بوعريريج"
  },
  {
    "pk": 1195  ,"fields": { "postcode": 34032,  "wilaya":   34, "name": "Ghilassa" },
    "id": 1180,
    "commune_name_ascii": "Ghailasa",
    "commune_name": "غيلاسة",
    "daira_name_ascii": "Bordj Ghedir",
    "daira_name": "برج الغدير",
    "wilaya_code": "34",
    "wilaya_name_ascii": "Bordj Bou Arreridj",
    "wilaya_name": "برج بوعريريج"
  },
  {
    "model": "base.commune",
    "pk": 1184,
    "fields": {
      "postcode": 34021,
      "wilaya": 34,
      "name": "Taglait"
    },
    "id": 1194,
    "commune_name_ascii": "Taglait",
    "commune_name": "تقلعيت",
    "daira_name_ascii": "Bordj Ghedir",
    "daira_name": "برج الغدير",
    "wilaya_code": "34",
    "wilaya_name_ascii": "Bordj Bou Arreridj",
    "wilaya_name": "برج بوعريريج"
  },
  {
    "pk": 1172  ,"fields": { "postcode": 34009,  "wilaya":   34, "name": "Bordj Ghdir" },
    "id": 1170,
    "commune_name_ascii": "Bordj Ghedir",
    "commune_name": "برج الغدير",
    "daira_name_ascii": "Bordj Ghedir",
    "daira_name": "برج الغدير",
    "wilaya_code": "34",
    "wilaya_name_ascii": "Bordj Bou Arreridj",
    "wilaya_name": "برج بوعريريج"
  },
  {
    "pk": 1190  ,"fields": { "postcode": 34027,  "wilaya":   34, "name": "El Ach" },
    "id": 1174,
    "commune_name_ascii": "El Euch",
    "commune_name": "العش",
    "daira_name_ascii": "El Hamadia",
    "daira_name": "الحمادية",
    "wilaya_code": "34",
    "wilaya_name_ascii": "Bordj Bou Arreridj",
    "wilaya_name": "برج بوعريريج"
  },
  {
    "pk": 1173  ,"fields": { "postcode": 34010,  "wilaya":   34, "name": "Sidi Embarek" },
    "id": 1192,
    "commune_name_ascii": "Sidi Embarek",
    "commune_name": "سيدي أمبارك",
    "daira_name_ascii": "Bir Kasdali",
    "daira_name": "بئر قاصد علي",
    "wilaya_code": "34",
    "wilaya_name_ascii": "Bordj Bou Arreridj",
    "wilaya_name": "برج بوعريريج"
  },
  {
    "model": "base.commune",
    "pk": 1183,
    "fields": {
      "postcode": 34020,
      "wilaya": 34,
      "name": "Khelil"
    },
    "id": 1183,
    "commune_name_ascii": "Khelil",
    "commune_name": "خليل",
    "daira_name_ascii": "Bir Kasdali",
    "daira_name": "بئر قاصد علي",
    "wilaya_code": "34",
    "wilaya_name_ascii": "Bordj Bou Arreridj",
    "wilaya_name": "برج بوعريريج"
  },
  {
    "model": "base.commune",
    "pk": 1194,
    "fields": {
      "postcode": 34031,
      "wilaya": 34,
      "name": "Bir Kasdali"
    },
    "id": 1169,
    "commune_name_ascii": "Bir Kasdali",
    "commune_name": "بئر قاصد علي",
    "daira_name_ascii": "Bir Kasdali",
    "daira_name": "بئر قاصد علي",
    "wilaya_code": "34",
    "wilaya_name_ascii": "Bordj Bou Arreridj",
    "wilaya_name": "برج بوعريريج"
  },
  {
    "pk": 1187  ,"fields": { "postcode": 34024,  "wilaya":   34, "name": "Tafreg" },
    "id": 1193,
    "commune_name_ascii": "Tefreg",
    "commune_name": "تفرق",
    "daira_name_ascii": "Djaafra",
    "daira_name": "جعافرة",
    "wilaya_code": "34",
    "wilaya_name_ascii": "Bordj Bou Arreridj",
    "wilaya_name": "برج بوعريريج"
  },
  {
    "model": "base.commune",
    "pk": 1179,
    "fields": {
      "postcode": 34016,
      "wilaya": 34,
      "name": "El Main"
    },
    "id": 1178,
    "commune_name_ascii": "El Main",
    "commune_name": "الماين",
    "daira_name_ascii": "Djaafra",
    "daira_name": "جعافرة",
    "wilaya_code": "34",
    "wilaya_name_ascii": "Bordj Bou Arreridj",
    "wilaya_name": "برج بوعريريج"
  },
  {
    "model": "base.commune",
    "pk": 1178,
    "fields": {
      "postcode": 34015,
      "wilaya": 34,
      "name": "Djaafra"
    },
    "id": 1173,
    "commune_name_ascii": "Djaafra",
    "commune_name": "جعافرة",
    "daira_name_ascii": "Djaafra",
    "daira_name": "جعافرة",
    "wilaya_code": "34",
    "wilaya_name_ascii": "Bordj Bou Arreridj",
    "wilaya_name": "برج بوعريريج"
  },
  {
    "model": "base.commune",
    "pk": 1188,
    "fields": {
      "postcode": 34025,
      "wilaya": 34,
      "name": "Colla"
    },
    "id": 1172,
    "commune_name_ascii": "Colla",
    "commune_name": "القلة",
    "daira_name_ascii": "Djaafra",
    "daira_name": "جعافرة",
    "wilaya_code": "34",
    "wilaya_name_ascii": "Bordj Bou Arreridj",
    "wilaya_name": "برج بوعريريج"
  },
  {
    "model": "base.commune",
    "pk": 1177,
    "fields": {
      "postcode": 34014,
      "wilaya": 34,
      "name": "Teniet En Nasr"
    },
    "id": 1196,
    "commune_name_ascii": "Teniet En Nasr",
    "commune_name": "ثنية النصر",
    "daira_name_ascii": "Medjana",
    "daira_name": "مجانة",
    "wilaya_code": "34",
    "wilaya_name_ascii": "Bordj Bou Arreridj",
    "wilaya_name": "برج بوعريريج"
  },
  {
    "pk": 1168  ,"fields": { "postcode": 34005,  "wilaya":   34, "name": "El Mhir" },
    "id": 1179,
    "commune_name_ascii": "El M'hir",
    "commune_name": "المهير",
    "daira_name_ascii": "Mansourah",
    "daira_name": "المنصورة",
    "wilaya_code": "34",
    "wilaya_name_ascii": "Bordj Bou Arreridj",
    "wilaya_name": "برج بوعريريج"
  },
  {
    "model": "base.commune",
    "pk": 1185,
    "fields": {
      "postcode": 34022,
      "wilaya": 34,
      "name": "Ksour"
    },
    "id": 1184,
    "commune_name_ascii": "Ksour",
    "commune_name": "القصور",
    "daira_name_ascii": "El Hamadia",
    "daira_name": "الحمادية",
    "wilaya_code": "34",
    "wilaya_name_ascii": "Bordj Bou Arreridj",
    "wilaya_name": "برج بوعريريج"
  },
  {
    "model": "base.commune",
    "pk": 1167,
    "fields": {
      "postcode": 34004,
      "wilaya": 34,
      "name": "Mansoura"
    },
    "id": 1185,
    "commune_name_ascii": "Mansoura",
    "commune_name": "المنصورة",
    "daira_name_ascii": "Mansourah",
    "daira_name": "المنصورة",
    "wilaya_code": "34",
    "wilaya_name_ascii": "Bordj Bou Arreridj",
    "wilaya_name": "برج بوعريريج"
  },
  {
    "model": "base.commune",
    "pk": 1197,
    "fields": {
      "postcode": 34034,
      "wilaya": 34,
      "name": "Haraza"
    },
    "id": 1181,
    "commune_name_ascii": "Haraza",
    "commune_name": "حرازة",
    "daira_name_ascii": "Mansourah",
    "daira_name": "المنصورة",
    "wilaya_code": "34",
    "wilaya_name_ascii": "Bordj Bou Arreridj",
    "wilaya_name": "برج بوعريريج"
  },
  {
    "model": "base.commune",
    "pk": 1196,
    "fields": {
      "postcode": 34033,
      "wilaya": 34,
      "name": "Rabta"
    },
    "id": 1190,
    "commune_name_ascii": "Rabta",
    "commune_name": "الرابطة",
    "daira_name_ascii": "El Hamadia",
    "daira_name": "الحمادية",
    "wilaya_code": "34",
    "wilaya_name_ascii": "Bordj Bou Arreridj",
    "wilaya_name": "برج بوعريريج"
  },
  {
    "model": "base.commune",
    "pk": 1170,
    "fields": {
      "postcode": 34007,
      "wilaya": 34,
      "name": "El Achir"
    },
    "id": 1175,
    "commune_name_ascii": "El Achir",
    "commune_name": "الياشير",
    "daira_name_ascii": "Medjana",
    "daira_name": "مجانة",
    "wilaya_code": "34",
    "wilaya_name_ascii": "Bordj Bou Arreridj",
    "wilaya_name": "برج بوعريريج"
  },
  {
    "model": "base.commune",
    "pk": 1182,
    "fields": {
      "postcode": 34019,
      "wilaya": 34,
      "name": "Hasnaoua"
    },
    "id": 1182,
    "commune_name_ascii": "Hasnaoua",
    "commune_name": "حسناوة",
    "daira_name_ascii": "Medjana",
    "daira_name": "مجانة",
    "wilaya_code": "34",
    "wilaya_name_ascii": "Bordj Bou Arreridj",
    "wilaya_name": "برج بوعريريج"
  },
  {
    "model": "base.commune",
    "pk": 1176,
    "fields": {
      "postcode": 34013,
      "wilaya": 34,
      "name": "Medjana"
    },
    "id": 1186,
    "commune_name_ascii": "Medjana",
    "commune_name": "مجانة",
    "daira_name_ascii": "Medjana",
    "daira_name": "مجانة",
    "wilaya_code": "34",
    "wilaya_name_ascii": "Bordj Bou Arreridj",
    "wilaya_name": "برج بوعريريج"
  },
  {
    "model": "base.commune",
    "pk": 1193,
    "fields": {
      "postcode": 34030,
      "wilaya": 34,
      "name": "Ain Tesra"
    },
    "id": 1165,
    "commune_name_ascii": "Ain Tesra",
    "commune_name": "عين تسرة",
    "daira_name_ascii": "Ras El Oued",
    "daira_name": "رأس الوادي",
    "wilaya_code": "34",
    "wilaya_name_ascii": "Bordj Bou Arreridj",
    "wilaya_name": "برج بوعريريج"
  },
  {
    "model": "base.commune",
    "pk": 1180,
    "fields": {
      "postcode": 34017,
      "wilaya": 34,
      "name": "Ouled Brahem"
    },
    "id": 1187,
    "commune_name_ascii": "Ouled Brahem",
    "commune_name": "أولاد أبراهم",
    "daira_name_ascii": "Ras El Oued",
    "daira_name": "رأس الوادي",
    "wilaya_code": "34",
    "wilaya_name_ascii": "Bordj Bou Arreridj",
    "wilaya_name": "برج بوعريريج"
  },
  {
    "model": "base.commune",
    "pk": 1165,
    "fields": {
      "postcode": 34002,
      "wilaya": 34,
      "name": "Ras El Oued"
    },
    "id": 1191,
    "commune_name_ascii": "Ras El Oued",
    "commune_name": "رأس الوادي",
    "daira_name_ascii": "Ras El Oued",
    "daira_name": "رأس الوادي",
    "wilaya_code": "34",
    "wilaya_name_ascii": "Bordj Bou Arreridj",
    "wilaya_name": "برج بوعريريج"
  },
  {
    "pk": 1166  ,"fields": { "postcode": 34003,  "wilaya":   34, "name": "Bordj Zemoura" },
    "id": 1171,
    "commune_name_ascii": "Bordj Zemmoura",
    "commune_name": "برج زمورة",
    "daira_name_ascii": "Bordj Zemmoura",
    "daira_name": "برج زمورة",
    "wilaya_code": "34",
    "wilaya_name_ascii": "Bordj Bou Arreridj",
    "wilaya_name": "برج بوعريريج"
  },
  {
    "model": "base.commune",
    "pk": 1181,
    "fields": {
      "postcode": 34018,
      "wilaya": 34,
      "name": "Ouled Dahmane"
    },
    "id": 1188,
    "commune_name_ascii": "Ouled Dahmane",
    "commune_name": "أولاد دحمان",
    "daira_name_ascii": "Bordj Zemmoura",
    "daira_name": "برج زمورة",
    "wilaya_code": "34",
    "wilaya_name_ascii": "Bordj Bou Arreridj",
    "wilaya_name": "برج بوعريريج"
  },
  {
    "pk": 1192  ,"fields": { "postcode": 34029,  "wilaya":   34, "name": "Tesmart" },
    "id": 1195,
    "commune_name_ascii": "Tassamert",
    "commune_name": "تسامرت",
    "daira_name_ascii": "Bordj Zemmoura",
    "daira_name": "برج زمورة",
    "wilaya_code": "34",
    "wilaya_name_ascii": "Bordj Bou Arreridj",
    "wilaya_name": "برج بوعريريج"
  },
  {
    "pk": 1164  ,"fields": { "postcode": 34001,  "wilaya":   34, "name": "Bordj Bou Arreridj" },
    "id": 1166,
    "commune_name_ascii": "B. B. Arreridj",
    "commune_name": "برج بوعريرج",
    "daira_name_ascii": "Bordj Bou Arreridj",
    "daira_name": "برج بوعريريج",
    "wilaya_code": "34",
    "wilaya_name_ascii": "Bordj Bou Arreridj",
    "wilaya_name": "برج بوعريريج"
  },
  {
    "model": "base.commune",
    "pk": 1169,
    "fields": {
      "postcode": 34006,
      "wilaya": 34,
      "name": "Ben Daoud"
    },
    "id": 1168,
    "commune_name_ascii": "Ben Daoud",
    "commune_name": "بن داود",
    "daira_name_ascii": "Mansourah",
    "daira_name": "المنصورة",
    "wilaya_code": "34",
    "wilaya_name_ascii": "Bordj Bou Arreridj",
    "wilaya_name": "برج بوعريريج"
  },
  {
    "model": "base.commune",
    "pk": 1229,
    "fields": {
      "postcode": 35038,
      "wilaya": 35,
      "name": "El Kharrouba"
    },
    "id": 1212,
    "commune_name_ascii": "El Kharrouba",
    "commune_name": "الخروبة",
    "daira_name_ascii": "Boudouaou",
    "daira_name": "بودواو",
    "wilaya_code": "35",
    "wilaya_name_ascii": "Boumerdes",
    "wilaya_name": "بومرداس"
  },
  {
    "model": "base.commune",
    "pk": 1220,
    "fields": {
      "postcode": 35028,
      "wilaya": 35,
      "name": "Dellys"
    },
    "id": 1210,
    "commune_name_ascii": "Dellys",
    "commune_name": "دلس",
    "daira_name_ascii": "Dellys",
    "daira_name": "دلس",
    "wilaya_code": "35",
    "wilaya_name_ascii": "Boumerdes",
    "wilaya_name": "بومرداس"
  },
  {
    "model": "base.commune",
    "pk": 1219,
    "fields": {
      "postcode": 35027,
      "wilaya": 35,
      "name": "Ben Choud"
    },
    "id": 1201,
    "commune_name_ascii": "Ben Choud",
    "commune_name": "بن شود",
    "daira_name_ascii": "Dellys",
    "daira_name": "دلس",
    "wilaya_code": "35",
    "wilaya_name_ascii": "Boumerdes",
    "wilaya_name": "بومرداس"
  },
  {
    "model": "base.commune",
    "pk": 1200,
    "fields": {
      "postcode": 35004,
      "wilaya": 35,
      "name": "Afir"
    },
    "id": 1198,
    "commune_name_ascii": "Afir",
    "commune_name": "أعفير",
    "daira_name_ascii": "Dellys",
    "daira_name": "دلس",
    "wilaya_code": "35",
    "wilaya_name_ascii": "Boumerdes",
    "wilaya_name": "بومرداس"
  },
  {
    "model": "base.commune",
    "pk": 1211,
    "fields": {
      "postcode": 35015,
      "wilaya": 35,
      "name": "Thenia"
    },
    "id": 1226,
    "commune_name_ascii": "Thenia",
    "commune_name": "الثنية",
    "daira_name_ascii": "Thenia",
    "daira_name": "الثنية",
    "wilaya_code": "35",
    "wilaya_name_ascii": "Boumerdes",
    "wilaya_name": "بومرداس"
  },
  {
    "model": "base.commune",
    "pk": 1222,
    "fields": {
      "postcode": 35030,
      "wilaya": 35,
      "name": "Beni Amrane"
    },
    "id": 1202,
    "commune_name_ascii": "Beni Amrane",
    "commune_name": "بني عمران",
    "daira_name_ascii": "Thenia",
    "daira_name": "الثنية",
    "wilaya_code": "35",
    "wilaya_name_ascii": "Boumerdes",
    "wilaya_name": "بومرداس"
  },
  {
    "model": "base.commune",
    "pk": 1228,
    "fields": {
      "postcode": 35037,
      "wilaya": 35,
      "name": "Khemis El Khechna"
    },
    "id": 1215,
    "commune_name_ascii": "Khemis El Khechna",
    "commune_name": "خميس الخشنة",
    "daira_name_ascii": "Khemis El Khechna",
    "daira_name": "خميس الخشنة",
    "wilaya_code": "35",
    "wilaya_name_ascii": "Boumerdes",
    "wilaya_name": "بومرداس"
  },
  {
    "model": "base.commune",
    "pk": 1221,
    "fields": {
      "postcode": 35029,
      "wilaya": 35,
      "name": "Ammal"
    },
    "id": 1199,
    "commune_name_ascii": "Ammal",
    "commune_name": "عمال",
    "daira_name_ascii": "Thenia",
    "daira_name": "الثنية",
    "wilaya_code": "35",
    "wilaya_name_ascii": "Boumerdes",
    "wilaya_name": "بومرداس"
  },
  {
    "model": "base.commune",
    "pk": 1212,
    "fields": {
      "postcode": 35018,
      "wilaya": 35,
      "name": "Timezrit"
    },
    "id": 1228,
    "commune_name_ascii": "Timezrit",
    "commune_name": "تيمزريت",
    "daira_name_ascii": "Isser",
    "daira_name": "يسر",
    "wilaya_code": "35",
    "wilaya_name_ascii": "Boumerdes",
    "wilaya_name": "بومرداس"
  },
  {
    "model": "base.commune",
    "pk": 1207,
    "fields": {
      "postcode": 35011,
      "wilaya": 35,
      "name": "Zemmouri"
    },
    "id": 1229,
    "commune_name_ascii": "Zemmouri",
    "commune_name": "زموري",
    "daira_name_ascii": "Bordj Menaiel",
    "daira_name": "برج منايل",
    "wilaya_code": "35",
    "wilaya_name_ascii": "Boumerdes",
    "wilaya_name": "بومرداس"
  },
  {
    "model": "base.commune",
    "pk": 1215,
    "fields": {
      "postcode": 35021,
      "wilaya": 35,
      "name": "Larbatache"
    },
    "id": 1216,
    "commune_name_ascii": "Larbatache",
    "commune_name": "الاربعطاش",
    "daira_name_ascii": "Khemis El Khechna",
    "daira_name": "خميس الخشنة",
    "wilaya_code": "35",
    "wilaya_name_ascii": "Boumerdes",
    "wilaya_name": "بومرداس"
  },
  {
    "model": "base.commune",
    "pk": 1206,
    "fields": {
      "postcode": 35010,
      "wilaya": 35,
      "name": "Isser"
    },
    "id": 1214,
    "commune_name_ascii": "Isser",
    "commune_name": "يسر",
    "daira_name_ascii": "Isser",
    "daira_name": "يسر",
    "wilaya_code": "35",
    "wilaya_name_ascii": "Boumerdes",
    "wilaya_name": "بومرداس"
  },
  {
    "model": "base.commune",
    "pk": 1210,
    "fields": {
      "postcode": 35014,
      "wilaya": 35,
      "name": "Chabet El Ameur"
    },
    "id": 1208,
    "commune_name_ascii": "Chabet El Ameur",
    "commune_name": "شعبة العامر",
    "daira_name_ascii": "Isser",
    "daira_name": "يسر",
    "wilaya_code": "35",
    "wilaya_name_ascii": "Boumerdes",
    "wilaya_name": "بومرداس"
  },
  {
    "model": "base.commune",
    "pk": 27,
    "fields": {
      "postcode": 1027,
      "wilaya": 1,
      "name": "Ouled Aissa"
    },
    "id": 1219,
    "commune_name_ascii": "Ouled Aissa",
    "commune_name": "أولاد عيسى",
    "daira_name_ascii": "Naciria",
    "daira_name": "الناصرية",
    "wilaya_code": "35",
    "wilaya_name_ascii": "Boumerdes",
    "wilaya_name": "بومرداس"
  },
  {
    "model": "base.commune",
    "pk": 1204,
    "fields": {
      "postcode": 35008,
      "wilaya": 35,
      "name": "Naciria"
    },
    "id": 1218,
    "commune_name_ascii": "Naciria",
    "commune_name": "الناصرية",
    "daira_name_ascii": "Naciria",
    "daira_name": "الناصرية",
    "wilaya_code": "35",
    "wilaya_name_ascii": "Boumerdes",
    "wilaya_name": "بومرداس"
  },
  {
    "model": "base.commune",
    "pk": 1216,
    "fields": {
      "postcode": 35022,
      "wilaya": 35,
      "name": "Bouzegza Keddara"
    },
    "id": 1207,
    "commune_name_ascii": "Bouzegza Keddara",
    "commune_name": "بوزقزة قدارة",
    "daira_name_ascii": "Boudouaou",
    "daira_name": "بودواو",
    "wilaya_code": "35",
    "wilaya_name_ascii": "Boumerdes",
    "wilaya_name": "بومرداس"
  },
  {
    "model": "base.commune",
    "pk": 1223,
    "fields": {
      "postcode": 35031,
      "wilaya": 35,
      "name": "Souk El Had"
    },
    "id": 1224,
    "commune_name_ascii": "Souk El Had",
    "commune_name": "سوق الحد",
    "daira_name_ascii": "Thenia",
    "daira_name": "الثنية",
    "wilaya_code": "35",
    "wilaya_name_ascii": "Boumerdes",
    "wilaya_name": "بومرداس"
  },
  {
    "model": "base.commune",
    "pk": 1203,
    "fields": {
      "postcode": 35007,
      "wilaya": 35,
      "name": "Sidi Daoud"
    },
    "id": 1223,
    "commune_name_ascii": "Sidi Daoud",
    "commune_name": "سيدي داود",
    "daira_name_ascii": "Baghlia",
    "daira_name": "بغلية",
    "wilaya_code": "35",
    "wilaya_name_ascii": "Boumerdes",
    "wilaya_name": "بومرداس"
  },
  {
    "model": "base.commune",
    "pk": 1202,
    "fields": {
      "postcode": 35006,
      "wilaya": 35,
      "name": "Baghlia"
    },
    "id": 1200,
    "commune_name_ascii": "Baghlia",
    "commune_name": "بغلية",
    "daira_name_ascii": "Baghlia",
    "daira_name": "بغلية",
    "wilaya_code": "35",
    "wilaya_name_ascii": "Boumerdes",
    "wilaya_name": "بومرداس"
  },
  {
    "pk": 1226  ,"fields": { "postcode": 35035,  "wilaya":   35, "name": "Laghata" },
    "id": 1217,
    "commune_name_ascii": "Leghata",
    "commune_name": "لقاطة",
    "daira_name_ascii": "Bordj Menaiel",
    "daira_name": "برج منايل",
    "wilaya_code": "35",
    "wilaya_name_ascii": "Boumerdes",
    "wilaya_name": "بومرداس"
  },
  {
    "model": "base.commune",
    "pk": 1205,
    "fields": {
      "postcode": 35009,
      "wilaya": 35,
      "name": "Djinet"
    },
    "id": 1211,
    "commune_name_ascii": "Djinet",
    "commune_name": "جنات",
    "daira_name_ascii": "Bordj Menaiel",
    "daira_name": "برج منايل",
    "wilaya_code": "35",
    "wilaya_name_ascii": "Boumerdes",
    "wilaya_name": "بومرداس"
  },
  {
    "model": "base.commune",
    "pk": 1209,
    "fields": {
      "postcode": 35013,
      "wilaya": 35,
      "name": "Tidjelabine"
    },
    "id": 1227,
    "commune_name_ascii": "Tidjelabine",
    "commune_name": "تيجلابين",
    "daira_name_ascii": "Boumerdes",
    "daira_name": "بومرداس",
    "wilaya_code": "35",
    "wilaya_name_ascii": "Boumerdes",
    "wilaya_name": "بومرداس"
  },
  {
    "model": "base.commune",
    "pk": 1208,
    "fields": {
      "postcode": 35012,
      "wilaya": 35,
      "name": "Si Mustapha"
    },
    "id": 1222,
    "commune_name_ascii": "Si Mustapha",
    "commune_name": "سي مصطفى",
    "daira_name_ascii": "Isser",
    "daira_name": "يسر",
    "wilaya_code": "35",
    "wilaya_name_ascii": "Boumerdes",
    "wilaya_name": "بومرداس"
  },
  {
    "model": "base.commune",
    "pk": 1225,
    "fields": {
      "postcode": 35033,
      "wilaya": 35,
      "name": "Ouled Hedadj"
    },
    "id": 1220,
    "commune_name_ascii": "Ouled Hedadj",
    "commune_name": "أولاد هداج",
    "daira_name_ascii": "Boudouaou",
    "daira_name": "بودواو",
    "wilaya_code": "35",
    "wilaya_name_ascii": "Boumerdes",
    "wilaya_name": "بومرداس"
  },
  {
    "model": "base.commune",
    "pk": 1214,
    "fields": {
      "postcode": 35020,
      "wilaya": 35,
      "name": "Ouled Moussa"
    },
    "id": 1221,
    "commune_name_ascii": "Ouled Moussa",
    "commune_name": "أولاد موسى",
    "daira_name_ascii": "Khemis El Khechna",
    "daira_name": "خميس الخشنة",
    "wilaya_code": "35",
    "wilaya_name_ascii": "Boumerdes",
    "wilaya_name": "بومرداس"
  },
  {
    "model": "base.commune",
    "pk": 1198,
    "fields": {
      "postcode": 35001,
      "wilaya": 35,
      "name": "Boumerdes"
    },
    "id": 1206,
    "commune_name_ascii": "Boumerdes",
    "commune_name": "بومرداس",
    "daira_name_ascii": "Boumerdes",
    "daira_name": "بومرداس",
    "wilaya_code": "35",
    "wilaya_name_ascii": "Boumerdes",
    "wilaya_name": "بومرداس"
  },
  {
    "model": "base.commune",
    "pk": 1213,
    "fields": {
      "postcode": 35019,
      "wilaya": 35,
      "name": "Corso"
    },
    "id": 1209,
    "commune_name_ascii": "Corso",
    "commune_name": "قورصو",
    "daira_name_ascii": "Boumerdes",
    "daira_name": "بومرداس",
    "wilaya_code": "35",
    "wilaya_name_ascii": "Boumerdes",
    "wilaya_name": "بومرداس"
  },
  {
    "model": "base.commune",
    "pk": 1201,
    "fields": {
      "postcode": 35005,
      "wilaya": 35,
      "name": "Bordj Menaiel"
    },
    "id": 1203,
    "commune_name_ascii": "Bordj Menaiel",
    "commune_name": "برج منايل",
    "daira_name_ascii": "Bordj Menaiel",
    "daira_name": "برج منايل",
    "wilaya_code": "35",
    "wilaya_name_ascii": "Boumerdes",
    "wilaya_name": "بومرداس"
  },
  {
    "model": "base.commune",
    "pk": 1199,
    "fields": {
      "postcode": 35002,
      "wilaya": 35,
      "name": "Boudouaou"
    },
    "id": 1204,
    "commune_name_ascii": "Boudouaou",
    "commune_name": "بودواو",
    "daira_name_ascii": "Boudouaou",
    "daira_name": "بودواو",
    "wilaya_code": "35",
    "wilaya_name_ascii": "Boumerdes",
    "wilaya_name": "بومرداس"
  },
  {
    "model": "base.commune",
    "pk": 1224,
    "fields": {
      "postcode": 35032,
      "wilaya": 35,
      "name": "Boudouaou El Bahri"
    },
    "id": 1205,
    "commune_name_ascii": "Boudouaou El Bahri",
    "commune_name": "بودواو البحري",
    "daira_name_ascii": "Boudouaou",
    "daira_name": "بودواو",
    "wilaya_code": "35",
    "wilaya_name_ascii": "Boumerdes",
    "wilaya_name": "بومرداس"
  },
  {
    "model": "base.commune",
    "pk": 1217,
    "fields": {
      "postcode": 35025,
      "wilaya": 35,
      "name": "Taourga"
    },
    "id": 1225,
    "commune_name_ascii": "Taourga",
    "commune_name": "تاورقة",
    "daira_name_ascii": "Baghlia",
    "daira_name": "بغلية",
    "wilaya_code": "35",
    "wilaya_name_ascii": "Boumerdes",
    "wilaya_name": "بومرداس"
  },
  {
    "pk": 1227  ,"fields": { "postcode": 35036,  "wilaya":   35, "name": "Hemmadi" },
    "id": 1213,
    "commune_name_ascii": "Hammedi",
    "commune_name": "حمادي",
    "daira_name_ascii": "Khemis El Khechna",
    "daira_name": "خميس الخشنة",
    "wilaya_code": "35",
    "wilaya_name_ascii": "Boumerdes",
    "wilaya_name": "بومرداس"
  },
  {
    "model": "base.commune",
    "pk": 1235,
    "fields": {
      "postcode": 36006,
      "wilaya": 36,
      "name": "Ain El Assel"
    },
    "id": 1230,
    "commune_name_ascii": "Ain El Assel",
    "commune_name": "عين العسل",
    "daira_name_ascii": "El Tarf",
    "daira_name": "الطارف",
    "wilaya_code": "36",
    "wilaya_name_ascii": "El Tarf",
    "wilaya_name": "الطارف"
  },
  {
    "model": "base.commune",
    "pk": 1233,
    "fields": {
      "postcode": 36004,
      "wilaya": 36,
      "name": "Bougous"
    },
    "id": 1236,
    "commune_name_ascii": "Bougous",
    "commune_name": "بوقوس",
    "daira_name_ascii": "El Tarf",
    "daira_name": "الطارف",
    "wilaya_code": "36",
    "wilaya_name_ascii": "El Tarf",
    "wilaya_name": "الطارف"
  },
  {
    "model": "base.commune",
    "pk": 1230,
    "fields": {
      "postcode": 36001,
      "wilaya": 36,
      "name": "El Tarf"
    },
    "id": 1246,
    "commune_name_ascii": "El Tarf",
    "commune_name": "الطارف",
    "daira_name_ascii": "El Tarf",
    "daira_name": "الطارف",
    "wilaya_code": "36",
    "wilaya_name_ascii": "El Tarf",
    "wilaya_name": "الطارف"
  },
  {
    "model": "base.commune",
    "pk": 765,
    "fields": {
      "postcode": 21015,
      "wilaya": 21,
      "name": "Zitouna"
    },
    "id": 1253,
    "commune_name_ascii": "Zitouna",
    "commune_name": "الزيتونة",
    "daira_name_ascii": "El Tarf",
    "daira_name": "الطارف",
    "wilaya_code": "36",
    "wilaya_name_ascii": "El Tarf",
    "wilaya_name": "الطارف"
  },
  {
    "model": "base.commune",
    "pk": 236,
    "fields": {
      "postcode": 7007,
      "wilaya": 7,
      "name": "Besbes"
    },
    "id": 1235,
    "commune_name_ascii": "Besbes",
    "commune_name": "البسباس",
    "daira_name_ascii": "Besbes",
    "daira_name": "البسباس",
    "wilaya_code": "36",
    "wilaya_name_ascii": "El Tarf",
    "wilaya_name": "الطارف"
  },
  {
    "model": "base.commune",
    "pk": 1134,
    "fields": {
      "postcode": 31025,
      "wilaya": 31,
      "name": "Ain Kerma"
    },
    "id": 1231,
    "commune_name_ascii": "Ain Kerma",
    "commune_name": "عين الكرمة",
    "daira_name_ascii": "Bouhadjar",
    "daira_name": "بوحجار",
    "wilaya_code": "36",
    "wilaya_name_ascii": "El Tarf",
    "wilaya_name": "الطارف"
  },
  {
    "model": "base.commune",
    "pk": 1231,
    "fields": {
      "postcode": 36002,
      "wilaya": 36,
      "name": "Bouhadjar"
    },
    "id": 1237,
    "commune_name_ascii": "Bouhadjar",
    "commune_name": "بوحجار",
    "daira_name_ascii": "Bouhadjar",
    "daira_name": "بوحجار",
    "wilaya_code": "36",
    "wilaya_name_ascii": "El Tarf",
    "wilaya_name": "الطارف"
  },
  {
    "model": "base.commune",
    "pk": 1252,
    "fields": {
      "postcode": 36023,
      "wilaya": 36,
      "name": "Hammam Beni Salah"
    },
    "id": 1247,
    "commune_name_ascii": "Hammam Beni Salah",
    "commune_name": "حمام بني صالح",
    "daira_name_ascii": "Bouhadjar",
    "daira_name": "بوحجار",
    "wilaya_code": "36",
    "wilaya_name_ascii": "El Tarf",
    "wilaya_name": "الطارف"
  },
  {
    "model": "base.commune",
    "pk": 1251,
    "fields": {
      "postcode": 36022,
      "wilaya": 36,
      "name": "Oued Zitoun"
    },
    "id": 1249,
    "commune_name_ascii": "Oued Zitoun",
    "commune_name": "وادي الزيتون",
    "daira_name_ascii": "Bouhadjar",
    "daira_name": "بوحجار",
    "wilaya_code": "36",
    "wilaya_name_ascii": "El Tarf",
    "wilaya_name": "الطارف"
  },
  {
    "pk": 1232  ,"fields": { "postcode": 36003,  "wilaya":   36, "name": "Ben Mhidi" },
    "id": 1233,
    "commune_name_ascii": "Ben M Hidi",
    "commune_name": "بن مهيدي",
    "daira_name_ascii": "Ben M'hidi",
    "daira_name": "بن مهيدي",
    "wilaya_code": "36",
    "wilaya_name_ascii": "El Tarf",
    "wilaya_name": "الطارف"
  },
  {
    "model": "base.commune",
    "pk": 1239,
    "fields": {
      "postcode": 36010,
      "wilaya": 36,
      "name": "Berrihane"
    },
    "id": 1234,
    "commune_name_ascii": "Berrihane",
    "commune_name": "بريحان",
    "daira_name_ascii": "Ben M'hidi",
    "daira_name": "بن مهيدي",
    "wilaya_code": "36",
    "wilaya_name_ascii": "El Tarf",
    "wilaya_name": "الطارف"
  },
  {
    "model": "base.commune",
    "pk": 1244,
    "fields": {
      "postcode": 36015,
      "wilaya": 36,
      "name": "Chebaita Mokhtar"
    },
    "id": 1239,
    "commune_name_ascii": "Chebaita Mokhtar",
    "commune_name": "شبيطة مختار",
    "daira_name_ascii": "Drean",
    "daira_name": "الذرعان",
    "wilaya_code": "36",
    "wilaya_name_ascii": "El Tarf",
    "wilaya_name": "الطارف"
  },
  {
    "model": "base.commune",
    "pk": 1247,
    "fields": {
      "postcode": 36018,
      "wilaya": 36,
      "name": "Echatt"
    },
    "id": 1243,
    "commune_name_ascii": "Echatt",
    "commune_name": "الشط",
    "daira_name_ascii": "Ben M'hidi",
    "daira_name": "بن مهيدي",
    "wilaya_code": "36",
    "wilaya_name_ascii": "El Tarf",
    "wilaya_name": "الطارف"
  },
  {
    "model": "base.commune",
    "pk": 1236,
    "fields": {
      "postcode": 36007,
      "wilaya": 36,
      "name": "El Aioun"
    },
    "id": 1244,
    "commune_name_ascii": "El Aioun",
    "commune_name": "العيون",
    "daira_name_ascii": "El Kala",
    "daira_name": "القالة",
    "wilaya_code": "36",
    "wilaya_name_ascii": "El Tarf",
    "wilaya_name": "الطارف"
  },
  {
    "model": "base.commune",
    "pk": 1234,
    "fields": {
      "postcode": 36005,
      "wilaya": 36,
      "name": "El Kala"
    },
    "id": 1245,
    "commune_name_ascii": "El Kala",
    "commune_name": "القالة",
    "daira_name_ascii": "El Kala",
    "daira_name": "القالة",
    "wilaya_code": "36",
    "wilaya_name_ascii": "El Tarf",
    "wilaya_name": "الطارف"
  },
  {
    "model": "base.commune",
    "pk": 1238,
    "fields": {
      "postcode": 36009,
      "wilaya": 36,
      "name": "Souarekh"
    },
    "id": 1251,
    "commune_name_ascii": "Souarekh",
    "commune_name": "السوارخ",
    "daira_name_ascii": "El Kala",
    "daira_name": "القالة",
    "wilaya_code": "36",
    "wilaya_name_ascii": "El Tarf",
    "wilaya_name": "الطارف"
  },
  {
    "model": "base.commune",
    "pk": 1248,
    "fields": {
      "postcode": 36019,
      "wilaya": 36,
      "name": "Zerizer"
    },
    "id": 1252,
    "commune_name_ascii": "Zerizer",
    "commune_name": "زريزر",
    "daira_name_ascii": "Besbes",
    "daira_name": "البسباس",
    "wilaya_code": "36",
    "wilaya_name_ascii": "El Tarf",
    "wilaya_name": "الطارف"
  },
  {
    "model": "base.commune",
    "pk": 1237,
    "fields": {
      "postcode": 36008,
      "wilaya": 36,
      "name": "Bouteldja"
    },
    "id": 1238,
    "commune_name_ascii": "Bouteldja",
    "commune_name": "بوثلجة",
    "daira_name_ascii": "Bouteldja",
    "daira_name": "بوثلجة",
    "wilaya_code": "36",
    "wilaya_name_ascii": "El Tarf",
    "wilaya_name": "الطارف"
  },
  {
    "model": "base.commune",
    "pk": 1241,
    "fields": {
      "postcode": 36012,
      "wilaya": 36,
      "name": "Chefia"
    },
    "id": 1240,
    "commune_name_ascii": "Chefia",
    "commune_name": "الشافية",
    "daira_name_ascii": "Bouteldja",
    "daira_name": "بوثلجة",
    "wilaya_code": "36",
    "wilaya_name_ascii": "El Tarf",
    "wilaya_name": "الطارف"
  },
  {
    "model": "base.commune",
    "pk": 1240,
    "fields": {
      "postcode": 36011,
      "wilaya": 36,
      "name": "Lac Des Oiseaux"
    },
    "id": 1248,
    "commune_name_ascii": "Lac Des Oiseaux",
    "commune_name": "بحيرة الطيور",
    "daira_name_ascii": "Bouteldja",
    "daira_name": "بوثلجة",
    "wilaya_code": "36",
    "wilaya_name_ascii": "El Tarf",
    "wilaya_name": "الطارف"
  },
  {
    "model": "base.commune",
    "pk": 1243,
    "fields": {
      "postcode": 36014,
      "wilaya": 36,
      "name": "Chihani"
    },
    "id": 1241,
    "commune_name_ascii": "Chihani",
    "commune_name": "شحاني",
    "daira_name_ascii": "Drean",
    "daira_name": "الذرعان",
    "wilaya_code": "36",
    "wilaya_name_ascii": "El Tarf",
    "wilaya_name": "الطارف"
  },
  {
    "model": "base.commune",
    "pk": 1253,
    "fields": {
      "postcode": 36024,
      "wilaya": 36,
      "name": "Raml Souk"
    },
    "id": 1250,
    "commune_name_ascii": "Raml Souk",
    "commune_name": "رمل السوق",
    "daira_name_ascii": "El Kala",
    "daira_name": "القالة",
    "wilaya_code": "36",
    "wilaya_name_ascii": "El Tarf",
    "wilaya_name": "الطارف"
  },
  {
    "model": "base.commune",
    "pk": 1246,
    "fields": {
      "postcode": 36017,
      "wilaya": 36,
      "name": "Asfour"
    },
    "id": 1232,
    "commune_name_ascii": "Asfour",
    "commune_name": "عصفور",
    "daira_name_ascii": "Besbes",
    "daira_name": "البسباس",
    "wilaya_code": "36",
    "wilaya_name_ascii": "El Tarf",
    "wilaya_name": "الطارف"
  },
  {
    "model": "base.commune",
    "pk": 1242,
    "fields": {
      "postcode": 36013,
      "wilaya": 36,
      "name": "Drean"
    },
    "id": 1242,
    "commune_name_ascii": "Drean",
    "commune_name": "الذرعـان",
    "daira_name_ascii": "Drean",
    "daira_name": "الذرعان",
    "wilaya_code": "36",
    "wilaya_name_ascii": "El Tarf",
    "wilaya_name": "الطارف"
  },
  {
    "model": "base.commune",
    "pk": 1254,
    "fields": {
      "postcode": 37001,
      "wilaya": 37,
      "name": "Tindouf"
    },
    "id": 1255,
    "commune_name_ascii": "Tindouf",
    "commune_name": "تندوف",
    "daira_name_ascii": "Tindouf",
    "daira_name": "تندوف",
    "wilaya_code": "37",
    "wilaya_name_ascii": "Tindouf",
    "wilaya_name": "تندوف"
  },
  {
    "model": "base.commune",
    "pk": 1255,
    "fields": {
      "postcode": 37002,
      "wilaya": 37,
      "name": "Oum El Assel"
    },
    "id": 1254,
    "commune_name_ascii": "Oum El Assel",
    "commune_name": "أم العسل",
    "daira_name_ascii": "Tindouf",
    "daira_name": "تندوف",
    "wilaya_code": "37",
    "wilaya_name_ascii": "Tindouf",
    "wilaya_name": "تندوف"
  },
  {
    "model": "base.commune",
    "pk": 1266,
    "fields": {
      "postcode": 38011,
      "wilaya": 38,
      "name": "Khemisti"
    },
    "id": 1262,
    "commune_name_ascii": "Khemisti",
    "commune_name": "خميستي",
    "daira_name_ascii": "Khemisti",
    "daira_name": "خميستي",
    "wilaya_code": "38",
    "wilaya_name_ascii": "Tissemsilt",
    "wilaya_name": "تيسمسيلت"
  },
  {
    "model": "base.commune",
    "pk": 1258,
    "fields": {
      "postcode": 38003,
      "wilaya": 38,
      "name": "Theniet El Had"
    },
    "id": 1275,
    "commune_name_ascii": "Theniet El Had",
    "commune_name": "ثنية الاحد",
    "daira_name_ascii": "Theniet El Had",
    "daira_name": "ثنية الاحد",
    "wilaya_code": "38",
    "wilaya_name_ascii": "Tissemsilt",
    "wilaya_name": "تيسمسيلت"
  },
  {
    "id": 1269,
    "commune_name_ascii": "Ouled Bessam",
    "commune_name": "أولاد بسام",
    "daira_name_ascii": "Tissemsilt",
    "daira_name": "تيسمسيلت",
    "wilaya_code": "38",
    "wilaya_name_ascii": "Tissemsilt",
    "wilaya_name": "تيسمسيلت"
  },
  {
    "model": "base.commune",
    "pk": 1270,
    "fields": {
      "postcode": 38015,
      "wilaya": 38,
      "name": "Sidi Boutouchent"
    },
    "id": 1271,
    "commune_name_ascii": "Sidi Boutouchent",
    "commune_name": "سيدي بوتوشنت",
    "daira_name_ascii": "Theniet El Had",
    "daira_name": "ثنية الاحد",
    "wilaya_code": "38",
    "wilaya_name_ascii": "Tissemsilt",
    "wilaya_name": "تيسمسيلت"
  },
  {
    "model": "base.commune",
    "pk": 1256,
    "fields": {
      "postcode": 38001,
      "wilaya": 38,
      "name": "Tissemsilt"
    },
    "id": 1276,
    "commune_name_ascii": "Tissemsilt",
    "commune_name": "تيسمسيلت",
    "daira_name_ascii": "Tissemsilt",
    "daira_name": "تيسمسيلت",
    "wilaya_code": "38",
    "wilaya_name_ascii": "Tissemsilt",
    "wilaya_name": "تيسمسيلت"
  },
  {
    "model": "base.commune",
    "pk": 1263,
    "fields": {
      "postcode": 38008,
      "wilaya": 38,
      "name": "Sidi Lantri"
    },
    "id": 1272,
    "commune_name_ascii": "Sidi Lantri",
    "commune_name": "سيدي العنتري",
    "daira_name_ascii": "Lardjem",
    "daira_name": "لرجام",
    "wilaya_code": "38",
    "wilaya_name_ascii": "Tissemsilt",
    "wilaya_name": "تيسمسيلت"
  },
  {
    "model": "base.commune",
    "pk": 1260,
    "fields": {
      "postcode": 38005,
      "wilaya": 38,
      "name": "Beni Chaib"
    },
    "id": 1257,
    "commune_name_ascii": "Beni Chaib",
    "commune_name": "بني شعيب",
    "daira_name_ascii": "Bordj Bounaama",
    "daira_name": "برج بونعامة",
    "wilaya_code": "38",
    "wilaya_name_ascii": "Tissemsilt",
    "wilaya_name": "تيسمسيلت"
  },
  {
    "model": "base.commune",
    "pk": 1277,
    "fields": {
      "postcode": 38022,
      "wilaya": 38,
      "name": "Beni Lahcene"
    },
    "id": 1258,
    "commune_name_ascii": "Beni Lahcene",
    "commune_name": "بني لحسن",
    "daira_name_ascii": "Bordj Bounaama",
    "daira_name": "برج بونعامة",
    "wilaya_code": "38",
    "wilaya_name_ascii": "Tissemsilt",
    "wilaya_name": "تيسمسيلت"
  },
  {
    "model": "base.commune",
    "pk": 1273,
    "fields": {
      "postcode": 38018,
      "wilaya": 38,
      "name": "Sidi Abed"
    },
    "id": 1270,
    "commune_name_ascii": "Sidi Abed",
    "commune_name": "سيدي عابد",
    "daira_name_ascii": "Ammari",
    "daira_name": "عماري",
    "wilaya_code": "38",
    "wilaya_name_ascii": "Tissemsilt",
    "wilaya_name": "تيسمسيلت"
  },
  {
    "model": "base.commune",
    "pk": 1098,
    "fields": {
      "postcode": 30010,
      "wilaya": 30,
      "name": "Sidi Slimane"
    },
    "id": 1273,
    "commune_name_ascii": "Sidi Slimane",
    "commune_name": "سيدي سليمان",
    "daira_name_ascii": "Bordj Bounaama",
    "daira_name": "برج بونعامة",
    "wilaya_code": "38",
    "wilaya_name_ascii": "Tissemsilt",
    "wilaya_name": "تيسمسيلت"
  },
  {
    "model": "base.commune",
    "pk": 1276,
    "fields": {
      "postcode": 38021,
      "wilaya": 38,
      "name": "Boucaid"
    },
    "id": 1261,
    "commune_name_ascii": "Boucaid",
    "commune_name": "بوقائد",
    "daira_name_ascii": "Lazharia",
    "daira_name": "الأزهرية",
    "wilaya_code": "38",
    "wilaya_name_ascii": "Tissemsilt",
    "wilaya_name": "تيسمسيلت"
  },
  {
    "model": "base.commune",
    "pk": 177,
    "fields": {
      "postcode": 5061,
      "wilaya": 5,
      "name": "Larbaa"
    },
    "id": 1263,
    "commune_name_ascii": "Larbaa",
    "commune_name": "الأربعاء",
    "daira_name_ascii": "Lazharia",
    "daira_name": "الأزهرية",
    "wilaya_code": "38",
    "wilaya_name_ascii": "Tissemsilt",
    "wilaya_name": "تيسمسيلت"
  },
  {
    "model": "base.commune",
    "pk": 1259,
    "fields": {
      "postcode": 38004,
      "wilaya": 38,
      "name": "Lazharia"
    },
    "id": 1266,
    "commune_name_ascii": "Lazharia",
    "commune_name": "الأزهرية",
    "daira_name_ascii": "Lazharia",
    "daira_name": "الأزهرية",
    "wilaya_code": "38",
    "wilaya_name_ascii": "Tissemsilt",
    "wilaya_name": "تيسمسيلت"
  },
  {
    "model": "base.commune",
    "pk": 1261,
    "fields": {
      "postcode": 38006,
      "wilaya": 38,
      "name": "Lardjem"
    },
    "id": 1264,
    "commune_name_ascii": "Lardjem",
    "commune_name": "لرجام",
    "daira_name_ascii": "Lardjem",
    "daira_name": "لرجام",
    "wilaya_code": "38",
    "wilaya_name_ascii": "Tissemsilt",
    "wilaya_name": "تيسمسيلت"
  },
  {
    "model": "base.commune",
    "pk": 1262,
    "fields": {
      "postcode": 38007,
      "wilaya": 38,
      "name": "Melaab"
    },
    "id": 1268,
    "commune_name_ascii": "Melaab",
    "commune_name": "الملعب",
    "daira_name_ascii": "Lardjem",
    "daira_name": "لرجام",
    "wilaya_code": "38",
    "wilaya_name_ascii": "Tissemsilt",
    "wilaya_name": "تيسمسيلت"
  },
  {
    "model": "base.commune",
    "pk": 1265,
    "fields": {
      "postcode": 38010,
      "wilaya": 38,
      "name": "Layoune"
    },
    "id": 1265,
    "commune_name_ascii": "Layoune",
    "commune_name": "العيون",
    "daira_name_ascii": "Khemisti",
    "daira_name": "خميستي",
    "wilaya_code": "38",
    "wilaya_name_ascii": "Tissemsilt",
    "wilaya_name": "تيسمسيلت"
  },
  {
    "id": 1274,
    "commune_name_ascii": "Tamellahet",
    "commune_name": "تملاحت",
    "daira_name_ascii": "Lardjem",
    "daira_name": "لرجام",
    "wilaya_code": "38",
    "wilaya_name_ascii": "Tissemsilt",
    "wilaya_name": "تيسمسيلت"
  },
  {
    "model": "base.commune",
    "pk": 1269,
    "fields": {
      "postcode": 38014,
      "wilaya": 38,
      "name": "Youssoufia"
    },
    "id": 1277,
    "commune_name_ascii": "Youssoufia",
    "commune_name": "اليوسفية",
    "daira_name_ascii": "Bordj Emir Abdelkader",
    "daira_name": "برج الأمير عبد القادر",
    "wilaya_code": "38",
    "wilaya_name_ascii": "Tissemsilt",
    "wilaya_name": "تيسمسيلت"
  },
  {
    "model": "base.commune",
    "pk": 1264,
    "fields": {
      "postcode": 38009,
      "wilaya": 38,
      "name": "Bordj El Emir Abdelkader"
    },
    "id": 1260,
    "commune_name_ascii": "Bordj El Emir Abdelkader",
    "commune_name": "برج الأمير عبد القادر",
    "daira_name_ascii": "Bordj Emir Abdelkader",
    "daira_name": "برج الأمير عبد القادر",
    "wilaya_code": "38",
    "wilaya_name_ascii": "Tissemsilt",
    "wilaya_name": "تيسمسيلت"
  },
  {
    "model": "base.commune",
    "pk": 1268,
    "fields": {
      "postcode": 38013,
      "wilaya": 38,
      "name": "Ammari"
    },
    "id": 1256,
    "commune_name_ascii": "Ammari",
    "commune_name": "عماري",
    "daira_name_ascii": "Ammari",
    "daira_name": "عماري",
    "wilaya_code": "38",
    "wilaya_name_ascii": "Tissemsilt",
    "wilaya_name": "تيسمسيلت"
  },
  {
    "id": 1267,
    "commune_name_ascii": "Maacem",
    "commune_name": "المعاصم",
    "daira_name_ascii": "Ammari",
    "daira_name": "عماري",
    "wilaya_code": "38",
    "wilaya_name_ascii": "Tissemsilt",
    "wilaya_name": "تيسمسيلت"
  },
  {
    "id": 1259,
    "commune_name_ascii": "Bordj Bounaama",
    "commune_name": "برج بونعامة",
    "daira_name_ascii": "Bordj Bounaama",
    "daira_name": "برج بونعامة",
    "wilaya_code": "38",
    "wilaya_name_ascii": "Tissemsilt",
    "wilaya_name": "تيسمسيلت"
  },
  {
    "id": 1282,
    "commune_name_ascii": "Douar El Maa",
    "commune_name": "دوار الماء",
    "daira_name_ascii": "Taleb Larbi",
    "daira_name": "الطالب العربي",
    "wilaya_code": "39",
    "wilaya_name_ascii": "El Oued",
    "wilaya_name": "الوادي"
  },
  {
    "model": "base.commune",
    "pk": 376,
    "fields": {
      "postcode": 12013,
      "wilaya": 12,
      "name": "El Ogla"
    },
    "id": 1283,
    "commune_name_ascii": "El Ogla",
    "commune_name": "العقلة",
    "daira_name_ascii": "Robbah",
    "daira_name": "الرباح",
    "wilaya_code": "39",
    "wilaya_name_ascii": "El Oued",
    "wilaya_name": "الوادي"
  },
  {
    "model": "base.commune",
    "pk": 1295,
    "fields": {
      "postcode": 39018,
      "wilaya": 39,
      "name": "Magrane"
    },
    "id": 1291,
    "commune_name_ascii": "Magrane",
    "commune_name": "المقرن",
    "daira_name_ascii": "Magrane",
    "daira_name": "المقرن",
    "wilaya_code": "39",
    "wilaya_name_ascii": "El Oued",
    "wilaya_name": "الوادي"
  },
  {
    "model": "base.commune",
    "pk": 1293,
    "fields": {
      "postcode": 39016,
      "wilaya": 39,
      "name": "Sidi Aoun"
    },
    "id": 1301,
    "commune_name_ascii": "Sidi Aoun",
    "commune_name": "سيدي عون",
    "daira_name_ascii": "Magrane",
    "daira_name": "المقرن",
    "wilaya_code": "39",
    "wilaya_name_ascii": "El Oued",
    "wilaya_name": "الوادي"
  },
  {
    "model": "base.commune",
    "pk": 1303,
    "fields": {
      "postcode": 39026,
      "wilaya": 39,
      "name": "Mih Ouansa"
    },
    "id": 1292,
    "commune_name_ascii": "Mih Ouansa",
    "commune_name": "اميه وانسة",
    "daira_name_ascii": "Mih Ouensa",
    "daira_name": "اميه وانسة",
    "wilaya_code": "39",
    "wilaya_name_ascii": "El Oued",
    "wilaya_name": "الوادي"
  },
  {
    "model": "base.commune",
    "pk": 1284,
    "fields": {
      "postcode": 39007,
      "wilaya": 39,
      "name": "Kouinine"
    },
    "id": 1290,
    "commune_name_ascii": "Kouinine",
    "commune_name": "كوينين",
    "daira_name_ascii": "El Oued",
    "daira_name": "الوادي",
    "wilaya_code": "39",
    "wilaya_name_ascii": "El Oued",
    "wilaya_name": "الوادي"
  },
  {
    "model": "base.commune",
    "pk": 1281,
    "fields": {
      "postcode": 39004,
      "wilaya": 39,
      "name": "Bayadha"
    },
    "id": 1278,
    "commune_name_ascii": "Bayadha",
    "commune_name": "البياضة",
    "daira_name_ascii": "Bayadha",
    "daira_name": "البياضة",
    "wilaya_code": "39",
    "wilaya_name_ascii": "El Oued",
    "wilaya_name": "الوادي"
  },
  {
    "model": "base.commune",
    "pk": 1282,
    "fields": {
      "postcode": 39005,
      "wilaya": 39,
      "name": "Nakhla"
    },
    "id": 1294,
    "commune_name_ascii": "Nakhla",
    "commune_name": "النخلة",
    "daira_name_ascii": "Robbah",
    "daira_name": "الرباح",
    "wilaya_code": "39",
    "wilaya_name_ascii": "El Oued",
    "wilaya_name": "الوادي"
  },
  {
    "model": "base.commune",
    "pk": 1279,
    "fields": {
      "postcode": 39002,
      "wilaya": 39,
      "name": "Robbah"
    },
    "id": 1299,
    "commune_name_ascii": "Robbah",
    "commune_name": "الرباح",
    "daira_name_ascii": "Robbah",
    "daira_name": "الرباح",
    "wilaya_code": "39",
    "wilaya_name_ascii": "El Oued",
    "wilaya_name": "الوادي"
  },
  {
    "model": "base.commune",
    "pk": 1283,
    "fields": {
      "postcode": 39006,
      "wilaya": 39,
      "name": "Guemar"
    },
    "id": 1286,
    "commune_name_ascii": "Guemar",
    "commune_name": "قمار",
    "daira_name_ascii": "Guemar",
    "daira_name": "قمار",
    "wilaya_code": "39",
    "wilaya_name_ascii": "El Oued",
    "wilaya_name": "الوادي"
  },
  {
    "id": 1279,
    "commune_name_ascii": "Ben Guecha",
    "commune_name": "بن  قشة",
    "daira_name_ascii": "Taleb Larbi",
    "daira_name": "الطالب العربي",
    "wilaya_code": "39",
    "wilaya_name_ascii": "El Oued",
    "wilaya_name": "الوادي"
  },
  {
    "id": 1297,
    "commune_name_ascii": "Ourmes",
    "commune_name": "ورماس",
    "daira_name_ascii": "Guemar",
    "daira_name": "قمار",
    "wilaya_code": "39",
    "wilaya_name_ascii": "El Oued",
    "wilaya_name": "الوادي"
  },
  {
    "model": "base.commune",
    "pk": 317,
    "fields": {
      "postcode": 10009,
      "wilaya": 10,
      "name": "Taghzout"
    },
    "id": 1304,
    "commune_name_ascii": "Taghzout",
    "commune_name": "تغزوت",
    "daira_name_ascii": "Guemar",
    "daira_name": "قمار",
    "wilaya_code": "39",
    "wilaya_name_ascii": "El Oued",
    "wilaya_name": "الوادي"
  },
  {
    "model": "base.commune",
    "pk": 1286,
    "fields": {
      "postcode": 39009,
      "wilaya": 39,
      "name": "Hamraia"
    },
    "id": 1287,
    "commune_name_ascii": "Hamraia",
    "commune_name": "الحمراية",
    "daira_name_ascii": "Reguiba",
    "daira_name": "الرقيبة",
    "wilaya_code": "39",
    "wilaya_name_ascii": "El Oued",
    "wilaya_name": "الوادي"
  },
  {
    "model": "base.commune",
    "pk": 1285,
    "fields": {
      "postcode": 39008,
      "wilaya": 39,
      "name": "Reguiba"
    },
    "id": 1298,
    "commune_name_ascii": "Reguiba",
    "commune_name": "الرقيبة",
    "daira_name_ascii": "Reguiba",
    "daira_name": "الرقيبة",
    "wilaya_code": "39",
    "wilaya_name_ascii": "El Oued",
    "wilaya_name": "الوادي"
  },
  {
    "model": "base.commune",
    "pk": 1288,
    "fields": {
      "postcode": 39011,
      "wilaya": 39,
      "name": "Debila"
    },
    "id": 1280,
    "commune_name_ascii": "Debila",
    "commune_name": "الدبيلة",
    "daira_name_ascii": "Debila",
    "daira_name": "الدبيلة",
    "wilaya_code": "39",
    "wilaya_name_ascii": "El Oued",
    "wilaya_name": "الوادي"
  },
  {
    "model": "base.commune",
    "pk": 1289,
    "fields": {
      "postcode": 39012,
      "wilaya": 39,
      "name": "Hassani Abdelkrim"
    },
    "id": 1288,
    "commune_name_ascii": "Hassani Abdelkrim",
    "commune_name": "حساني عبد الكريم",
    "daira_name_ascii": "Debila",
    "daira_name": "الدبيلة",
    "wilaya_code": "39",
    "wilaya_name_ascii": "El Oued",
    "wilaya_name": "الوادي"
  },
  {
    "id": 1289,
    "commune_name_ascii": "Hassi Khalifa",
    "commune_name": "حاسي خليفة",
    "daira_name_ascii": "Hassi Khalifa",
    "daira_name": "حاسي خليفة",
    "wilaya_code": "39",
    "wilaya_name_ascii": "El Oued",
    "wilaya_name": "الوادي"
  },
  {
    "model": "base.commune",
    "pk": 1294,
    "fields": {
      "postcode": 39017,
      "wilaya": 39,
      "name": "Trifaoui"
    },
    "id": 1307,
    "commune_name_ascii": "Trifaoui",
    "commune_name": "الطريفاوي",
    "daira_name_ascii": "Hassi Khalifa",
    "daira_name": "حاسي خليفة",
    "wilaya_code": "39",
    "wilaya_name_ascii": "El Oued",
    "wilaya_name": "الوادي"
  },
  {
    "model": "base.commune",
    "pk": 1291,
    "fields": {
      "postcode": 39014,
      "wilaya": 39,
      "name": "Taleb Larbi"
    },
    "id": 1305,
    "commune_name_ascii": "Taleb Larbi",
    "commune_name": "الطالب العربي",
    "daira_name_ascii": "Taleb Larbi",
    "daira_name": "الطالب العربي",
    "wilaya_code": "39",
    "wilaya_name_ascii": "El Oued",
    "wilaya_name": "الوادي"
  },
  {
    "model": "base.commune",
    "pk": 1280,
    "fields": {
      "postcode": 39003,
      "wilaya": 39,
      "name": "Oued El Alenda"
    },
    "id": 1295,
    "commune_name_ascii": "Oued El Alenda",
    "commune_name": "وادي العلندة",
    "daira_name_ascii": "Mih Ouensa",
    "daira_name": "اميه وانسة",
    "wilaya_code": "39",
    "wilaya_name_ascii": "El Oued",
    "wilaya_name": "الوادي"
  },
  {
    "id": 1285,
    "commune_name_ascii": "El Oued",
    "commune_name": "الوادي",
    "daira_name_ascii": "El Oued",
    "daira_name": "الوادي",
    "wilaya_code": "39",
    "wilaya_name_ascii": "El Oued",
    "wilaya_name": "الوادي"
  },
  {
    "model": "base.commune",
    "pk": 1327,
    "fields": {
      "postcode": 40020,
      "wilaya": 40,
      "name": "Khirane"
    },
    "id": 1321,
    "commune_name_ascii": "Khirane",
    "commune_name": "خيران",
    "daira_name_ascii": "Chechar",
    "daira_name": "ششار",
    "wilaya_code": "40",
    "wilaya_name_ascii": "Khenchela",
    "wilaya_name": "خنشلة"
  },
  {
    "model": "base.commune",
    "pk": 1320,
    "fields": {
      "postcode": 40013,
      "wilaya": 40,
      "name": "Babar"
    },
    "id": 1309,
    "commune_name_ascii": "Babar",
    "commune_name": "بابار",
    "daira_name_ascii": "Babar",
    "daira_name": "بابار",
    "wilaya_code": "40",
    "wilaya_name_ascii": "Khenchela",
    "wilaya_name": "خنشلة"
  },
  {
    "model": "base.commune",
    "pk": 1324,
    "fields": {
      "postcode": 40017,
      "wilaya": 40,
      "name": "El Mahmal"
    },
    "id": 1316,
    "commune_name_ascii": "El Mahmal",
    "commune_name": "المحمل",
    "daira_name_ascii": "Ouled Rechache",
    "daira_name": "أولاد رشاش",
    "wilaya_code": "40",
    "wilaya_name_ascii": "Khenchela",
    "wilaya_name": "خنشلة"
  },
  {
    "model": "base.commune",
    "pk": 1323,
    "fields": {
      "postcode": 40016,
      "wilaya": 40,
      "name": "Ouled Rechache"
    },
    "id": 1324,
    "commune_name_ascii": "Ouled Rechache",
    "commune_name": "أولاد رشاش",
    "daira_name_ascii": "Ouled Rechache",
    "daira_name": "أولاد رشاش",
    "wilaya_code": "40",
    "wilaya_name_ascii": "Khenchela",
    "wilaya_name": "خنشلة"
  },
  {
    "model": "base.commune",
    "pk": 1319,
    "fields": {
      "postcode": 40012,
      "wilaya": 40,
      "name": "Djellal"
    },
    "id": 1314,
    "commune_name_ascii": "Djellal",
    "commune_name": "جلال",
    "daira_name_ascii": "Chechar",
    "daira_name": "ششار",
    "wilaya_code": "40",
    "wilaya_name_ascii": "Khenchela",
    "wilaya_name": "خنشلة"
  },
  {
    "model": "base.commune",
    "pk": 1326,
    "fields": {
      "postcode": 40019,
      "wilaya": 40,
      "name": "Yabous"
    },
    "id": 1328,
    "commune_name_ascii": "Yabous",
    "commune_name": "يابوس",
    "daira_name_ascii": "Bouhmama",
    "daira_name": "بوحمامة",
    "wilaya_code": "40",
    "wilaya_name_ascii": "Khenchela",
    "wilaya_name": "خنشلة"
  },
  {
    "model": "base.commune",
    "pk": 1308,
    "fields": {
      "postcode": 40001,
      "wilaya": 40,
      "name": "Khenchela"
    },
    "id": 1320,
    "commune_name_ascii": "Khenchela",
    "commune_name": "خنشلة",
    "daira_name_ascii": "Khenchela",
    "daira_name": "خنشلة",
    "wilaya_code": "40",
    "wilaya_name_ascii": "Khenchela",
    "wilaya_name": "خنشلة"
  },
  {
    "model": "base.commune",
    "pk": 1310,
    "fields": {
      "postcode": 40003,
      "wilaya": 40,
      "name": "Kais"
    },
    "id": 1319,
    "commune_name_ascii": "Kais",
    "commune_name": "قايس",
    "daira_name_ascii": "Kais",
    "daira_name": "قايس",
    "wilaya_code": "40",
    "wilaya_name_ascii": "Khenchela",
    "wilaya_name": "خنشلة"
  },
  {
    "model": "base.commune",
    "pk": 1328,
    "fields": {
      "postcode": 40021,
      "wilaya": 40,
      "name": "Chelia"
    },
    "id": 1313,
    "commune_name_ascii": "Chelia",
    "commune_name": "شلية",
    "daira_name_ascii": "Bouhmama",
    "daira_name": "بوحمامة",
    "wilaya_code": "40",
    "wilaya_name_ascii": "Khenchela",
    "wilaya_name": "خنشلة"
  },
  {
    "model": "base.commune",
    "pk": 1317,
    "fields": {
      "postcode": 40010,
      "wilaya": 40,
      "name": "Remila"
    },
    "id": 1325,
    "commune_name_ascii": "Remila",
    "commune_name": "الرميلة",
    "daira_name_ascii": "Kais",
    "daira_name": "قايس",
    "wilaya_code": "40",
    "wilaya_name_ascii": "Khenchela",
    "wilaya_name": "خنشلة"
  },
  {
    "model": "base.commune",
    "pk": 1314,
    "fields": {
      "postcode": 40007,
      "wilaya": 40,
      "name": "Taouzianat"
    },
    "id": 1327,
    "commune_name_ascii": "Taouzianat",
    "commune_name": "تاوزيانت",
    "daira_name_ascii": "Kais",
    "daira_name": "قايس",
    "wilaya_code": "40",
    "wilaya_name_ascii": "Khenchela",
    "wilaya_name": "خنشلة"
  },
  {
    "model": "base.commune",
    "pk": 1311,
    "fields": {
      "postcode": 40004,
      "wilaya": 40,
      "name": "Baghai"
    },
    "id": 1310,
    "commune_name_ascii": "Baghai",
    "commune_name": "بغاي",
    "daira_name_ascii": "El Hamma",
    "daira_name": "الحامة",
    "wilaya_code": "40",
    "wilaya_name_ascii": "Khenchela",
    "wilaya_name": "خنشلة"
  },
  {
    "model": "base.commune",
    "pk": 1312,
    "fields": {
      "postcode": 40005,
      "wilaya": 40,
      "name": "El Hamma"
    },
    "id": 1315,
    "commune_name_ascii": "El Hamma",
    "commune_name": "الحامة",
    "daira_name_ascii": "El Hamma",
    "daira_name": "الحامة",
    "wilaya_code": "40",
    "wilaya_name_ascii": "Khenchela",
    "wilaya_name": "خنشلة"
  },
  {
    "model": "base.commune",
    "pk": 1322,
    "fields": {
      "postcode": 40015,
      "wilaya": 40,
      "name": "Ensigha"
    },
    "id": 1318,
    "commune_name_ascii": "Ensigha",
    "commune_name": "انسيغة",
    "daira_name_ascii": "El Hamma",
    "daira_name": "الحامة",
    "wilaya_code": "40",
    "wilaya_name_ascii": "Khenchela",
    "wilaya_name": "خنشلة"
  },
  {
    "model": "base.commune",
    "pk": 1321,
    "fields": {
      "postcode": 40014,
      "wilaya": 40,
      "name": "Tamza"
    },
    "id": 1326,
    "commune_name_ascii": "Tamza",
    "commune_name": "طامزة",
    "daira_name_ascii": "El Hamma",
    "daira_name": "الحامة",
    "wilaya_code": "40",
    "wilaya_name_ascii": "Khenchela",
    "wilaya_name": "خنشلة"
  },
  {
    "model": "base.commune",
    "pk": 1313,
    "fields": {
      "postcode": 40006,
      "wilaya": 40,
      "name": "Ain Touila"
    },
    "id": 1308,
    "commune_name_ascii": "Ain Touila",
    "commune_name": "عين الطويلة",
    "daira_name_ascii": "Ain Touila",
    "daira_name": "عين الطويلة",
    "wilaya_code": "40",
    "wilaya_name_ascii": "Khenchela",
    "wilaya_name": "خنشلة"
  },
  {
    "id": 1323,
    "commune_name_ascii": "M'toussa",
    "commune_name": "متوسة",
    "daira_name_ascii": "Ain Touila",
    "daira_name": "عين الطويلة",
    "wilaya_code": "40",
    "wilaya_name_ascii": "Khenchela",
    "wilaya_name": "خنشلة"
  },
  {
    "model": "base.commune",
    "pk": 1315,
    "fields": {
      "postcode": 40008,
      "wilaya": 40,
      "name": "Bouhmama"
    },
    "id": 1311,
    "commune_name_ascii": "Bouhmama",
    "commune_name": "بوحمامة",
    "daira_name_ascii": "Bouhmama",
    "daira_name": "بوحمامة",
    "wilaya_code": "40",
    "wilaya_name_ascii": "Khenchela",
    "wilaya_name": "خنشلة"
  },
  {
    "model": "base.commune",
    "pk": 1316,
    "fields": {
      "postcode": 40009,
      "wilaya": 40,
      "name": "El Oueldja"
    },
    "id": 1317,
    "commune_name_ascii": "El Oueldja",
    "commune_name": "الولجة",
    "daira_name_ascii": "Chechar",
    "daira_name": "ششار",
    "wilaya_code": "40",
    "wilaya_name_ascii": "Khenchela",
    "wilaya_name": "خنشلة"
  },
  {
    "id": 1322,
    "commune_name_ascii": "M'sara",
    "commune_name": "مصارة",
    "daira_name_ascii": "Bouhmama",
    "daira_name": "بوحمامة",
    "wilaya_code": "40",
    "wilaya_name_ascii": "Khenchela",
    "wilaya_name": "خنشلة"
  },
  {
    "id": 1312,
    "commune_name_ascii": "Chechar",
    "commune_name": "ششار",
    "daira_name_ascii": "Chechar",
    "daira_name": "ششار",
    "wilaya_code": "40",
    "wilaya_name_ascii": "Khenchela",
    "wilaya_name": "خنشلة"
  },
  {
    "model": "base.commune",
    "pk": 1329,
    "fields": {
      "postcode": 41001,
      "wilaya": 41,
      "name": "Souk Ahras"
    },
    "id": 1349,
    "commune_name_ascii": "Souk Ahras",
    "commune_name": "سوق أهراس",
    "daira_name_ascii": "Souk Ahras",
    "daira_name": "سوق أهراس",
    "wilaya_code": "41",
    "wilaya_name_ascii": "Souk Ahras",
    "wilaya_name": "سوق أهراس"
  },
  {
    "model": "base.commune",
    "pk": 750,
    "fields": {
      "postcode": 20016,
      "wilaya": 20,
      "name": "Ain Soltane"
    },
    "id": 1329,
    "commune_name_ascii": "Ain Soltane",
    "commune_name": "عين سلطان",
    "daira_name_ascii": "Sedrata",
    "daira_name": "سدراتة",
    "wilaya_code": "41",
    "wilaya_name_ascii": "Souk Ahras",
    "wilaya_name": "سوق أهراس"
  },
  {
    "model": "base.commune",
    "pk": 1330,
    "fields": {
      "postcode": 41002,
      "wilaya": 41,
      "name": "Sedrata"
    },
    "id": 1347,
    "commune_name_ascii": "Sedrata",
    "commune_name": "سدراتة",
    "daira_name_ascii": "Sedrata",
    "daira_name": "سدراتة",
    "wilaya_code": "41",
    "wilaya_name_ascii": "Souk Ahras",
    "wilaya_name": "سوق أهراس"
  },
  {
    "id": 1334,
    "commune_name_ascii": "Hanencha",
    "commune_name": "الحنانشة",
    "daira_name_ascii": "Mechroha",
    "daira_name": "المشروحة",
    "wilaya_code": "41",
    "wilaya_name_ascii": "Souk Ahras",
    "wilaya_name": "سوق أهراس"
  },
  {
    "id": 1337,
    "commune_name_ascii": "Machroha",
    "commune_name": "المشروحة",
    "daira_name_ascii": "Mechroha",
    "daira_name": "المشروحة",
    "wilaya_code": "41",
    "wilaya_name_ascii": "Souk Ahras",
    "wilaya_name": "سوق أهراس"
  },
  {
    "model": "base.commune",
    "pk": 1345,
    "fields": {
      "postcode": 41017,
      "wilaya": 41,
      "name": "Ain Zana"
    },
    "id": 1330,
    "commune_name_ascii": "Ain Zana",
    "commune_name": "عين الزانة",
    "daira_name_ascii": "Ouled Driss",
    "daira_name": "أولاد إدريس",
    "wilaya_code": "41",
    "wilaya_name_ascii": "Souk Ahras",
    "wilaya_name": "سوق أهراس"
  },
  {
    "model": "base.commune",
    "pk": 1333,
    "fields": {
      "postcode": 41005,
      "wilaya": 41,
      "name": "Ouled Driss"
    },
    "id": 1341,
    "commune_name_ascii": "Ouled Driss",
    "commune_name": "أولاد إدريس",
    "daira_name_ascii": "Ouled Driss",
    "daira_name": "أولاد إدريس",
    "wilaya_code": "41",
    "wilaya_name_ascii": "Souk Ahras",
    "wilaya_name": "سوق أهراس"
  },
  {
    "model": "base.commune",
    "pk": 1353,
    "fields": {
      "postcode": 41025,
      "wilaya": 41,
      "name": "Terraguelt"
    },
    "id": 1351,
    "commune_name_ascii": "Terraguelt",
    "commune_name": "ترقالت",
    "daira_name_ascii": "Oum El Adhaim",
    "daira_name": "أم العظايم",
    "wilaya_code": "41",
    "wilaya_name_ascii": "Souk Ahras",
    "wilaya_name": "سوق أهراس"
  },
  {
    "model": "base.commune",
    "pk": 1344,
    "fields": {
      "postcode": 41016,
      "wilaya": 41,
      "name": "Oum El Adhaim"
    },
    "id": 1343,
    "commune_name_ascii": "Oum El Adhaim",
    "commune_name": "أم العظايم",
    "daira_name_ascii": "Oum El Adhaim",
    "daira_name": "أم العظايم",
    "wilaya_code": "41",
    "wilaya_name_ascii": "Souk Ahras",
    "wilaya_name": "سوق أهراس"
  },
  {
    "id": 1340,
    "commune_name_ascii": "Oued Kebrit",
    "commune_name": "وادي الكبريت",
    "daira_name_ascii": "Oum El Adhaim",
    "daira_name": "أم العظايم",
    "wilaya_code": "41",
    "wilaya_name_ascii": "Souk Ahras",
    "wilaya_name": "سوق أهراس"
  },
  {
    "model": "base.commune",
    "pk": 1334,
    "fields": {
      "postcode": 41006,
      "wilaya": 41,
      "name": "Tiffech"
    },
    "id": 1352,
    "commune_name_ascii": "Tiffech",
    "commune_name": "تيفاش",
    "daira_name_ascii": "M'daourouche",
    "daira_name": "مداوروش",
    "wilaya_code": "41",
    "wilaya_name_ascii": "Souk Ahras",
    "wilaya_name": "سوق أهراس"
  },
  {
    "model": "base.commune",
    "pk": 1350,
    "fields": {
      "postcode": 41022,
      "wilaya": 41,
      "name": "Ragouba"
    },
    "id": 1345,
    "commune_name_ascii": "Ragouba",
    "commune_name": "الراقوبة",
    "daira_name_ascii": "M'daourouche",
    "daira_name": "مداوروش",
    "wilaya_code": "41",
    "wilaya_name_ascii": "Souk Ahras",
    "wilaya_name": "سوق أهراس"
  },
  {
    "model": "base.commune",
    "pk": 1337,
    "fields": {
      "postcode": 41009,
      "wilaya": 41,
      "name": "Drea"
    },
    "id": 1332,
    "commune_name_ascii": "Drea",
    "commune_name": "الدريعة",
    "daira_name_ascii": "Taoura",
    "daira_name": "تاورة",
    "wilaya_code": "41",
    "wilaya_name_ascii": "Souk Ahras",
    "wilaya_name": "سوق أهراس"
  },
  {
    "model": "base.commune",
    "pk": 1336,
    "fields": {
      "postcode": 41008,
      "wilaya": 41,
      "name": "Taoura"
    },
    "id": 1350,
    "commune_name_ascii": "Taoura",
    "commune_name": "تاورة",
    "daira_name_ascii": "Taoura",
    "daira_name": "تاورة",
    "wilaya_code": "41",
    "wilaya_name_ascii": "Souk Ahras",
    "wilaya_name": "سوق أهراس"
  },
  {
    "model": "base.commune",
    "pk": 1335,
    "fields": {
      "postcode": 41007,
      "wilaya": 41,
      "name": "Zaarouria"
    },
    "id": 1353,
    "commune_name_ascii": "Zaarouria",
    "commune_name": "الزعرورية",
    "daira_name_ascii": "Taoura",
    "daira_name": "تاورة",
    "wilaya_code": "41",
    "wilaya_name_ascii": "Souk Ahras",
    "wilaya_name": "سوق أهراس"
  },
  {
    "model": "base.commune",
    "pk": 1338,
    "fields": {
      "postcode": 41010,
      "wilaya": 41,
      "name": "Haddada"
    },
    "id": 1333,
    "commune_name_ascii": "Haddada",
    "commune_name": "الحدادة",
    "daira_name_ascii": "Haddada",
    "daira_name": "الحدادة",
    "wilaya_code": "41",
    "wilaya_name_ascii": "Souk Ahras",
    "wilaya_name": "سوق أهراس"
  },
  {
    "model": "base.commune",
    "pk": 1339,
    "fields": {
      "postcode": 41011,
      "wilaya": 41,
      "name": "Khedara"
    },
    "id": 1335,
    "commune_name_ascii": "Khedara",
    "commune_name": "الخضارة",
    "daira_name_ascii": "Haddada",
    "daira_name": "الحدادة",
    "wilaya_code": "41",
    "wilaya_name_ascii": "Souk Ahras",
    "wilaya_name": "سوق أهراس"
  },
  {
    "model": "base.commune",
    "pk": 1341,
    "fields": {
      "postcode": 41013,
      "wilaya": 41,
      "name": "Ouled Moumen"
    },
    "id": 1342,
    "commune_name_ascii": "Ouled Moumen",
    "commune_name": "أولاد مومن",
    "daira_name_ascii": "Haddada",
    "daira_name": "الحدادة",
    "wilaya_code": "41",
    "wilaya_name_ascii": "Souk Ahras",
    "wilaya_name": "سوق أهراس"
  },
  {
    "model": "base.commune",
    "pk": 1340,
    "fields": {
      "postcode": 41012,
      "wilaya": 41,
      "name": "Merahna"
    },
    "id": 1339,
    "commune_name_ascii": "Merahna",
    "commune_name": "المراهنة",
    "daira_name_ascii": "Merahna",
    "daira_name": "المراهنة",
    "wilaya_code": "41",
    "wilaya_name_ascii": "Souk Ahras",
    "wilaya_name": "سوق أهراس"
  },
  {
    "id": 1344,
    "commune_name_ascii": "Ouillen",
    "commune_name": "ويلان",
    "daira_name_ascii": "Merahna",
    "daira_name": "المراهنة",
    "wilaya_code": "41",
    "wilaya_name_ascii": "Souk Ahras",
    "wilaya_name": "سوق أهراس"
  },
  {
    "model": "base.commune",
    "pk": 1348,
    "fields": {
      "postcode": 41020,
      "wilaya": 41,
      "name": "Sidi Fredj"
    },
    "id": 1348,
    "commune_name_ascii": "Sidi Fredj",
    "commune_name": "سيدي فرج",
    "daira_name_ascii": "Merahna",
    "daira_name": "المراهنة",
    "wilaya_code": "41",
    "wilaya_name_ascii": "Souk Ahras",
    "wilaya_name": "سوق أهراس"
  },
  {
    "model": "base.commune",
    "pk": 1342,
    "fields": {
      "postcode": 41014,
      "wilaya": 41,
      "name": "Bir Bouhouche"
    },
    "id": 1331,
    "commune_name_ascii": "Bir Bouhouche",
    "commune_name": "بئر بوحوش",
    "daira_name_ascii": "Bir Bouhouche",
    "daira_name": "بئر بوحوش",
    "wilaya_code": "41",
    "wilaya_name_ascii": "Souk Ahras",
    "wilaya_name": "سوق أهراس"
  },
  {
    "model": "base.commune",
    "pk": 1349,
    "fields": {
      "postcode": 41021,
      "wilaya": 41,
      "name": "Safel El Ouiden"
    },
    "id": 1346,
    "commune_name_ascii": "Safel El Ouiden",
    "commune_name": "سافل الويدان",
    "daira_name_ascii": "Bir Bouhouche",
    "daira_name": "بئر بوحوش",
    "wilaya_code": "41",
    "wilaya_name_ascii": "Souk Ahras",
    "wilaya_name": "سوق أهراس"
  },
  {
    "model": "base.commune",
    "pk": 1351,
    "fields": {
      "postcode": 41023,
      "wilaya": 41,
      "name": "Khemissa"
    },
    "id": 1336,
    "commune_name_ascii": "Khemissa",
    "commune_name": "خميسة",
    "daira_name_ascii": "Sedrata",
    "daira_name": "سدراتة",
    "wilaya_code": "41",
    "wilaya_name_ascii": "Souk Ahras",
    "wilaya_name": "سوق أهراس"
  },
  {
    "id": 1338,
    "commune_name_ascii": "M'daourouche",
    "commune_name": "مداوروش",
    "daira_name_ascii": "M'daourouche",
    "daira_name": "مداوروش",
    "wilaya_code": "41",
    "wilaya_name_ascii": "Souk Ahras",
    "wilaya_name": "سوق أهراس"
  },
  {
    "model": "base.commune",
    "pk": 1354,
    "fields": {
      "postcode": 41026,
      "wilaya": 41,
      "name": "Zouabi"
    },
    "id": 1354,
    "commune_name_ascii": "Zouabi",
    "commune_name": "الزوابي",
    "daira_name_ascii": "Bir Bouhouche",
    "daira_name": "بئر بوحوش",
    "wilaya_code": "41",
    "wilaya_name_ascii": "Souk Ahras",
    "wilaya_name": "سوق أهراس"
  },
  {
    "model": "base.commune",
    "pk": 1362,
    "fields": {
      "postcode": 42012,
      "wilaya": 42,
      "name": "Hadjout"
    },
    "id": 1369,
    "commune_name_ascii": "Hadjout",
    "commune_name": "حجوط",
    "daira_name_ascii": "Hadjout",
    "daira_name": "حجوط",
    "wilaya_code": "42",
    "wilaya_name_ascii": "Tipaza",
    "wilaya_name": "تيبازة"
  },
  {
    "id": 1375,
    "commune_name_ascii": "Merad",
    "commune_name": "مراد",
    "daira_name_ascii": "Hadjout",
    "daira_name": "حجوط",
    "wilaya_code": "42",
    "wilaya_name_ascii": "Tipaza",
    "wilaya_name": "تيبازة"
  },
  {
    "model": "base.commune",
    "pk": 1356,
    "fields": {
      "postcode": 42002,
      "wilaya": 42,
      "name": "Menaceur"
    },
    "id": 1374,
    "commune_name_ascii": "Menaceur",
    "commune_name": "مناصر",
    "daira_name_ascii": "Sidi Amar",
    "daira_name": "سيدي أعمر",
    "wilaya_code": "42",
    "wilaya_name_ascii": "Tipaza",
    "wilaya_name": "تيبازة"
  },
  {
    "id": 1355,
    "commune_name_ascii": "Aghbal",
    "commune_name": "أغبال",
    "daira_name_ascii": "Gouraya",
    "daira_name": "قوراية",
    "wilaya_code": "42",
    "wilaya_name_ascii": "Tipaza",
    "wilaya_name": "تيبازة"
  },
  {
    "id": 1377,
    "commune_name_ascii": "Nador",
    "commune_name": "الناظور",
    "daira_name_ascii": "Sidi Amar",
    "daira_name": "سيدي أعمر",
    "wilaya_code": "42",
    "wilaya_name_ascii": "Tipaza",
    "wilaya_name": "تيبازة"
  },
  {
    "id": 1381,
    "commune_name_ascii": "Sidi Amar",
    "commune_name": "سيدي عامر",
    "daira_name_ascii": "Sidi Amar",
    "daira_name": "سيدي أعمر",
    "wilaya_code": "42",
    "wilaya_name_ascii": "Tipaza",
    "wilaya_name": "تيبازة"
  },
  {
    "model": "base.commune",
    "pk": 1364,
    "fields": {
      "postcode": 42014,
      "wilaya": 42,
      "name": "Gouraya"
    },
    "id": 1368,
    "commune_name_ascii": "Gouraya",
    "commune_name": "قوراية",
    "daira_name_ascii": "Gouraya",
    "daira_name": "قوراية",
    "wilaya_code": "42",
    "wilaya_name_ascii": "Tipaza",
    "wilaya_name": "تيبازة"
  },
  {
    "model": "base.commune",
    "pk": 1376,
    "fields": {
      "postcode": 42033,
      "wilaya": 42,
      "name": "Messelmoun"
    },
    "id": 1376,
    "commune_name_ascii": "Messelmoun",
    "commune_name": "مسلمون",
    "daira_name_ascii": "Gouraya",
    "daira_name": "قوراية",
    "wilaya_code": "42",
    "wilaya_name_ascii": "Tipaza",
    "wilaya_name": "تيبازة"
  },
  {
    "id": 1364,
    "commune_name_ascii": "Cherchell",
    "commune_name": "شرشال",
    "daira_name_ascii": "Cherchell",
    "daira_name": "شرشال",
    "wilaya_code": "42",
    "wilaya_name_ascii": "Tipaza",
    "wilaya_name": "تيبازة"
  },
  {
    "id": 1370,
    "commune_name_ascii": "Hadjret Ennous",
    "commune_name": "حجرة النص",
    "daira_name_ascii": "Cherchell",
    "daira_name": "شرشال",
    "wilaya_code": "42",
    "wilaya_name_ascii": "Tipaza",
    "wilaya_name": "تيبازة"
  },
  {
    "model": "base.commune",
    "pk": 1375,
    "fields": {
      "postcode": 42032,
      "wilaya": 42,
      "name": "Sidi Ghiles"
    },
    "id": 1378,
    "commune_name_ascii": "Sidi Ghiles",
    "commune_name": "سيدي غيلاس",
    "daira_name_ascii": "Cherchell",
    "daira_name": "شرشال",
    "wilaya_code": "42",
    "wilaya_name_ascii": "Tipaza",
    "wilaya_name": "تيبازة"
  },
  {
    "model": "base.commune",
    "pk": 1369,
    "fields": {
      "postcode": 42023,
      "wilaya": 42,
      "name": "Damous"
    },
    "id": 1365,
    "commune_name_ascii": "Damous",
    "commune_name": "الداموس",
    "daira_name_ascii": "Damous",
    "daira_name": "الداموس",
    "wilaya_code": "42",
    "wilaya_name_ascii": "Tipaza",
    "wilaya_name": "تيبازة"
  },
  {
    "model": "base.commune",
    "pk": 1357,
    "fields": {
      "postcode": 42003,
      "wilaya": 42,
      "name": "Larhat"
    },
    "id": 1373,
    "commune_name_ascii": "Larhat",
    "commune_name": "الأرهاط",
    "daira_name_ascii": "Damous",
    "daira_name": "الداموس",
    "wilaya_code": "42",
    "wilaya_name_ascii": "Tipaza",
    "wilaya_name": "تيبازة"
  },
  {
    "model": "base.commune",
    "pk": 1371,
    "fields": {
      "postcode": 42025,
      "wilaya": 42,
      "name": "Fouka"
    },
    "id": 1367,
    "commune_name_ascii": "Fouka",
    "commune_name": "فوكة",
    "daira_name_ascii": "Fouka",
    "daira_name": "فوكة",
    "wilaya_code": "42",
    "wilaya_name_ascii": "Tipaza",
    "wilaya_name": "تيبازة"
  },
  {
    "model": "base.commune",
    "pk": 1367,
    "fields": {
      "postcode": 42017,
      "wilaya": 42,
      "name": "Ain Tagourait"
    },
    "id": 1357,
    "commune_name_ascii": "Ain Tagourait",
    "commune_name": "عين تاقورايت",
    "daira_name_ascii": "Bou Ismail",
    "daira_name": "بواسماعيل",
    "wilaya_code": "42",
    "wilaya_name_ascii": "Tipaza",
    "wilaya_name": "تيبازة"
  },
  {
    "model": "base.commune",
    "pk": 1374,
    "fields": {
      "postcode": 42030,
      "wilaya": 42,
      "name": "Bou Haroun"
    },
    "id": 1360,
    "commune_name_ascii": "Bou Haroun",
    "commune_name": "بوهارون",
    "daira_name_ascii": "Bou Ismail",
    "daira_name": "بواسماعيل",
    "wilaya_code": "42",
    "wilaya_name_ascii": "Tipaza",
    "wilaya_name": "تيبازة"
  },
  {
    "model": "base.commune",
    "pk": 1372,
    "fields": {
      "postcode": 42026,
      "wilaya": 42,
      "name": "Bou Ismail"
    },
    "id": 1361,
    "commune_name_ascii": "Bou Ismail",
    "commune_name": "بواسماعيل",
    "daira_name_ascii": "Bou Ismail",
    "daira_name": "بواسماعيل",
    "wilaya_code": "42",
    "wilaya_name_ascii": "Tipaza",
    "wilaya_name": "تيبازة"
  },
  {
    "model": "base.commune",
    "pk": 1266,
    "fields": {
      "postcode": 38011,
      "wilaya": 38,
      "name": "Khemisti"
    },
    "id": 1371,
    "commune_name_ascii": "Khemisti",
    "commune_name": "خميستي",
    "daira_name_ascii": "Bou Ismail",
    "daira_name": "بواسماعيل",
    "wilaya_code": "42",
    "wilaya_name_ascii": "Tipaza",
    "wilaya_name": "تيبازة"
  },
  {
    "model": "base.commune",
    "pk": 1373,
    "fields": {
      "postcode": 42027,
      "wilaya": 42,
      "name": "Ahmer El Ain"
    },
    "id": 1356,
    "commune_name_ascii": "Ahmer El Ain",
    "commune_name": "أحمر العين",
    "daira_name_ascii": "Ahmar El Ain",
    "daira_name": "أحمر العين",
    "wilaya_code": "42",
    "wilaya_name_ascii": "Tipaza",
    "wilaya_name": "تيبازة"
  },
  {
    "model": "base.commune",
    "pk": 1359,
    "fields": {
      "postcode": 42005,
      "wilaya": 42,
      "name": "Bourkika"
    },
    "id": 1362,
    "commune_name_ascii": "Bourkika",
    "commune_name": "بورقيقة",
    "daira_name_ascii": "Ahmar El Ain",
    "daira_name": "أحمر العين",
    "wilaya_code": "42",
    "wilaya_name_ascii": "Tipaza",
    "wilaya_name": "تيبازة"
  },
  {
    "model": "base.commune",
    "pk": 1358,
    "fields": {
      "postcode": 42004,
      "wilaya": 42,
      "name": "Douaouda"
    },
    "id": 1366,
    "commune_name_ascii": "Douaouda",
    "commune_name": "دواودة",
    "daira_name_ascii": "Fouka",
    "daira_name": "فوكة",
    "wilaya_code": "42",
    "wilaya_name_ascii": "Tipaza",
    "wilaya_name": "تيبازة"
  },
  {
    "model": "base.commune",
    "pk": 1377,
    "fields": {
      "postcode": 42034,
      "wilaya": 42,
      "name": "Sidi Rached"
    },
    "id": 1379,
    "commune_name_ascii": "Sidi Rached",
    "commune_name": "سيدي راشد",
    "daira_name_ascii": "Ahmar El Ain",
    "daira_name": "أحمر العين",
    "wilaya_code": "42",
    "wilaya_name_ascii": "Tipaza",
    "wilaya_name": "تيبازة"
  },
  {
    "model": "base.commune",
    "pk": 1379,
    "fields": {
      "postcode": 42036,
      "wilaya": 42,
      "name": "Attatba"
    },
    "id": 1358,
    "commune_name_ascii": "Attatba",
    "commune_name": "الحطاطبة",
    "daira_name_ascii": "Kolea",
    "daira_name": "القليعة",
    "wilaya_code": "42",
    "wilaya_name_ascii": "Tipaza",
    "wilaya_name": "تيبازة"
  },
  {
    "model": "base.commune",
    "pk": 1366,
    "fields": {
      "postcode": 42016,
      "wilaya": 42,
      "name": "Chaiba"
    },
    "id": 1363,
    "commune_name_ascii": "Chaiba",
    "commune_name": "الشعيبة",
    "daira_name_ascii": "Kolea",
    "daira_name": "القليعة",
    "wilaya_code": "42",
    "wilaya_name_ascii": "Tipaza",
    "wilaya_name": "تيبازة"
  },
  {
    "model": "base.commune",
    "pk": 1378,
    "fields": {
      "postcode": 42035,
      "wilaya": 42,
      "name": "Kolea"
    },
    "id": 1372,
    "commune_name_ascii": "Kolea",
    "commune_name": "القليعة",
    "daira_name_ascii": "Kolea",
    "daira_name": "القليعة",
    "wilaya_code": "42",
    "wilaya_name_ascii": "Tipaza",
    "wilaya_name": "تيبازة"
  },
  {
    "model": "base.commune",
    "pk": 1380,
    "fields": {
      "postcode": 42040,
      "wilaya": 42,
      "name": "Sidi Semiane"
    },
    "id": 1380,
    "commune_name_ascii": "Sidi Semiane",
    "commune_name": "سيدي سميان",
    "daira_name_ascii": "Cherchell",
    "daira_name": "شرشال",
    "wilaya_code": "42",
    "wilaya_name_ascii": "Tipaza",
    "wilaya_name": "تيبازة"
  },
  {
    "model": "base.commune",
    "pk": 1355,
    "fields": {
      "postcode": 42001,
      "wilaya": 42,
      "name": "Tipaza"
    },
    "id": 1382,
    "commune_name_ascii": "Tipaza",
    "commune_name": "تيبازة",
    "daira_name_ascii": "Tipaza",
    "daira_name": "تيبازة",
    "wilaya_code": "42",
    "wilaya_name_ascii": "Tipaza",
    "wilaya_name": "تيبازة"
  },
  {
    "id": 1359,
    "commune_name_ascii": "Beni Mileuk",
    "commune_name": "بني ميلك",
    "daira_name_ascii": "Damous",
    "daira_name": "الداموس",
    "wilaya_code": "42",
    "wilaya_name_ascii": "Tipaza",
    "wilaya_name": "تيبازة"
  },
  {
    "model": "base.commune",
    "pk": 1408,
    "fields": {
      "postcode": 43026,
      "wilaya": 43,
      "name": "El Mechira"
    },
    "id": 1394,
    "commune_name_ascii": "El Mechira",
    "commune_name": "مشيرة",
    "daira_name_ascii": "Teleghma",
    "daira_name": "التلاغمة",
    "wilaya_code": "43",
    "wilaya_name_ascii": "Mila",
    "wilaya_name": "ميلة"
  },
  {
    "id": 1393,
    "commune_name_ascii": "El Ayadi Barbes",
    "commune_name": "العياضي برباس",
    "daira_name_ascii": "Ain Beida Harriche",
    "daira_name": "عين البيضاء أحريش",
    "wilaya_code": "43",
    "wilaya_name_ascii": "Mila",
    "wilaya_name": "ميلة"
  },
  {
    "model": "base.commune",
    "pk": 1412,
    "fields": {
      "postcode": 43030,
      "wilaya": 43,
      "name": "Ain Beida Harriche"
    },
    "id": 1384,
    "commune_name_ascii": "Ain Beida Harriche",
    "commune_name": " عين البيضاء أحريش",
    "daira_name_ascii": "Ain Beida Harriche",
    "daira_name": "عين البيضاء أحريش",
    "wilaya_code": "43",
    "wilaya_name_ascii": "Mila",
    "wilaya_name": "ميلة"
  },
  {
    "id": 1411,
    "commune_name_ascii": "Tassala Lematai",
    "commune_name": "تسالة لمطاعي",
    "daira_name_ascii": "Terrai Bainen",
    "daira_name": "ترعي باينان",
    "wilaya_code": "43",
    "wilaya_name_ascii": "Mila",
    "wilaya_name": "ميلة"
  },
  {
    "model": "base.commune",
    "pk": 1405,
    "fields": {
      "postcode": 43023,
      "wilaya": 43,
      "name": "Terrai Bainen"
    },
    "id": 1410,
    "commune_name_ascii": "Terrai Bainen",
    "commune_name": "ترعي باينان",
    "daira_name_ascii": "Terrai Bainen",
    "daira_name": "ترعي باينان",
    "wilaya_code": "43",
    "wilaya_name_ascii": "Mila",
    "wilaya_name": "ميلة"
  },
  {
    "id": 1387,
    "commune_name_ascii": "Amira Arres",
    "commune_name": "اعميرة اراس",
    "daira_name_ascii": "Terrai Bainen",
    "daira_name": "ترعي باينان",
    "wilaya_code": "43",
    "wilaya_name_ascii": "Mila",
    "wilaya_name": "ميلة"
  },
  {
    "model": "base.commune",
    "pk": 1401,
    "fields": {
      "postcode": 43019,
      "wilaya": 43,
      "name": "Tassadane Haddada"
    },
    "id": 1408,
    "commune_name_ascii": "Tassadane Haddada",
    "commune_name": "تسدان حدادة",
    "daira_name_ascii": "Tassadane Haddada",
    "daira_name": "تسدان حدادة",
    "wilaya_code": "43",
    "wilaya_name_ascii": "Mila",
    "wilaya_name": "ميلة"
  },
  {
    "model": "base.commune",
    "pk": 1403,
    "fields": {
      "postcode": 43021,
      "wilaya": 43,
      "name": "Minar Zarza"
    },
    "id": 1399,
    "commune_name_ascii": "Minar Zarza",
    "commune_name": "مينار زارزة",
    "daira_name_ascii": "Tassadane Haddada",
    "daira_name": "تسدان حدادة",
    "wilaya_code": "43",
    "wilaya_name_ascii": "Mila",
    "wilaya_name": "ميلة"
  },
  {
    "model": "base.commune",
    "pk": 1400,
    "fields": {
      "postcode": 43018,
      "wilaya": 43,
      "name": "Sidi Merouane"
    },
    "id": 1406,
    "commune_name_ascii": "Sidi Merouane",
    "commune_name": "سيدي مروان",
    "daira_name_ascii": "Sidi Merouane",
    "daira_name": "سيدي مروان",
    "wilaya_code": "43",
    "wilaya_name_ascii": "Mila",
    "wilaya_name": "ميلة"
  },
  {
    "model": "base.commune",
    "pk": 1414,
    "fields": {
      "postcode": 43032,
      "wilaya": 43,
      "name": "Chigara"
    },
    "id": 1391,
    "commune_name_ascii": "Chigara",
    "commune_name": "الشيقارة",
    "daira_name_ascii": "Sidi Merouane",
    "daira_name": "سيدي مروان",
    "wilaya_code": "43",
    "wilaya_name_ascii": "Mila",
    "wilaya_name": "ميلة"
  },
  {
    "model": "base.commune",
    "pk": 1406,
    "fields": {
      "postcode": 43024,
      "wilaya": 43,
      "name": "Hamala"
    },
    "id": 1397,
    "commune_name_ascii": "Hamala",
    "commune_name": "حمالة",
    "daira_name_ascii": "Grarem Gouga",
    "daira_name": "القرارم قوقة",
    "wilaya_code": "43",
    "wilaya_name_ascii": "Mila",
    "wilaya_name": "ميلة"
  },
  {
    "model": "base.commune",
    "pk": 1399,
    "fields": {
      "postcode": 43017,
      "wilaya": 43,
      "name": "Grarem Gouga"
    },
    "id": 1396,
    "commune_name_ascii": "Grarem Gouga",
    "commune_name": "القرارم قوقة",
    "daira_name_ascii": "Grarem Gouga",
    "daira_name": "القرارم قوقة",
    "wilaya_code": "43",
    "wilaya_name_ascii": "Mila",
    "wilaya_name": "ميلة"
  },
  {
    "model": "base.commune",
    "pk": 1395,
    "fields": {
      "postcode": 43013,
      "wilaya": 43,
      "name": "Tiberguent"
    },
    "id": 1412,
    "commune_name_ascii": "Tiberguent",
    "commune_name": "تيبرقنت",
    "daira_name_ascii": "Rouached",
    "daira_name": "الرواشد",
    "wilaya_code": "43",
    "wilaya_name_ascii": "Mila",
    "wilaya_name": "ميلة"
  },
  {
    "model": "base.commune",
    "pk": 1397,
    "fields": {
      "postcode": 43015,
      "wilaya": 43,
      "name": "Rouached"
    },
    "id": 1404,
    "commune_name_ascii": "Rouached",
    "commune_name": "الرواشد",
    "daira_name_ascii": "Rouached",
    "daira_name": "الرواشد",
    "wilaya_code": "43",
    "wilaya_name_ascii": "Mila",
    "wilaya_name": "ميلة"
  },
  {
    "id": 1392,
    "commune_name_ascii": "Derrahi Bousselah",
    "commune_name": "دراحي بوصلاح",
    "daira_name_ascii": "Bouhatem",
    "daira_name": "بوحاتم",
    "wilaya_code": "43",
    "wilaya_name_ascii": "Mila",
    "wilaya_name": "ميلة"
  },
  {
    "model": "base.commune",
    "pk": 1410,
    "fields": {
      "postcode": 43028,
      "wilaya": 43,
      "name": "Zeghaia"
    },
    "id": 1414,
    "commune_name_ascii": "Zeghaia",
    "commune_name": "زغاية",
    "daira_name_ascii": "Oued Endja",
    "daira_name": "وادي النجاء",
    "wilaya_code": "43",
    "wilaya_name_ascii": "Mila",
    "wilaya_name": "ميلة"
  },
  {
    "model": "base.commune",
    "pk": 1392,
    "fields": {
      "postcode": 43010,
      "wilaya": 43,
      "name": "Oued Endja"
    },
    "id": 1401,
    "commune_name_ascii": "Oued Endja",
    "commune_name": "وادي النجاء",
    "daira_name_ascii": "Oued Endja",
    "daira_name": "وادي النجاء",
    "wilaya_code": "43",
    "wilaya_name_ascii": "Mila",
    "wilaya_name": "ميلة"
  },
  {
    "model": "base.commune",
    "pk": 1393,
    "fields": {
      "postcode": 43011,
      "wilaya": 43,
      "name": "Ahmed Rachedi"
    },
    "id": 1383,
    "commune_name_ascii": "Ahmed Rachedi",
    "commune_name": "أحمد راشدي",
    "daira_name_ascii": "Oued Endja",
    "daira_name": "وادي النجاء",
    "wilaya_code": "43",
    "wilaya_name_ascii": "Mila",
    "wilaya_name": "ميلة"
  },
  {
    "model": "base.commune",
    "pk": 1390,
    "fields": {
      "postcode": 43008,
      "wilaya": 43,
      "name": "Tadjenanet"
    },
    "id": 1407,
    "commune_name_ascii": "Tadjenanet",
    "commune_name": "تاجنانت",
    "daira_name_ascii": "Tadjenanet",
    "daira_name": "تاجنانت",
    "wilaya_code": "43",
    "wilaya_name_ascii": "Mila",
    "wilaya_name": "ميلة"
  },
  {
    "model": "base.commune",
    "pk": 1387,
    "fields": {
      "postcode": 43005,
      "wilaya": 43,
      "name": "Ain Mellouk"
    },
    "id": 1385,
    "commune_name_ascii": "Ain Mellouk",
    "commune_name": "عين الملوك",
    "daira_name_ascii": "Chelghoum Laid",
    "daira_name": "شلغوم العيد",
    "wilaya_code": "43",
    "wilaya_name_ascii": "Mila",
    "wilaya_name": "ميلة"
  },
  {
    "model": "base.commune",
    "pk": 1394,
    "fields": {
      "postcode": 43012,
      "wilaya": 43,
      "name": "Ouled Khalouf"
    },
    "id": 1403,
    "commune_name_ascii": "Ouled Khalouf",
    "commune_name": "أولاد اخلوف",
    "daira_name_ascii": "Tadjenanet",
    "daira_name": "تاجنانت",
    "wilaya_code": "43",
    "wilaya_name_ascii": "Mila",
    "wilaya_name": "ميلة"
  },
  {
    "model": "base.commune",
    "pk": 1391,
    "fields": {
      "postcode": 43009,
      "wilaya": 43,
      "name": "Benyahia Abderrahmane"
    },
    "id": 1388,
    "commune_name_ascii": "Benyahia Abderrahmane",
    "commune_name": "بن يحي عبد الرحمن",
    "daira_name_ascii": "Tadjenanet",
    "daira_name": "تاجنانت",
    "wilaya_code": "43",
    "wilaya_name_ascii": "Mila",
    "wilaya_name": "ميلة"
  },
  {
    "id": 1409,
    "commune_name_ascii": "Teleghma",
    "commune_name": "التلاغمة",
    "daira_name_ascii": "Teleghma",
    "daira_name": "التلاغمة",
    "wilaya_code": "43",
    "wilaya_name_ascii": "Mila",
    "wilaya_name": "ميلة"
  },
  {
    "model": "base.commune",
    "pk": 1389,
    "fields": {
      "postcode": 43007,
      "wilaya": 43,
      "name": "Oued Seguen"
    },
    "id": 1402,
    "commune_name_ascii": "Oued Seguen",
    "commune_name": "وادي سقان",
    "daira_name_ascii": "Teleghma",
    "daira_name": "التلاغمة",
    "wilaya_code": "43",
    "wilaya_name_ascii": "Mila",
    "wilaya_name": "ميلة"
  },
  {
    "model": "base.commune",
    "pk": 1386,
    "fields": {
      "postcode": 43004,
      "wilaya": 43,
      "name": "Oued Athmenia"
    },
    "id": 1400,
    "commune_name_ascii": "Oued Athmenia",
    "commune_name": "وادي العثمانية",
    "daira_name_ascii": "Chelghoum Laid",
    "daira_name": "شلغوم العيد",
    "wilaya_code": "43",
    "wilaya_name_ascii": "Mila",
    "wilaya_name": "ميلة"
  },
  {
    "model": "base.commune",
    "pk": 1407,
    "fields": {
      "postcode": 43025,
      "wilaya": 43,
      "name": "Ain Tine"
    },
    "id": 1386,
    "commune_name_ascii": "Ain Tine",
    "commune_name": "عين التين",
    "daira_name_ascii": "Mila",
    "daira_name": "ميلة",
    "wilaya_code": "43",
    "wilaya_name_ascii": "Mila",
    "wilaya_name": "ميلة"
  },
  {
    "model": "base.commune",
    "pk": 1385,
    "fields": {
      "postcode": 43003,
      "wilaya": 43,
      "name": "Chelghoum Laid"
    },
    "id": 1390,
    "commune_name_ascii": "Chelghoum Laid",
    "commune_name": "شلغوم العيد",
    "daira_name_ascii": "Chelghoum Laid",
    "daira_name": "شلغوم العيد",
    "wilaya_code": "43",
    "wilaya_name_ascii": "Mila",
    "wilaya_name": "ميلة"
  },
  {
    "model": "base.commune",
    "pk": 1413,
    "fields": {
      "postcode": 43031,
      "wilaya": 43,
      "name": "Yahia Beniguecha"
    },
    "id": 1413,
    "commune_name_ascii": "Yahia Beniguecha",
    "commune_name": "يحي بني قشة",
    "daira_name_ascii": "Ferdjioua",
    "daira_name": "فرجيوة",
    "wilaya_code": "43",
    "wilaya_name_ascii": "Mila",
    "wilaya_name": "ميلة"
  },
  {
    "model": "base.commune",
    "pk": 1384,
    "fields": {
      "postcode": 43002,
      "wilaya": 43,
      "name": "Ferdjioua"
    },
    "id": 1395,
    "commune_name_ascii": "Ferdjioua",
    "commune_name": "فرجيوة",
    "daira_name_ascii": "Ferdjioua",
    "daira_name": "فرجيوة",
    "wilaya_code": "43",
    "wilaya_name_ascii": "Mila",
    "wilaya_name": "ميلة"
  },
  {
    "model": "base.commune",
    "pk": 1409,
    "fields": {
      "postcode": 43027,
      "wilaya": 43,
      "name": "Sidi Khelifa"
    },
    "id": 1405,
    "commune_name_ascii": "Sidi Khelifa",
    "commune_name": "سيدي خليفة",
    "daira_name_ascii": "Mila",
    "daira_name": "ميلة",
    "wilaya_code": "43",
    "wilaya_name_ascii": "Mila",
    "wilaya_name": "ميلة"
  },
  {
    "model": "base.commune",
    "pk": 1383,
    "fields": {
      "postcode": 43001,
      "wilaya": 43,
      "name": "Mila"
    },
    "id": 1398,
    "commune_name_ascii": "Mila",
    "commune_name": "ميلة",
    "daira_name_ascii": "Mila",
    "daira_name": "ميلة",
    "wilaya_code": "43",
    "wilaya_name_ascii": "Mila",
    "wilaya_name": "ميلة"
  },
  {
    "model": "base.commune",
    "pk": 1396,
    "fields": {
      "postcode": 43014,
      "wilaya": 43,
      "name": "Bouhatem"
    },
    "id": 1389,
    "commune_name_ascii": "Bouhatem",
    "commune_name": "بوحاتم",
    "daira_name_ascii": "Bouhatem",
    "daira_name": "بوحاتم",
    "wilaya_code": "43",
    "wilaya_name_ascii": "Mila",
    "wilaya_name": "ميلة"
  },
  {
    "id": 1440,
    "commune_name_ascii": "Khemis Miliana",
    "commune_name": "خميس مليانة",
    "daira_name_ascii": "Khemis",
    "daira_name": "خميس",
    "fields": {
      "wilaya": 44,
    },
    "wilaya_code": "44",
    "wilaya_name_ascii": "Ain Defla",
    "wilaya_name": "عين الدفلة"
  },
  {
    "id": 1446,
    "commune_name_ascii": "Sidi Lakhdar",
    "commune_name": "سيدي الأخضر",
    "daira_name_ascii": "Khemis",
    "daira_name": "خميس",
    "fields": {
      "wilaya": 44,
    },
    "wilaya_code": "44",
    "wilaya_name_ascii": "Ain Defla",
    "wilaya_name": "عين الدفلة"
  },
  {
    "id": 1415,
    "commune_name_ascii": "Ain Benian",
    "commune_name": "عين البنيان",
    "daira_name_ascii": "Hammam Righa",
    "daira_name": "حمام ريغة",
    "wilaya_code": "44",
    "fields": {
      "wilaya": 44,
    },
    "wilaya_name_ascii": "Ain Defla",
    "wilaya_name": "عين الدفلة"
  },
  {
    "id": 1420,
    "commune_name_ascii": "Ain Torki",
    "commune_name": "عين التركي",
    "daira_name_ascii": "Hammam Righa",
    "daira_name": "حمام ريغة",
    "wilaya_code": "44",
    "fields": {
      "wilaya": 44,
    },
    "wilaya_name_ascii": "Ain Defla",
    "wilaya_name": "عين الدفلة"
  },
  {
    "id": 1437,
    "commune_name_ascii": "Hammam Righa",
    "commune_name": "حمام ريغة",
    "daira_name_ascii": "Hammam Righa",
    "daira_name": "حمام ريغة",
    "wilaya_code": "44",
    "fields": {
      "wilaya": 44,
    },
    "wilaya_name_ascii": "Ain Defla",
    "wilaya_name": "عين الدفلة"
  },
  {
    "model": "base.commune",
    "pk": 1423,
    "fields": {
      "postcode": 44009,
      "wilaya": 44,
      "name": "Bourached"
    },
    "id": 1429,
    "commune_name_ascii": "Bourached",
    "commune_name": "بوراشد",
    "daira_name_ascii": "Djelida",
    "daira_name": "جليدة",
    "wilaya_code": "44",
    "wilaya_name_ascii": "Ain Defla",
    "wilaya_name": "عين الدفلة"
  },
  {
    "model": "base.commune",
    "pk": 1441,
    "fields": {
      "postcode": 44027,
      "wilaya": 44,
      "name": "Hoceinia"
    },
    "id": 1439,
    "commune_name_ascii": "Hoceinia",
    "commune_name": "الحسينية",
    "daira_name_ascii": "Boumedfaa",
    "daira_name": "بومدفع",
    "wilaya_code": "44",
    "wilaya_name_ascii": "Ain Defla",
    "wilaya_name": "عين الدفلة"
  },
  {
    "model": "base.commune",
    "pk": 1421,
    "fields": {
      "postcode": 44007,
      "wilaya": 44,
      "name": "Djelida"
    },
    "id": 1430,
    "commune_name_ascii": "Djelida",
    "commune_name": "جليدة",
    "daira_name_ascii": "Djelida",
    "daira_name": "جليدة",
    "wilaya_code": "44",
    "wilaya_name_ascii": "Ain Defla",
    "wilaya_name": "عين الدفلة"
  },
  {
    "model": "base.commune",
    "pk": 1420,
    "fields": {
      "postcode": 44006,
      "wilaya": 44,
      "name": "Arib"
    },
    "id": 1421,
    "commune_name_ascii": "Arib",
    "commune_name": "عريب",
    "daira_name_ascii": "El-Amra",
    "daira_name": "العامرة",
    "wilaya_code": "44",
    "wilaya_name_ascii": "Ain Defla",
    "wilaya_name": "عين الدفلة"
  },
  {
    "id": 1431,
    "commune_name_ascii": "Djemaa Ouled Cheikh",
    "commune_name": "جمعة أولاد الشيخ",
    "daira_name_ascii": "Djelida",
    "daira_name": "جليدة",
    "wilaya_code": "44",
    "wilaya_name_ascii": "Ain Defla",
    "wilaya_name": "عين الدفلة"
  },
  {
    "id": 1434,
    "commune_name_ascii": "El-Amra",
    "commune_name": "العامرة",
    "daira_name_ascii": "El-Amra",
    "daira_name": "العامرة",
    "wilaya_code": "44",
    "wilaya_name_ascii": "Ain Defla",
    "wilaya_name": "عين الدفلة"
  },
  {
    "id": 1435,
    "commune_name_ascii": "El Attaf",
    "commune_name": "العطاف",
    "daira_name_ascii": "El Attaf",
    "daira_name": "العطاف",
    "wilaya_code": "44",
    "wilaya_name_ascii": "Ain Defla",
    "wilaya_name": "عين الدفلة"
  },
  {
    "model": "base.commune",
    "pk": 1449,
    "fields": {
      "postcode": 44035,
      "wilaya": 44,
      "name": "Tiberkanine"
    },
    "id": 1449,
    "commune_name_ascii": "Tiberkanine",
    "commune_name": "تبركانين",
    "daira_name_ascii": "El Attaf",
    "daira_name": "العطاف",
    "wilaya_code": "44",
    "wilaya_name_ascii": "Ain Defla",
    "wilaya_name": "عين الدفلة"
  },
  {
    "id": 1416,
    "commune_name_ascii": "Ain Bouyahia",
    "commune_name": "عين بويحيى",
    "daira_name_ascii": "El Abadia",
    "daira_name": "العبادية",
    "wilaya_code": "44",
    "wilaya_name_ascii": "Ain Defla",
    "wilaya_name": "عين الدفلة"
  },
  {
    "id": 1433,
    "commune_name_ascii": "El Abadia",
    "commune_name": "العبادية",
    "daira_name_ascii": "El Abadia",
    "daira_name": "العبادية",
    "wilaya_code": "44",
    "wilaya_name_ascii": "Ain Defla",
    "wilaya_name": "عين الدفلة"
  },
  {
    "id": 1447,
    "commune_name_ascii": "Tacheta Zegagha",
    "commune_name": "تاشتة زقاغة",
    "daira_name_ascii": "El Abadia",
    "daira_name": "العبادية",
    "wilaya_code": "44",
    "wilaya_name_ascii": "Ain Defla",
    "wilaya_name": "عين الدفلة"
  },
  {
    "id": 1422,
    "commune_name_ascii": "Birbouche",
    "commune_name": "بربوش",
    "daira_name_ascii": "Djendel",
    "daira_name": "جندل",
    "wilaya_code": "44",
    "wilaya_name_ascii": "Ain Defla",
    "wilaya_name": "عين الدفلة"
  },
  {
    "model": "base.commune",
    "pk": 1426,
    "fields": {
      "postcode": 44012,
      "wilaya": 44,
      "name": "Djendel"
    },
    "id": 1432,
    "commune_name_ascii": "Djendel",
    "commune_name": "جندل",
    "daira_name_ascii": "Djendel",
    "daira_name": "جندل",
    "wilaya_code": "44",
    "wilaya_name_ascii": "Ain Defla",
    "wilaya_name": "عين الدفلة"
  },
  {
    "model": "base.commune",
    "pk": 1439,
    "fields": {
      "postcode": 44025,
      "wilaya": 44,
      "name": "Ben Allal"
    },
    "id": 1425,
    "commune_name_ascii": "Ben Allal",
    "commune_name": "بن علال",
    "daira_name_ascii": "Miliana",
    "daira_name": "مليانة",
    "wilaya_code": "44",
    "wilaya_name_ascii": "Ain Defla",
    "wilaya_name": "عين الدفلة"
  },
  {
    "model": "base.commune",
    "pk": 1427,
    "fields": {
      "postcode": 44013,
      "wilaya": 44,
      "name": "Oued Chorfa"
    },
    "id": 1443,
    "commune_name_ascii": "Oued Chorfa",
    "commune_name": "وادي الشرفاء",
    "daira_name_ascii": "Djendel",
    "daira_name": "جندل",
    "wilaya_code": "44",
    "wilaya_name_ascii": "Ain Defla",
    "wilaya_name": "عين الدفلة"
  },
  {
    "model": "base.commune",
    "pk": 1417,
    "fields": {
      "postcode": 44003,
      "wilaya": 44,
      "name": "Boumedfaa"
    },
    "id": 1428,
    "commune_name_ascii": "Boumedfaa",
    "commune_name": "بومدفع",
    "daira_name_ascii": "Boumedfaa",
    "daira_name": "بومدفع",
    "wilaya_code": "44",
    "wilaya_name_ascii": "Ain Defla",
    "wilaya_name": "عين الدفلة"
  },
  {
    "id": 1418,
    "commune_name_ascii": "Ain Lechiakh",
    "commune_name": "عين الاشياخ",
    "daira_name_ascii": "Ain Lechiakh",
    "daira_name": "عين الاشياخ",
    "wilaya_code": "44",
    "wilaya_name_ascii": "Ain Defla",
    "wilaya_name": "عين الدفلة"
  },
  {
    "id": 1419,
    "commune_name_ascii": "Ain Soltane",
    "commune_name": "عين السلطان",
    "daira_name_ascii": "Ain Lechiakh",
    "daira_name": "عين الاشياخ",
    "wilaya_code": "44",
    "wilaya_name_ascii": "Ain Defla",
    "wilaya_name": "عين الدفلة"
  },
  {
    "model": "base.commune",
    "pk": 1429,
    "fields": {
      "postcode": 44015,
      "wilaya": 44,
      "name": "Oued Djemaa"
    },
    "id": 1444,
    "commune_name_ascii": "Oued Djemaa",
    "commune_name": "واد الجمعة",
    "daira_name_ascii": "Ain Lechiakh",
    "daira_name": "عين الاشياخ",
    "wilaya_code": "44",
    "wilaya_name_ascii": "Ain Defla",
    "wilaya_name": "عين الدفلة"
  },
  {
    "id": 1436,
    "commune_name_ascii": "El Maine",
    "commune_name": "الماين",
    "daira_name_ascii": "Rouina",
    "daira_name": "الروينة",
    "wilaya_code": "44",
    "wilaya_name_ascii": "Ain Defla",
    "wilaya_name": "عين الدفلة"
  },
  {
    "model": "base.commune",
    "pk": 1430,
    "fields": {
      "postcode": 44016,
      "wilaya": 44,
      "name": "Rouina"
    },
    "id": 1445,
    "commune_name_ascii": "Rouina",
    "commune_name": "الروينة",
    "daira_name_ascii": "Rouina",
    "daira_name": "الروينة",
    "wilaya_code": "44",
    "wilaya_name_ascii": "Ain Defla",
    "wilaya_name": "عين الدفلة"
  },
  {
    "model": "base.commune",
    "pk": 1431,
    "fields": {
      "postcode": 44017,
      "wilaya": 44,
      "name": "Zeddine"
    },
    "id": 1450,
    "commune_name_ascii": "Zeddine",
    "commune_name": "زدين",
    "daira_name_ascii": "Rouina",
    "daira_name": "الروينة",
    "wilaya_code": "44",
    "wilaya_name_ascii": "Ain Defla",
    "wilaya_name": "عين الدفلة"
  },
  {
    "id": 1426,
    "commune_name_ascii": "Bir Ould Khelifa",
    "commune_name": "بئر ولد خليفة",
    "daira_name_ascii": "Bordj El Emir Khaled",
    "daira_name": "برج الأمير خالد",
    "wilaya_code": "44",
    "wilaya_name_ascii": "Ain Defla",
    "wilaya_name": "عين الدفلة"
  },
  {
    "id": 1427,
    "commune_name_ascii": "Bordj Emir Khaled",
    "commune_name": "برج الأمير خالد",
    "daira_name_ascii": "Bordj El Emir Khaled",
    "daira_name": "برج الأمير خالد",
    "wilaya_code": "44",
    "wilaya_name_ascii": "Ain Defla",
    "wilaya_name": "عين الدفلة"
  },
  {
    "id": 1448,
    "commune_name_ascii": "Tarik Ibn Ziad",
    "commune_name": "طارق بن زياد",
    "daira_name_ascii": "Bordj El Emir Khaled",
    "daira_name": "برج الأمير خالد",
    "wilaya_code": "44",
    "wilaya_name_ascii": "Ain Defla",
    "wilaya_name": "عين الدفلة"
  },
  {
    "model": "base.commune",
    "pk": 1445,
    "fields": {
      "postcode": 44031,
      "wilaya": 44,
      "name": "Bathia"
    },
    "id": 1423,
    "commune_name_ascii": "Bathia",
    "commune_name": "بطحية",
    "daira_name_ascii": "Bathia",
    "daira_name": "بطحية",
    "wilaya_code": "44",
    "wilaya_name_ascii": "Ain Defla",
    "wilaya_name": "عين الدفلة"
  },
  {
    "model": "base.commune",
    "pk": 1450,
    "fields": {
      "postcode": 44036,
      "wilaya": 44,
      "name": "Belaas"
    },
    "id": 1424,
    "commune_name_ascii": "Belaas",
    "commune_name": "بلعاص",
    "daira_name_ascii": "Bathia",
    "daira_name": "بطحية",
    "wilaya_code": "44",
    "wilaya_name_ascii": "Ain Defla",
    "wilaya_name": "عين الدفلة"
  },
  {
    "id": 1438,
    "commune_name_ascii": "Hassania",
    "commune_name": "الحسانية",
    "daira_name_ascii": "Bathia",
    "daira_name": "بطحية",
    "wilaya_code": "44",
    "wilaya_name_ascii": "Ain Defla",
    "wilaya_name": "عين الدفلة"
  },
  {
    "id": 1417,
    "commune_name_ascii": "Ain Defla",
    "commune_name": "عين الدفلى",
    "daira_name_ascii": "Ain Defla",
    "daira_name": "عين الدفلى",
    "wilaya_code": "44",
    "wilaya_name_ascii": "Ain Defla",
    "wilaya_name": "عين الدفلة"
  },
  {
    "model": "base.commune",
    "pk": 1416,
    "fields": {
      "postcode": 44002,
      "wilaya": 44,
      "name": "Miliana"
    },
    "id": 1442,
    "commune_name_ascii": "Miliana",
    "commune_name": "مليانة",
    "daira_name_ascii": "Miliana",
    "daira_name": "مليانة",
    "wilaya_code": "44",
    "wilaya_name_ascii": "Ain Defla",
    "wilaya_name": "عين الدفلة"
  },
  {
    "model": "base.commune",
    "pk": 1444,
    "fields": {
      "postcode": 44030,
      "wilaya": 44,
      "name": "Mekhatria"
    },
    "id": 1441,
    "commune_name_ascii": "Mekhatria",
    "commune_name": "المخاطرية",
    "daira_name_ascii": "El-Amra",
    "daira_name": "العامرة",
    "wilaya_code": "44",
    "wilaya_name_ascii": "Ain Defla",
    "wilaya_name": "عين الدفلة"
  },
   {
    "id": 1440,
    "commune_name_ascii": "Khemis Miliana",
    "commune_name": "خميس مليانة",
    "daira_name_ascii": "Khemis",
    "daira_name": "خميس",
    "fields": {
      "wilaya": 44,
    },
    "wilaya_code": "44",
    "wilaya_name_ascii": "Aïn Defla",
    "wilaya_name": "عين الدفلى"
  },
  {
    "id": 1446,
    "commune_name_ascii": "Sidi Lakhdar",
    "commune_name": "سيدي الأخضر",
    "daira_name_ascii": "Khemis",
    "daira_name": "خميس",
    "fields": {
      "wilaya": 44,
    },
    "wilaya_code": "44",
    "wilaya_name_ascii": "Aïn Defla",
    "wilaya_name": "عين الدفلى"
  },
  {
    "id": 1415,
    "commune_name_ascii": "Ain-Benian",
    "commune_name": "عين البنيان",
    "daira_name_ascii": "Hammam Righa",
    "daira_name": "حمام ريغة",
    "wilaya_code": "44",
    "fields": {
      "wilaya": 44,
    },
    "wilaya_name_ascii": "Aïn Defla",
    "wilaya_name": "عين الدفلى"
  },
  {
    "id": 1420,
    "commune_name_ascii": "Ain Torki",
    "commune_name": "عين التركي",
    "daira_name_ascii": "Hammam Righa",
    "daira_name": "حمام ريغة",
    "wilaya_code": "44",
    "fields": {
      "wilaya": 44,
    },
    "wilaya_name_ascii": "Aïn Defla",
    "wilaya_name": "عين الدفلى"
  },
  {
    "id": 1437,
    "commune_name_ascii": "Hammam Righa",
    "commune_name": "حمام ريغة",
    "daira_name_ascii": "Hammam Righa",
    "daira_name": "حمام ريغة",
    "wilaya_code": "44",
    "fields": {
      "wilaya": 44,
    },
    "wilaya_name_ascii": "Aïn Defla",
    "wilaya_name": "عين الدفلى"
  },
  {
    "model": "base.commune",
    "pk": 1423,
    "fields": {
      "postcode": 44009,
      "wilaya": 44,
      "name": "Bourached"
    },
    "id": 1429,
    "commune_name_ascii": "Bourached",
    "commune_name": "بوراشد",
    "daira_name_ascii": "Djelida",
    "daira_name": "جليدة",
    "wilaya_code": "44",
    "wilaya_name_ascii": "Aïn Defla",
    "wilaya_name": "عين الدفلى"
  },
  {
    "model": "base.commune",
    "pk": 1441,
    "fields": {
      "postcode": 44027,
      "wilaya": 44,
      "name": "Hoceinia"
    },
    "id": 1439,
    "commune_name_ascii": "Hoceinia",
    "commune_name": "الحسينية",
    "daira_name_ascii": "Boumedfaa",
    "daira_name": "بومدفع",
    "wilaya_code": "44",
    "wilaya_name_ascii": "Aïn Defla",
    "wilaya_name": "عين الدفلى"
  },
  {
    "model": "base.commune",
    "pk": 1421,
    "fields": {
      "postcode": 44007,
      "wilaya": 44,
      "name": "Djelida"
    },
    "id": 1430,
    "commune_name_ascii": "Djelida",
    "commune_name": "جليدة",
    "daira_name_ascii": "Djelida",
    "daira_name": "جليدة",
    "wilaya_code": "44",
    "wilaya_name_ascii": "Aïn Defla",
    "wilaya_name": "عين الدفلى"
  },
  {
    "model": "base.commune",
    "pk": 1420,
    "fields": {
      "postcode": 44006,
      "wilaya": 44,
      "name": "Arib"
    },
    "id": 1421,
    "commune_name_ascii": "Arib",
    "commune_name": "عريب",
    "daira_name_ascii": "El Amra",
    "daira_name": "العامرة",
    "wilaya_code": "44",
    "wilaya_name_ascii": "Aïn Defla",
    "wilaya_name": "عين الدفلى"
  },
  {
    "id": 1431,
    "commune_name_ascii": "Djemaa Ouled Cheikh",
    "commune_name": "جمعة أولاد الشيخ",
    "daira_name_ascii": "Djelida",
    "daira_name": "جليدة",
    "wilaya_code": "44",
    "wilaya_name_ascii": "Aïn Defla",
    "wilaya_name": "عين الدفلى"
  },
  {
    "id": 1434,
    "commune_name_ascii": "El Amra",
    "commune_name": "العامرة",
    "daira_name_ascii": "El Amra",
    "daira_name": "العامرة",
    "wilaya_code": "44",
    "wilaya_name_ascii": "Aïn Defla",
    "wilaya_name": "عين الدفلى"
  },
  {
    "id": 1435,
    "commune_name_ascii": "El Attaf",
    "commune_name": "العطاف",
    "daira_name_ascii": "El Attaf",
    "daira_name": "العطاف",
    "wilaya_code": "44",
    "wilaya_name_ascii": "Aïn Defla",
    "wilaya_name": "عين الدفلى"
  },
  {
    "model": "base.commune",
    "pk": 1449,
    "fields": {
      "postcode": 44035,
      "wilaya": 44,
      "name": "Tiberkanine"
    },
    "id": 1449,
    "commune_name_ascii": "Tiberkanine",
    "commune_name": "تبركانين",
    "daira_name_ascii": "El Attaf",
    "daira_name": "العطاف",
    "wilaya_code": "44",
    "wilaya_name_ascii": "Aïn Defla",
    "wilaya_name": "عين الدفلى"
  },
  {
    "id": 1416,
    "commune_name_ascii": "Ain Bouyahia",
    "commune_name": "عين بويحيى",
    "daira_name_ascii": "El Abadia",
    "daira_name": "العبادية",
    "wilaya_code": "44",
    "wilaya_name_ascii": "Aïn Defla",
    "wilaya_name": "عين الدفلى"
  },
  {
    "id": 1433,
    "commune_name_ascii": "El Abadia",
    "commune_name": "العبادية",
    "daira_name_ascii": "El Abadia",
    "daira_name": "العبادية",
    "wilaya_code": "44",
    "wilaya_name_ascii": "Aïn Defla",
    "wilaya_name": "عين الدفلى"
  },
  {
    "id": 1447,
    "commune_name_ascii": "Tacheta Zegagha",
    "commune_name": "تاشتة زقاغة",
    "daira_name_ascii": "El Abadia",
    "daira_name": "العبادية",
    "wilaya_code": "44",
    "wilaya_name_ascii": "Aïn Defla",
    "wilaya_name": "عين الدفلى"
  },
  {
    "id": 1422,
    "commune_name_ascii": "Birbouche",
    "commune_name": "بربوش",
    "daira_name_ascii": "Djendel",
    "daira_name": "جندل",
    "wilaya_code": "44",
    "wilaya_name_ascii": "Aïn Defla",
    "wilaya_name": "عين الدفلى"
  },
  {
    "model": "base.commune",
    "pk": 1426,
    "fields": {
      "postcode": 44012,
      "wilaya": 44,
      "name": "Djendel"
    },
    "id": 1432,
    "commune_name_ascii": "Djendel",
    "commune_name": "جندل",
    "daira_name_ascii": "Djendel",
    "daira_name": "جندل",
    "wilaya_code": "44",
    "wilaya_name_ascii": "Aïn Defla",
    "wilaya_name": "عين الدفلى"
  },
  {
    "model": "base.commune",
    "pk": 1439,
    "fields": {
      "postcode": 44025,
      "wilaya": 44,
      "name": "Ben Allal"
    },
    "id": 1425,
    "commune_name_ascii": "Ben Allal",
    "commune_name": "بن علال",
    "daira_name_ascii": "Miliana",
    "daira_name": "مليانة",
    "wilaya_code": "44",
    "wilaya_name_ascii": "Aïn Defla",
    "wilaya_name": "عين الدفلى"
  },
  {
    "model": "base.commune",
    "pk": 1427,
    "fields": {
      "postcode": 44013,
      "wilaya": 44,
      "name": "Oued Chorfa"
    },
    "id": 1443,
    "commune_name_ascii": "Oued Chorfa",
    "commune_name": "وادي الشرفاء",
    "daira_name_ascii": "Djendel",
    "daira_name": "جندل",
    "wilaya_code": "44",
    "wilaya_name_ascii": "Aïn Defla",
    "wilaya_name": "عين الدفلى"
  },
  {
    "model": "base.commune",
    "pk": 1417,
    "fields": {
      "postcode": 44003,
      "wilaya": 44,
      "name": "Boumedfaa"
    },
    "id": 1428,
    "commune_name_ascii": "Boumedfaa",
    "commune_name": "بومدفع",
    "daira_name_ascii": "Boumedfaa",
    "daira_name": "بومدفع",
    "wilaya_code": "44",
    "wilaya_name_ascii": "Aïn Defla",
    "wilaya_name": "عين الدفلى"
  },
  {
    "id": 1418,
    "commune_name_ascii": "Ain Lechiakh",
    "commune_name": "عين الاشياخ",
    "daira_name_ascii": "Ain Lechiakh",
    "daira_name": "عين الاشياخ",
    "wilaya_code": "44",
    "wilaya_name_ascii": "Aïn Defla",
    "wilaya_name": "عين الدفلى"
  },
  {
    "id": 1419,
    "commune_name_ascii": "Ain Soltane",
    "commune_name": "عين السلطان",
    "daira_name_ascii": "Ain Lechiakh",
    "daira_name": "عين الاشياخ",
    "wilaya_code": "44",
    "wilaya_name_ascii": "Aïn Defla",
    "wilaya_name": "عين الدفلى"
  },
  {
    "model": "base.commune",
    "pk": 1429,
    "fields": {
      "postcode": 44015,
      "wilaya": 44,
      "name": "Oued Djemaa"
    },
    "id": 1444,
    "commune_name_ascii": "Oued Djemaa",
    "commune_name": "واد الجمعة",
    "daira_name_ascii": "Ain Lechiakh",
    "daira_name": "عين الاشياخ",
    "wilaya_code": "44",
    "wilaya_name_ascii": "Aïn Defla",
    "wilaya_name": "عين الدفلى"
  },
  {
    "id": 1436,
    "commune_name_ascii": "El Maine",
    "commune_name": "الماين",
    "daira_name_ascii": "Rouina",
    "daira_name": "الروينة",
    "wilaya_code": "44",
    "wilaya_name_ascii": "Aïn Defla",
    "wilaya_name": "عين الدفلى"
  },
  {
    "model": "base.commune",
    "pk": 1430,
    "fields": {
      "postcode": 44016,
      "wilaya": 44,
      "name": "Rouina"
    },
    "id": 1445,
    "commune_name_ascii": "Rouina",
    "commune_name": "الروينة",
    "daira_name_ascii": "Rouina",
    "daira_name": "الروينة",
    "wilaya_code": "44",
    "wilaya_name_ascii": "Aïn Defla",
    "wilaya_name": "عين الدفلى"
  },
  {
    "model": "base.commune",
    "pk": 1431,
    "fields": {
      "postcode": 44017,
      "wilaya": 44,
      "name": "Zeddine"
    },
    "id": 1450,
    "commune_name_ascii": "Zeddine",
    "commune_name": "زدين",
    "daira_name_ascii": "Rouina",
    "daira_name": "الروينة",
    "wilaya_code": "44",
    "wilaya_name_ascii": "Aïn Defla",
    "wilaya_name": "عين الدفلى"
  },
  {
    "id": 1426,
    "commune_name_ascii": "Bir Ould Khelifa",
    "commune_name": "بئر ولد خليفة",
    "daira_name_ascii": "Bordj El Emir Khaled",
    "daira_name": "برج الأمير خالد",
    "wilaya_code": "44",
    "wilaya_name_ascii": "Aïn Defla",
    "wilaya_name": "عين الدفلى"
  },
  {
    "id": 1427,
    "commune_name_ascii": "Bordj Emir Khaled",
    "commune_name": "برج الأمير خالد",
    "daira_name_ascii": "Bordj El Emir Khaled",
    "daira_name": "برج الأمير خالد",
    "wilaya_code": "44",
    "wilaya_name_ascii": "Aïn Defla",
    "wilaya_name": "عين الدفلى"
  },
  {
    "id": 1448,
    "commune_name_ascii": "Tarik Ibn Ziad",
    "commune_name": "طارق بن زياد",
    "daira_name_ascii": "Bordj El Emir Khaled",
    "daira_name": "برج الأمير خالد",
    "wilaya_code": "44",
    "wilaya_name_ascii": "Aïn Defla",
    "wilaya_name": "عين الدفلى"
  },
  {
    "model": "base.commune",
    "pk": 1445,
    "fields": {
      "postcode": 44031,
      "wilaya": 44,
      "name": "Bathia"
    },
    "id": 1423,
    "commune_name_ascii": "Bathia",
    "commune_name": "بطحية",
    "daira_name_ascii": "Bathia",
    "daira_name": "بطحية",
    "wilaya_code": "44",
    "wilaya_name_ascii": "Aïn Defla",
    "wilaya_name": "عين الدفلى"
  },
  {
    "model": "base.commune",
    "pk": 1450,
    "fields": {
      "postcode": 44036,
      "wilaya": 44,
      "name": "Belaas"
    },
    "id": 1424,
    "commune_name_ascii": "Belaas",
    "commune_name": "بلعاص",
    "daira_name_ascii": "Bathia",
    "daira_name": "بطحية",
    "wilaya_code": "44",
    "wilaya_name_ascii": "Aïn Defla",
    "wilaya_name": "عين الدفلى"
  },
  {
    "id": 1438,
    "commune_name_ascii": "Hassania",
    "commune_name": "الحسانية",
    "daira_name_ascii": "Bathia",
    "daira_name": "بطحية",
    "wilaya_code": "44",
    "wilaya_name_ascii": "Aïn Defla",
    "wilaya_name": "عين الدفلى"
  },
  {
    "id": 1417,
    "commune_name_ascii": "Ain Defla",
    "commune_name": "عين الدفلى",
    "daira_name_ascii": "Ain Defla",
    "daira_name": "عين الدفلى",
    "wilaya_code": "44",
    "wilaya_name_ascii": "Aïn Defla",
    "wilaya_name": "عين الدفلى"
  },
  {
    "model": "base.commune",
    "pk": 1416,
    "fields": {
      "postcode": 44002,
      "wilaya": 44,
      "name": "Miliana"
    },
    "id": 1442,
    "commune_name_ascii": "Miliana",
    "commune_name": "مليانة",
    "daira_name_ascii": "Miliana",
    "daira_name": "مليانة",
    "wilaya_code": "44",
    "wilaya_name_ascii": "Aïn Defla",
    "wilaya_name": "عين الدفلى"
  },
  {
    "model": "base.commune",
    "pk": 1444,
    "fields": {
      "postcode": 44030,
      "wilaya": 44,
      "name": "Mekhatria"
    },
    "id": 1441,
    "commune_name_ascii": "Mekhatria",
    "commune_name": "المخاطرية",
    "daira_name_ascii": "El Amra",
    "daira_name": "العامرة",
    "wilaya_code": "44",
    "wilaya_name_ascii": "Aïn Defla",
    "wilaya_name": "عين الدفلى"
  },
  {
    "model": "base.commune",
    "pk": 1454,
    "fields": {
      "postcode": 45004,
      "wilaya": 45,
      "name": "Tiout"
    },
    "id": 1462,
    "commune_name_ascii": "Tiout",
    "commune_name": "تيوت",
    "daira_name_ascii": "Ain Sefra",
    "daira_name": "عين الصفراء",
    "wilaya_code": "45",
    "wilaya_name_ascii": "Naâma",
    "wilaya_name": "النعامة"
  },
  {
    "model": "base.commune",
    "pk": 1456,
    "fields": {
      "postcode": 45006,
      "wilaya": 45,
      "name": "Moghrar"
    },
    "id": 1459,
    "commune_name_ascii": "Moghrar",
    "commune_name": "مغرار",
    "daira_name_ascii": "Moghrar",
    "daira_name": "مغرار",
    "wilaya_code": "45",
    "wilaya_name_ascii": "Naâma",
    "wilaya_name": "النعامة"
  },
  {
    "pk": 1457  ,"fields": { "postcode": 45007,  "wilaya":   45, "name": "Assela" },
    "id": 1453,
    "commune_name_ascii": "Asla",
    "commune_name": "عسلة",
    "daira_name_ascii": "Asla",
    "daira_name": "عسلة",
    "wilaya_code": "45",
    "wilaya_name_ascii": "Naâma",
    "wilaya_name": "النعامة"
  },
  {
    "model": "base.commune",
    "pk": 1461,
    "fields": {
      "postcode": 45011,
      "wilaya": 45,
      "name": "Kasdir"
    },
    "id": 1456,
    "commune_name_ascii": "Kasdir",
    "commune_name": "القصدير",
    "daira_name_ascii": "Mekmen Ben Amar",
    "daira_name": "مكمن بن عمار",
    "wilaya_code": "45",
    "wilaya_name_ascii": "Naâma",
    "wilaya_name": "النعامة"
  },
  {
    "pk": 1460  ,"fields": { "postcode": 45010,  "wilaya":   45, "name": "Makman Ben Amer" },
    "id": 1457,
    "commune_name_ascii": "Makmen Ben Amar",
    "commune_name": "مكمن بن عمار",
    "daira_name_ascii": "Mekmen Ben Amar",
    "daira_name": "مكمن بن عمار",
    "wilaya_code": "45",
    "wilaya_name_ascii": "Naâma",
    "wilaya_name": "النعامة"
  },
  {
    "model": "base.commune",
    "pk": 1453,
    "fields": {
      "postcode": 45003,
      "wilaya": 45,
      "name": "Ain Sefra"
    },
    "id": 1452,
    "commune_name_ascii": "Ain Sefra",
    "commune_name": "عين الصفراء",
    "daira_name_ascii": "Ain Sefra",
    "daira_name": "عين الصفراء",
    "wilaya_code": "45",
    "wilaya_name_ascii": "Naâma",
    "wilaya_name": "النعامة"
  },
  {
    "pk": 1452  ,"fields": { "postcode": 45002,  "wilaya":   45, "name": "Mechria" },
    "id": 1458,
    "commune_name_ascii": "Mecheria",
    "commune_name": "المشرية",
    "daira_name_ascii": "Mecheria",
    "daira_name": "المشرية",
    "wilaya_code": "45",
    "wilaya_name_ascii": "Naâma",
    "wilaya_name": "النعامة"
  },
  {
    "pk": 1462  ,"fields": { "postcode": 45012,  "wilaya":   45, "name": "El Biod" },
    "id": 1455,
    "commune_name_ascii": "El Biodh",
    "commune_name": "البيوض",
    "daira_name_ascii": "Mecheria",
    "daira_name": "المشرية",
    "wilaya_code": "45",
    "wilaya_name_ascii": "Naâma",
    "wilaya_name": "النعامة"
  },
  {
    "model": "base.commune",
    "pk": 1459,
    "fields": {
      "postcode": 45009,
      "wilaya": 45,
      "name": "Ain Ben Khelil"
    },
    "id": 1451,
    "commune_name_ascii": "Ain Ben Khelil",
    "commune_name": "عين بن خليل",
    "daira_name_ascii": "Mecheria",
    "daira_name": "المشرية",
    "wilaya_code": "45",
    "wilaya_name_ascii": "Naâma",
    "wilaya_name": "النعامة"
  },
  {
    "model": "base.commune",
    "pk": 1451,
    "fields": {
      "postcode": 45001,
      "wilaya": 45,
      "name": "Naama"
    },
    "id": 1460,
    "commune_name_ascii": "Naama",
    "commune_name": "النعامة",
    "daira_name_ascii": "Naama",
    "daira_name": "النعامة",
    "wilaya_code": "45",
    "wilaya_name_ascii": "Naâma",
    "wilaya_name": "النعامة"
  },
  {
    "pk": 1458  ,"fields": { "postcode": 45008,  "wilaya":   45, "name": "Djeniane Bourzeg" },
    "id": 1454,
    "commune_name_ascii": "Djenienne Bourezg",
    "commune_name": "جنين بورزق",
    "daira_name_ascii": "Moghrar",
    "daira_name": "مغرار",
    "wilaya_code": "45",
    "wilaya_name_ascii": "Naâma",
    "wilaya_name": "النعامة"
  },
  {
    "model": "base.commune",
    "pk": 1455,
    "fields": {
      "postcode": 45005,
      "wilaya": 45,
      "name": "Sfissifa"
    },
    "id": 1461,
    "commune_name_ascii": "Sfissifa",
    "commune_name": "سفيسيفة",
    "daira_name_ascii": "Sfissifa",
    "daira_name": "سفيسيفة",
    "wilaya_code": "45",
    "wilaya_name_ascii": "Naâma",
    "wilaya_name": "النعامة"
  },
  {
    "model": "base.commune",
    "pk": 1477,
    "fields": {
      "postcode": 46015,
      "wilaya": 46,
      "name": "Sidi Boumediene"
    },
    "id": 1486,
    "commune_name_ascii": "Sidi Boumediene",
    "commune_name": "سيدي بومدين",
    "daira_name_ascii": "Ain Larbaa",
    "daira_name": "عين الأربعاء",
    "wilaya_code": "46",
    "wilaya_name_ascii": "Ain Temouchent",
    "wilaya_name": "عين تيموشنت"
  },
  {
    "model": "base.commune",
    "pk": 1472,
    "fields": {
      "postcode": 46010,
      "wilaya": 46,
      "name": "Tamzoura"
    },
    "id": 1489,
    "commune_name_ascii": "Tamzoura",
    "commune_name": "تامزورة",
    "daira_name_ascii": "Ain Larbaa",
    "daira_name": "عين الأربعاء",
    "wilaya_code": "46",
    "wilaya_name_ascii": "Ain Temouchent",
    "wilaya_name": "عين تيموشنت"
  },
  {
    "pk": 1464  ,"fields": { "postcode": 46002,  "wilaya":   46, "name": "Chaabet El Ham" },
    "id": 1471,
    "commune_name_ascii": "Chaabat El Ham",
    "commune_name": "شعبة اللحم",
    "daira_name_ascii": "El Maleh",
    "daira_name": "المالح",
    "wilaya_code": "46",
    "wilaya_name_ascii": "Ain Temouchent",
    "wilaya_name": "عين تيموشنت"
  },
  {
    "pk": 1476  ,"fields": { "postcode": 46014,  "wilaya":   46, "name": "El Malah" },
    "id": 1474,
    "commune_name_ascii": "El Maleh",
    "commune_name": "المالح",
    "daira_name_ascii": "El Maleh",
    "daira_name": "المالح",
    "wilaya_code": "46",
    "wilaya_name_ascii": "Ain Temouchent",
    "wilaya_name": "عين تيموشنت"
  },
  {
    "model": "base.commune",
    "pk": 1484,
    "fields": {
      "postcode": 46022,
      "wilaya": 46,
      "name": "Ouled Kihal"
    },
    "id": 1483,
    "commune_name_ascii": "Ouled Kihal",
    "commune_name": "أولاد الكيحل",
    "daira_name_ascii": "El Maleh",
    "daira_name": "المالح",
    "wilaya_code": "46",
    "wilaya_name_ascii": "Ain Temouchent",
    "wilaya_name": "عين تيموشنت"
  },
  {
    "model": "base.commune",
    "pk": 1473,
    "fields": {
      "postcode": 46011,
      "wilaya": 46,
      "name": "Chentouf"
    },
    "id": 1472,
    "commune_name_ascii": "Chentouf",
    "commune_name": "شنتوف",
    "daira_name_ascii": "Hammam Bou Hadjar",
    "daira_name": "حمام بوحجر",
    "wilaya_code": "46",
    "wilaya_name_ascii": "Ain Temouchent",
    "wilaya_name": "عين تيموشنت"
  },
  {
    "model": "base.commune",
    "pk": 1470,
    "fields": {
      "postcode": 46008,
      "wilaya": 46,
      "name": "Terga"
    },
    "id": 1490,
    "commune_name_ascii": "Terga",
    "commune_name": "تارقة",
    "daira_name_ascii": "El Maleh",
    "daira_name": "المالح",
    "wilaya_code": "46",
    "wilaya_name_ascii": "Ain Temouchent",
    "wilaya_name": "عين تيموشنت"
  },
  {
    "pk": 1478  ,"fields": { "postcode": 46016,  "wilaya":   46, "name": "Oued Sabah" },
    "id": 1481,
    "commune_name_ascii": "Oued Sebbah",
    "commune_name": "وادي الصباح",
    "daira_name_ascii": "Ain Larbaa",
    "daira_name": "عين الأربعاء",
    "wilaya_code": "46",
    "wilaya_name_ascii": "Ain Temouchent",
    "wilaya_name": "عين تيموشنت"
  },
  {
    "model": "base.commune",
    "pk": 1481,
    "fields": {
      "postcode": 46019,
      "wilaya": 46,
      "name": "El Amria"
    },
    "id": 1473,
    "commune_name_ascii": "El Amria",
    "commune_name": "العامرية",
    "daira_name_ascii": "El Amria",
    "daira_name": "العامرية",
    "wilaya_code": "46",
    "wilaya_name_ascii": "Ain Temouchent",
    "wilaya_name": "عين تيموشنت"
  },
  {
    "model": "base.commune",
    "pk": 1482,
    "fields": {
      "postcode": 46020,
      "wilaya": 46,
      "name": "Hassi El Ghella"
    },
    "id": 1479,
    "commune_name_ascii": "Hassi El Ghella",
    "commune_name": "حاسي الغلة",
    "daira_name_ascii": "El Amria",
    "daira_name": "العامرية",
    "wilaya_code": "46",
    "wilaya_name_ascii": "Ain Temouchent",
    "wilaya_name": "عين تيموشنت"
  },
  {
    "model": "base.commune",
    "pk": 1479,
    "fields": {
      "postcode": 46017,
      "wilaya": 46,
      "name": "Ouled Boudjemaa"
    },
    "id": 1482,
    "commune_name_ascii": "Ouled Boudjemaa",
    "commune_name": "أولاد بوجمعة",
    "daira_name_ascii": "El Amria",
    "daira_name": "العامرية",
    "wilaya_code": "46",
    "wilaya_name_ascii": "Ain Temouchent",
    "wilaya_name": "عين تيموشنت"
  },
  {
    "model": "base.commune",
    "pk": 1469,
    "fields": {
      "postcode": 46007,
      "wilaya": 46,
      "name": "Aghlal"
    },
    "id": 1463,
    "commune_name_ascii": "Aghlal",
    "commune_name": "أغلال",
    "daira_name_ascii": "Ain Kihel",
    "daira_name": "عين الكيحل",
    "wilaya_code": "46",
    "wilaya_name_ascii": "Ain Temouchent",
    "wilaya_name": "عين تيموشنت"
  },
  {
    "model": "base.commune",
    "pk": 1465,
    "fields": {
      "postcode": 46003,
      "wilaya": 46,
      "name": "Ain Kihal"
    },
    "id": 1465,
    "commune_name_ascii": "Ain Kihal",
    "commune_name": "عين الكيحل",
    "daira_name_ascii": "Ain Kihel",
    "daira_name": "عين الكيحل",
    "wilaya_code": "46",
    "wilaya_name_ascii": "Ain Temouchent",
    "wilaya_name": "عين تيموشنت"
  },
  {
    "model": "base.commune",
    "pk": 1480,
    "fields": {
      "postcode": 46018,
      "wilaya": 46,
      "name": "Ain Tolba"
    },
    "id": 1467,
    "commune_name_ascii": "Ain Tolba",
    "commune_name": "عين الطلبة",
    "daira_name_ascii": "Ain Kihel",
    "daira_name": "عين الكيحل",
    "wilaya_code": "46",
    "wilaya_name_ascii": "Ain Temouchent",
    "wilaya_name": "عين تيموشنت"
  },
  {
    "model": "base.commune",
    "pk": 1475,
    "fields": {
      "postcode": 46013,
      "wilaya": 46,
      "name": "Aoubellil"
    },
    "id": 1468,
    "commune_name_ascii": "Aoubellil",
    "commune_name": "عقب الليل",
    "daira_name_ascii": "Ain Kihel",
    "daira_name": "عين الكيحل",
    "wilaya_code": "46",
    "wilaya_name_ascii": "Ain Temouchent",
    "wilaya_name": "عين تيموشنت"
  },
  {
    "model": "base.commune",
    "pk": 1485,
    "fields": {
      "postcode": 46023,
      "wilaya": 46,
      "name": "Beni Saf"
    },
    "id": 1469,
    "commune_name_ascii": "Beni Saf",
    "commune_name": "بني صاف",
    "daira_name_ascii": "Beni Saf",
    "daira_name": "بني صاف",
    "wilaya_code": "46",
    "wilaya_name_ascii": "Ain Temouchent",
    "wilaya_name": "عين تيموشنت"
  },
  {
    "model": "base.commune",
    "pk": 1483,
    "fields": {
      "postcode": 46021,
      "wilaya": 46,
      "name": "Hassasna"
    },
    "id": 1478,
    "commune_name_ascii": "Hassasna",
    "commune_name": "الحساسنة",
    "daira_name_ascii": "Hammam Bou Hadjar",
    "daira_name": "حمام بوحجر",
    "wilaya_code": "46",
    "wilaya_name_ascii": "Ain Temouchent",
    "wilaya_name": "عين تيموشنت"
  },
  {
    "model": "base.commune",
    "pk": 652,
    "fields": {
      "postcode": 18006,
      "wilaya": 18,
      "name": "Emir Abdelkader"
    },
    "id": 1476,
    "commune_name_ascii": "Emir Abdelkader",
    "commune_name": "الأمير عبد القادر",
    "daira_name_ascii": "Beni Saf",
    "daira_name": "بني صاف",
    "wilaya_code": "46",
    "wilaya_name_ascii": "Ain Temouchent",
    "wilaya_name": "عين تيموشنت"
  },
  {
    "model": "base.commune",
    "pk": 1486,
    "fields": {
      "postcode": 46024,
      "wilaya": 46,
      "name": "Sidi Safi"
    },
    "id": 1488,
    "commune_name_ascii": "Sidi Safi",
    "commune_name": "سيدي صافي",
    "daira_name_ascii": "Beni Saf",
    "daira_name": "بني صاف",
    "wilaya_code": "46",
    "wilaya_name_ascii": "Ain Temouchent",
    "wilaya_name": "عين تيموشنت"
  },
  {
    "model": "base.commune",
    "pk": 1487,
    "fields": {
      "postcode": 46025,
      "wilaya": 46,
      "name": "Oulhaca El Gheraba"
    },
    "id": 1484,
    "commune_name_ascii": "Oulhaca El Gheraba",
    "commune_name": "ولهاصة الغرابة",
    "daira_name_ascii": "Oulhassa Gheraba",
    "daira_name": "ولهاصة الغرابة",
    "wilaya_code": "46",
    "wilaya_name_ascii": "Ain Temouchent",
    "wilaya_name": "عين تيموشنت"
  },
  {
    /*                                                                                           */
    "id": 1487,
    "commune_name_ascii": "Sidi Ouriache",
    "commune_name": "سيدي ورياش",
    "daira_name_ascii": "Oulhassa Gheraba",
    "daira_name": "ولهاصة الغرابة",
    "wilaya_code": "46",
    "wilaya_name_ascii": "Ain Temouchent",
    "wilaya_name": "عين تيموشنت"
  },
  {
    "model": "base.commune",
    "pk": 1471,
    "fields": {
      "postcode": 46009,
      "wilaya": 46,
      "name": "Ain El Arbaa"
    },
    "id": 1464,
    "commune_name_ascii": "Ain El Arbaa",
    "commune_name": "عين الأربعاء",
    "daira_name_ascii": "Ain Larbaa",
    "daira_name": "عين الأربعاء",
    "wilaya_code": "46",
    "wilaya_name_ascii": "Ain Temouchent",
    "wilaya_name": "عين تيموشنت"
  },
  {
    "model": "base.commune",
    "pk": 1490,
    "fields": {
      "postcode": 46028,
      "wilaya": 46,
      "name": "El Messaid"
    },
    "id": 1475,
    "commune_name_ascii": "El Messaid",
    "commune_name": "المساعيد",
    "daira_name_ascii": "El Amria",
    "daira_name": "العامرية",
    "wilaya_code": "46",
    "wilaya_name_ascii": "Ain Temouchent",
    "wilaya_name": "عين تيموشنت"
  },
  {
    "model": "base.commune",
    "pk": 1468,
    "fields": {
      "postcode": 46006,
      "wilaya": 46,
      "name": "Oued Berkeche"
    },
    "id": 1480,
    "commune_name_ascii": "Oued Berkeche",
    "commune_name": "وادي برقش",
    "daira_name_ascii": "Hammam Bou Hadjar",
    "daira_name": "حمام بوحجر",
    "wilaya_code": "46",
    "wilaya_name_ascii": "Ain Temouchent",
    "wilaya_name": "عين تيموشنت"
  },
  {
    "model": "base.commune",
    "pk": 1474,
    "fields": {
      "postcode": 46012,
      "wilaya": 46,
      "name": "Sidi Ben Adda"
    },
    "id": 1485,
    "commune_name_ascii": "Sidi Ben Adda",
    "commune_name": "سيدي بن عدة",
    "daira_name_ascii": "Ain Temouchent",
    "daira_name": "عين تموشنت",
    "wilaya_code": "46",
    "wilaya_name_ascii": "Ain Temouchent",
    "wilaya_name": "عين تيموشنت"
  },
  {
    "model": "base.commune",
    "pk": 1463,
    "fields": {
      "postcode": 46001,
      "wilaya": 46,
      "name": "Ain Temouchent"
    },
    "id": 1466,
    "commune_name_ascii": "Ain Temouchent",
    "commune_name": "عين تموشنت",
    "daira_name_ascii": "Ain Temouchent",
    "daira_name": "عين تموشنت",
    "wilaya_code": "46",
    "wilaya_name_ascii": "Ain Temouchent",
    "wilaya_name": "عين تيموشنت"
  },
  {
    "pk": 1467  ,"fields": { "postcode": 46005,  "wilaya":   46, "name": "Bou Zedjar" },
    "id": 1470,
    "commune_name_ascii": "Bouzedjar",
    "commune_name": "بوزجار",
    "daira_name_ascii": "El Amria",
    "daira_name": "العامرية",
    "wilaya_code": "46",
    "wilaya_name_ascii": "Ain Temouchent",
    "wilaya_name": "عين تيموشنت"
  },
  {
    "pk": 1466  ,"fields": { "postcode": 46004,  "wilaya":   46, "name": "Hammam Bouhadjar" },
    "id": 1477,
    "commune_name_ascii": "Hammam Bou Hadjar",
    "commune_name": " حمام بوحجر",
    "daira_name_ascii": "Hammam Bou Hadjar",
    "daira_name": "حمام بوحجر",
    "wilaya_code": "46",
    "wilaya_name_ascii": "Ain Temouchent",
    "wilaya_name": "عين تيموشنت"
  },
  {
    "model": "base.commune",
    "pk": 1493,
    "fields": {
      "postcode": 47003,
      "wilaya": 47,
      "name": "Dhayet Bendhahoua"
    },
    "id": 1493,
    "commune_name_ascii": "Dhayet Bendhahoua",
    "commune_name": "ضاية بن ضحوة",
    "daira_name_ascii": "Dhayet Ben Dhahoua",
    "daira_name": "ضاية بن ضحوة",
    "wilaya_code": "47",
    "wilaya_name_ascii": "Ghardaia",
    "wilaya_name": "غرداية"
  },
  {
    "model": "base.commune",
    "pk": 1167,
    "fields": {
      "postcode": 34004,
      "wilaya": 34,
      "name": "Mansoura"
    },
    "id": 1500,
    "commune_name_ascii": "Mansoura",
    "commune_name": "المنصورة",
    "daira_name_ascii": "Mansourah",
    "daira_name": "المنصورة",
    "wilaya_code": "47",
    "wilaya_name_ascii": "Ghardaia",
    "wilaya_name": "غرداية"
  },
  {
    "model": "base.commune",
    "pk": 1497,
    "fields": {
      "postcode": 47007,
      "wilaya": 47,
      "name": "El Atteuf"
    },
    "id": 1494,
    "commune_name_ascii": "El Atteuf",
    "commune_name": "العطف",
    "daira_name_ascii": "Bounoura",
    "daira_name": "بونورة",
    "wilaya_code": "47",
    "wilaya_name_ascii": "Ghardaia",
    "wilaya_name": "غرداية"
  },
  {
    "model": "base.commune",
    "pk": 1500,
    "fields": {
      "postcode": 47010,
      "wilaya": 47,
      "name": "Bounoura"
    },
    "id": 1492,
    "commune_name_ascii": "Bounoura",
    "commune_name": "بونورة",
    "daira_name_ascii": "Bounoura",
    "daira_name": "بونورة",
    "wilaya_code": "47",
    "wilaya_name_ascii": "Ghardaia",
    "wilaya_name": "غرداية"
  },
  {
    "model": "base.commune",
    "pk": 1498,
    "fields": {
      "postcode": 47008,
      "wilaya": 47,
      "name": "Zelfana"
    },
    "id": 1503,
    "commune_name_ascii": "Zelfana",
    "commune_name": "زلفانة",
    "daira_name_ascii": "Zelfana",
    "daira_name": "زلفانة",
    "wilaya_code": "47",
    "wilaya_name_ascii": "Ghardaia",
    "wilaya_name": "غرداية"
  },
  {
    "model": "base.commune",
    "pk": 1496,
    "fields": {
      "postcode": 47006,
      "wilaya": 47,
      "name": "El Guerrara"
    },
    "id": 1497,
    "commune_name_ascii": "El Guerrara",
    "commune_name": "القرارة",
    "daira_name_ascii": "El Guerrara",
    "daira_name": "القرارة",
    "wilaya_code": "47",
    "wilaya_name_ascii": "Ghardaia",
    "wilaya_name": "غرداية"
  },
  {
    "model": "base.commune",
    "pk": 1499,
    "fields": {
      "postcode": 47009,
      "wilaya": 47,
      "name": "Sebseb"
    },
    "id": 1502,
    "commune_name_ascii": "Sebseb",
    "commune_name": "سبسب",
    "daira_name_ascii": "Metlili",
    "daira_name": "متليلي",
    "wilaya_code": "47",
    "wilaya_name_ascii": "Ghardaia",
    "wilaya_name": "غرداية"
  },
  {
    "model": "base.commune",
    "pk": 1495,
    "fields": {
      "postcode": 47005,
      "wilaya": 47,
      "name": "Metlili"
    },
    "id": 1501,
    "commune_name_ascii": "Metlili",
    "commune_name": "متليلي",
    "daira_name_ascii": "Metlili",
    "daira_name": "متليلي",
    "wilaya_code": "47",
    "wilaya_name_ascii": "Ghardaia",
    "wilaya_name": "غرداية"
  },
  {
    "model": "base.commune",
    "pk": 1494,
    "fields": {
      "postcode": 47004,
      "wilaya": 47,
      "name": "Berriane"
    },
    "id": 1491,
    "commune_name_ascii": "Berriane",
    "commune_name": "بريان",
    "daira_name_ascii": "Berriane",
    "daira_name": "بريان",
    "wilaya_code": "47",
    "wilaya_name_ascii": "Ghardaia",
    "wilaya_name": "غرداية"
  },
  {
    "model": "base.commune",
    "pk": 1491,
    "fields": {
      "postcode": 47001,
      "wilaya": 47,
      "name": "Ghardaia"
    },
    "id": 1496,
    "commune_name_ascii": "Ghardaia",
    "commune_name": "غرداية",
    "daira_name_ascii": "Ghardaia",
    "daira_name": "غرداية",
    "wilaya_code": "47",
    "wilaya_name_ascii": "Ghardaia",
    "wilaya_name": "غرداية"
  },
  {
    "pk": 1518  ,"fields": { "postcode": 48015,  "wilaya":   48, "name": "El Guettar" },
    "id": 1516,
    "commune_name_ascii": "El Guettar",
    "commune_name": "القطار",
    "daira_name_ascii": "Mazouna",
    "daira_name": "مازونة",
    "wilaya_code": "48",
    "wilaya_name_ascii": "Relizane",
    "wilaya_name": "غليزان"
  },
  {
    "model": "base.commune",
    "pk": 1508,
    "fields": {
      "postcode": 48005,
      "wilaya": 48,
      "name": "Ouled Aiche"
    },
    "id": 1530,
    "commune_name_ascii": "Ouled Aiche",
    "commune_name": "أولاد يعيش",
    "daira_name_ascii": "Ammi Moussa",
    "daira_name": "عمي موسى",
    "wilaya_code": "48",
    "wilaya_name_ascii": "Relizane",
    "wilaya_name": "غليزان"
  },
  {
    "model": "base.commune",
    "pk": 1516,
    "fields": {
      "postcode": 48013,
      "wilaya": 48,
      "name": "Beni Dergoun"
    },
    "id": 1509,
    "commune_name_ascii": "Beni Dergoun",
    "commune_name": "بني درقن",
    "daira_name_ascii": "Zemmoura",
    "daira_name": "زمورة",
    "wilaya_code": "48",
    "wilaya_name_ascii": "Relizane",
    "wilaya_name": "غليزان"
  },
  {
    "pk": 1535  ,"fields": { "postcode": 48032,  "wilaya":   48, "name": "Dar Ben Abdellah" },
    "id": 1511,
    "commune_name_ascii": "Dar Ben Abdelah",
    "commune_name": "دار بن عبد الله",
    "daira_name_ascii": "Zemmoura",
    "daira_name": "زمورة",
    "wilaya_code": "48",
    "wilaya_name_ascii": "Relizane",
    "wilaya_name": "غليزان"
  },
  {
    "model": "base.commune",
    "pk": 1515,
    "fields": {
      "postcode": 48012,
      "wilaya": 48,
      "name": "Zemmoura"
    },
    "id": 1541,
    "commune_name_ascii": "Zemmoura",
    "commune_name": "زمورة",
    "daira_name_ascii": "Zemmoura",
    "daira_name": "زمورة",
    "wilaya_code": "48",
    "wilaya_name_ascii": "Relizane",
    "wilaya_name": "غليزان"
  },
  {
    "model": "base.commune",
    "pk": 1517,
    "fields": {
      "postcode": 48014,
      "wilaya": 48,
      "name": "Djidiouia"
    },
    "id": 1512,
    "commune_name_ascii": "Djidiouia",
    "commune_name": "جديوية",
    "daira_name_ascii": "Djidiouia",
    "daira_name": "جديوية",
    "wilaya_code": "48",
    "wilaya_name_ascii": "Relizane",
    "wilaya_name": "غليزان"
  },
  {
    "model": "base.commune",
    "pk": 1519,
    "fields": {
      "postcode": 48016,
      "wilaya": 48,
      "name": "Hamri"
    },
    "id": 1519,
    "commune_name_ascii": "Hamri",
    "commune_name": "حمري",
    "daira_name_ascii": "Djidiouia",
    "daira_name": "جديوية",
    "wilaya_code": "48",
    "wilaya_name_ascii": "Relizane",
    "wilaya_name": "غليزان"
  },
  {
    "pk": 1506  ,"fields": { "postcode": 48003,  "wilaya":   48, "name": "Belaassel Bouzegza" },
    "id": 1507,
    "commune_name_ascii": "Belaassel Bouzagza",
    "commune_name": "بلعسل بوزقزة",
    "daira_name_ascii": "El Matmar",
    "daira_name": "المطمر",
    "wilaya_code": "48",
    "wilaya_name_ascii": "Relizane",
    "wilaya_name": "غليزان"
  },
  {
    "pk": 1520  ,"fields": { "postcode": 48017,  "wilaya":   48, "name": "El Matmar" },
    "id": 1517,
    "commune_name_ascii": "El Matmar",
    "commune_name": "المطمر",
    "daira_name_ascii": "El Matmar",
    "daira_name": "المطمر",
    "wilaya_code": "48",
    "wilaya_name_ascii": "Relizane",
    "wilaya_name": "غليزان"
  },
  {
    "model": "base.commune",
    "pk": 1513,
    "fields": {
      "postcode": 48010,
      "wilaya": 48,
      "name": "Sidi Khettab"
    },
    "id": 1534,
    "commune_name_ascii": "Sidi Khettab",
    "commune_name": "سيدي  خطاب",
    "daira_name_ascii": "El Matmar",
    "daira_name": "المطمر",
    "wilaya_code": "48",
    "wilaya_name_ascii": "Relizane",
    "wilaya_name": "غليزان"
  },
  {
    "pk": 1521  ,"fields": { "postcode": 48018,  "wilaya":   48, "name": "Sidi Mhamed Ben Aouda" },
    "id": 1537,
    "commune_name_ascii": "Sidi M'hamed Benaouda",
    "commune_name": "سيدي امحمد بن عودة",
    "daira_name_ascii": "El Matmar",
    "daira_name": "المطمر",
    "wilaya_code": "48",
    "wilaya_name_ascii": "Relizane",
    "wilaya_name": "غليزان"
  },
  {
    "pk": 1522  ,"fields": { "postcode": 48019,  "wilaya":   48, "name": "Ain Tarek" },
    "id": 1505,
    "commune_name_ascii": "Ain Tarek",
    "commune_name": "عين طارق",
    "daira_name_ascii": "Ain Tarek",
    "daira_name": "عين طارق",
    "wilaya_code": "48",
    "wilaya_name_ascii": "Relizane",
    "wilaya_name": "غليزان"
  },
  {
    "model": "base.commune",
    "pk": 1537,
    "fields": {
      "postcode": 48034,
      "wilaya": 48,
      "name": "Had Echkalla"
    },
    "id": 1518,
    "commune_name_ascii": "Had Echkalla",
    "commune_name": "حد الشكالة",
    "daira_name_ascii": "Ain Tarek",
    "daira_name": "عين طارق",
    "wilaya_code": "48",
    "wilaya_name_ascii": "Relizane",
    "wilaya_name": "غليزان"
  },
  {
    "model": "base.commune",
    "pk": 733,
    "fields": {
      "postcode": 19059,
      "wilaya": 19,
      "name": "El Ouldja"
    },
    "id": 1515,
    "commune_name_ascii": "El Ouldja",
    "commune_name": "الولجة",
    "daira_name_ascii": "Ammi Moussa",
    "daira_name": "عمي موسى",
    "wilaya_code": "48",
    "wilaya_name_ascii": "Relizane",
    "wilaya_name": "غليزان"
  },
  {
    "model": "base.commune",
    "pk": 1525,
    "fields": {
      "postcode": 48022,
      "wilaya": 48,
      "name": "Mazouna"
    },
    "id": 1522,
    "commune_name_ascii": "Mazouna",
    "commune_name": "مازونة",
    "daira_name_ascii": "Mazouna",
    "daira_name": "مازونة",
    "wilaya_code": "48",
    "wilaya_name_ascii": "Relizane",
    "wilaya_name": "غليزان"
  },
  {
    "model": "base.commune",
    "pk": 1527,
    "fields": {
      "postcode": 48024,
      "wilaya": 48,
      "name": "Ain Rahma"
    },
    "id": 1504,
    "commune_name_ascii": "Ain Rahma",
    "commune_name": "عين الرحمة",
    "daira_name_ascii": "Yellel",
    "daira_name": "يلل",
    "wilaya_code": "48",
    "wilaya_name_ascii": "Relizane",
    "wilaya_name": "غليزان"
  },
  {
    "model": "base.commune",
    "pk": 1526,
    "fields": {
      "postcode": 48023,
      "wilaya": 48,
      "name": "Kalaa"
    },
    "id": 1520,
    "commune_name_ascii": "Kalaa",
    "commune_name": "القلعة",
    "daira_name_ascii": "Yellel",
    "daira_name": "يلل",
    "wilaya_code": "48",
    "wilaya_name_ascii": "Relizane",
    "wilaya_name": "غليزان"
  },
  {
    "model": "base.commune",
    "pk": 1507,
    "fields": {
      "postcode": 48004,
      "wilaya": 48,
      "name": "Sidi Saada"
    },
    "id": 1538,
    "commune_name_ascii": "Sidi Saada",
    "commune_name": "سيدي سعادة",
    "daira_name_ascii": "Yellel",
    "daira_name": "يلل",
    "wilaya_code": "48",
    "wilaya_name_ascii": "Relizane",
    "wilaya_name": "غليزان"
  },
  {
    "model": "base.commune",
    "pk": 1528,
    "fields": {
      "postcode": 48025,
      "wilaya": 48,
      "name": "Yellel"
    },
    "id": 1540,
    "commune_name_ascii": "Yellel",
    "commune_name": "يلل",
    "daira_name_ascii": "Yellel",
    "daira_name": "يلل",
    "wilaya_code": "48",
    "wilaya_name_ascii": "Relizane",
    "wilaya_name": "غليزان"
  },
  {
    "model": "base.commune",
    "pk": 1223,
    "fields": {
      "postcode": 35031,
      "wilaya": 35,
      "name": "Souk El Had"
    },
    "id": 1539,
    "commune_name_ascii": "Souk El Had",
    "commune_name": "سوق الحد",
    "daira_name_ascii": "Ramka",
    "daira_name": "الرمكة",
    "wilaya_code": "48",
    "wilaya_name_ascii": "Relizane",
    "wilaya_name": "غليزان"
  },
  {
    "model": "base.commune",
    "pk": 1531,
    "fields": {
      "postcode": 48028,
      "wilaya": 48,
      "name": "Mendes"
    },
    "id": 1524,
    "commune_name_ascii": "Mendes",
    "commune_name": "منداس",
    "daira_name_ascii": "Mendes",
    "daira_name": "منداس",
    "wilaya_code": "48",
    "wilaya_name_ascii": "Relizane",
    "wilaya_name": "غليزان"
  },
  {
    "model": "base.commune",
    "pk": 1523,
    "fields": {
      "postcode": 48020,
      "wilaya": 48,
      "name": "Oued Essalem"
    },
    "id": 1528,
    "commune_name_ascii": "Oued Essalem",
    "commune_name": "وادي السلام",
    "daira_name_ascii": "Mendes",
    "daira_name": "منداس",
    "wilaya_code": "48",
    "wilaya_name_ascii": "Relizane",
    "wilaya_name": "غليزان"
  },
  {
    "model": "base.commune",
    "pk": 1509,
    "fields": {
      "postcode": 48006,
      "wilaya": 48,
      "name": "Sidi Lazreg"
    },
    "id": 1535,
    "commune_name_ascii": "Sidi Lazreg",
    "commune_name": "سيدي لزرق",
    "daira_name_ascii": "Mendes",
    "daira_name": "منداس",
    "wilaya_code": "48",
    "wilaya_name_ascii": "Relizane",
    "wilaya_name": "غليزان"
  },
  {
    "model": "base.commune",
    "pk": 1514,
    "fields": {
      "postcode": 48011,
      "wilaya": 48,
      "name": "Ammi Moussa"
    },
    "id": 1506,
    "commune_name_ascii": "Ammi Moussa",
    "commune_name": "عمي موسى",
    "daira_name_ascii": "Ammi Moussa",
    "daira_name": "عمي موسى",
    "wilaya_code": "48",
    "wilaya_name_ascii": "Relizane",
    "wilaya_name": "غليزان"
  },
  {
    "model": "base.commune",
    "pk": 1524,
    "fields": {
      "postcode": 48021,
      "wilaya": 48,
      "name": "Ouarizane"
    },
    "id": 1526,
    "commune_name_ascii": "Ouarizane",
    "commune_name": "واريزان",
    "daira_name_ascii": "Oued Rhiou",
    "daira_name": "وادي رهيو",
    "wilaya_code": "48",
    "wilaya_name_ascii": "Relizane",
    "wilaya_name": "غليزان"
  },
  {
    "model": "base.commune",
    "pk": 1540,
    "fields": {
      "postcode": 48037,
      "wilaya": 48,
      "name": "Merdja Sidi Abed"
    },
    "id": 1525,
    "commune_name_ascii": "Merdja Sidi Abed",
    "commune_name": "مرجة سيدي عابد",
    "daira_name_ascii": "Oued Rhiou",
    "daira_name": "وادي رهيو",
    "wilaya_code": "48",
    "wilaya_name_ascii": "Relizane",
    "wilaya_name": "غليزان"
  },
  {
    "model": "base.commune",
    "pk": 1541,
    "fields": {
      "postcode": 48038,
      "wilaya": 48,
      "name": "Ouled Sidi Mihoub"
    },
    "id": 1531,
    "commune_name_ascii": "Ouled Sidi Mihoub",
    "commune_name": "أولاد سيدي الميهوب",
    "daira_name_ascii": "Djidiouia",
    "daira_name": "جديوية",
    "wilaya_code": "48",
    "wilaya_name_ascii": "Relizane",
    "wilaya_name": "غليزان"
  },
  {
    "model": "base.commune",
    "pk": 1538,
    "fields": {
      "postcode": 48035,
      "wilaya": 48,
      "name": "Bendaoud"
    },
    "id": 1508,
    "commune_name_ascii": "Bendaoud",
    "commune_name": "بن داود",
    "daira_name_ascii": "Relizane",
    "daira_name": "غليزان",
    "wilaya_code": "48",
    "wilaya_name_ascii": "Relizane",
    "wilaya_name": "غليزان"
  },
  {
    "pk": 1505  ,"fields": { "postcode": 48002,  "wilaya":   48, "name": "Oued Rhiou" },
    "id": 1529,
    "commune_name_ascii": "Oued Rhiou",
    "commune_name": "وادي رهيو",
    "daira_name_ascii": "Oued Rhiou",
    "daira_name": "وادي رهيو",
    "wilaya_code": "48",
    "wilaya_name_ascii": "Relizane",
    "wilaya_name": "غليزان"
  },
  {
    "model": "base.commune",
    "pk": 173,
    "fields": {
      "postcode": 5057,
      "wilaya": 5,
      "name": "El Hassi"
    },
    "id": 1513,
    "commune_name_ascii": "El Hassi",
    "commune_name": "الحاسي",
    "daira_name_ascii": "Ammi Moussa",
    "daira_name": "عمي موسى",
    "wilaya_code": "48",
    "wilaya_name_ascii": "Relizane",
    "wilaya_name": "غليزان"
  },
  {
    "pk": 1511  ,"fields": { "postcode": 48008,  "wilaya":   48, "name": "Sidi Mhamed Ben Ali" },
    "id": 1536,
    "commune_name_ascii": "Sidi M'hamed Benali",
    "commune_name": "سيدي أمحمد بن علي",
    "daira_name_ascii": "Sidi M'hamed Ben Ali",
    "daira_name": "سيدي أمحمد بن علي",
    "wilaya_code": "48",
    "wilaya_name_ascii": "Relizane",
    "wilaya_name": "غليزان"
  },
  {
    "model": "base.commune",
    "pk": 1512,
    "fields": {
      "postcode": 48009,
      "wilaya": 48,
      "name": "Mediouna"
    },
    "id": 1523,
    "commune_name_ascii": "Mediouna",
    "commune_name": "مديونة",
    "daira_name_ascii": "Sidi M'hamed Ben Ali",
    "daira_name": "سيدي أمحمد بن علي",
    "wilaya_code": "48",
    "wilaya_name_ascii": "Relizane",
    "wilaya_name": "غليزان"
  },
  {
    "model": "base.commune",
    "pk": 1533,
    "fields": {
      "postcode": 48030,
      "wilaya": 48,
      "name": "Beni Zentis"
    },
    "id": 1510,
    "commune_name_ascii": "Beni Zentis",
    "commune_name": "بني زنطيس",
    "daira_name_ascii": "Sidi M'hamed Ben Ali",
    "daira_name": "سيدي أمحمد بن علي",
    "wilaya_code": "48",
    "wilaya_name_ascii": "Relizane",
    "wilaya_name": "غليزان"
  },
  {
    "model": "base.commune",
    "pk": 1529,
    "fields": {
      "postcode": 48026,
      "wilaya": 48,
      "name": "Oued El Djemaa"
    },
    "id": 1527,
    "commune_name_ascii": "Oued El Djemaa",
    "commune_name": "وادي الجمعة",
    "daira_name_ascii": "El H'madna",
    "daira_name": "الحمادنة",
    "wilaya_code": "48",
    "wilaya_name_ascii": "Relizane",
    "wilaya_name": "غليزان"
  },
  {
    "model": "base.commune",
    "pk": 1532,
    "fields": {
      "postcode": 48029,
      "wilaya": 48,
      "name": "Lahlef"
    },
    "id": 1521,
    "commune_name_ascii": "Lahlef",
    "commune_name": "لحلاف",
    "daira_name_ascii": "Oued Rhiou",
    "daira_name": "وادي رهيو",
    "wilaya_code": "48",
    "wilaya_name_ascii": "Relizane",
    "wilaya_name": "غليزان"
  },
  {
    "model": "base.commune",
    "pk": 1504,
    "fields": {
      "postcode": 48001,
      "wilaya": 48,
      "name": "Relizane"
    },
    "id": 1533,
    "commune_name_ascii": "Relizane",
    "commune_name": "غليزان",
    "daira_name_ascii": "Relizane",
    "daira_name": "غليزان",
    "wilaya_code": "48",
    "wilaya_name_ascii": "Relizane",
    "wilaya_name": "غليزان"
  },
  {
    "pk": 1510  ,"fields": { "postcode": 48007,  "wilaya":   48, "name": "El Hamadna" },
    "id": 1514,
    "commune_name_ascii": "El H'madna",
    "commune_name": "الحمادنة",
    "daira_name_ascii": "El H'madna",
    "daira_name": "الحمادنة",
    "wilaya_code": "48",
    "wilaya_name_ascii": "Relizane",
    "wilaya_name": "غليزان"
  },
  {
    "model": "base.commune",
    "pk": 1530,
    "fields": {
      "postcode": 48027,
      "wilaya": 48,
      "name": "Ramka"
    },
    "id": 1532,
    "commune_name_ascii": "Ramka",
    "commune_name": "الرمكة",
    "daira_name_ascii": "Ramka",
    "daira_name": "الرمكة",
    "wilaya_code": "48",
    "wilaya_name_ascii": "Relizane",
    "wilaya_name": "غليزان"
  },
  {
    "model": "base.commune",
    "pk": 16,
    "fields": {
      "postcode": 1016,
      "wilaya": 1,
      "name": "Tinerkouk"
    },
    "id": 25,
    "commune_name_ascii": "Tinerkouk",
    "commune_name": "تنركوك",
    "daira_name_ascii": "Tinerkouk",
    "daira_name": "تنركوك",
    "wilaya_code": "49",
    "wilaya_name_ascii": "Timimoun",
    "wilaya_name": "تيميمون"
  },
  {
    "model": "base.commune",
    "pk": 9,
    "fields": {
      "postcode": 1009,
      "wilaya": 1,
      "name": "Timimoun"
    },
    "id": 24,
    "commune_name_ascii": "Timimoun",
    "commune_name": "تيميمون",
    "daira_name_ascii": "Timimoun",
    "daira_name": "تيميمون",
    "wilaya_code": "49",
    "wilaya_name_ascii": "Timimoun",
    "wilaya_name": "تيميمون"
  },
  {
    "model": "base.commune",
    "pk": 10,
    "fields": {
      "postcode": 1010,
      "wilaya": 1,
      "name": "Ouled Said"
    },
    "id": 15,
    "commune_name_ascii": "Ouled Said",
    "commune_name": "أولاد السعيد",
    "daira_name_ascii": "Timimoun",
    "daira_name": "تيميمون",
    "wilaya_code": "49",
    "wilaya_name_ascii": "Timimoun",
    "wilaya_name": "تيميمون"
  },
  {
    "model": "base.commune",
    "pk": 20,
    "fields": {
      "postcode": 1020,
      "wilaya": 1,
      "name": "Metarfa"
    },
    "id": 12,
    "commune_name_ascii": "Metarfa",
    "commune_name": "المطارفة",
    "daira_name_ascii": "Aougrout",
    "daira_name": "أوقروت",
    "wilaya_code": "49",
    "wilaya_name_ascii": "Timimoun",
    "wilaya_name": "تيميمون"
  },
  {
    "model": "base.commune",
    "pk": 24,
    "fields": {
      "postcode": 1024,
      "wilaya": 1,
      "name": "Talmine"
    },
    "id": 19,
    "commune_name_ascii": "Talmine",
    "commune_name": "طالمين",
    "daira_name_ascii": "Charouine",
    "daira_name": "شروين",
    "wilaya_code": "49",
    "wilaya_name_ascii": "Timimoun",
    "wilaya_name": "تيميمون"
  },
  {
    "model": "base.commune",
    "pk": 27,
    "fields": {
      "postcode": 1027,
      "wilaya": 1,
      "name": "Ouled Aissa"
    },
    "id": 14,
    "commune_name_ascii": "Ouled Aissa",
    "commune_name": "أولاد عيسى",
    "daira_name_ascii": "Charouine",
    "daira_name": "شروين",
    "wilaya_code": "49",
    "wilaya_name_ascii": "Timimoun",
    "wilaya_name": "تيميمون"
  },
  {
    "model": "base.commune",
    "pk": 3,
    "fields": {
      "postcode": 1003,
      "wilaya": 1,
      "name": "Charouine"
    },
    "id": 7,
    "commune_name_ascii": "Charouine",
    "commune_name": "شروين",
    "daira_name_ascii": "Charouine",
    "daira_name": "شروين",
    "wilaya_code": "49",
    "wilaya_name_ascii": "Timimoun",
    "wilaya_name": "تيميمون"
  },
  {
    "model": "base.commune",
    "pk": 23,
    "fields": {
      "postcode": 1023,
      "wilaya": 1,
      "name": "Aougrout"
    },
    "id": 3,
    "commune_name_ascii": "Aougrout",
    "commune_name": "أوقروت",
    "daira_name_ascii": "Aougrout",
    "daira_name": "أوقروت",
    "wilaya_code": "49",
    "wilaya_name_ascii": "Timimoun",
    "wilaya_name": "تيميمون"
  },
  {
    "model": "base.commune",
    "pk": 17,
    "fields": {
      "postcode": 1017,
      "wilaya": 1,
      "name": "Deldoul"
    },
    "id": 8,
    "commune_name_ascii": "Deldoul",
    "commune_name": "دلدول",
    "daira_name_ascii": "Aougrout",
    "daira_name": "أوقروت",
    "wilaya_code": "49",
    "wilaya_name_ascii": "Timimoun",
    "wilaya_name": "تيميمون"
  },
  {
    "model": "base.commune",
    "pk": 7,
    "fields": {
      "postcode": 1007,
      "wilaya": 1,
      "name": "Ksar Kaddour"
    },
    "id": 11,
    "commune_name_ascii": "Ksar Kaddour",
    "commune_name": "قصر قدور",
    "daira_name_ascii": "Tinerkouk",
    "daira_name": "تنركوك",
    "wilaya_code": "49",
    "wilaya_name_ascii": "Timimoun",
    "wilaya_name": "تيميمون"
  },
  {
    "model": "base.commune",
    "pk": 28,
    "fields": {
      "postcode": 1028,
      "wilaya": 1,
      "name": "Timiaouine"
    },
    "id": 23,
    "commune_name_ascii": "Timiaouine",
    "commune_name": "تيمياوين",
    "daira_name_ascii": "Bordj Badji Mokhtar",
    "daira_name": "برج باجي مختار",
    "wilaya_code": "50",
    "wilaya_name_ascii": "Bordj Badji Mokhtar",
    "wilaya_name": "برج باجي مختار"
  },
  {
    "model": "base.commune",
    "pk": 25,
    "fields": {
      "postcode": 1025,
      "wilaya": 1,
      "name": "Bordj Badji Mokhtar"
    },
    "id": 5,
    "commune_name_ascii": "Bordj Badji Mokhtar",
    "commune_name": "برج باجي مختار",
    "daira_name_ascii": "Bordj Badji Mokhtar",
    "daira_name": "برج باجي مختار",
    "wilaya_code": "50",
    "wilaya_name_ascii": "Bordj Badji Mokhtar",
    "wilaya_name": "برج باجي مختار"
  },
  {
    "pk": 235 ,"fields": {  "postcode": 7006 , "wilaya":   7, "name": "Ras El Miaad" },
    "id": 258,
    "commune_name_ascii": "Ras El Miad",
    "commune_name": "رأس الميعاد",
    "daira_name_ascii": "Sidi Khaled",
    "daira_name": "سيدي  خالد",
    "wilaya_code": "51",
    "wilaya_name_ascii": "Ouled Djellal",
    "wilaya_name": "أولاد جلال"
  },
  {
    "model": "base.commune",
    "pk": 236,
    "fields": {
      "postcode": 7007,
      "wilaya": 7,
      "name": "Besbes"
    },
    "id": 232,
    "commune_name_ascii": "Besbes",
    "commune_name": "بسباس",
    "daira_name_ascii": "Sidi Khaled",
    "daira_name": "سيدي  خالد",
    "wilaya_code": "51",
    "wilaya_name_ascii": "Ouled Djellal",
    "wilaya_name": "أولاد جلال"
  },
  {
    "model": "base.commune",
    "pk": 237,
    "fields": {
      "postcode": 7008,
      "wilaya": 7,
      "name": "Sidi Khaled"
    },
    "id": 259,
    "commune_name_ascii": "Sidi Khaled",
    "commune_name": "سيدي  خالد",
    "daira_name_ascii": "Sidi Khaled",
    "daira_name": "سيدي  خالد",
    "wilaya_code": "51",
    "wilaya_name_ascii": "Ouled Djellal",
    "wilaya_name": "أولاد جلال"
  },
  {
    "model": "base.commune",
    "pk": 238,
    "fields": {
      "postcode": 7009,
      "wilaya": 7,
      "name": "Doucen"
    },
    "id": 240,
    "commune_name_ascii": "Doucen",
    "commune_name": "الدوسن",
    "daira_name_ascii": "Ouled Djellal",
    "daira_name": "أولاد جلال",
    "wilaya_code": "51",
    "wilaya_name_ascii": "Ouled Djellal",
    "wilaya_name": "أولاد جلال"
  },
  {
    "model": "base.commune",
    "pk": 1366,
    "fields": {
      "postcode": 42016,
      "wilaya": 42,
      "name": "Chaiba"
    },
    "id": 237,
    "commune_name_ascii": "Chaiba",
    "commune_name": "الشعيبة",
    "daira_name_ascii": "Ouled Djellal",
    "daira_name": "أولاد جلال",
    "wilaya_code": "51",
    "wilaya_name_ascii": "Ouled Djellal",
    "wilaya_name": "أولاد جلال"
  },
  {
    "model": "base.commune",
    "pk": 234,
    "fields": {
      "postcode": 7005,
      "wilaya": 7,
      "name": "Ouled Djellal"
    },
    "id": 255,
    "commune_name_ascii": "Ouled Djellal",
    "commune_name": "أولاد جلال",
    "daira_name_ascii": "Ouled Djellal",
    "daira_name": "أولاد جلال",
    "wilaya_code": "51",
    "wilaya_name_ascii": "Ouled Djellal",
    "wilaya_name": "أولاد جلال"
  },
  {
    "pk": 269 ,"fields": {  "postcode": 8007 , "wilaya":   8, "name": "Beni Abbes" },
    "id": 265,
    "commune_name_ascii": "Beni Abbes",
    "commune_name": "بني عباس",
    "daira_name_ascii": "Beni Abbes",
    "daira_name": "بني عباس",
    "wilaya_code": "52",
    "wilaya_name_ascii": "Beni Abbes",
    "wilaya_name": "بني عباس"
  },
  {
    "model": "base.commune",
    "pk": 282,
    "fields": {
      "postcode": 8020,
      "wilaya": 8,
      "name": "Tamtert"
    },
    "id": 282,
    "commune_name_ascii": "Tamtert",
    "commune_name": "تامترت",
    "daira_name_ascii": "Beni Abbes",
    "daira_name": "بني عباس",
    "wilaya_code": "52",
    "wilaya_name_ascii": "Beni Abbes",
    "wilaya_name": "بني عباس"
  },
  {
    "model": "base.commune",
    "pk": 273,
    "fields": {
      "postcode": 8011,
      "wilaya": 8,
      "name": "Igli"
    },
    "id": 271,
    "commune_name_ascii": "Igli",
    "commune_name": "إقلي",
    "daira_name_ascii": "Igli",
    "daira_name": "إقلي",
    "wilaya_code": "52",
    "wilaya_name_ascii": "Beni Abbes",
    "wilaya_name": "بني عباس"
  },
  {
    "model": "base.commune",
    "pk": 276,
    "fields": {
      "postcode": 8014,
      "wilaya": 8,
      "name": "El Ouata"
    },
    "id": 269,
    "commune_name_ascii": "El Ouata",
    "commune_name": "الواتة",
    "daira_name_ascii": "El Ouata",
    "daira_name": "الواتة",
    "wilaya_code": "52",
    "wilaya_name_ascii": "Beni Abbes",
    "wilaya_name": "بني عباس"
  },
  {
    "pk": 265 ,"fields": {  "postcode": 8003 , "wilaya":   8, "name": "Ouled Khoudir" },
    "id": 279,
    "commune_name_ascii": "Ouled Khodeir",
    "commune_name": "أولاد خضير",
    "daira_name_ascii": "Ouled Khodeir",
    "daira_name": "أولاد خضير",
    "wilaya_code": "52",
    "wilaya_name_ascii": "Beni Abbes",
    "wilaya_name": "بني عباس"
  },
  {
    "model": "base.commune",
    "pk": 280,
    "fields": {
      "postcode": 8018,
      "wilaya": 8,
      "name": "Kerzaz"
    },
    "id": 273,
    "commune_name_ascii": "Kerzaz",
    "commune_name": "كرزاز",
    "daira_name_ascii": "Kerzaz",
    "daira_name": "كرزاز",
    "wilaya_code": "52",
    "wilaya_name_ascii": "Beni Abbes",
    "wilaya_name": "بني عباس"
  },
  {
    "model": "base.commune",
    "pk": 267,
    "fields": {
      "postcode": 8005,
      "wilaya": 8,
      "name": "Timoudi"
    },
    "id": 283,
    "commune_name_ascii": "Timoudi",
    "commune_name": "تيمودي",
    "daira_name_ascii": "Kerzaz",
    "daira_name": "كرزاز",
    "wilaya_code": "52",
    "wilaya_name_ascii": "Beni Abbes",
    "wilaya_name": "بني عباس"
  },
  {
    "model": "base.commune",
    "pk": 281,
    "fields": {
      "postcode": 8019,
      "wilaya": 8,
      "name": "Ksabi"
    },
    "id": 274,
    "commune_name_ascii": "Ksabi",
    "commune_name": "القصابي",
    "daira_name_ascii": "Ouled Khodeir",
    "daira_name": "أولاد خضير",
    "wilaya_code": "52",
    "wilaya_name_ascii": "Beni Abbes",
    "wilaya_name": "بني عباس"
  },
  {
    "pk": 270 ,"fields": {  "postcode": 8008 , "wilaya":   8, "name": "Beni Ikhlef" },
    "id": 266,
    "commune_name_ascii": "Beni Ikhlef",
    "commune_name": "بن يخلف",
    "daira_name_ascii": "Kerzaz",
    "daira_name": "كرزاز",
    "wilaya_code": "52",
    "wilaya_name_ascii": "Beni Abbes",
    "wilaya_name": "بني عباس"
  },
  {
    "pk": 356  ,"fields": { "postcode": 11003,  "wilaya":   11, "name": "In Ghar" },
    "id": 360,
    "commune_name_ascii": "Inghar",
    "commune_name": "إينغر",
    "daira_name_ascii": "In Ghar",
    "daira_name": "إينغر",
    "wilaya_code": "53",
    "wilaya_name_ascii": "In Salah",
    "wilaya_name": "عين صالح"
  },
  {
    "pk": 361  ,"fields": { "postcode": 11008,  "wilaya":   11, "name": "In Salah" },
    "id": 357,
    "commune_name_ascii": "Ain Salah",
    "commune_name": "عين صالح",
    "daira_name_ascii": "In Salah",
    "daira_name": "عين صالح",
    "wilaya_code": "53",
    "wilaya_name_ascii": "In Salah",
    "wilaya_name": "عين صالح"
  },
  {
    "pk": 363  ,"fields": { "postcode": 11010,  "wilaya":   11, "name": "Foggaret Ezzaouia" },
    "id": 358,
    "commune_name_ascii": "Foggaret Ezzoua",
    "commune_name": "فقارة الزوى",
    "daira_name_ascii": "In Salah",
    "daira_name": "عين صالح",
    "wilaya_code": "53",
    "wilaya_name_ascii": "In Salah",
    "wilaya_name": "عين صالح"
  },
  {
    "pk": 360  ,"fields": { "postcode": 11007,  "wilaya":   11, "name": "Tinzaouatine" },
    "id": 363,
    "commune_name_ascii": "Tin Zouatine",
    "commune_name": "تين زواتين",
    "daira_name_ascii": "Tin Zouatine",
    "daira_name": "تين زواتين",
    "wilaya_code": "54",
    "wilaya_name_ascii": "In Guezzam",
    "wilaya_name": "عين قزام"
  },
  {
    "pk": 357  ,"fields": { "postcode": 11004,  "wilaya":   11, "name": "In Guezzam" },
    "id": 356,
    "commune_name_ascii": "Ain Guezzam",
    "commune_name": "عين قزام",
    "daira_name_ascii": "In Guezzam",
    "daira_name": "عين قزام",
    "wilaya_code": "54",
    "wilaya_name_ascii": "In Guezzam",
    "wilaya_name": "عين قزام"
  },
  {

    "pk": 1104  ,"fields": { "postcode": 30016,  "wilaya":   30, "name": "Tamacine" },
    "id": 1107,
    "commune_name_ascii": "Temacine",
    "commune_name": "تماسين",
    "daira_name_ascii": "Temacine",
    "daira_name": "تماسين",
    "wilaya_code": "55",
    "wilaya_name_ascii": "Touggourt",
    "wilaya_name": "تقرت"
  },
  {
    "model": "base.commune",
    "pk": 1098,
    "fields": {
      "postcode": 30010,
      "wilaya": 30,
      "name": "Sidi Slimane"
    },
    "id": 1104,
    "commune_name_ascii": "Sidi Slimane",
    "commune_name": "سيدي سليمان",
    "daira_name_ascii": "Megarine",
    "daira_name": "المقارين",
    "wilaya_code": "55",
    "wilaya_name_ascii": "Touggourt",
    "wilaya_name": "تقرت"
  },
  {
    "model": "base.commune",
    "pk": 1107,
    "fields": {
      "postcode": 30019,
      "wilaya": 30,
      "name": "Megarine"
    },
    "id": 1097,
    "commune_name_ascii": "Megarine",
    "commune_name": "المقارين",
    "daira_name_ascii": "Megarine",
    "daira_name": "المقارين",
    "wilaya_code": "55",
    "wilaya_name_ascii": "Touggourt",
    "wilaya_name": "تقرت"
  },
  {
    "model": "base.commune",
    "pk": 1096,
    "fields": {
      "postcode": 30008,
      "wilaya": 30,
      "name": "Nezla"
    },
    "id": 1099,
    "commune_name_ascii": "Nezla",
    "commune_name": "النزلة",
    "daira_name_ascii": "Touggourt",
    "daira_name": "تقرت",
    "wilaya_code": "55",
    "wilaya_name_ascii": "Touggourt",
    "wilaya_name": "تقرت"
  },
  {
    "pk": 1094  ,"fields": { "postcode": 30006,  "wilaya":   30, "name": "Balidat Ameur" },
    "id": 1091,
    "commune_name_ascii": "Blidet Amor",
    "commune_name": "بلدة اعمر",
    "daira_name_ascii": "Temacine",
    "daira_name": "تماسين",
    "wilaya_code": "55",
    "wilaya_name_ascii": "Touggourt",
    "wilaya_name": "تقرت"
  },
  {
    "model": "base.commune",
    "pk": 1095,
    "fields": {
      "postcode": 30007,
      "wilaya": 30,
      "name": "Tebesbest"
    },
    "id": 1106,
    "commune_name_ascii": "Tebesbest",
    "commune_name": "تبسبست",
    "daira_name_ascii": "Touggourt",
    "daira_name": "تقرت",
    "wilaya_code": "55",
    "wilaya_name_ascii": "Touggourt",
    "wilaya_name": "تقرت"
  },
  {
    "model": "base.commune",
    "pk": 1101,
    "fields": {
      "postcode": 30013,
      "wilaya": 30,
      "name": "Touggourt"
    },
    "id": 1108,
    "commune_name_ascii": "Touggourt",
    "commune_name": "تقرت",
    "daira_name_ascii": "Touggourt",
    "daira_name": "تقرت",
    "wilaya_code": "55",
    "wilaya_name_ascii": "Touggourt",
    "wilaya_name": "تقرت"
  },
  {
    "model": "base.commune",
    "pk": 1103,
    "fields": {
      "postcode": 30015,
      "wilaya": 30,
      "name": "Taibet"
    },
    "id": 1105,
    "commune_name_ascii": "Taibet",
    "commune_name": "الطيبات",
    "daira_name_ascii": "Taibet",
    "daira_name": "الطيبات",
    "wilaya_code": "55",
    "wilaya_name_ascii": "Touggourt",
    "wilaya_name": "تقرت"
  },
  {
    /*                                          */
    "id": 1092,
    "commune_name_ascii": "El Alia",
    "commune_name": "العالية",
    "daira_name_ascii": "El Hadjira",
    "daira_name": "الحجيرة",
    "wilaya_code": "55",
    "wilaya_name_ascii": "Touggourt",
    "wilaya_name": "تقرت"
  },
  {
    "pk": 1102  ,"fields": { "postcode": 30014,  "wilaya":   30, "name": "El Hadjira" },
    "id": 1094,
    "commune_name_ascii": "El Hadjira",
    "commune_name": "الحجيرة",
    "daira_name_ascii": "El Hadjira",
    "daira_name": "الحجيرة",
    "wilaya_code": "55",
    "wilaya_name_ascii": "Touggourt",
    "wilaya_name": "تقرت"
  },
  {
    "model": "base.commune",
    "pk": 1105,
    "fields": {
      "postcode": 30017,
      "wilaya": 30,
      "name": "Benaceur"
    },
    "id": 1090,
    "commune_name_ascii": "Benaceur",
    "commune_name": "بن ناصر",
    "daira_name_ascii": "Taibet",
    "daira_name": "الطيبات",
    "wilaya_code": "55",
    "wilaya_name_ascii": "Touggourt",
    "wilaya_name": "تقرت"
  },
  {
    "pk": 1106  ,"fields": { "postcode": 30018,  "wilaya":   30, "name": "Mnaguer" },
    "id": 1098,
    "commune_name_ascii": "M'naguer",
    "commune_name": "المنقر",
    "daira_name_ascii": "Taibet",
    "daira_name": "الطيبات",
    "wilaya_code": "55",
    "wilaya_name_ascii": "Touggourt",
    "wilaya_name": "تقرت"
  },
  {
    "model": "base.commune",
    "pk": 1097,
    "fields": {
      "postcode": 30009,
      "wilaya": 30,
      "name": "Zaouia El Abidia"
    },
    "id": 1109,
    "commune_name_ascii": "Zaouia El Abidia",
    "commune_name": "الزاوية العابدية",
    "daira_name_ascii": "Touggourt",
    "daira_name": "تقرت",
    "wilaya_code": "55",
    "wilaya_name_ascii": "Touggourt",
    "wilaya_name": "تقرت"
  },
  {
    "model": "base.commune",
    "pk": 1159,
    "fields": {
      "postcode": 33002,
      "wilaya": 33,
      "name": "Djanet"
    },
    "id": 1161,
    "commune_name_ascii": "Djanet",
    "commune_name": "جانت",
    "daira_name_ascii": "Djanet",
    "daira_name": "جانت",
    "wilaya_code": "56",
    "wilaya_name_ascii": "Djanet",
    "wilaya_name": "جانت"
  },
  {
    "pk": 1162  ,"fields": { "postcode": 33005,  "wilaya":   33, "name": "Bordj El Haouasse" },
    "id": 1158,
    "commune_name_ascii": "Bordj El Haouass",
    "commune_name": "برج الحواس",
    "daira_name_ascii": "Djanet",
    "daira_name": "جانت",
    "wilaya_code": "56",
    "wilaya_name_ascii": "Djanet",
    "wilaya_name": "جانت"
  },
  {
    "model": "base.commune",
    "pk": 1306,
    "fields": {
      "postcode": 39029,
      "wilaya": 39,
      "name": "Oum Touyour"
    },
    "id": 1296,
    "commune_name_ascii": "Oum Touyour",
    "commune_name": "أم الطيور",
    "daira_name_ascii": "El Meghaier",
    "daira_name": "المغير",
    "wilaya_code": "57",
    "wilaya_name_ascii": "El Meghaier",
    "wilaya_name": "المغير"
  },
  {
    "model": "base.commune",
    "pk": 1307,
    "fields": {
      "postcode": 39030,
      "wilaya": 39,
      "name": "Sidi Amrane"
    },
    "id": 1300,
    "commune_name_ascii": "Sidi Amrane",
    "commune_name": "سيدي عمران",
    "daira_name_ascii": "Djamaa",
    "daira_name": "جامعة",
    "wilaya_code": "57",
    "wilaya_name_ascii": "El Meghaier",
    "wilaya_name": "المغير"
  },
  {
    "pk": 1299  ,"fields": { "postcode": 39022,  "wilaya":   39, "name": "Mrara" },
    "id": 1293,
    "commune_name_ascii": "M'rara",
    "commune_name": "المرارة",
    "daira_name_ascii": "Djamaa",
    "daira_name": "جامعة",
    "wilaya_code": "57",
    "wilaya_name_ascii": "El Meghaier",
    "wilaya_name": "المغير"
  },
  {
    "model": "base.commune",
    "pk": 1305,
    "fields": {
      "postcode": 39028,
      "wilaya": 39,
      "name": "Djamaa"
    },
    "id": 1281,
    "commune_name_ascii": "Djamaa",
    "commune_name": "جامعة",
    "daira_name_ascii": "Djamaa",
    "daira_name": "جامعة",
    "wilaya_code": "57",
    "wilaya_name_ascii": "El Meghaier",
    "wilaya_name": "المغير"
  },
  {
    "pk": 1301  ,"fields": { "postcode": 39024,  "wilaya":   39, "name": "Tendla" },
    "id": 1306,
    "commune_name_ascii": "Tenedla",
    "commune_name": "تندلة",
    "daira_name_ascii": "Djamaa",
    "daira_name": "جامعة",
    "wilaya_code": "57",
    "wilaya_name_ascii": "El Meghaier",
    "wilaya_name": "المغير"
  },
  {
    "pk": 1304  ,"fields": { "postcode": 39027,  "wilaya":   39, "name": "El Mghair" },
    "id": 1284,
    "commune_name_ascii": "El M'ghaier",
    "commune_name": "المغير",
    "daira_name_ascii": "El Meghaier",
    "daira_name": "المغير",
    "wilaya_code": "57",
    "wilaya_name_ascii": "El Meghaier",
    "wilaya_name": "المغير"
  },
  {
    "model": "base.commune",
    "pk": 1298,
    "fields": {
      "postcode": 39021,
      "wilaya": 39,
      "name": "Still"
    },
    "id": 1303,
    "commune_name_ascii": "Still",
    "commune_name": "سطيل",
    "daira_name_ascii": "El Meghaier",
    "daira_name": "المغير",
    "wilaya_code": "57",
    "wilaya_name_ascii": "El Meghaier",
    "wilaya_name": "المغير"
  },
  {
    "pk": 1300  ,"fields": { "postcode": 39023,  "wilaya":   39, "name": "Sidi Khellil" },
    "id": 1302,
    "commune_name_ascii": "Sidi Khelil",
    "commune_name": "سيدي خليل",
    "daira_name_ascii": "El Meghaier",
    "daira_name": "المغير",
    "wilaya_code": "57",
    "wilaya_name_ascii": "El Meghaier",
    "wilaya_name": "المغير"
  },
  {
    "model": "base.commune",
    "pk": 1492,
    "fields": {
      "postcode": 47002,
      "wilaya": 47,
      "name": "El Meniaa"
    },
    "id": 1495,
    "commune_name_ascii": "El Meniaa",
    "commune_name": "المنيعة",
    "daira_name_ascii": "El Menia",
    "daira_name": "المنيعة",
    "wilaya_code": "58",
    "wilaya_name_ascii": "El Menia",
    "wilaya_name": "المنيعة"
  },
  {
    "model": "base.commune",
    "pk": 1502,
    "fields": {
      "postcode": 47012,
      "wilaya": 47,
      "name": "Hassi Gara"
    },
    "id": 1499,
    "commune_name_ascii": "Hassi Gara",
    "commune_name": "حاسي القارة",
    "daira_name_ascii": "El Menia",
    "daira_name": "المنيعة",
    "wilaya_code": "58",
    "wilaya_name_ascii": "El Menia",
    "wilaya_name": "المنيعة"
  },
  {
    "model": "base.commune",
    "pk": 1501,
    "fields": {
      "postcode": 47011,
      "wilaya": 47,
      "name": "Hassi Fehal"
    },
    "id": 1498,
    "commune_name_ascii": "Hassi Fehal",
    "commune_name": "حاسي الفحل",
    "daira_name_ascii": "Mansourah",
    "daira_name": "المنصورة",
    "wilaya_code": "58",
    "wilaya_name_ascii": "El Menia",
    "wilaya_name": "المنيعة"
  }
]
